var $gXNCa$xstate = require("xstate");
var $gXNCa$three = require("three");
var $gXNCa$xstatelibmodel = require("xstate/lib/model");
var $gXNCa$uuid = require("uuid");
var $gXNCa$xstatelibactions = require("xstate/lib/actions");
var $gXNCa$reactjsxruntime = require("react/jsx-runtime");
var $gXNCa$react = require("react");
var $gXNCa$styledcomponents = require("styled-components");
var $gXNCa$crocksEither = require("crocks/Either");
var $gXNCa$crockshelperscompose = require("crocks/helpers/compose");
var $gXNCa$crockslogicifElse = require("crocks/logic/ifElse");
var $gXNCa$crockslogicor = require("crocks/logic/or");
var $gXNCa$crockspredicatesisNumber = require("crocks/predicates/isNumber");
var $gXNCa$crockspredicatesisString = require("crocks/predicates/isString");
var $gXNCa$crockscoreisFunction = require("crocks/core/isFunction");
var $gXNCa$shallowequal = require("shallowequal");
var $gXNCa$reactbeautifuldnd = require("react-beautiful-dnd");
var $gXNCa$reacttooltip = require("react-tooltip");
var $gXNCa$reactmodal = require("react-modal");
var $gXNCa$reactdraggable = require("react-draggable");
var $gXNCa$lodash = require("lodash");
var $gXNCa$reactcollapsible = require("react-collapsible");
var $gXNCa$clamp = require("clamp");
var $gXNCa$d3scale = require("d3-scale");
var $gXNCa$toawait = require("to-await");
var $gXNCa$socketioclient = require("socket.io-client");
var $gXNCa$reactdom = require("react-dom");
var $gXNCa$downshift = require("downshift");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "controlCenter", () => $4fa36e821943b400$export$a8d37c3100d63152);
$parcel$export(module.exports, "machineBuilder", () => $4fa36e821943b400$export$4a1a65d8c0fb68a1);


var $a94c350358e784aa$exports = {};

$parcel$export($a94c350358e784aa$exports, "createEmptyReferenceFrame", () => $a94c350358e784aa$export$eb141b764bb7abbb);
$parcel$export($a94c350358e784aa$exports, "createPose", () => $a94c350358e784aa$export$a2a01fea32009ccc);
$parcel$export($a94c350358e784aa$exports, "createEmptyPose", () => $a94c350358e784aa$export$f257cf4a095dcbcc);
$parcel$export($a94c350358e784aa$exports, "createEmptyRobotState", () => $a94c350358e784aa$export$e5b169abf882e8ee);
$parcel$export($a94c350358e784aa$exports, "createEmptyJointStates", () => $a94c350358e784aa$export$1b792dfa92d90e0b);
$parcel$export($a94c350358e784aa$exports, "createEmptyRobotAppsContext", () => $a94c350358e784aa$export$6b730617056440e7);
$parcel$export($a94c350358e784aa$exports, "createDefaultMachineLogicRobotConfig", () => $a94c350358e784aa$export$678e4b22a1ba9af5);
$parcel$export($a94c350358e784aa$exports, "createEmptyPoint3", () => $a94c350358e784aa$export$85acb7d9a4534c17);
$parcel$export($a94c350358e784aa$exports, "createDefaultStartStreamingJoggerFrameDeltasRequestBody", () => $a94c350358e784aa$export$b2a985e8ea03724b);
$parcel$export($a94c350358e784aa$exports, "createDefaultStartStreamingJoggerJointDeltasRequestBody", () => $a94c350358e784aa$export$114d07bef9113991);

/**
 * @typedef {number} Xaxis
 */ /**
 * @typedef {number} Yaxis
 */ /**
 * @typedef {number} Zaxis
 */ /**
 * @typedef {number} EulerX
 */ /**
 * @typedef {number} EulerY
 */ /**
 * @typedef {number} EulerZ
 */ /**
 * @typedef {Xaxis, Yaxis, Zaxis, EulerX, EulerY, EulerZ} FreedriveConstraints
 */ /**
 * @typedef {{
 *    running: boolean,
 *    constraints: FreedriveConstraints,
 * }} FreedriveStatus
 */ /**
 * @returns {FreedriveStatus}
 */ function $8bd3f182af6b3660$export$185802fd694ee1f5() {
    return {
        running: false,
        constraints: [
            1,
            1,
            1,
            1,
            1,
            1
        ]
    };
}


/**
 * @returns {import("./types").ReferenceFrame}
 */ function $a94c350358e784aa$export$eb141b764bb7abbb() {
    return {
        name: "",
        arrayMatrix__referenceFrame_robotKinematicsChainRoot: [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]
    };
}
/**
 * @param {number} x
 * @param {number} y
 * @param {number} z
 * @param {number} qx
 * @param {number} qy
 * @param {number} qz
 * @param {number} qw
 * @returns {import("./types").Pose}
 */ function $a94c350358e784aa$export$a2a01fea32009ccc(x, y, z, qx, qy, qz, qw) {
    return {
        position: new $gXNCa$three.Vector3(x, y, z),
        rotation: new $gXNCa$three.Quaternion(qx, qy, qz, qw)
    };
}
/**
 * @returns {import("./types").Pose}
 */ function $a94c350358e784aa$export$f257cf4a095dcbcc() {
    return $a94c350358e784aa$export$a2a01fea32009ccc(0, 0, 0, 0, 0, 0, 1);
}
/**
 * @returns {import("./types").RobotState}
 */ function $a94c350358e784aa$export$e5b169abf882e8ee() {
    return {
        jointStates: $a94c350358e784aa$export$1b792dfa92d90e0b(),
        cartesianPose: $a94c350358e784aa$export$f257cf4a095dcbcc(),
        freedriveStatus: (0, $8bd3f182af6b3660$export$185802fd694ee1f5)()
    };
}
/**
 * @returns {import("./types").RobotAppsContext}
 */ function $a94c350358e784aa$export$6b730617056440e7() {
    return {
        vid: -1,
        robotConfig: null,
        connectedRobotType: "",
        reactStateUpdateFunctions: {},
        robotState: $a94c350358e784aa$export$e5b169abf882e8ee(),
        editingReferenceFrameId: "",
        referenceFrames: {},
        joggerSpeedPercentage: 50,
        ventionRosConnectionState: "disconnected",
        ventionRosRobotDriverState: null
    };
}
/**
 * @param {{
 *   uniqueRobotName: string,
 *   uniqueRobotId: string,
 *   controllerId: string,
 * }} props
 * @returns {import("./types").MachineLogicRobotConfig}
 */ function $a94c350358e784aa$export$678e4b22a1ba9af5({ uniqueRobotName: uniqueRobotName , uniqueRobotId: uniqueRobotId , controllerId: controllerId  }) {
    return {
        robotMLVertex: true,
        category: "config",
        name: "robot",
        parameters: {
            friendlyName: uniqueRobotName,
            robotId: uniqueRobotId,
            robotType: "ur3_e",
            controllerId: controllerId
        }
    };
}
/**
 * @returns {import('./types').Point3}
 */ function $a94c350358e784aa$export$85acb7d9a4534c17() {
    return {
        x: 0,
        y: 0,
        z: 0
    };
}
/**
 * @returns {import('./types').JointState}
 */ function $a94c350358e784aa$export$1b792dfa92d90e0b() {
    return [
        0,
        0,
        0,
        0,
        0,
        0
    ];
}
/**
 * @returns {import('./types').ExecuteFrameDeltasRequestBody}
 */ function $a94c350358e784aa$export$b2a985e8ea03724b() {
    return {
        linearDelta: $a94c350358e784aa$export$85acb7d9a4534c17(),
        angularDelta: $a94c350358e784aa$export$85acb7d9a4534c17()
    };
}
/**
 * @returns {import('./types').ExecuteJointDeltaRequestBody}
 */ function $a94c350358e784aa$export$114d07bef9113991() {
    return {
        deltas: $a94c350358e784aa$export$1b792dfa92d90e0b()
    };
}



/**
 * @returns {import('./types').CalibrationReferenceFrame}
 */ const $5736410646f0466e$export$d9d8d55d63ce489c = ()=>{
    /** @type {import('./types').ArrayMatrix} */ const identity = new $gXNCa$three.Matrix4().toArray();
    return Object.freeze({
        name: "Robot_Base",
        arrayMatrix__referenceFrame_world: identity,
        arrayMatrix__referenceFrame_robotKinematicsChainRoot: identity
    });
};


function $dac17a56277219f2$var$getClipById(sequence, clipId) {
    const clips = [
        ...sequence?.mApp?.robotParameters?.clips || [],
        ...sequence?.robotParameters?.clips || []
    ];
    return clips && clips.find((clip)=>clip.id === clipId);
}
/**
 * Check if the application has CalibrationPart not defined in the config.
 * @param {Application} pApp
 * @returns
 */ const $dac17a56277219f2$export$d768e119085dca34 = function(pApp, errorTypes) {
    const parentConfig = pApp.mLibrary.getConfigManager().getParentConfiguration();
    const result = [];
    for (const sequence of pApp.mSequences)for (const instruction of sequence.mInstructions){
        if (instruction.mCategory !== "robot") continue;
        const calibrationReferenceFrameName = instruction.getParameter("calibrationReferenceFrame").name;
        const robotBaseName = (0, $5736410646f0466e$export$d9d8d55d63ce489c)().name;
        if (calibrationReferenceFrameName === robotBaseName) continue;
        const calibrationPart = parentConfig.getCalibrationPartByName(calibrationReferenceFrameName);
        if (!calibrationPart || !calibrationPart.isSelectedInConfig()) {
            const clipId = instruction.getParameter("clipId");
            const clip = $dac17a56277219f2$var$getClipById(sequence, clipId);
            result.push({
                header: "Recalibrate robot",
                onError: {
                    message: `The ${pApp.mName} application has a Robot Path ${clip?.name} using the calibration tool ${calibrationReferenceFrameName} but it is not found in the configuration.`,
                    options: [
                        {
                            message: `Add a Robot Calibration Tool and select ${calibrationReferenceFrameName}`,
                            target: "redirect-config"
                        }
                    ]
                },
                onSuccess: {
                    message: `Calibration tool ${calibrationReferenceFrameName} found in the configuration.`
                },
                type: errorTypes.ApplicationError,
                key: calibrationReferenceFrameName,
                app: pApp.mName,
                seq: sequence.mName,
                id: pApp.mId
            });
        }
    }
    return result;
};



/**
 *
 * @param {string} topic - event topic to listen on websocket client
 * @param {function} handler -
 * @returns {{ topic: string, handler: function }}
 */ function $9c35425985377ff1$var$subscribe(topic, handler) {
    return {
        topic: topic,
        handler: handler
    };
}
/**
 * @typedef {{topic: string, handler: function }} WebsocketSubscribeEvent
 *
 */ /**
 *
 * @param {string} topic
 * @param {function} handler
 * @returns {{topic: string, handler: function }}
 */ function $9c35425985377ff1$var$unsubscribe(topic, handler) {
    return {
        topic: topic,
        handler: handler
    };
}
/**
 *
 * @param {import("socket.io-client").Socket | null} socket
 */ function $9c35425985377ff1$var$onWebsocketClientConnect(socket) {
    return {
        socket: socket
    };
}
const $9c35425985377ff1$export$2f952c48dd3bb7b0 = (0, $gXNCa$xstatelibmodel.createModel)({
    /** @type {import("socket.io-client").Socket | null} */ websocketClient: null
}, {
    events: {
        onWebsocketClientConnect: $9c35425985377ff1$var$onWebsocketClientConnect,
        subscribe: $9c35425985377ff1$var$subscribe,
        unsubscribe: $9c35425985377ff1$var$unsubscribe
    }
});


/**
 * @param {THREE.Vector3} vector
 * @param {number} scalar
 */ function $244a53b2e57b5b1d$export$2e2bcd8739ae039(vector, scalar) {
    const newVector = vector.clone();
    // eslint-disable-next-line functional/no-expression-statements
    newVector.multiplyScalar(scalar);
    return newVector;
}



function $9bee722f86890ada$export$2e2bcd8739ae039(angles, scalar) {
    return new $gXNCa$three.Euler().fromArray(angles.toArray().map((value)=>value * scalar));
}


const $49b61417b640529d$export$c45596821edb3bba = "new-clip";
const $49b61417b640529d$export$7556d3a9f806327e = {
    triad: "Triad",
    pointToPoint: "Point to point",
    jogger: "Jogger"
};
/**
 * This is to be used as an "enum"
 */ const $49b61417b640529d$export$99c05c98ada369d6 = Object.freeze({
    OTHER: "OTHER",
    NORMAL: "NORMAL",
    PROTECTIVE_STOP: "PROTECTIVE_STOP",
    REDUCED: "REDUCED",
    ROBOT_EMERGENCY_STOP: "ROBOT_EMERGENCY_STOP",
    SAFEGUARD_STOP: "SAFEGUARD_STOP"
});
const $49b61417b640529d$export$2a603a1db86c460f = Object.freeze({
    DISCONNECTED: "DISCONNECTED",
    NOT_READY: "NOT_READY",
    READY: "READY"
});
const $49b61417b640529d$export$c80eb66b670f184a = Object.freeze({
    DISCONNECTED: "disconnected",
    CONNECTING: "connecting",
    CONNECTED: "connected",
    DISCONNECTING: "disconnecting",
    UNEXPECTEDLY_DISCONNECTED: "unexpectedly_disconnected"
});



/**
 * Note: if the char is not found in the string an empty string
 * @param {string} string
 * @param {string} char
 * @returns {string}
 */ var $e3cf532bb3a3066e$export$2e2bcd8739ae039 = (string, char)=>string.substring(0, string.lastIndexOf(char));


const $c1079e917223b83f$var$SEPARATOR = "#";
function $c1079e917223b83f$export$d177d65704b00822(applicationId) {
    return applicationId + $c1079e917223b83f$var$SEPARATOR + (0, $gXNCa$uuid.v4)();
}
function $c1079e917223b83f$export$e7fbeaf048afc774(ApplicationIdWithReferenceFrameId, applicationId) {
    return (0, $e3cf532bb3a3066e$export$2e2bcd8739ae039)(ApplicationIdWithReferenceFrameId, $c1079e917223b83f$var$SEPARATOR) === applicationId;
}


/**
 * filter object properties using a predicate that takes as parameter the key, value or index of the entry
 *
 * @param {Object} obj
 * @param {(v: any, k: string, i: number) => any} fn
 * @returns {Object}
 */ var $7a9e5387fae80ef8$export$2e2bcd8739ae039 = (obj, fn)=>Object.fromEntries(Object.entries(obj).filter(([k, v], i)=>fn(v, k, i)));




var $26b56b7a4b609458$export$2e2bcd8739ae039 = (0, $gXNCa$xstate.createMachine)({
    id: "joggerEnableRobotMachine",
    initial: "IDLE",
    states: {
        IDLE: {
            on: {
                modalShown: {
                    target: "NOT_READY"
                }
            }
        },
        NOT_READY: {
            on: {
                enableRobotButtonClick: {
                    target: "READYING"
                },
                readyStateChangeToREADY: {
                    target: "IDLE"
                }
            }
        },
        READYING: {
            after: {
                15000: {
                    target: "#joggerEnableRobotMachine.NOT_READY",
                    actions: [
                        (0, $gXNCa$xstatelibactions.sendParent)("joggerEnableRobotMachine/READYING/timedout")
                    ],
                    internal: false
                }
            },
            on: {
                readyStateChangeToREADY: {
                    target: "IDLE"
                }
            }
        }
    },
    context: {},
    predictableActionArguments: true,
    preserveActionOrder: true
});




var $8a08288a9c40227e$export$2e2bcd8739ae039 = (0, $gXNCa$xstate.createMachine)({
    id: "playRequestedEnableRobotMachine",
    initial: "IDLE",
    states: {
        IDLE: {
            on: {
                modalShown: {
                    target: "NOT_READY"
                }
            }
        },
        NOT_READY: {
            on: {
                enableRobotButtonClick: {
                    target: "READYING"
                },
                readyStateChangeToREADY: {
                    target: "IDLE"
                }
            }
        },
        READYING: {
            after: {
                15000: {
                    target: "#playRequestedEnableRobotMachine.IDLE",
                    actions: [
                        (0, $gXNCa$xstatelibactions.sendParent)("playRequestedEnableRobotMachine/READYING/timedout")
                    ],
                    internal: false
                }
            },
            on: {
                readyStateChangeToREADY: {
                    target: "IDLE"
                }
            }
        }
    },
    context: {},
    predictableActionArguments: true,
    preserveActionOrder: true
});


const $e9a5479fa42b7804$var$M_TO_MM = 1000;
const $e9a5479fa42b7804$var$RAD_TO_DEG = 180 / Math.PI;
/**
 * @param {Object} features
 */ const $e9a5479fa42b7804$var$robotApps = (features)=>{
    return (0, $gXNCa$xstate.createMachine)({
        id: "robotApps",
        initial: "idle",
        context: {
            ...(0, $a94c350358e784aa$export$6b730617056440e7)(),
            joggerEnableRobotMachineActorRef: null,
            playRequestedEnableRobotMachineActorRef: null
        },
        entry: (0, $gXNCa$xstate.assign)({
            joggerEnableRobotMachineActorRef: ()=>(0, $gXNCa$xstate.spawn)((0, $26b56b7a4b609458$export$2e2bcd8739ae039), {
                    sync: true
                }),
            playRequestedEnableRobotMachineActorRef: ()=>(0, $gXNCa$xstate.spawn)((0, $8a08288a9c40227e$export$2e2bcd8739ae039), {
                    sync: true
                })
        }),
        on: {
            ...features.websocket.transitions
        },
        type: "parallel",
        states: {
            websocket: {
                initial: features.websocket.initial,
                states: {
                    ...features.websocket.states
                }
            },
            app: {
                initial: "idle",
                states: {
                    robotInstructionEditableJoggerTicked: {
                        invoke: {
                            ...features.robotInstructionEditableJoggerTicked.invoke
                        },
                        on: {
                            ...features.robotInstructionEditableJoggerTicked.transitions
                        }
                    },
                    referenceFramesJoggerTicked: {
                        invoke: {
                            ...features.referenceFramesJoggerTicked.invoke
                        },
                        on: {
                            ...features.referenceFramesJoggerTicked.transitions
                        }
                    },
                    robotClipsJoggerTicked: {
                        invoke: {
                            ...features.robotClipsJoggerTicked.invoke
                        },
                        on: {
                            ...features.robotClipsJoggerTicked.transitions,
                            ...features.robotClipsJoggerTicked.transitions.idle
                        }
                    },
                    ticked: {},
                    idle: {
                        on: {
                            ...features.idle.transitions,
                            ...features.arrayEditor.transitions.notInArrayEditor,
                            ...features.robotConfig.transitions.idle,
                            ...features.robotClips.transitions.idle,
                            ...features.referenceFrames.transitions,
                            ...features.robotInstruction.transitions,
                            ...features.robotLoopInstruction.transitions,
                            ...features.robotInstructionEditable.transitions,
                            ...features.robotInstructionSelector.transitions,
                            ...features.machineLogic.transitions,
                            ...features.protectiveStopModal.transitions.enable,
                            ...features.robotClipsJogger.transitions.idle,
                            ...features.robotClipsJoggerTicked.transitions.idle
                        }
                    },
                    triad: {
                        on: {
                            ...features.robotClips.transitions.triad
                        }
                    },
                    robotInstructionEditableJogger: {
                        invoke: {
                            ...features.robotInstructionEditableJogger.invoke
                        },
                        on: {
                            ...features.robotInstructionEditableJogger.transitions,
                            ...features.referenceFrames.transitions,
                            // ...features.triad.transitions.notInTriad,
                            // ...features.pointToPoint.transitions.notInPointToPoint,
                            // ...features.editRobot.transitions.notInEditRobot,
                            // ...features.machineLogic.transitions.inMachineLogic,
                            ...features.robotInstruction.transitions,
                            // ...features.robotClips.transitions,
                            ...features.robotInstructionEditable.transitions
                        }
                    },
                    referenceFramesJogger: {
                        invoke: {
                            ...features.referenceFramesJogger.invoke
                        },
                        on: {
                            ...features.referenceFramesJogger.transitions,
                            ...features.referenceFrames.transitions
                        }
                    },
                    robotClipsJogger: {
                        invoke: {
                            ...features.robotClipsJogger.invoke
                        },
                        on: {
                            ...features.robotClipsJogger.transitions,
                            ...features.robotClipsJogger.transitions.idle,
                            ...features.referenceFrames.transitions,
                            // ...features.triad.transitions.notInTriad,
                            // ...features.pointToPoint.transitions.notInPointToPoint,
                            // ...features.editRobot.transitions.notInEditRobot,
                            // ...features.machineLogic.transitions.inMachineLogic,
                            // ...features.robotInstruction.transitions,
                            ...features.robotClips.transitions
                        }
                    },
                    inArrayEditor: {
                        on: {
                            ...features.arrayEditor.transitions.inArrayEditor
                        },
                        ...features.arrayEditor.states.inArrayEditor
                    },
                    robotReadyStateNotReady: {
                        entry: features.robotReadyStateNotReady.entry,
                        on: {
                            ...features.robotReadyStateNotReady.transitions
                        }
                    },
                    moveHere: {
                        invoke: {
                            ...features.moveHere.invoke
                        },
                        on: {
                            ...features.moveHere.transitions,
                            ...features.protectiveStopModal.transitions.enable
                        }
                    },
                    manualControlJogger: {
                        ...features.manualControlJogger
                    },
                    exitJogger: {
                        ...features.exitJogger
                    }
                }
            }
        }
    });
};
const $e9a5479fa42b7804$var$createRobotAppsService = (props)=>{
    const robotAppsMachine = $e9a5479fa42b7804$var$robotApps(props);
    return (0, $gXNCa$xstate.interpret)(robotAppsMachine.withContext({
        ...robotAppsMachine.context,
        ...(0, $9c35425985377ff1$export$2f952c48dd3bb7b0).initialContext
    }), {
        devTools: true
    })// eslint-disable-next-line no-unused-vars
    .onTransition((state)=>{
    // eslint-disable-next-line functional/no-expression-statements
    // console.log(
    //   "\n===xstate transition occurred===",
    //   "\nstate value: ",
    //   JSON.stringify(state.value),
    //   "\nevent:",
    //   state.event.type,
    //   "\nstate:",
    //   state,
    //   "\n"
    // );
    }).start();
};
// eslint-disable-next-line functional/no-let
let $e9a5479fa42b7804$var$service;
const $e9a5479fa42b7804$export$57c55162807a37cb = (props, validator, featureFlags)=>{
    // eslint-disable-next-line functional/no-expression-statements
    $e9a5479fa42b7804$var$service = $e9a5479fa42b7804$var$createRobotAppsService(props);
    if (featureFlags.DIGITAL_CALIBRATION_FLOW) validator.addValidateAppCallback("calibrationPartCheck", (0, $dac17a56277219f2$export$d768e119085dca34));
    return {
        selectors: $e9a5479fa42b7804$export$e1252723db1c541,
        send: $e9a5479fa42b7804$var$service.send,
        onTransition: $e9a5479fa42b7804$var$service.onTransition
    };
};
const $e9a5479fa42b7804$var$getRobotAppsService = ()=>{
    return $e9a5479fa42b7804$var$service;
};
const $e9a5479fa42b7804$var$getVentionRosRobotDriverState = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState;
};
/**
 * @returns {import('../../model/types').MachineLogicRobotConfig | null}
 */ const $e9a5479fa42b7804$var$getRobotConfig = ()=>{
    if (!$e9a5479fa42b7804$var$service.state.context.robotConfig) return null;
    return {
        ...$e9a5479fa42b7804$var$service.state.context.robotConfig,
        // HACK to act as an interface to MachineLogic's data model, add accessors
        getName: ()=>$e9a5479fa42b7804$var$service.state.context.robotConfig.parameters.friendlyName,
        getType: ()=>$e9a5479fa42b7804$var$service.state.context.robotConfig.parameters.robotType,
        getRobotId: ()=>$e9a5479fa42b7804$var$service.state.context.robotConfig.parameters.robotId,
        getControllerId: ()=>$e9a5479fa42b7804$var$service.state.context.robotConfig.parameters.controllerId
    };
};
/**
 * getRobotConfigName.
 * @returns {string} - robot config friendlyName
 */ const $e9a5479fa42b7804$var$getRobotConfigName = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.robotConfig.parameters.friendlyName;
};
const $e9a5479fa42b7804$var$getRobotConfigArray = ()=>{
    return $e9a5479fa42b7804$var$getRobotConfig() ? [
        $e9a5479fa42b7804$var$getRobotConfig()
    ] : [];
};
const $e9a5479fa42b7804$var$getRobotAppServiceStateValue = ()=>{
    return $e9a5479fa42b7804$var$service.state.value;
};
/*
 * @returns {import('../../model/types').Pose}
 *
 */ const $e9a5479fa42b7804$var$getRobotStateCartesianPoseInMM = ()=>{
    const { robotState: { cartesianPose: { position: position , rotation: rotation  }  }  } = $e9a5479fa42b7804$var$service.state.context;
    const positionInMM = (0, $244a53b2e57b5b1d$export$2e2bcd8739ae039)(position, $e9a5479fa42b7804$var$M_TO_MM);
    return (0, $a94c350358e784aa$export$a2a01fea32009ccc)(...positionInMM.toArray(), ...rotation.toArray());
};
const $e9a5479fa42b7804$var$getRobotCartesianPositionInM = ()=>{
    /** @type {import("../../model/types").RobotAppsContext} */ const { robotState: { cartesianPose: { position: position  }  }  } = $e9a5479fa42b7804$var$service.state.context;
    return position;
};
const $e9a5479fa42b7804$var$getRobotCartesianPositionInMM = ()=>{
    /** @type {import("../../model/types").RobotAppsContext} */ const { robotState: { cartesianPose: { position: position  }  }  } = $e9a5479fa42b7804$var$service.state.context;
    return (0, $244a53b2e57b5b1d$export$2e2bcd8739ae039)(position, $e9a5479fa42b7804$var$M_TO_MM);
};
const $e9a5479fa42b7804$var$getRobotCartesianRotationInRad = ()=>{
    /** @type {import("../../model/types").RobotAppsContext} */ const { robotState: { cartesianPose: { rotation: rotation  }  }  } = $e9a5479fa42b7804$var$service.state.context;
    return new $gXNCa$three.Euler().setFromQuaternion(rotation);
};
const $e9a5479fa42b7804$var$getRobotCartesianRotationInDeg = ()=>{
    /** @type {import("../../model/types").RobotAppsContext} */ const { robotState: { cartesianPose: { rotation: rotation  }  }  } = $e9a5479fa42b7804$var$service.state.context;
    return (0, $9bee722f86890ada$export$2e2bcd8739ae039)(new $gXNCa$three.Euler().setFromQuaternion(rotation), $e9a5479fa42b7804$var$RAD_TO_DEG);
};
const $e9a5479fa42b7804$var$getRobotJointStatesInRad = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.robotState.jointStates;
};
const $e9a5479fa42b7804$var$getRobotJointStatesInDeg = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.robotState.jointStates.map((value)=>value * $e9a5479fa42b7804$var$RAD_TO_DEG);
};
const $e9a5479fa42b7804$var$getFreedriveStatus = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.robotState.freedriveStatus;
};
/**
 * @param {import('../../model/types').ApplicationId} applicationId
 * @returns {import('../../model/types').Map__ApplicationIdWithReferenceFrameId_x_ReferenceFrame}
 */ const $e9a5479fa42b7804$var$getReferenceFramesByApplicationId = (applicationId)=>{
    return (0, $7a9e5387fae80ef8$export$2e2bcd8739ae039)($e9a5479fa42b7804$var$service.state.context.referenceFrames, (_, id)=>(0, $c1079e917223b83f$export$e7fbeaf048afc774)(id, applicationId));
};
const $e9a5479fa42b7804$var$getJoggerSpeedPercentage = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.joggerSpeedPercentage;
};
const $e9a5479fa42b7804$var$getRobotSafetyStateModalTitle = ()=>{
    switch($e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState?.robot_safety_state.state){
        case (0, $49b61417b640529d$export$99c05c98ada369d6).PROTECTIVE_STOP:
            return "Protective Stop";
        case (0, $49b61417b640529d$export$99c05c98ada369d6).OTHER:
            return "Safety issue has occured";
        case (0, $49b61417b640529d$export$99c05c98ada369d6).SAFEGUARD_STOP:
            return "Safeguard Activated";
        default:
            return undefined;
    }
};
/**
 * @returns { string }
 */ const $e9a5479fa42b7804$var$getEditingKeyframePath = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.editingKeyframePath;
};
const $e9a5479fa42b7804$var$getDispatch = ()=>{
    return $e9a5479fa42b7804$var$service.send;
};
const $e9a5479fa42b7804$var$isInitialized = ()=>{
    return !!$e9a5479fa42b7804$var$service;
};
/**
 * @returns { string }
 */ const $e9a5479fa42b7804$var$getVentionRosConnectionState = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosConnectionState;
};
const $e9a5479fa42b7804$var$isVentionRosConnecting = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosConnectionState === (0, $49b61417b640529d$export$c80eb66b670f184a).CONNECTING;
};
const $e9a5479fa42b7804$var$isVentionRosConnected = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosConnectionState === (0, $49b61417b640529d$export$c80eb66b670f184a).CONNECTED;
};
const $e9a5479fa42b7804$var$isVentionRosDisconnecting = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosConnectionState === (0, $49b61417b640529d$export$c80eb66b670f184a).DISCONNECTING;
};
const $e9a5479fa42b7804$var$isVentionRosDisconnected = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosConnectionState === (0, $49b61417b640529d$export$c80eb66b670f184a).DISCONNECTED;
};
const $e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateDisconnected = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState?.robot_ready_state?.state === (0, $49b61417b640529d$export$2a603a1db86c460f).DISCONNECTED;
};
const $e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateNotReady = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState?.robot_ready_state?.state === (0, $49b61417b640529d$export$2a603a1db86c460f).NOT_READY;
};
const $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateReduced = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState.robot_safety_state.state === (0, $49b61417b640529d$export$99c05c98ada369d6).REDUCED;
};
const $e9a5479fa42b7804$var$isVentionRosUnexpectedlyDisconnected = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosConnectionState === (0, $49b61417b640529d$export$c80eb66b670f184a).UNEXPECTEDLY_DISCONNECTED;
};
/**
 * @returns { string }
 */ const $e9a5479fa42b7804$var$getConnectedRobotType = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.connectedRobotType;
};
const $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateProtectiveStop = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState?.robot_safety_state.state === (0, $49b61417b640529d$export$99c05c98ada369d6).PROTECTIVE_STOP;
};
const $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateOther = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState?.robot_safety_state.state === (0, $49b61417b640529d$export$99c05c98ada369d6).OTHER;
};
const $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateSafeguardStop = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState?.robot_safety_state.state === (0, $49b61417b640529d$export$99c05c98ada369d6).SAFEGUARD_STOP;
};
const $e9a5479fa42b7804$var$shouldDisplayRobotClipsJogger = ()=>{
    return $e9a5479fa42b7804$var$service.state.matches("app.robotClipsJogger") || $e9a5479fa42b7804$var$service.state.matches("app.robotClipsJoggerTicked");
};
const $e9a5479fa42b7804$var$shouldDisplayRobotInstructionEditableJogger = ()=>{
    return $e9a5479fa42b7804$var$service.state.matches("app.robotInstructionEditableJogger") || $e9a5479fa42b7804$var$service.state.matches("app.robotInstructionEditableJoggerTicked");
};
const $e9a5479fa42b7804$var$shouldDisplayReferenceFramesJogger = ()=>{
    return $e9a5479fa42b7804$var$service.state.matches("app.referenceFramesJogger") || $e9a5479fa42b7804$var$service.state.matches("app.referenceFramesJoggerTicked");
};
const $e9a5479fa42b7804$var$shouldDisplayRobotJoggerRobotDisconnectedOverlay = ()=>{
    return !$e9a5479fa42b7804$var$isVentionRosConnected() || $e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateDisconnected();
};
const $e9a5479fa42b7804$var$shouldDisplayRobotJoggerRobotNotReadyOverlay = ()=>{
    return $e9a5479fa42b7804$var$isVentionRosConnected() && $e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateNotReady();
};
const $e9a5479fa42b7804$var$shouldDisplayConnected = ()=>{
    return $e9a5479fa42b7804$var$isVentionRosConnected() && !$e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateDisconnected();
};
const $e9a5479fa42b7804$var$shouldDisplayLoader = ()=>{
    return $e9a5479fa42b7804$var$isVentionRosConnecting() || $e9a5479fa42b7804$var$isVentionRosDisconnecting();
};
const $e9a5479fa42b7804$var$isRobotNotSimulatable = ()=>{
    return !$e9a5479fa42b7804$var$isVentionRosConnected() || $e9a5479fa42b7804$var$service.state.context.ventionRosRobotDriverState.robot_ready_state.state !== (0, $49b61417b640529d$export$2a603a1db86c460f).READY;
};
const $e9a5479fa42b7804$var$showRobotSafetyStateModal = ()=>{
    return !$e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateDisconnected() && ($e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateSafeguardStop() || $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateOther() || $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateProtectiveStop());
};
const $e9a5479fa42b7804$var$showRobotReadyStateNotReadyModal = ()=>{
    return $e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateNotReady() && $e9a5479fa42b7804$var$service.state.matches("app.robotReadyStateNotReady");
};
const $e9a5479fa42b7804$var$isRobotReadyStateNotReadyButtonLoading = ()=>{
    return $e9a5479fa42b7804$var$service.state.context.joggerEnableRobotMachineActorRef?.getSnapshot().matches("READYING") || $e9a5479fa42b7804$var$service.state.context.playRequestedEnableRobotMachineActorRef?.getSnapshot().matches("READYING");
};
const $e9a5479fa42b7804$export$e1252723db1c541 = {
    getDispatch: $e9a5479fa42b7804$var$getDispatch,
    getEditingKeyframePath: $e9a5479fa42b7804$var$getEditingKeyframePath,
    getRobotSafetyStateModalTitle: $e9a5479fa42b7804$var$getRobotSafetyStateModalTitle,
    getRobotAppsService: $e9a5479fa42b7804$var$getRobotAppsService,
    getVentionRosRobotDriverState: $e9a5479fa42b7804$var$getVentionRosRobotDriverState,
    getRobotConfig: $e9a5479fa42b7804$var$getRobotConfig,
    getRobotConfigArray: $e9a5479fa42b7804$var$getRobotConfigArray,
    getRobotConfigName: $e9a5479fa42b7804$var$getRobotConfigName,
    getRobotAppServiceStateValue: $e9a5479fa42b7804$var$getRobotAppServiceStateValue,
    getRobotCartesianPositionInM: $e9a5479fa42b7804$var$getRobotCartesianPositionInM,
    getRobotCartesianPositionInMM: $e9a5479fa42b7804$var$getRobotCartesianPositionInMM,
    getRobotCartesianRotationInDeg: $e9a5479fa42b7804$var$getRobotCartesianRotationInDeg,
    getRobotCartesianRotationInRad: $e9a5479fa42b7804$var$getRobotCartesianRotationInRad,
    getRobotStateCartesianPoseInMM: $e9a5479fa42b7804$var$getRobotStateCartesianPoseInMM,
    getRobotJointStatesInRad: $e9a5479fa42b7804$var$getRobotJointStatesInRad,
    getRobotJointStatesInDeg: $e9a5479fa42b7804$var$getRobotJointStatesInDeg,
    getFreedriveStatus: $e9a5479fa42b7804$var$getFreedriveStatus,
    getVentionRosConnectionState: $e9a5479fa42b7804$var$getVentionRosConnectionState,
    getReferenceFramesByApplicationId: $e9a5479fa42b7804$var$getReferenceFramesByApplicationId,
    getJoggerSpeedPercentage: $e9a5479fa42b7804$var$getJoggerSpeedPercentage,
    getConnectedRobotType: $e9a5479fa42b7804$var$getConnectedRobotType,
    isInitialized: $e9a5479fa42b7804$var$isInitialized,
    isVentionRosConnecting: $e9a5479fa42b7804$var$isVentionRosConnecting,
    isVentionRosConnected: $e9a5479fa42b7804$var$isVentionRosConnected,
    isVentionRosDisconnecting: $e9a5479fa42b7804$var$isVentionRosDisconnecting,
    isVentionRosDisconnected: $e9a5479fa42b7804$var$isVentionRosDisconnected,
    isVentionRosUnexpectedlyDisconnected: $e9a5479fa42b7804$var$isVentionRosUnexpectedlyDisconnected,
    isRobotDriverStateRobotSafetyStateSafeguardStop: $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateSafeguardStop,
    isRobotDriverStateRobotSafetyStateOther: $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateOther,
    isRobotDriverStateRobotSafetyStateProtectiveStop: $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateProtectiveStop,
    isRobotReadyStateNotReadyButtonLoading: $e9a5479fa42b7804$var$isRobotReadyStateNotReadyButtonLoading,
    showRobotReadyStateNotReadyModal: $e9a5479fa42b7804$var$showRobotReadyStateNotReadyModal,
    showRobotSafetyStateModal: $e9a5479fa42b7804$var$showRobotSafetyStateModal,
    shouldDisplayRobotClipsJogger: $e9a5479fa42b7804$var$shouldDisplayRobotClipsJogger,
    shouldDisplayRobotInstructionEditableJogger: $e9a5479fa42b7804$var$shouldDisplayRobotInstructionEditableJogger,
    shouldDisplayReferenceFramesJogger: $e9a5479fa42b7804$var$shouldDisplayReferenceFramesJogger,
    shouldDisplayRobotJoggerRobotDisconnectedOverlay: $e9a5479fa42b7804$var$shouldDisplayRobotJoggerRobotDisconnectedOverlay,
    shouldDisplayRobotJoggerRobotNotReadyOverlay: $e9a5479fa42b7804$var$shouldDisplayRobotJoggerRobotNotReadyOverlay,
    shouldDisplayConnected: $e9a5479fa42b7804$var$shouldDisplayConnected,
    shouldDisplayLoader: $e9a5479fa42b7804$var$shouldDisplayLoader,
    isRobotNotSimulatable: $e9a5479fa42b7804$var$isRobotNotSimulatable,
    isRobotDriverStateRobotSafetyStateReduced: $e9a5479fa42b7804$var$isRobotDriverStateRobotSafetyStateReduced,
    isRobotDriverStateRobotReadyStateNotReady: $e9a5479fa42b7804$var$isRobotDriverStateRobotReadyStateNotReady
};



/**
 * @param {{
 *   ctx3dInterface: {
 *     getRobotProgrammingState: () => import("../model/MachineBuilderRobotModelState").MachineBuilderRobotModelState
 *   }
 *   ExecutionEngineAPI: {
 *     setMachineBuilderRobotModelCurrentState: (sequenceName: string, instructionIndex: number, data: { machineBuilderRobotModelCurrentState: import("../model/MachineBuilderRobotModelState").MachineBuilderRobotModelState }) => Promise<void>
 *   }
 *   instructionIndex: number,
 *   sequenceName: string,
 * }} parameters
 */ var $70ab5576dcfb2d8a$export$2e2bcd8739ae039 = async ({ ctx3dInterface: ctx3dInterface , ExecutionEngineAPI: ExecutionEngineAPI , instructionIndex: instructionIndex , robotActuatorVid: robotActuatorVid , sequenceName: sequenceName  })=>{
    const nextInstructionIndex = instructionIndex + 1;
    await ExecutionEngineAPI.setMachineBuilderRobotModelCurrentState(sequenceName, nextInstructionIndex, {
        machineBuilderRobotModelCurrentState: ctx3dInterface.getRobotProgrammingState(robotActuatorVid)
    });
};


/**
 * @param {{
 *   application: object
 *   configManager: object
 *   ctx3D: object
 *   simulationData: object
 * }} parameters
 */ var $656b531cc056c482$export$2e2bcd8739ae039 = ({ application: application , configManager: configManager , ctx3D: ctx3D , simulationData: simulationData  })=>{
    simulationData.robotSimulation.forEach(/**
     * @param {import('../model/ExecutionEngineRobotSimulateInstructionData').ExecutionEngineRobotSimulateInstructionData} robotSimulationData
     */ (robotSimulationData)=>{
        {
            const sequence = application.getSequence(robotSimulationData.sequenceName);
            const instruction = sequence.mInstructions[robotSimulationData.instructionIndex];
            const robot = configManager.listRobots().find((robotConfig)=>robotConfig.mRobotId === instruction.getParameter("robotId"));
            const getRobotActuatorVID = ()=>robot?.mRobotActuators && parseInt(Object.keys(robot.mRobotActuators)[0]);
            const lActiveManip = ctx3D.mManipCurrent.getType();
            if (lActiveManip !== "manip-robot" && lActiveManip !== "manip-robot-create-reference-frame") {
                ctx3D.setTopManipulator("manip-robot", getRobotActuatorVID()); // This is a hack to init the orocos solver. Should be done once elsewhere to avoid doing this here
                lActiveManip !== "manip-robot-create-array" && ctx3D.setTopManipulator(lActiveManip);
            }
        }
        switch(simulationData.state){
            case "running":
                if (robotSimulationData.simulationState === "started") ctx3D.robotAppsService.send("ROBOT_SIMULATION_MOTION_STARTED");
                else if (robotSimulationData.simulationState === "listening") robotSimulationData.jointStates && ctx3D.robotAppsService.send("ROBOT_SIMULATION_JOINT_STATES_RECEIVED", {
                    payload: robotSimulationData.jointStates
                });
                break;
        }
    });
};



const $b632cfa24756cd8a$var$robotApps = (features)=>{
    return (0, $gXNCa$xstate.createMachine)({
        id: "robotApps",
        initial: "idle",
        context: {
            vid: -1,
            reactStateUpdateFunctions: {},
            isRosConnected: false,
            robotClipReferenceFrameEditingId: "",
            calibrationHighlights: {
                previous: []
            }
        },
        on: {
            ...features.websocket.transitions,
            "RobotConfig/connectToVentionRos/connectedToVentionRos": features.robotConfigWidget.transitions["RobotConfig/connectToVentionRos/connectedToVentionRos"]
        },
        type: "parallel",
        states: {
            websocket: {
                initial: features.websocket.initial,
                states: features.websocket.states
            },
            app: {
                initial: "idle",
                states: {
                    idle: {
                        on: {
                            ...features.triad.transitions.notInTriad,
                            ...features.jogger.transitions.notJogger,
                            ...features.pointToPoint.transitions.notInPointToPoint,
                            ...features.editRobot.transitions.notInEditRobot,
                            ...features.referenceFrameCreator.transitions.notCreatingReferenceFrame,
                            ...features.simulation.transitions,
                            ...features.arrayEditor.transitions.notInArrayEditor,
                            ...features.calibrationPartEditor.transitions.inCalibrationPartEditor,
                            ...features.machineLogic.transitions.inMachineLogic,
                            ...features.robotInstruction.transitions,
                            ...features.robotClips.transitions,
                            ...features.robotInstructionEditable.transitions,
                            ...features.robotInstructionSelector.transitions,
                            ...features.robotLoopInstruction.transitions,
                            ...features["/machine-builder"].transitions,
                            ...features.robotConfigWidget.transitions,
                            ...features.machineBuilder.transitions
                        }
                    },
                    inEditRobot: {
                        on: {
                            ...features.manipRobotExit.transitions,
                            ...features.machineLogic.transitions.inMachineLogic,
                            ...features.triad.transitions.notInTriad,
                            ...features.jogger.transitions.notJogger,
                            ...features.arrayEditor.transitions.notInArrayEditor,
                            ...features.calibrationPartEditor.transitions.inCalibrationPartEditor,
                            ...features.pointToPoint.transitions.notInPointToPoint,
                            ...features["/machine-builder"].transitions
                        },
                        ...features.editRobot.states.inEditRobot
                    },
                    triad: {
                        on: {
                            ...features.jogger.transitions.notJogger,
                            ...features.pointToPoint.transitions.notInPointToPoint,
                            ...features.editRobot.transitions.notInEditRobot,
                            ...features.referenceFrameCreator.transitions.notCreatingReferenceFrame,
                            ...features.machineLogic.transitions.inMachineLogic,
                            ...features.robotInstruction.transitions,
                            ...features.robotClips.transitions,
                            ...features.robotInstructionEditable.transitions,
                            ...features.robotInstructionSelector.transitions,
                            ...features.robotLoopInstruction.transitions,
                            ...features["/machine-builder"].transitions
                        },
                        ...features.triad.states.triad
                    },
                    jogger: {
                        initial: features.jogger.states.jogger.initial,
                        states: features.jogger.states.jogger.states,
                        on: {
                            ...features.jogger.states.jogger.on,
                            ...features.triad.transitions.notInTriad,
                            ...features.pointToPoint.transitions.notInPointToPoint,
                            ...features.editRobot.transitions.notInEditRobot,
                            ...features.machineLogic.transitions.inMachineLogic,
                            ...features.robotInstruction.transitions,
                            ...features.robotClips.transitions,
                            ...features.robotInstructionEditable.transitions,
                            ...features.robotInstructionSelector.transitions,
                            ...features.robotLoopInstruction.transitions,
                            ...features["/machine-builder"].transitions
                        }
                    },
                    pointToPoint: {
                        on: {
                            ...features.triad.transitions.notInTriad,
                            ...features.jogger.transitions.notJogger,
                            ...features.pointToPoint.transitions.inPointToPoint,
                            ...features.editRobot.transitions.notInEditRobot,
                            ...features.machineLogic.transitions.inMachineLogic,
                            ...features.robotInstruction.transitions,
                            ...features.robotClips.transitions,
                            ...features.robotInstructionEditable.transitions,
                            ...features.robotInstructionSelector.transitions,
                            ...features.robotLoopInstruction.transitions,
                            ...features["/machine-builder"].transitions
                        }
                    },
                    creatingReferenceFrame: {
                        on: {
                            ...features.referenceFrameCreator.transitions.creatingReferenceFrame,
                            ...features.robotClipsExit.transitions
                        }
                    },
                    inArrayEditor: {
                        on: {
                            ...features.arrayEditor.transitions.inArrayEditor
                        },
                        ...features.arrayEditor.states.inArrayEditor
                    },
                    simulating: {
                        on: {
                            ...features.simulation.transitions.simulating
                        }
                    }
                }
            }
        }
    });
};
const $b632cfa24756cd8a$var$createRobotAppsService = (helpers)=>(props)=>{
        const robotAppsMachine = $b632cfa24756cd8a$var$robotApps(props);
        return (0, $gXNCa$xstate.interpret)(robotAppsMachine.withContext({
            ...robotAppsMachine.context,
            ...(0, $9c35425985377ff1$export$2f952c48dd3bb7b0).initialContext
        })).onTransition((state)=>{
            // check if there is action for the event sent
            if (!helpers.isProdDeployment() && !state.actions.length) console.warn(`Xstate
          there is no action for the event: ${state.event.type}
          for the state: ${JSON.stringify(state.value)}
        `);
        // if (!ilib_helpers.isProdDeployment()){
        //   console.log(
        //     '\n===xstate transition occurred===',
        //     '\nstate value: ', JSON.stringify(state.value),
        //     '\nmanipulator: ', window.assembler.get3DContext()?.mManipCurrent?.getType(),
        //     '\nevent:', state.event.type,
        //     '\nstate:', state,
        //     '\n'
        //   );
        // }
        }).start();
    };
const $b632cfa24756cd8a$export$57c55162807a37cb = (dependencies)=>(props)=>{
        const service = $b632cfa24756cd8a$var$createRobotAppsService(dependencies.helpers)(props);
        const getDispatch = ()=>{
            return service?.send;
        };
        const getIsRosConnected = ()=>{
            return service.state.context?.isRosConnected;
        };
        const getRobotAppsServiceState = ()=>{
            return service.state;
        };
        const getRobotClipReferenceFrameEditingId = ()=>{
            return service.state.context?.robotClipReferenceFrameEditingId;
        };
        const isInitialized = ()=>{
            return !!service;
        };
        const isEditingArrayReferenceFrame = ()=>{
            return service.state.matches("app.inArrayEditor.creatingArrayReferenceFrame");
        };
        const selectors = {
            getDispatch: getDispatch,
            getIsRosConnected: getIsRosConnected,
            getRobotAppsServiceState: getRobotAppsServiceState,
            getRobotClipReferenceFrameEditingId: getRobotClipReferenceFrameEditingId,
            isInitialized: isInitialized,
            isEditingArrayReferenceFrame: isEditingArrayReferenceFrame
        };
        return {
            selectors: selectors,
            send: service.send,
            onTransition: service.onTransition,
            callSetMachineBuilderRobotModelCurrentStateWithCurrentRobotProgrammingState: ({ ctx3dInterface: ctx3dInterface , ExecutionEngineAPI: ExecutionEngineAPI , instructionIndex: instructionIndex , sequence: sequence , sequenceName: sequenceName  })=>{
                const robotActuatorVid = service.state.context.vid;
                if (robotActuatorVid && ctx3dInterface.isRobotVID(robotActuatorVid)) (0, $70ab5576dcfb2d8a$export$2e2bcd8739ae039)({
                    ctx3dInterface: ctx3dInterface,
                    ExecutionEngineAPI: ExecutionEngineAPI,
                    instructionIndex: instructionIndex,
                    robotActuatorVid: robotActuatorVid,
                    sequence: sequence,
                    sequenceName: sequenceName
                });
            },
            simulate: $656b531cc056c482$export$2e2bcd8739ae039
        };
    };


var $66ec0fd1738a6fd1$exports = {};
/**
 * @typedef {Number} VID
 * @typedef {[number, number, number, number, number, number, number, number, number, number, number, number, number, number, number, number]} ArrayMatrix
 * @typedef {string} ApplicationName
 * @typedef {UUID} ApplicationId
 * @typedef {string} UUID
 * @typedef {`${ApplicationId}#${UUID}`} ApplicationIdWithReferenceFrameId
 * @typedef {{
 *    name: string,
 *    arrayMatrix__referenceFrame_robotKinematicsChainRoot: ArrayMatrix,
 *  }} ReferenceFrame
 * @typedef {import('three').Vector3} Position
 * @typedef {import('three').Quaternion} Rotation
 * @typedef {{
 *   position: Position,
 *   rotation: Rotation,
 * }} Pose
 * @typedef {[number, number, number, number, number, number]} JointState
 * @typedef {{
 *   jointStates: JointState,
 *   cartesianPose: Pose, // unit: meters
 *   freedriveStatus: import('FreedriveStatus').FreedriveStatus
 * }} RobotState
 * @typedef {[number, number, number, number, number, number, number]} ExecutionEngineRobotStateCartesianPose // unit: milimeters
 * @typedef {{
 *   jointStates: JointState,
 *   cartesianPose: ExecutionEngineRobotStateCartesianPose,
 * }} ExecutionEngineRobotState
 * @typedef {{
 *   robotMLVertex: boolean,
 *   category: string,
 *   name: string,
 *   parameters: {
 *     robotId: UUID
 *     controllerId: string,
 *     friendlyName: string,
 *     robotType: string,
 *   }
 * }} MachineLogicRobotConfig
 * @typedef { "connected" | "connecting" | "disconnected" | "disconnecting" | "unexpectedly_disconnected" } VentionRosConnectionState
 * @typedef {{
 *   robot_ready_state: {
 *     state: "DISCONNECTED" | "NOT_READY" | "READY" // https://github.com/VentionCo/vention_ros/blob/1121-robot_driver_state/melodic/workspace/src/robot_driver_state_publisher/msg/RobotReadyState.msg
 *   }
 *   robot_safety_state: {
 *     state: "NORMAL" | "REDUCED" | "PROTECTIVE_STOP" | "ROBOT_EMERGENCY_STOP" | "SAFEGUARD_STOP" | "OTHER" // https://github.com/VentionCo/vention_ros/blob/1121-robot_driver_state/melodic/workspace/src/robot_driver_state_publisher/msg/RobotSafetyState.msg
 *   }
 * }} VentionRosRobotDriverState
 * @typedef {Object.<ApplicationIdWithReferenceFrameId, ReferenceFrame>} Map__ApplicationIdWithReferenceFrameId_x_ReferenceFrame
 * @typedef {{
 *   vid: number,
 *   robotConfig: MachineLogicRobotConfig,
 *   reactStateUpdateFunctions: Object.<number, function>,
 *   robotState: RobotState,
 *   editingReferenceFrameId: UUID,
 *   referenceFrames: Map__ApplicationIdWithReferenceFrameId_x_ReferenceFrame,
 *   joggerSpeedPercentage: number,
 *   editingKeyframePath: string
 *   previousEditingKeyframePath: string // necessary due to "When a state transition has assign(...) actions, those actions are always batched and computed first, to determine the next state" - https://xstate.js.org/docs/guides/context.html#action-order
 *   ventionRosConnectionState: VentionRosConnectionState
 *   ventionRosRobotDriverState: VentionRosRobotDriverState | null
 * }}  RobotAppsContext
 *
 * @typedef {import('xstate').ContextFrom<RobotAppsContext>} ContextFromRobotAppsContext
 *
 * @typedef {{
 *   linearDelta: Point3,
 *   angularDelta: Point3,
 * }} ExecuteFrameDeltasRequestBody
 * @typedef {{
 *   deltas: JointState,
 * }} ExecuteJointDeltaRequestBody
 * @typedef {{
 *   x: number,
 *   y: number,
 *   z: number,
 * }} Point3
 * @typedef {{
 *   x: number,
 *   y: number,
 * }} Point2
 * @typedef {{
 *   x: Number,
 *   y: Number,
 *   id: String,
 *   isSelected: Boolean,
 * }} Point2WithIdWithIsSelected
 * @typedef {{
 *    name: string,
 *    vid: VID,
 *    arrayMatrix__referenceFrame_world: ArrayMatrix,
 *    arrayMatrix__referenceFrame_robotKinematicsChainRoot: ArrayMatrix,
 *  }} CalibrationReferenceFrame
 * @typedef {{
 *   vid: Number,
 *   arrayMatrix__referenceFrame_world: ArrayMatrix,
 *   arrayMatrix__referenceFrame_vidAssociatedModel: ArrayMatrix,
 * }} ClipTeachingReferenceFrame
 * @typedef {{
 *   vid: Number,
 *   arrayMatrix__referenceFrame_world: ArrayMatrix,
 *   arrayMatrix__referenceFrame_vidAssociatedModel: ArrayMatrix,
 * }} InstructionExecutionReferenceFrame
 * @typedef {{
 *   vid: Number,
 *   arrayMatrix__referenceFrame_world: ArrayMatrix,
 *   arrayMatrix__vidAssociatedModel_world: ArrayMatrix,
 *   arrayMatrix__referenceFrame_vidAssociatedModel: ArrayMatrix,
 * }} ArrayTeachingReferenceFrame
 * @typedef {{
 *   arrayMatrix__referenceFrame_world: ArrayMatrix,
 * }} ArrayExecutionReferenceFrame
 * @typedef {{
 *   arrayType: "Fixed spacings",
 *   name: String,
 *   rowCount: Number,
 *   colCount: Number,
 *   xSpacing: Number,
 *   ySpacing: Number,
 *   isRowCountTooHigh: Boolean,
 *   isColCountTooHigh: Boolean,
 * }} PatternConfig
 * @typedef {{
 *   id: String,
 *   arrayArrayPoint2D: Point2WithIdWithIsSelected[],
 *   arrayMatrixReferenceFrame: ArrayTeachingReferenceFrame,
 *   patternConfig: PatternConfig,
 * }} ArrayEditorState
 * @typedef {Object} Keyframe
 * @property {Object} [waypoint]
 * @property {ArrayMatrix} [waypoint.pose]
 * @property {JointState} [waypoint.jointAngles]
 * @typedef {Object} RobotParametersClip
 * @property {UUID} robotId
 * @property {Keyframe[]} keyframes
 * @property {ClipTeachingReferenceFrame | undefined} teachingReferenceFrame
 * @typedef {{
 *   clips: RobotParametersClip[]
 *   arrays: ArrayEditorState[]
 *   calibrationParts: CalibrationReferenceFrame[]
 * }} RobotParameters
 * @type {RobotParameters}
 * @typedef {Object} MachineLogicApplication
 * @property {RobotParameters} robotParameters
 * @property {{
 *   robotParameters: RobotParameters
 *   mInstructions: {
 *     mCategory: String
 *     mName: String
 *     mParameters: {
 *       calibrationReferenceFrame: Object | undefined
 *       executionReferenceFrame: InstructionExecutionReferenceFrame | undefined
 *       arrayId: String | undefined
 *       arrayName: String | undefined
 *       arrayValue: ArrayExecutionReferenceFrame[] | undefined
 *     }
 *   }[]
 * }[]} mSequences
 * @property {() => void} setDirty
 * @typedef {Object} MachineLogicDynamicLoadedLibrary
 * @property {{
 *   mCurrentApplication: MachineLogicApplication
 * }} mLibrary
 */ // HACK make this file a module to make it importable




var $1d3cf5330bb207de$exports = {};

$parcel$export($1d3cf5330bb207de$exports, "updateFromPoseDisplacement", () => $1d3cf5330bb207de$export$2e8c804cf36be98);
$parcel$export($1d3cf5330bb207de$exports, "getUniqueClipNameFromApplication", () => $1d3cf5330bb207de$export$64c313e59f94d976);
$parcel$export($1d3cf5330bb207de$exports, "updateEndEffectorToolCenterPoint", () => $1d3cf5330bb207de$export$3fd6c15374412e0);
$parcel$export($1d3cf5330bb207de$exports, "updateRobotParametersClipsWith", () => $1d3cf5330bb207de$export$2704a7f0b64bdf92);
$parcel$export($1d3cf5330bb207de$exports, "updateRobotID", () => $1d3cf5330bb207de$export$f39c10a7b99a6467);
// eslint-disable-next-line no-unused-vars



const $77ae0e02d8e49871$var$Box = (0, ($parcel$interopDefault($gXNCa$styledcomponents))).div.attrs((props)=>({
        dataattribute: props.dataattribute
    }))`
  /* border: ${(props)=>props.border || "unset"};
  border-radius: ${(props)=>props.borderRadius || "unset"}; */
  background-color: ${(props)=>props.backgroundColor || "inherit"};
  padding: ${(props)=>props.padding || `8px`};
  width: ${(props)=>props.width || "auto"};
  height: ${(props)=>props.height || "auto"};
`;
var $77ae0e02d8e49871$export$2e2bcd8739ae039 = $77ae0e02d8e49871$var$Box;




// HACK: This is a hack used to forward props to the DOM as we are using composed styled-components
const $79df3d6dfc00b4b7$var$blacklistedProps = [
    "alignItems",
    "flexDirection",
    "justifyContent",
    "height",
    "width",
    "backgroundColor"
];
const $79df3d6dfc00b4b7$var$Flex = (0, ($parcel$interopDefault($gXNCa$styledcomponents)))((0, $77ae0e02d8e49871$export$2e2bcd8739ae039)).withConfig({
    shouldForwardProp: (prop)=>!$79df3d6dfc00b4b7$var$blacklistedProps.includes(prop)
})`
  align-items: ${(props)=>props.alignItems || "unset"};
  display: flex;
  flex-direction: ${(props)=>props.flexDirection || "row"};
  justify-content: ${(props)=>props.justifyContent || "unset"};
  height: ${(props)=>props.height || "auto"};
  width: ${(props)=>props.width || "auto"};
`;
var $79df3d6dfc00b4b7$export$2e2bcd8739ae039 = $79df3d6dfc00b4b7$var$Flex;




// HACK: This is a hack used to forward props to the DOM as we are using composed styled-components
const $e874e726514bc29c$var$blacklistedProps = [
    "display",
    "gridTemplateRows",
    "gridTemplateColumns",
    "gap",
    "width",
    "height"
];
const $e874e726514bc29c$var$Grid = (0, ($parcel$interopDefault($gXNCa$styledcomponents)))((0, $77ae0e02d8e49871$export$2e2bcd8739ae039)).withConfig({
    shouldForwardProp: (prop)=>!$e874e726514bc29c$var$blacklistedProps.includes(prop)
})`
  display: grid;
  grid-template-columns: ${(props)=>props.gridTemplateColumns || "unset"};
  grid-template-rows: ${(props)=>props.gridTemplateRows || "unset"};
  gap: ${(props)=>props.gap || "unset"};
  height: ${(props)=>props.height || "auto"};
  width: ${(props)=>props.width || "auto"};
`;
var $e874e726514bc29c$export$2e2bcd8739ae039 = $e874e726514bc29c$var$Grid;



const $ebdc0fd79394a43a$var$Slider = (0, ($parcel$interopDefault($gXNCa$styledcomponents))).input`
  -webkit-appearance: none;
  background: transparent;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 20px;
    width: 23px;
    background: #1ac876;
    cursor: pointer;
    margin-top: -20px;
    clip-path: polygon(0 0, 100% 0, 100% 60%, 50% 100%, 0 60%);
  }

  &::-moz-range-thumb {
    height: 20px;
    width: 23px;
    background: #1ac876;
    cursor: pointer;
    margin-top: -20px;
    clip-path: polygon(0 0, 100% 0, 100% 60%, 50% 100%, 0 60%);
  }

  &::-ms-thumb {
    height: 20px;
    width: 23px;
    background: #1ac876;
    cursor: pointer;
    margin-top: -20px;
    clip-path: polygon(0 0, 100% 0, 100% 60%, 50% 100%, 0 60%);
  }

  &::-webkit-slider-runnable-track {
    height: 8.4px;
    cursor: pointer;
    border-radius: 1.3px;
    border: 2px solid #d0d0d0;
  }

  &::-moz-range-track {
    height: 8.4px;
    cursor: pointer;
    border-radius: 1.3px;
    border: 2px solid #d0d0d0;
  }

  &::-ms-track {
    height: 8.4px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
`;
var $ebdc0fd79394a43a$export$2e2bcd8739ae039 = $ebdc0fd79394a43a$var$Slider;





var $b7c3f63a1efa4cdf$exports = {};

$parcel$export($b7c3f63a1efa4cdf$exports, "updateObjectInArray", () => $b7c3f63a1efa4cdf$export$19149de5bd5a5295);
$parcel$export($b7c3f63a1efa4cdf$exports, "replaceObjectInArray", () => $b7c3f63a1efa4cdf$export$ab7c9300a2aa157);
$parcel$export($b7c3f63a1efa4cdf$exports, "removeItem", () => $b7c3f63a1efa4cdf$export$fe2d9b4e03920b4c);
$parcel$export($b7c3f63a1efa4cdf$exports, "insertItem", () => $b7c3f63a1efa4cdf$export$da4743e1585b574b);
$parcel$export($b7c3f63a1efa4cdf$exports, "getUniqueName", () => $b7c3f63a1efa4cdf$export$798a797a6d4e253e);
$parcel$export($b7c3f63a1efa4cdf$exports, "optionValue", () => $b7c3f63a1efa4cdf$export$e7f5479139dfb59a);
$parcel$export($b7c3f63a1efa4cdf$exports, "getRobotInstructionPlayStateClass", () => $b7c3f63a1efa4cdf$export$a5c766b2d3222a93);







const { Left: $b7c3f63a1efa4cdf$var$Left , Right: $b7c3f63a1efa4cdf$var$Right  } = (0, ($parcel$interopDefault($gXNCa$crocksEither)));
// https://redux.js.org/recipes/structuring-reducers/immutable-update-patterns
/**
 * @typedef Action
 * @property {Number} index
 * @property {Object} item
 */ /**
 * @param {Array<Object>} array
 * @param {Action} action
 * @returns {Array<Object>}
 */ function $b7c3f63a1efa4cdf$export$19149de5bd5a5295(array, action) {
    return array.map((item, index)=>{
        if (index !== action.index) // This isn't the item we care about - keep it as-is
        return item;
        // Otherwise, this is the one we want - return an updated value
        return {
            ...item,
            ...action.item
        };
    });
}
function $b7c3f63a1efa4cdf$export$ab7c9300a2aa157(array, action) {
    return array.map((item, index)=>{
        if (index !== action.index) // This isn't the item we care about - keep it as-is
        return item;
        // Otherwise, this is the one we want - return an updated value
        return {
            ...action.item
        };
    });
}
/**
 * @param {any[]} array
 * @param {{
 *   index: number
 * }} action
 * @returns {any[]}
 */ function $b7c3f63a1efa4cdf$export$fe2d9b4e03920b4c(array, action) {
    return [
        ...array.slice(0, action.index),
        ...array.slice(action.index + 1)
    ];
}
function $b7c3f63a1efa4cdf$export$da4743e1585b574b(array, action) {
    return [
        ...array.slice(0, action.index),
        action.item,
        ...array.slice(action.index)
    ];
}
const $b7c3f63a1efa4cdf$export$798a797a6d4e253e = (pName, pNameList)=>{
    var _lName = pName, _lCounter = 0;
    while(pNameList.includes(_lName)){
        _lCounter += 1;
        _lName = pName + " (" + _lCounter + ")";
    }
    return _lName;
};
const $b7c3f63a1efa4cdf$var$eitherIsFunction = (0, ($parcel$interopDefault($gXNCa$crockslogicifElse)))((0, ($parcel$interopDefault($gXNCa$crockscoreisFunction))), $b7c3f63a1efa4cdf$var$Right, (0, ($parcel$interopDefault($gXNCa$crockshelperscompose)))($b7c3f63a1efa4cdf$var$Left, (val)=>`${typeof val} is not a function`));
const $b7c3f63a1efa4cdf$var$eitherIsNumberOrIsString = (0, ($parcel$interopDefault($gXNCa$crockslogicifElse)))((0, ($parcel$interopDefault($gXNCa$crockslogicor)))((0, ($parcel$interopDefault($gXNCa$crockspredicatesisNumber))), (0, ($parcel$interopDefault($gXNCa$crockspredicatesisString)))), $b7c3f63a1efa4cdf$var$Right, (0, ($parcel$interopDefault($gXNCa$crockshelperscompose)))($b7c3f63a1efa4cdf$var$Left, (val)=>`${typeof val} is not a number nor a string`));
const $b7c3f63a1efa4cdf$export$e7f5479139dfb59a = (getOptionValue, optionItem)=>$b7c3f63a1efa4cdf$var$eitherIsFunction(getOptionValue).bichain(()=>$b7c3f63a1efa4cdf$var$eitherIsNumberOrIsString(optionItem), ()=>$b7c3f63a1efa4cdf$var$eitherIsNumberOrIsString(getOptionValue(optionItem))).either((res)=>{
        throw new Error(res);
    }, (res)=>res);
const $b7c3f63a1efa4cdf$export$a5c766b2d3222a93 = (playState)=>playState === "running" ? "ml_animated_background_instruction running" : "";






const $52734ecf42276147$var$EditableInput = /*#__PURE__*/ (0, $gXNCa$react.forwardRef)(({ defaultValue: defaultValue , valueOnBlur: valueOnBlur , onChange: onChange , onMount: onMount , onBlur: onBlur , ...otherProps }, ref)=>{
    const [textValue, setTextValue] = (0, $gXNCa$react.useState)(defaultValue);
    (0, $gXNCa$react.useEffect)(()=>{
        defaultValue && onMount?.(defaultValue);
    }, []);
    (0, $gXNCa$react.useEffect)(()=>{
        defaultValue && setTextValue(defaultValue);
    }, [
        defaultValue
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
            ...otherProps,
            ref: ref,
            value: textValue,
            onBlur: (event)=>{
                valueOnBlur && setTextValue(valueOnBlur);
                onBlur?.(event);
            },
            onChange: (event)=>{
                setTextValue(event.target.value);
                onChange(event);
            }
        })
    });
});
var $52734ecf42276147$export$2e2bcd8739ae039 = $52734ecf42276147$var$EditableInput;


const $13573c04939367a2$export$598c1eea1a67754e = ({ children: children , iconClassName: iconClassName , index: index , playState: playState , ...otherProps })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        alignItems: "flex-start",
        padding: "0.65rem",
        ...otherProps,
        className: `${otherProps.className || ""} ${(0, $b7c3f63a1efa4cdf$export$a5c766b2d3222a93)(playState) || ""}`,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($13573c04939367a2$export$31aabcdbfafd6e66, {
                iconClassName: iconClassName,
                label: index
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "5px",
                padding: "0",
                style: {
                    alignItems: "center",
                    flex: "1",
                    backgroundColor: "transparent",
                    paddingRight: "50px"
                },
                children: children
            })
        ]
    });
const $13573c04939367a2$export$1d41361302b577a1 = ({ children: children , ...otherProps })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "ml_parameter v_layout spaced",
        ...otherProps,
        children: children
    });
const $13573c04939367a2$export$579a1e9bab103f15 = ({ label: label , labelStyle: labelStyle = {} , labelClassNames: labelClassNames = ""  })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "h_layout",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "ml_error_icon icon-help"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                className: "ml_widget_label " + labelClassNames,
                style: labelStyle,
                children: label
            })
        ]
    });
const $13573c04939367a2$export$c2e9fd968ef47d4 = ({ label: label , onClick: onClick , ...otherProps })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "h_layout",
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "ml_error_icon icon-help"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                className: "ml_widget_label",
                children: label
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                className: "ml_tooltip_icon ml_label_icon icon-help",
                style: {
                    border: "0px",
                    backgroundColor: "transparent",
                    marginRight: "0.2rem"
                },
                onClick: onClick
            })
        ]
    });
/**
 * StyledDeleteButton.
 *
 * @param {Object} - style
 * @returns {import('react').ReactElement}
 */ const $13573c04939367a2$export$e5aa014779ff2b01 = ({ style: style , ...otherProps })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
        className: "ml_close ml_close_card_widget",
        ...otherProps,
        style: {
            ...style
        }
    });
const $13573c04939367a2$export$3a9efa6242d14e94 = ({ ...otherProps })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
        className: "ml_close_card_widget ml_locked icon-lock",
        ...otherProps
    });
/**
 *
 * @param {{
 *   className: string,
 *   children: Object,
 *   text: string
 *   ...otherProps}} param0 classNames is a string containing class names to add to the ml_button_regular (Ex: "ml_button_green"),
 *                          text is the text of the button
 * @returns
 */ const $13573c04939367a2$export$ed53c48188888a22 = ({ className: className , children: children , text: text , ...otherProps })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
        className: "ml_button_regular " + className,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                children: text
            }),
            children
        ]
    });
};
function $13573c04939367a2$export$4a0738231a72639({ optionItems: optionItems , getOptionValue: getOptionValue , getOptionTextContent: getOptionTextContent , onChange: onChange , onMount: onMount , ...otherProps }) {
    const [selectedOption, setSelectedOption] = (0, $gXNCa$react.useState)(" ");
    (0, $gXNCa$react.useEffect)(()=>{
        onMount && onMount(setSelectedOption);
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("select", {
        className: !selectedOption ? "no_selection" : "",
        style: {
            position: "relative",
            height: "2.5rem",
            float: "left",
            fontSize: "0.9rem",
            minWidth: "120px",
            border: "1px solid rgb(207, 207, 207)",
            borderRadius: "0.15rem"
        },
        value: selectedOption,
        onChange: (e)=>{
            if (onChange) {
                onChange(e);
                setSelectedOption(e.target.value);
            }
        },
        ...otherProps,
        children: (!selectedOption ? [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                value: " ",
                hidden: true,
                children: "Select"
            }, "Select")
        ] : []).concat(optionItems.map((optionItem)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                style: {
                    color: "black"
                },
                value: (0, $b7c3f63a1efa4cdf$export$e7f5479139dfb59a)(getOptionValue, optionItem),
                children: (0, $b7c3f63a1efa4cdf$export$e7f5479139dfb59a)(getOptionTextContent, optionItem)
            }, `styledSelect-${(0, $b7c3f63a1efa4cdf$export$e7f5479139dfb59a)(getOptionValue, optionItem)}`)))
    });
}
function $13573c04939367a2$export$e7e6b99c949fd18a({ optionItems: optionItems , optionProps: optionProps = {} , getOptionValue: getOptionValue , getOptionTextContent: getOptionTextContent , onChange: onChange , onMount: onMount , ...otherProps }) {
    const [selectedOption, setSelectedOption] = (0, $gXNCa$react.useState)(undefined);
    (0, $gXNCa$react.useEffect)(()=>{
        onMount && onMount(setSelectedOption);
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("select", {
        className: "ml_parameter_widget",
        value: selectedOption,
        onChange: (e)=>{
            if (onChange) {
                onChange(e);
                setSelectedOption(e.target.value);
                e.target.blur();
            }
        },
        ...otherProps,
        children: optionItems.map((optionItem, i)=>/*#__PURE__*/ (0, $gXNCa$react.createElement)("option", {
                ...optionProps[i],
                value: (0, $b7c3f63a1efa4cdf$export$e7f5479139dfb59a)(getOptionValue, optionItem),
                key: `styledSelect-${(0, $b7c3f63a1efa4cdf$export$e7f5479139dfb59a)(getOptionValue, optionItem)}`
            }, (0, $b7c3f63a1efa4cdf$export$e7f5479139dfb59a)(getOptionTextContent, optionItem)))
    });
}
function $13573c04939367a2$export$9cad5df6f2ba047a({ text: text , ...otherProps }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "ml_parameter_widget",
        ...otherProps,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            children: [
                " ",
                text,
                " "
            ]
        })
    });
}
const $13573c04939367a2$export$31aabcdbfafd6e66 = ({ iconClassName: iconClassName , label: label  })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "ml_parameter v_layout spaced",
        children: [
            label ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($13573c04939367a2$export$579a1e9bab103f15, {
                label: label,
                labelClassNames: "ml_number"
            }) : null,
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: iconClassName,
                style: {
                    fontSize: "1.25rem",
                    paddingRight: "0.2rem"
                }
            })
        ]
    });
const $13573c04939367a2$export$a1e34fa9d184a3b6 = ({ iconClassName: iconClassName , text: text , ...otherProps })=>{
    const buttonRef = (0, $gXNCa$react.useRef)(null);
    // reference: https://github.com/adobe/react-spectrum/issues/1513
    (0, $gXNCa$react.useEffect)(()=>{
        buttonRef.current?.addEventListener("touchstart", (event)=>{
            event.preventDefault();
        });
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
        ref: buttonRef,
        className: "ml_button_text_icon_simple",
        style: {
            margin: "0 0 0 0",
            padding: "10px 10px 0 0"
        },
        ...otherProps,
        title: text,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                className: iconClassName,
                style: {
                    fontSize: "1.3rem"
                }
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "ml_button_text_decorated",
                children: text
            })
        ]
    });
};
const $13573c04939367a2$export$f8f3d5c775bf78be = ({ children: children , unit: unit  })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "ml_parameter_widget h_layout spaced",
        style: {
            justifyContent: "flex-end"
        },
        children: [
            children,
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "ml_parameter_unit",
                style: {
                    color: "#C4C4C4"
                },
                children: unit
            })
        ]
    });
const $13573c04939367a2$export$212aed895f9b9f10 = /*#__PURE__*/ (0, $gXNCa$react.forwardRef)(({ ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $52734ecf42276147$export$2e2bcd8739ae039), {
        className: "ml_parameter_widget truncated_text",
        ref: ref,
        ...otherProps
    });
});




function $03137bd1f9354234$var$UpdateableEditableInput({ defaultValue: defaultValue , shouldNotUpdateValue: shouldNotUpdateValue = ()=>false , onChange: onChange , onBlur: onBlur , onKeyDown: onKeyDown , ...otherProps }) {
    const [textValue, setTextValue] = (0, $gXNCa$react.useState)(defaultValue);
    (0, $gXNCa$react.useEffect)(()=>{
        if (shouldNotUpdateValue(defaultValue)) return;
        setTextValue(defaultValue);
    }, [
        defaultValue
    ]);
    const handleShouldNotUpdateValue = (event, eventHandler)=>{
        if (shouldNotUpdateValue(event.target.value)) return;
        setTextValue(event.target.value);
        eventHandler?.(event);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
            ...otherProps,
            value: textValue,
            onChange: (event)=>handleShouldNotUpdateValue(event, onChange),
            onBlur: (event)=>handleShouldNotUpdateValue(event, onBlur),
            onKeyDown: (event)=>handleShouldNotUpdateValue(event, onKeyDown)
        })
    });
}
var $03137bd1f9354234$export$2e2bcd8739ae039 = $03137bd1f9354234$var$UpdateableEditableInput;




const $be579d7e063d5849$export$945c94aaaae34956 = ({ ...otherProps })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
        ...otherProps,
        "data-cy": "left-jogger-arrow",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("svg", {
            width: "59",
            height: "52",
            viewBox: "0 0 59 52",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                    y: "0.339233",
                    width: "58.3368",
                    height: "50.7276",
                    rx: "2.8018",
                    fill: "#1C344F"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                    x: "19",
                    y: "24.3392",
                    width: "20.291",
                    height: "2.53638",
                    rx: "0.28018",
                    fill: "white"
                })
            ]
        })
    });
};
const $be579d7e063d5849$export$5303cd6ad868b9f1 = ({ ...otherProps })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
        ...otherProps,
        "data-cy": "right-jogger-arrow",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("svg", {
            width: "59",
            height: "51",
            viewBox: "0 0 59 51",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                    width: "58.3368",
                    height: "50.7276",
                    rx: "2.8018",
                    fill: "#1C344F"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("g", {
                    clipPath: "url(#clip0_3530_18219)",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                        d: "M38.8683 24.056H30.4137V15.3372C30.4137 15.0963 30.2245 14.9012 29.991 14.9012H28.3001C28.0665 14.9012 27.8773 15.0963 27.8773 15.3372V24.056H19.4227C19.1892 24.056 19 24.2511 19 24.4919V26.2357C19 26.4766 19.1892 26.6716 19.4227 26.6716H27.8773V35.3904C27.8773 35.6313 28.0665 35.8264 28.3001 35.8264H29.991C30.2245 35.8264 30.4137 35.6313 30.4137 35.3904V26.6716H38.8683C39.1019 26.6716 39.291 26.4766 39.291 26.2357V24.4919C39.291 24.2511 39.1019 24.056 38.8683 24.056Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("clipPath", {
                        id: "clip0_3530_18219",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                            width: "20.291",
                            height: "27.9002",
                            fill: "white",
                            transform: "translate(19 11.4137)"
                        })
                    })
                })
            ]
        })
    });
};


function $fde802728f8fc0c4$var$formatToNumber(pInput) {
    if (pInput === "") return 0;
    if (typeof pInput === "string") pInput = parseFloat(pInput);
    return parseFloat(pInput.toFixed(2));
}
function $fde802728f8fc0c4$var$InputPoseTranslationBoxes(props) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        children: [
            "x",
            "y",
            "z"
        ].map((pLetter)=>{
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                style: {
                    alignItems: "flex-start",
                    maxWidth: "130px"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        className: "ml_widget_label",
                        children: pLetter.toUpperCase()
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                        unit: "mm",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                            type: "number",
                            defaultValue: $fde802728f8fc0c4$var$formatToNumber(props.position.mP[pLetter]),
                            onMouseUp: (pEvent)=>pEvent.stopPropagation(),
                            onMouseDown: (pEvent)=>pEvent.stopPropagation(),
                            onMouseMove: (pEvent)=>pEvent.stopPropagation(),
                            onChange: (pEvent)=>{
                                props.onPoseTranslationChange(pLetter, $fde802728f8fc0c4$var$formatToNumber(pEvent.target.value));
                            },
                            "data-cy": "xyz-input"
                        })
                    })
                ]
            }, pLetter);
        })
    });
}
const $fde802728f8fc0c4$var$poseRotationLabel = {
    x: "I",
    y: "J",
    z: "K"
};
function $fde802728f8fc0c4$var$InputPoseRotationBoxes(props) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        children: [
            "x",
            "y",
            "z"
        ].map((pLetter)=>{
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                style: {
                    alignItems: "flex-start",
                    maxWidth: "130px"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        className: "ml_widget_label",
                        children: $fde802728f8fc0c4$var$poseRotationLabel[pLetter]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                        unit: "deg",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                            type: "number",
                            defaultValue: $fde802728f8fc0c4$var$formatToNumber(props.rotation.mP[pLetter]),
                            onMouseUp: (pEvent)=>pEvent.stopPropagation(),
                            onMouseDown: (pEvent)=>pEvent.stopPropagation(),
                            onMouseMove: (pEvent)=>pEvent.stopPropagation(),
                            onChange: (pEvent)=>{
                                props.onPoseRotationChange(pLetter, $fde802728f8fc0c4$var$formatToNumber(pEvent.target.value));
                            },
                            "data-cy": "ijk-input"
                        })
                    })
                ]
            }, `R${pLetter}`);
        })
    });
}
//TODO: generalize over robot type
const $fde802728f8fc0c4$var$jointNames = [
    "J1",
    "J2",
    "J3",
    "J4",
    "J5",
    "J6"
];
function $fde802728f8fc0c4$var$InputJointAnglesBoxes(props) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        flexDirection: "column",
        alignItems: "center",
        style: {
            marginTop: "1.5rem"
        },
        children: props.jointAngles.map((_, iJointAngles)=>{
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateColumns: "13% 15% 30% 15% 16%",
                gap: "0.8rem",
                padding: "0",
                style: {
                    width: "100%",
                    justifyItems: "end",
                    alignItems: "center",
                    margin: "0.25rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                        className: "ml_widget_label",
                        style: {
                            fontWeight: "normal"
                        },
                        children: $fde802728f8fc0c4$var$jointNames[iJointAngles]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $be579d7e063d5849$export$945c94aaaae34956), {
                        onClick: (pEvent)=>{
                            pEvent.stopPropagation();
                            if ($fde802728f8fc0c4$var$formatToNumber(props.jointAngles[iJointAngles]) < props.jointLimits[iJointAngles].min) return;
                            props.onJointAnglesChange(iJointAngles, $fde802728f8fc0c4$var$formatToNumber(props.jointAngles[iJointAngles]) - 1);
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $ebdc0fd79394a43a$export$2e2bcd8739ae039), {
                        type: "range",
                        min: props.jointLimits[iJointAngles].min,
                        max: props.jointLimits[iJointAngles].max,
                        value: $fde802728f8fc0c4$var$formatToNumber(props.jointAngles[iJointAngles]),
                        onMouseUp: (pEvent)=>pEvent.stopPropagation(),
                        onMouseDown: (pEvent)=>pEvent.stopPropagation(),
                        onMouseMove: (pEvent)=>pEvent.stopPropagation(),
                        onChange: (pEvent)=>{
                            props.onJointAnglesChange(iJointAngles, $fde802728f8fc0c4$var$formatToNumber(pEvent.target.value));
                        },
                        "data-cy": "jogger slider"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $be579d7e063d5849$export$5303cd6ad868b9f1), {
                        onClick: (pEvent)=>{
                            pEvent.stopPropagation();
                            if ($fde802728f8fc0c4$var$formatToNumber(props.jointAngles[iJointAngles]) > props.jointLimits[iJointAngles].max) return;
                            props.onJointAnglesChange(iJointAngles, $fde802728f8fc0c4$var$formatToNumber(props.jointAngles[iJointAngles]) + 1);
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                        unit: "\xb0",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                            type: "number",
                            defaultValue: $fde802728f8fc0c4$var$formatToNumber(props.jointAngles[iJointAngles]),
                            shouldNotUpdateValue: (value)=>$fde802728f8fc0c4$var$formatToNumber(value) < props.jointLimits[iJointAngles].min || $fde802728f8fc0c4$var$formatToNumber(value) > props.jointLimits[iJointAngles].max,
                            onMouseUp: (pEvent)=>pEvent.stopPropagation(),
                            onMouseDown: (pEvent)=>pEvent.stopPropagation(),
                            onMouseMove: (pEvent)=>pEvent.stopPropagation(),
                            onChange: (pEvent)=>{
                                props.onJointAnglesChange(iJointAngles, $fde802728f8fc0c4$var$formatToNumber(pEvent.target.value));
                            },
                            "data-cy": "jogger-number-input"
                        })
                    })
                ]
            }, `J${iJointAngles + 1}`);
        })
    });
}
function $fde802728f8fc0c4$var$InputPoseBox(props) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("fieldset", {
        style: {
            border: "1px solid #C9C9C9",
            boxSizing: "border-box",
            borderRadius: "3px"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("legend", {
                className: "ml_widget_label",
                style: {
                    width: "auto",
                    marginBottom: "0",
                    borderBottom: "0",
                    paddingInlineStart: "2px",
                    paddingInlineEnd: "2px",
                    fontSize: "14px"
                },
                children: "Current position"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateRows: "1fr 1fr",
                padding: "0",
                style: {
                    marginBottom: "0.5rem"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($fde802728f8fc0c4$var$InputPoseTranslationBoxes, {
                        ...props
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($fde802728f8fc0c4$var$InputPoseRotationBoxes, {
                        ...props
                    })
                ]
            })
        ]
    });
}
function $fde802728f8fc0c4$var$RobotJogger({ jointLimits: jointLimits , position: position , rotation: rotation , jointAngles: jointAngles , onPoseTranslationChange: onPoseTranslationChange , onPoseRotationChange: onPoseRotationChange , onJointAnglesChange: onJointAnglesChange , ...otherProps }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $77ae0e02d8e49871$export$2e2bcd8739ae039), {
        ...otherProps,
        style: {
            margin: "1rem 0.5rem"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                className: "ml_widget_label",
                style: {
                    fontSize: "20px",
                    marginBottom: "2rem"
                },
                children: "Jogger"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($fde802728f8fc0c4$var$InputPoseBox, {
                position: position,
                rotation: rotation,
                onPoseTranslationChange: onPoseTranslationChange,
                onPoseRotationChange: onPoseRotationChange
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($fde802728f8fc0c4$var$InputJointAnglesBoxes, {
                jointLimits: jointLimits,
                jointAngles: jointAngles,
                onJointAnglesChange: onJointAnglesChange
            })
        ]
    });
}
var $fde802728f8fc0c4$export$2e2bcd8739ae039 = $fde802728f8fc0c4$var$RobotJogger;





const $8b5d00d1b7e254c5$export$aa1a1894961eafab = ()=>`arrayEditor-${(0, $gXNCa$uuid.v4)()}`;





function $fc375b84455f4d9b$export$2e2bcd8739ae039({ name: name , children: children , containerStyle: containerStyle = {} , ...otherProps }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("h5", {
                children: [
                    " ",
                    name,
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    border: "1px solid rgb(160, 160, 160)",
                    boxSizing: "border-box",
                    borderRadius: "3px",
                    ...containerStyle
                },
                ...otherProps,
                children: children
            })
        ]
    });
}









function $412c4cb105f2bacf$export$2e2bcd8739ae039({ referenceFrame: referenceFrame , referenceFrameLabel: referenceFrameLabel , isEditingReferenceFrame: isEditingReferenceFrame , onMount: onMount , onReferenceFrameCreate: onReferenceFrameCreate , onExitReferenceFrameCreate: onExitReferenceFrameCreate , onReferenceFrameToolTipClick: onReferenceFrameToolTipClick  }) {
    (0, $gXNCa$react.useEffect)(()=>{
        referenceFrame && onMount?.(referenceFrame);
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        containerStyle: {
            position: "relative",
            margin: "0.5rem 1rem",
            background: "#FAFAFA",
            borderLeft: "4px solid #1C344F"
        },
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "10px 2.5rem",
            dataattribute: "array-editor-card",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$c2e9fd968ef47d4), {
                    label: referenceFrameLabel || "REFERENCE FRAME",
                    style: {
                        padding: "1rem 0"
                    },
                    onClick: onReferenceFrameToolTipClick
                }),
                isEditingReferenceFrame ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                    onClick: (event)=>{
                        event.stopPropagation();
                        onExitReferenceFrameCreate();
                    },
                    style: {
                        textAlign: "right",
                        border: "none",
                        background: "none",
                        textDecorationLine: "underline",
                        fontSize: "14px",
                        color: "#667A99",
                        cursor: "pointer"
                    },
                    children: "Done"
                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                    onClick: (event)=>{
                        event.stopPropagation();
                        onReferenceFrameCreate();
                    },
                    style: {
                        textAlign: "right",
                        border: "none",
                        background: "none",
                        textDecorationLine: "underline",
                        fontSize: "14px",
                        color: "#667A99",
                        cursor: "pointer"
                    },
                    children: "Edit"
                })
            ]
        })
    });
}




/** @type {import('./types').PatternConfig} */ const $9a809f6b2076d8a5$export$d4c72bab9d6cc13a = {
    arrayType: "Fixed spacings",
    name: "",
    rowCount: 0,
    colCount: 0,
    xSpacing: 0,
    ySpacing: 0,
    error: {
        type: "",
        message: ""
    }
};
/** @type {import('./types').PatternConfigErrorEnum} */ const $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR = Object.freeze({
    ROW_COUNT_ERROR: "ROW_COUNT_ERROR",
    COL_COUNT_ERROR: "COL_COUNT_ERROR",
    X_SPACING_ERROR: "X_SPACING_ERROR",
    Y_SPACING_ERROR: "Y_SPACING_ERROR"
});
// Form validation functions
/**
 * run through all validation functions and return
 *
 * @param {Function} fns
 * @returns { undefined | String }
 */ const $9a809f6b2076d8a5$var$validate = (...fns)=>(x)=>fns.reduce((acc, curr, currentIndex, array)=>{
            if (curr(acc)) {
                array.splice(currentIndex);
                return curr(acc);
            }
            if (currentIndex === array.length - 1) return undefined;
            return acc;
        }, x);
// validation functions
const $9a809f6b2076d8a5$var$isInteger = (value)=>Number.isInteger(value) ? undefined : "Please enter a integer number";
const $9a809f6b2076d8a5$var$smallerThan10 = (value)=>value <= 10 ? undefined : "Please enter a number from 1-10";
const $9a809f6b2076d8a5$var$isValidNumber = (value)=>value !== "" && !isNaN(value) ? undefined : "Plese enter a valid number";
/**
 * @param {import('./types').PatternConfig} state
 * @param {{ type: String, payload: String | Number }} action
 * @returns {import('./types').PatternConfig}
 */ const $9a809f6b2076d8a5$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case "arrayTypeChange":
            return {
                ...state,
                arrayType: action.payload
            };
        case "nameChange":
        case "onMountNameChange":
            return {
                ...state,
                name: action.payload
            };
        case "rowCountChange":
        case "onMountRowCountChange":
            {
                const rowValidationMessage = $9a809f6b2076d8a5$var$validate($9a809f6b2076d8a5$var$smallerThan10, $9a809f6b2076d8a5$var$isInteger)(action.payload);
                return rowValidationMessage ? {
                    ...state,
                    rowCount: state.rowCount,
                    error: {
                        type: $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.ROW_COUNT_ERROR,
                        message: rowValidationMessage
                    }
                } : {
                    ...state,
                    rowCount: action.payload,
                    error: {
                        type: "",
                        message: ""
                    }
                };
            }
        case "colCountChange":
        case "onMountColCountChange":
            {
                const colValidationMessage = $9a809f6b2076d8a5$var$validate($9a809f6b2076d8a5$var$smallerThan10, $9a809f6b2076d8a5$var$isInteger)(action.payload);
                return colValidationMessage ? {
                    ...state,
                    colCount: state.colCount,
                    error: {
                        type: $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.COL_COUNT_ERROR,
                        message: colValidationMessage
                    }
                } : {
                    ...state,
                    colCount: action.payload,
                    error: {
                        type: "",
                        message: ""
                    }
                };
            }
        case "rowCountBlur":
            return {
                ...state,
                isRowCountTooHigh: false
            };
        case "colCountBlur":
            return {
                ...state,
                isColCountTooHigh: false
            };
        case "xSpacingChange":
            {
                const xSpacingValidationMessage = $9a809f6b2076d8a5$var$validate($9a809f6b2076d8a5$var$isValidNumber)(action.payload);
                return xSpacingValidationMessage ? {
                    ...state,
                    xSpacing: state.xSpacing,
                    error: {
                        type: $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.X_SPACING_ERROR,
                        message: xSpacingValidationMessage
                    }
                } : {
                    ...state,
                    xSpacing: action.payload,
                    error: {
                        type: "",
                        message: ""
                    }
                };
            }
        case "ySpacingChange":
            {
                const ySpacingValidationMessage = $9a809f6b2076d8a5$var$validate($9a809f6b2076d8a5$var$isValidNumber)(action.payload);
                return ySpacingValidationMessage ? {
                    ...state,
                    ySpacing: state.ySpacing,
                    error: {
                        type: $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.Y_SPACING_ERROR,
                        message: ySpacingValidationMessage
                    }
                } : {
                    ...state,
                    ySpacing: action.payload,
                    error: {
                        type: "",
                        message: ""
                    }
                };
            }
        default:
            return state;
    }
};
/**
 * selectors.
 *
 * @param {Object} state
 * @return {{
 *   isRowCountError: Function,
 *   isColCountError: Function,
 *   isXSpacingError: Function,
 *   isYSpacingError: Function,
 *   getErrorMessage: Function
 * }}
 */ const $9a809f6b2076d8a5$export$e1252723db1c541 = (state)=>{
    const stateErrorType = state?.error?.type;
    return {
        isRowCountError: ()=>stateErrorType === $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.ROW_COUNT_ERROR,
        isColCountError: ()=>stateErrorType === $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.COL_COUNT_ERROR,
        isXSpacingError: ()=>stateErrorType === $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.X_SPACING_ERROR,
        isYSpacingError: ()=>stateErrorType === $9a809f6b2076d8a5$var$PATTERN_CONFIG_ERROR.Y_SPACING_ERROR,
        getErrorMessage: ()=>state?.error?.message || ""
    };
};


// code below was taken largely from https://codesandbox.io/examples/package/react-beautiful-dnd
// Using react-beautiful-dnd with hooks:
// https://codesandbox.io/s/zqwz5n5p9x



function $2bac9713285017a1$export$2e2bcd8739ae039({ items: items , getItemComponent: getItemComponent , onChange: onChange  }) {
    const reorder = (list, startIndex, endIndex)=>{
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    const getItem = (item, index)=>{
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbeautifuldnd.Draggable), {
            draggableId: item.id,
            index: index,
            children: (provided)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    ref: provided.innerRef,
                    ...provided.draggableProps,
                    ...provided.dragHandleProps,
                    children: getItemComponent(index)
                })
        }, item.id);
    };
    const ItemList = /*#__PURE__*/ (0, ($parcel$interopDefault($gXNCa$react))).memo(function ItemList({ items: items  }) {
        return items.map((item, index)=>getItem(item, index));
    });
    function onDragEnd(result) {
        if (!result.destination) return;
        if (result.destination.index === result.source.index) return;
        const newItems = reorder(items, result.source.index, result.destination.index);
        onChange?.(newItems);
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbeautifuldnd.DragDropContext), {
        onDragEnd: onDragEnd,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactbeautifuldnd.Droppable), {
            droppableId: "list",
            children: (provided)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    ref: provided.innerRef,
                    ...provided.droppableProps,
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        style: {
                            overflow: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)(ItemList, {
                                items: items
                            }),
                            provided.placeholder
                        ]
                    })
                })
        })
    });
}



/**
 * useSelectors.
 *
 * @see {https://gist.github.com/fnky/7d044b94070a35e552f3c139cdf80213}
 * @param {Object} state
 * @param {Function} mapStateToSelectors
 */ function $87b495e657dd2654$var$useSelectors(state, mapStateToSelectors) {
    const selectors = (0, $gXNCa$react.useMemo)(()=>mapStateToSelectors(state), [
        state
    ]);
    return selectors;
}
var $87b495e657dd2654$export$2e2bcd8739ae039 = $87b495e657dd2654$var$useSelectors;



function $4efad5d59f3ffac1$var$ArrayEditor({ initialState: initialState , isEditingReferenceFrame: isEditingReferenceFrame , ReferenceFrameCreator_onArrayReferenceFrameEditClick: ReferenceFrameCreator_onArrayReferenceFrameEditClick , ReferenceFrameCreator_onExitArrayReferenceFrameCreate: ReferenceFrameCreator_onExitArrayReferenceFrameCreate , ReferenceFrameCreator_onArrayReferenceFrameToolTipClick: ReferenceFrameCreator_onArrayReferenceFrameToolTipClick , shouldHideEditButton: shouldHideEditButton , shouldHideDuplicateButton: shouldHideDuplicateButton , shouldDisableEditName: shouldDisableEditName , onMount: onMount , onEditFrameDoneClick: onEditFrameDoneClick , onGenerateClick: onGenerateClick , onRegenerateClick: onRegenerateClick , onPatternChange: onPatternChange , onDeleteClick: onDeleteClick , onCopyClick: onCopyClick , robotArrayNamesUsed: robotArrayNamesUsed , onLockedDeleteClick: onLockedDeleteClick , onArrayCardClick: onArrayCardClick , onArrayCardEditClick: onArrayCardEditClick , onArrayNameUpdated: onArrayNameUpdated , style: style , isAdding: isAdding , ...otherProps }) {
    const [step, setStep] = (0, $gXNCa$react.useState)(initialState?.patternConfig && initialState?.arrayArrayPoint2D && initialState?.arrayMatrixReferenceFrame ? "view" : "edit/selectFrame");
    const [patternConfig, setPatternConfig] = (0, $gXNCa$react.useState)(initialState?.patternConfig || (0, $9a809f6b2076d8a5$export$d4c72bab9d6cc13a));
    // Note (alevy): Some good day we want to rename the property of initialState arrayArrayPoint2D to arrayOfPoint2D;
    const [arrayOfPoint2D__pattern, set___arrayOfPoint2D__pattern] = (0, $gXNCa$react.useState)(initialState?.arrayArrayPoint2D || []);
    const [arrayMatrixReferenceFrame, setArrayMatrixReferenceFrame] = (0, $gXNCa$react.useState)(initialState?.arrayMatrixReferenceFrame || []);
    /**
   * @param {import('./types').PatternConfig} patternConfig
   * @return {Array<import('./types').Point2WithIDWithIsSelected>}
   */ const getArrayOfPoint2WithIDWithIsSelected = (patternConfig)=>{
        return $4efad5d59f3ffac1$var$getArrayOfArrayOfPoint2WithID({
            x: 0,
            y: 0
        }, patternConfig.xSpacing, patternConfig.ySpacing, patternConfig.rowCount, patternConfig.colCount).map((items)=>items.map((item)=>({
                    ...item,
                    isSelected: true
                }))).flat();
    };
    /**
   * @param {import('./types').PatternConfig} newPatternConfig
   * @returns {Array<import('./types').Point2WithIDWithIsSelected>}
   */ const updatePattern = (newPatternConfig)=>{
        const arrayOfPoint2WithIDWithIsSelected = getArrayOfPoint2WithIDWithIsSelected(newPatternConfig);
        setPatternConfig({
            ...newPatternConfig
        });
        set___arrayOfPoint2D__pattern(arrayOfPoint2WithIDWithIsSelected);
        return arrayOfPoint2WithIDWithIsSelected;
    };
    /**
   * @param {import('./types').PatternConfig} newPatternConfig
   */ const onGeneratePattern = (newPatternConfig)=>{
        const arrayOfPoint2 = updatePattern(newPatternConfig).filter((item)=>item.isSelected).map(({ x: x , y: y  })=>({
                x: x,
                y: y
            }));
        onGenerateClick?.({
            array: arrayOfPoint2,
            referenceFrame: arrayMatrixReferenceFrame,
            onArrayFrameSet: (referenceFrame)=>{
                return setArrayMatrixReferenceFrame(referenceFrame);
            }
        });
    };
    (0, $gXNCa$react.useEffect)(()=>{
        isAdding && onMount((referenceFrame)=>{
            if (referenceFrame) {
                setArrayMatrixReferenceFrame(referenceFrame);
                setStep("edit/dimensions");
            }
        }, onDeleteClick);
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        containerStyle: {
            position: "relative",
            marginBottom: "0.5rem",
            display: "flex",
            flexDirection: "column",
            ...style || {}
        },
        onClick: (event)=>{
            // dataattribute is used to ensure we're clicking on the parent and not on any children
            if (event.target.attributes.getNamedItem("dataattribute")?.value !== "array-editor-card") return;
            arrayOfPoint2D__pattern.length && onArrayCardClick?.({
                array: arrayOfPoint2D__pattern.filter((item)=>item.isSelected).map(({ x: x , y: y  })=>({
                        x: x,
                        y: y
                    })),
                referenceFrame: arrayMatrixReferenceFrame,
                onArrayFrameSet: setArrayMatrixReferenceFrame
            });
        },
        dataattribute: "array-editor-card",
        children: [
            {
                "edit/selectFrame": /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                    alignItems: "flex-start",
                    padding: "0.65rem 1.5rem 0.65rem 0",
                    backgroundColor: "#FBFBFB",
                    style: {
                        borderLeft: "6px solid #1C344F"
                    },
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                        label: `Select reference frame (origin position of your array) in the 3D workspace.`,
                        labelStyle: {
                            fontWeight: "bold",
                            padding: "30px"
                        }
                    })
                }),
                "edit/dimensions": /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($4efad5d59f3ffac1$var$DimensionsEditor, {
                            selectors: (0, $9a809f6b2076d8a5$export$e1252723db1c541),
                            onGenerateClick: onGeneratePattern,
                            onRegenerateClick: (/** @type {import('./types').PatternConfig} */ state)=>{
                                const array = updatePattern(state).filter((item)=>item.isSelected).map(({ x: x , y: y  })=>({
                                        x: x,
                                        y: y
                                    }));
                                onRegenerateClick({
                                    array: /** @type {import('./types').Point2[]} */ array,
                                    onArrayFrameSet: (referenceFrame)=>{
                                        return setArrayMatrixReferenceFrame(referenceFrame);
                                    },
                                    referenceFrame: arrayMatrixReferenceFrame,
                                    state: state
                                });
                            },
                            initialState: patternConfig,
                            dataattribute: "array-editor-card",
                            ...otherProps,
                            arrayLength: arrayOfPoint2D__pattern.length,
                            onDoneClick: (name)=>{
                                setStep("view");
                                setPatternConfig({
                                    ...patternConfig,
                                    name: name
                                });
                                onEditFrameDoneClick?.({
                                    id: initialState?.id || (0, $8b5d00d1b7e254c5$export$aa1a1894961eafab)(),
                                    arrayArrayPoint2D: arrayOfPoint2D__pattern,
                                    arrayMatrixReferenceFrame: arrayMatrixReferenceFrame,
                                    patternConfig: patternConfig
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            style: {
                                borderBottom: "0.5px solid rgb(160, 160, 160)"
                            }
                        }),
                        arrayOfPoint2D__pattern.length != 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            "data-attribute": "array-editor-card",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $412c4cb105f2bacf$export$2e2bcd8739ae039), {
                                    referenceFrame: {
                                        x: 0,
                                        y: 0
                                    },
                                    isEditingReferenceFrame: isEditingReferenceFrame,
                                    onReferenceFrameCreate: ()=>ReferenceFrameCreator_onArrayReferenceFrameEditClick(arrayOfPoint2D__pattern.filter((item)=>item.isSelected).map(({ x: x , y: y  })=>({
                                                x: x,
                                                y: y
                                            })), setArrayMatrixReferenceFrame, onDeleteClick),
                                    onExitReferenceFrameCreate: ()=>ReferenceFrameCreator_onExitArrayReferenceFrameCreate(onEditFrameDoneClick),
                                    onReferenceFrameToolTipClick: ReferenceFrameCreator_onArrayReferenceFrameToolTipClick
                                }),
                                arrayOfPoint2D__pattern?.filter((item)=>item.isSelected).length && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $2bac9713285017a1$export$2e2bcd8739ae039), {
                                    onChange: (newArrayOfPoint2D__reorderedPattern)=>{
                                        const newArrayOfPoint2D__pattern = [
                                            arrayOfPoint2D__pattern[0],
                                            ...newArrayOfPoint2D__reorderedPattern
                                        ];
                                        onPatternChange?.({
                                            array: newArrayOfPoint2D__pattern.filter((item)=>item.isSelected).map(({ x: x , y: y  })=>({
                                                    x: x,
                                                    y: y
                                                })),
                                            referenceFrame: arrayMatrixReferenceFrame,
                                            onArrayFrameSet: setArrayMatrixReferenceFrame
                                        });
                                        set___arrayOfPoint2D__pattern(newArrayOfPoint2D__pattern);
                                    },
                                    // Note(alevy): the list of draggable items cannot include the reference frame
                                    // because the reference frame is our point of reference in our plain, therefore,
                                    // we don't want the user to drag it around.
                                    items: arrayOfPoint2D__pattern?.slice(1).filter((item)=>item.isSelected),
                                    getItemComponent: (index)=>{
                                        // this offset is due to the list
                                        // of draggable items being smaller
                                        // than the list of array points
                                        const INDEX_OFFSET = 1;
                                        const displayIndex = index + INDEX_OFFSET;
                                        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
                                            containerStyle: {
                                                position: "relative",
                                                margin: "0.5rem 1rem",
                                                padding: "0.65rem 0",
                                                background: "#FAFAFA",
                                                borderLeft: "4px solid #1C344F"
                                            },
                                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                                                dataattribute: "array-editor-card",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                        style: {
                                                            marginRight: "1.5rem"
                                                        },
                                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                                            className: "fas fa-grip-vertical"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                                        label: `Execution point ${displayIndex}`,
                                                        labelStyle: {
                                                            fontWeight: "normal"
                                                        }
                                                    })
                                                ]
                                            })
                                        }, `arrayOfPoint2D__pattern${displayIndex}`);
                                    }
                                })
                            ]
                        })
                    ]
                }),
                view: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                    backgroundColor: "#FAFAFA",
                    alignItems: "center",
                    justifyContent: "space-between",
                    style: {
                        flex: "1"
                    },
                    dataattribute: "array-editor-card",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                    label: "Array Name"
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                    disabled: shouldDisableEditName,
                                    type: "text",
                                    defaultValue: patternConfig.name,
                                    onChange: (e)=>{
                                        setPatternConfig({
                                            ...patternConfig,
                                            name: e.target.value
                                        });
                                        onArrayNameUpdated({
                                            ...initialState,
                                            patternConfig: {
                                                ...patternConfig,
                                                name: e.target.value
                                            }
                                        });
                                    },
                                    onMount: (name)=>{
                                        setPatternConfig({
                                            ...patternConfig,
                                            name: name
                                        });
                                    },
                                    style: {
                                        width: "100%"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                            children: [
                                !shouldHideDuplicateButton && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                    onClick: onCopyClick,
                                    style: {
                                        border: "1px solid #1C344F",
                                        borderRadius: "3px",
                                        color: "#1C344F",
                                        padding: "0.6rem 0.8rem",
                                        fontSize: "14px",
                                        marginRight: "0.5rem"
                                    },
                                    children: "Duplicate"
                                }),
                                !shouldHideEditButton && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                    onClick: ()=>{
                                        setStep("edit/dimensions");
                                        onArrayCardEditClick?.({
                                            array: arrayOfPoint2D__pattern.filter((item)=>item.isSelected).map(({ x: x , y: y  })=>({
                                                    x: x,
                                                    y: y
                                                })),
                                            referenceFrame: arrayMatrixReferenceFrame,
                                            onArrayFrameSet: setArrayMatrixReferenceFrame
                                        });
                                    },
                                    style: {
                                        background: "#1C344F",
                                        borderRadius: "3px",
                                        color: "#FFFFFF",
                                        padding: "0.6rem 2.5rem",
                                        fontSize: "14px"
                                    },
                                    children: "Edit"
                                })
                            ]
                        })
                    ]
                })
            }[step],
            patternConfig.name && robotArrayNamesUsed?.includes(patternConfig.name) ? onLockedDeleteClick && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$3a9efa6242d14e94), {
                style: {
                    padding: "0.25rem"
                },
                onClick: onLockedDeleteClick
            }) : onDeleteClick && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                style: {
                    paddingRight: "0.65rem"
                },
                onClick: onDeleteClick
            })
        ]
    });
}
function $4efad5d59f3ffac1$var$DimensionsEditor({ initialState: initialState , onGenerateClick: onGenerateClick , onRegenerateClick: onRegenerateClick , arrayNames: arrayNames , arrayLength: arrayLength , onDoneClick: onDoneClick , selectors: selectors , ...otherProps }) {
    const [state, dispatch] = (0, $gXNCa$react.useReducer)((0, $9a809f6b2076d8a5$export$1650419e431d3ba3), initialState);
    const { isRowCountError: isRowCountError , isColCountError: isColCountError , isXSpacingError: isXSpacingError , isYSpacingError: isYSpacingError , getErrorMessage: getErrorMessage  } = (0, $87b495e657dd2654$export$2e2bcd8739ae039)(state, selectors);
    const [hasChanges, setHasChanges] = (0, $gXNCa$react.useState)(false);
    const arrayTypes = [
        "Fixed spacings"
    ]; // TODO after demo day filming, implement 'Custom array'
    (0, $gXNCa$react.useEffect)(()=>{
        setHasChanges(!$gXNCa$shallowequal(initialState, state));
    }, [
        initialState,
        state
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        alignItems: "flex-start",
        padding: "0.65rem 1.5rem 0.65rem 0",
        backgroundColor: "#FBFBFB",
        style: {
            borderLeft: "6px solid #1C344F",
            paddingLeft: "0.65rem"
        },
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$31aabcdbfafd6e66), {
                iconClassName: "icon-robot-array"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateColumns: "1fr 1fr 1fr",
                dataattribute: "array-editor-card",
                gridTemplateRows: state.arrayType === arrayTypes[0] ? "1fr 1fr 0.75fr" : "1fr",
                gap: "0.5rem",
                padding: "0",
                style: {
                    gridTemplateAreas: ' "type name rows" "cols space-cols space-rows" ". done generate"',
                    flex: 1,
                    rowGap: 10,
                    paddingLeft: "0.65rem"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                        style: {
                            gridArea: "type"
                        },
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                label: "Array Type"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$4a0738231a72639), {
                                title: "Array Type",
                                optionItems: arrayTypes,
                                onChange: (e)=>dispatch({
                                        type: "arrayTypeChange",
                                        payload: e.target.value
                                    }),
                                onMount: (setSelectedOption)=>{
                                    dispatch({
                                        type: "arrayTypeChange",
                                        payload: state.arrayType
                                    });
                                    setSelectedOption(state.arrayType);
                                }
                            })
                        ]
                    }),
                    state.arrayType && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                                style: {
                                    gridArea: "name"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: "Array Name"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                        type: "text",
                                        defaultValue: state.name || (0, $b7c3f63a1efa4cdf$export$798a797a6d4e253e)("Robot Array", arrayNames || []),
                                        onChange: (e)=>dispatch({
                                                type: "nameChange",
                                                payload: e.target.value
                                            }),
                                        onMount: (name)=>dispatch({
                                                type: "onMountNameChange",
                                                payload: name
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                                style: {
                                    gridArea: "rows"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: "Number of rows"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                        type: "number",
                                        defaultValue: state.rowCount,
                                        valueOnBlur: state.rowCount,
                                        onBlur: ()=>dispatch({
                                                type: "rowCountBlur"
                                            }),
                                        onChange: (e)=>dispatch({
                                                type: "rowCountChange",
                                                payload: Number(e.target.value)
                                            }),
                                        onMount: (rowCount)=>dispatch({
                                                type: "onMountRowCountChange",
                                                payload: rowCount
                                            })
                                    }),
                                    isRowCountError() && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "ml_input_validation_error",
                                        children: getErrorMessage()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                                style: {
                                    gridArea: "cols"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: "Number of columns"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                        type: "number",
                                        defaultValue: state.colCount,
                                        valueOnBlur: state.colCount,
                                        onBlur: ()=>dispatch({
                                                type: "colCountBlur"
                                            }),
                                        onChange: (e)=>dispatch({
                                                type: "colCountChange",
                                                payload: Number(e.target.value)
                                            }),
                                        onMount: (colCount)=>dispatch({
                                                type: "onMountColCountChange",
                                                payload: colCount
                                            })
                                    }),
                                    isColCountError() && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "ml_input_validation_error",
                                        children: getErrorMessage()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                                style: {
                                    gridArea: "space-cols"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: "Space between columns"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                                        unit: "mm",
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $52734ecf42276147$export$2e2bcd8739ae039), {
                                            style: {
                                                height: "auto",
                                                textAlign: "left",
                                                paddingLeft: "0"
                                            },
                                            type: "number",
                                            defaultValue: state.xSpacing,
                                            onChange: (e)=>dispatch({
                                                    type: "xSpacingChange",
                                                    payload: e.target.value
                                                })
                                        })
                                    }),
                                    isXSpacingError() && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "ml_input_validation_error",
                                        children: getErrorMessage()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                                style: {
                                    gridArea: "space-rows"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: "Space between rows"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                                        unit: "mm",
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $52734ecf42276147$export$2e2bcd8739ae039), {
                                            style: {
                                                height: "auto",
                                                textAlign: "left",
                                                paddingLeft: "0"
                                            },
                                            type: "number",
                                            defaultValue: state.ySpacing,
                                            onChange: (e)=>dispatch({
                                                    type: "ySpacingChange",
                                                    payload: e.target.value
                                                })
                                        })
                                    }),
                                    isYSpacingError() && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "ml_input_validation_error",
                                        children: getErrorMessage()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                                style: {
                                    gridArea: "generate",
                                    justifyContent: "end"
                                },
                                gridTemplateColumns: "1fr",
                                gap: "0.5rem",
                                padding: "0",
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                                    children: [
                                        !!arrayLength && !hasChanges && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                            className: "ml_widget_label",
                                            disabled: !arrayLength,
                                            style: {
                                                background: "#1C344F",
                                                borderRadius: "3px",
                                                color: "#FFFFFF",
                                                justifySelf: "end",
                                                alignSelf: "center",
                                                padding: "0.8rem 1.25rem"
                                            },
                                            onClick: ()=>arrayLength && onDoneClick(state.name),
                                            children: "Done"
                                        }),
                                        (!arrayLength || hasChanges) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                            disabled: !onGenerateClick || state.rowCount * state.colCount === 0 || state.xSpacing === 0 && state.ySpacing === 0,
                                            onClick: ()=>{
                                                !arrayLength ? onGenerateClick?.(state) : onRegenerateClick?.(state);
                                            },
                                            className: "ml_widget_label",
                                            style: {
                                                color: "white",
                                                background: "#1AC876",
                                                border: "none",
                                                borderRadius: "3px",
                                                justifySelf: "end",
                                                alignSelf: "center",
                                                padding: "0.8rem 1.25rem"
                                            },
                                            children: !arrayLength ? "Generate array" : "Re-generate array"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/**
 *
 * @param {{
 *   rows: Number,
 *   columns: Number,
 *   defaultValue: any,
 * }} props
 * @returns {any[][]}
 */ // https://stackoverflow.com/a/53993525
const $4efad5d59f3ffac1$var$createAndFillTwoDArray = ({ rows: rows , columns: columns , defaultValue: defaultValue  })=>Array.from({
        length: rows
    }, ()=>Array.from({
            length: columns
        }, ()=>defaultValue));
/** Returns Array of Array of Point 2
 *
 * @param {import('./types').Point2} startPoint
 * @param {Number} xPointDistance
 * @param {Number} yPointDistance
 * @param {Number} xPointCount
 * @param {Number} yPointCount
 * @returns {import('./types').Point2WithID[][]}
 */ function $4efad5d59f3ffac1$var$getArrayOfArrayOfPoint2WithID(startPoint, xPointDistance, yPointDistance, xPointCount, yPointCount) {
    const initialArray = $4efad5d59f3ffac1$var$createAndFillTwoDArray({
        rows: xPointCount,
        columns: yPointCount,
        defaultValue: startPoint
    });
    /**
   * @param {Number} rowIndex
   * @param {Number} colIndex
   * @param {{
   *   x: Number,
   *   y: Number,
   * }} value
   * @returns {import('./types').Point2WithID}
   */ const getTranslatedPoint = (rowIndex, colIndex, value)=>({
            x: rowIndex * xPointDistance + value.x,
            y: colIndex * yPointDistance + value.x,
            id: `id-${rowIndex}-${colIndex}`
        });
    return initialArray.map((e, i)=>e.map((f, j)=>getTranslatedPoint(i, j, f)));
}
var $4efad5d59f3ffac1$export$2e2bcd8739ae039 = $4efad5d59f3ffac1$var$ArrayEditor;








/**
 * @typedef {{
 *   state: import('./types').PatternConfig,
 *   array: import('./types').Point2[],
 *   onArrayFrameSet: (referenceFrame: Object) => void,
 *   referenceFrame: import('./types').ArrayMatrix,
 * }} OnRegenerateClickProps
 */ function $93927e55b73dd707$var$ArraysEditor({ initialState: initialState , shouldShowAddRobotArrayButton: shouldShowAddRobotArrayButton = true , shouldHideDuplicateButton: shouldHideDuplicateButton = false , shouldHideEditButton: shouldHideEditButton = false , shouldDisableEditName: shouldDisableEditName = false , isEditingReferenceFrame: isEditingReferenceFrame , onEditFrameDoneClick: onEditFrameDoneClick , onDeleteClick: onDeleteClick , onCopyClick: onCopyClick , onRegenerateClick: onRegenerateClick , onArrayCardClick: onArrayCardClick , onArraysNameUpdated: onArraysNameUpdated , disableFirstArrayDelete: disableFirstArrayDelete = false , ...otherProps }) {
    /**
   * @type {[import('./types').ArrayEditorState[], (newArrayEditorStates: import('./types').ArrayEditorState[]) => void]}
   */ const [arrayEditorStates, setArrayEditorStates] = (0, $gXNCa$react.useState)(initialState || []);
    const [inEditModeId, setInEditModeId] = (0, $gXNCa$react.useState)(null); // id of the array that is being edited
    const [isAdding, setIsAdding] = (0, $gXNCa$react.useState)(false);
    (0, $gXNCa$react.useEffect)(()=>{
        initialState && setArrayEditorStates(initialState);
    }, [
        initialState
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            arrayEditorStates.map((initialState, /** @type {Number} */ i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $4efad5d59f3ffac1$export$2e2bcd8739ae039), {
                    shouldDisableEditName: shouldDisableEditName,
                    isAdding: isAdding,
                    style: {
                        display: isAdding && inEditModeId === initialState.id ? "inherit" : !isAdding ? "inherit" : "none"
                    },
                    ...otherProps,
                    initialState: initialState,
                    shouldHideDuplicateButton: shouldHideDuplicateButton,
                    shouldHideEditButton: shouldHideEditButton,
                    isEditingReferenceFrame: isEditingReferenceFrame,
                    arrayNames: (arrayEditorStates || []).map((arrayEditorState)=>arrayEditorState?.patternConfig?.name),
                    onEditFrameDoneClick: (state)=>{
                        const newStates = (0, $b7c3f63a1efa4cdf$export$19149de5bd5a5295)(arrayEditorStates, {
                            index: i,
                            item: state
                        });
                        setArrayEditorStates(newStates);
                        onEditFrameDoneClick?.(newStates);
                        setInEditModeId(null);
                        setIsAdding(false);
                    },
                    onDeleteClick: i === 0 && disableFirstArrayDelete ? null : ()=>{
                        const id = arrayEditorStates[i].id;
                        const newStates = (0, $b7c3f63a1efa4cdf$export$fe2d9b4e03920b4c)(arrayEditorStates, {
                            index: i
                        });
                        setArrayEditorStates(newStates);
                        onDeleteClick?.(newStates);
                        id === inEditModeId && setInEditModeId(null);
                        setIsAdding(false);
                    },
                    onCopyClick: ()=>{
                        const newStates = (0, $b7c3f63a1efa4cdf$export$da4743e1585b574b)(arrayEditorStates, {
                            index: i + 1,
                            item: {
                                ...arrayEditorStates[i],
                                id: (0, $8b5d00d1b7e254c5$export$aa1a1894961eafab)(),
                                patternConfig: {
                                    ...arrayEditorStates[i].patternConfig,
                                    name: `${(0, $b7c3f63a1efa4cdf$export$798a797a6d4e253e)("Robot Array", arrayEditorStates.map((el)=>el.patternConfig.name))}`
                                }
                            }
                        });
                        setArrayEditorStates(newStates);
                        onCopyClick?.(newStates);
                    },
                    onRegenerateClick: (/** @type {OnRegenerateClickProps} */ { array: array , referenceFrame: referenceFrame , onArrayFrameSet: onArrayFrameSet , state: state  })=>{
                        /** @type {import("./types").PatternConfig[]} */ const updatedArrayEditorStates = (0, $b7c3f63a1efa4cdf$export$19149de5bd5a5295)(arrayEditorStates, {
                            index: i,
                            item: state
                        });
                        setArrayEditorStates(updatedArrayEditorStates);
                        onRegenerateClick({
                            array: array,
                            referenceFrame: referenceFrame,
                            onArrayFrameSet: onArrayFrameSet,
                            newArrays: updatedArrayEditorStates
                        });
                    },
                    onArrayCardClick: onArrayCardClick,
                    onArrayNameUpdated: (payload)=>{
                        const updatedEditorState = {
                            index: i,
                            item: {
                                ...payload
                            }
                        };
                        const updatedArrayEditorStates = (0, $b7c3f63a1efa4cdf$export$19149de5bd5a5295)(arrayEditorStates, updatedEditorState);
                        setArrayEditorStates(updatedArrayEditorStates);
                        onArraysNameUpdated(updatedArrayEditorStates);
                    }
                }, initialState.id)),
            shouldShowAddRobotArrayButton && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                iconClassName: "icon-add-plus",
                text: "Add robot array",
                disabled: inEditModeId,
                onClick: ()=>{
                    if (!inEditModeId) {
                        const id = (0, $8b5d00d1b7e254c5$export$aa1a1894961eafab)();
                        setArrayEditorStates(arrayEditorStates.concat({
                            id: id
                        }));
                        setInEditModeId(id);
                        setIsAdding(true);
                    }
                }
            })
        ]
    });
}
var $93927e55b73dd707$export$2e2bcd8739ae039 = $93927e55b73dd707$var$ArraysEditor;






function $beb4189ab310535e$export$2e2bcd8739ae039({ arrays: arrays , selectedArrayId: selectedArrayId , onArraySelected: onArraySelected , label: label , onArraySelectorToolTipClick: onArraySelectorToolTipClick  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$c2e9fd968ef47d4), {
                label: label || "Array",
                onClick: ()=>onArraySelectorToolTipClick()
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                title: "Select array",
                optionItems: arrays,
                value: selectedArrayId,
                getOptionValue: (array)=>array?.id,
                getOptionTextContent: (array)=>array?.patternConfig.name,
                onChange: (event)=>onArraySelected(event.target.value),
                onMount: ()=>selectedArrayId || arrays?.length && onArraySelected(arrays[0].id)
            })
        ]
    });
}





function $7c72e01173199087$export$2e2bcd8739ae039({ clips: clips , selectedClipId: selectedClipId , onClipSelected: onClipSelected , onClipMounted: onClipMounted  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: "Robot Path Name"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                "data-cy": "path-selector",
                title: "Select predefined",
                optionItems: clips,
                value: selectedClipId,
                getOptionValue: (clip)=>clip.id,
                getOptionTextContent: (clip)=>clip.name,
                onChange: (event)=>onClipSelected(event.target.value),
                onMount: ()=>onClipMounted(selectedClipId || clips[0].id)
            })
        ]
    });
}






const $8c1dadece72da4af$var$StyledReactTooltip = (0, ($parcel$interopDefault($gXNCa$styledcomponents)))((0, ($parcel$interopDefault($gXNCa$reacttooltip))))`
  background-color: #ffffff !important;
  font-family: Larsseit !important;
  color: #1c344f !important;
  border: 1px solid #eff2f7 !important;
  box-sizing: border-box !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15) !important;
  &.type-dark.place-bottom {
    :after {
      border-bottom-color: #ffffff !important;
    }
  }
`;
function $8c1dadece72da4af$export$f7dc499a72baa103({ children: children  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            "data-tip": true,
            "data-for": "warningTip",
            style: {
                height: "20px",
                width: "20px",
                color: "#FFFFFF",
                backgroundColor: "#D9534F",
                borderRadius: "50%",
                display: "inline-block",
                fontFamily: "Larsseit",
                fontStyle: "normal",
                fontWeight: "normal",
                lineHeight: "1.3em",
                textAlign: "center",
                fontSize: "16px"
            },
            children: [
                "!",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($8c1dadece72da4af$var$StyledReactTooltip, {
                    id: "warningTip",
                    className: "tooltip",
                    place: "bottom",
                    effect: "solid",
                    children: children
                })
            ]
        })
    });
}
function $8c1dadece72da4af$export$1eb2ee5864472e77() {
    (0, ($parcel$interopDefault($gXNCa$reacttooltip))).rebuild();
}











// https://github.com/reactjs/react-modal/issues/232#issuecomment-414104703




const $7c96ca9c229052f1$var$styleOverrides = {
    overlay: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "none",
        pointerEvents: "none"
    },
    content: {
        bottom: "unset",
        overflow: "visible",
        padding: 0,
        border: "none",
        borderRadius: 0,
        position: "static",
        background: "none",
        pointerEvents: "none"
    }
};
function $7c96ca9c229052f1$export$2e2bcd8739ae039({ children: children , isOpen: isOpen , style: style  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$reactmodal))), {
        isOpen: isOpen,
        style: $7c96ca9c229052f1$var$styleOverrides,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$reactdraggable))), {
            handle: ".handle",
            bounds: "html",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "handle",
                style: {
                    pointerEvents: "all",
                    cursor: "move",
                    ...style
                },
                children: children
            })
        })
    });
}



// https://dev.to/alexandprivate/your-next-react-modal-with-your-own-usemodal-hook-context-api-3jg7

var $1f0d5ae97ce3f93a$export$2e2bcd8739ae039 = ()=>{
    let [modal, setModal] = (0, ($parcel$interopDefault($gXNCa$react))).useState(false);
    let [modalContent, setModalContent] = (0, ($parcel$interopDefault($gXNCa$react))).useState("I'm the Modal Content");
    let handleModal = (content = false)=>{
        setModal(!modal);
        if (content) setModalContent(content);
    };
    return {
        modal: modal,
        handleModal: handleModal,
        modalContent: modalContent,
        setModal: setModal
    };
};




// Combinatory logic is a notation to eliminate the need for quantified variables in mathematical logic (source: https://en.wikipedia.org/wiki/Combinatory_logic)
/**
 * returns the curried function f called with its 2 parameters flipped
 *
 * (implementation from https://gist.github.com/Avaq/1f0636ec5c8d6aed2e45)
 *
 * @template X
 * @template Y
 * @template Z
 * @param {(x: X) => (y: Y) => Z} f
 * @returns {(y: Y) => (x: X) => Z}
 */ const $fc4cc7fd1f26364a$export$8a83211c878a3f1f = (f)=>(y)=>(x)=>f(x)(y);
/**
 * returns the first argument it was given
 *
 * (implementation from https://gist.github.com/Avaq/1f0636ec5c8d6aed2e45)
 *
 * @template X
 * @template Y
 * @param {X} x
 * @returns {(y: Y) => X}
 */ // eslint-disable-next-line no-unused-vars
const $fc4cc7fd1f26364a$export$c983f826f44ff86 = (x)=>(y)=>x;
/**
 * returns the curried function f called with g(x) as first parameter and h(x) as second parameter
 *
 * (implementation from https://gist.github.com/Avaq/1f0636ec5c8d6aed2e45)
 *
 * @template X
 * @template G
 * @template H
 * @template F
 * @param {(g: G) => (h: H) => F} f
 * @returns {(g: (x: X) => G) => (h: (x: X) => H) => (x: X) => F}
 */ const $fc4cc7fd1f26364a$export$342c33653c71264 = (f)=>(g)=>(h)=>(x)=>f(g(x))(h(x));


var $cfe42de372e617bc$exports = {};

$parcel$export($cfe42de372e617bc$exports, "updateFromPoseDisplacement", () => $cfe42de372e617bc$export$2e8c804cf36be98);
$parcel$export($cfe42de372e617bc$exports, "updateJointAnglesAtIndex", () => $cfe42de372e617bc$export$c8aaa594a0bf3665);
$parcel$export($cfe42de372e617bc$exports, "isWaypointKeyframe", () => $cfe42de372e617bc$export$40ac058dfb167390);

var $cf5bdb72f7cf2ab5$exports = {};

$parcel$export($cf5bdb72f7cf2ab5$exports, "updateFromPoseDisplacement", () => $cf5bdb72f7cf2ab5$export$2e8c804cf36be98);

/**
 * Inverts matrix.
 *
 * @param {THREE.Matrix4} matrix
 * @returns {THREE.Matrix4}
 */ const $6623923a1bb51858$export$70ae2c07e401031b = (matrix)=>{
    const matrixClone = matrix.clone();
    // eslint-disable-next-line functional/no-expression-statements
    matrixClone.invert();
    return matrixClone;
};
/**
 * Pre-multiplies matrix2 by matrix1.
 *
 * @param {THREE.Matrix4} matrix1
 * @param {THREE.Matrix4} matrix2
 * @returns {THREE.Matrix4}
 */ const $6623923a1bb51858$export$71cf47b8291c00ec = (matrix1, matrix2)=>{
    const matrix2Clone = matrix2.clone();
    // eslint-disable-next-line functional/no-expression-statements
    matrix2Clone.multiply(matrix1);
    return matrix2Clone;
};
/**
 * @param {import('../model/types').ArrayMatrix} arrayMatrix
 * @returns {THREE.Matrix4}
 */ const $6623923a1bb51858$export$6448d436208f8b31 = (arrayMatrix)=>new $gXNCa$three.Matrix4().fromArray(arrayMatrix);


/**
 * @param {import('./types').Keyframe} keyframe
 * @returns {(difference: import('./types').ArrayMatrix | undefined) => import('./types').Keyframe}}
 */ const $cf5bdb72f7cf2ab5$export$2e8c804cf36be98 = (keyframe)=>(poseDisplacement)=>{
        if (!keyframe.waypoint?.pose) return keyframe;
        if (!poseDisplacement) return keyframe;
        return {
            ...keyframe,
            waypoint: {
                ...keyframe.waypoint,
                pose: (0, $6623923a1bb51858$export$71cf47b8291c00ec)((0, $6623923a1bb51858$export$6448d436208f8b31)(keyframe.waypoint.pose), (0, $6623923a1bb51858$export$6448d436208f8b31)(poseDisplacement)).toArray()
            }
        };
    };


var $38a8465f65c74a57$exports = {};

$parcel$export($38a8465f65c74a57$exports, "updateArrayTeachingReferenceFrameByVIDWith", () => $38a8465f65c74a57$export$4d9493d8089bd729);
$parcel$export($38a8465f65c74a57$exports, "updateTeachingReferenceFrameByVIDWith", () => $38a8465f65c74a57$export$9726b7c76651ed3b);
$parcel$export($38a8465f65c74a57$exports, "updateKeyframeByTeachingReferenceFrameVIDWith", () => $38a8465f65c74a57$export$48ad57cf2d29fbc5);
/**
 *
 * @param {import('./types').RobotParameters} robotParameters
 * @param {import('./types').VID} vid
 * @param {import('./types').ArrayMatrix} arrayMatrixOfVIDAssociatedModel
 * @param {(teachingReferenceFrame: import('./types').ArrayTeachingReferenceFrame | undefined) => import('./types').ArrayTeachingReferenceFrame | undefined} update
 */ const $38a8465f65c74a57$export$4d9493d8089bd729 = (robotParameters, vid, arrayMatrixOfVIDAssociatedModel, update)=>{
    robotParameters.arrays.filter((array)=>vid === array.arrayMatrixReferenceFrame.vid).forEach((array)=>{
        array.arrayMatrixReferenceFrame = {
            ...update(array.arrayMatrixReferenceFrame),
            arrayMatrix__vidAssociatedModel_world: arrayMatrixOfVIDAssociatedModel
        };
    });
};
/**
 * @param {import('./types').RobotParameters} robotParameters
 * @param {import('./types').VID} vid
 * @param {(teachingReferenceFrame: import('./types').ClipTeachingReferenceFrame | undefined) => import('./types').ClipTeachingReferenceFrame | undefined} update
 */ const $38a8465f65c74a57$export$9726b7c76651ed3b = (robotParameters, vid, update)=>{
    robotParameters.clips.filter((clip)=>vid === clip.teachingReferenceFrame?.vid).forEach((clip)=>{
        clip.teachingReferenceFrame = update(clip.teachingReferenceFrame);
    });
};
/**
 * @param {import('./types').RobotParameters} robotParameters
 * @param {import('./types').VID} vid
 * @param {(teachingReferenceFrame: import('./types').Keyframe) => import('./types').Keyframe} update
 */ const $38a8465f65c74a57$export$48ad57cf2d29fbc5 = (robotParameters, vid, update)=>{
    robotParameters.clips.filter((clip)=>vid === clip.teachingReferenceFrame?.vid).forEach((clip)=>{
        clip.keyframes = clip.keyframes.map(update);
    });
};


/**
 * @param {import('./types').MachineLogicApplication} application
 * @param {import('./types').ArrayMatrix} poseDisplacement
 * @returns {(vid: import('./types').VID) => void}
 */ const $cfe42de372e617bc$export$2e8c804cf36be98 = (application, poseDisplacement)=>(vid)=>{
        if (!application) return;
        if (!poseDisplacement) return;
        const update = (0, $fc4cc7fd1f26364a$export$8a83211c878a3f1f)($cf5bdb72f7cf2ab5$export$2e8c804cf36be98)(poseDisplacement);
        $38a8465f65c74a57$export$48ad57cf2d29fbc5(application.robotParameters, vid, update);
        application.mSequences.forEach((sequence)=>{
            $38a8465f65c74a57$export$48ad57cf2d29fbc5(sequence.robotParameters, vid, update);
        });
    };
/**
 * @param {import('../model/types').Keyframe[]} keyframes
 * @param {number} index
 * @param {import('../model/types').JointState} jointAngles
 * @returns {import('../model/types').Keyframe[]}
 */ const $cfe42de372e617bc$export$c8aaa594a0bf3665 = (keyframes, index, jointAngles)=>keyframes.map((keyframe, i)=>{
        if (i !== index) return keyframe;
        const updatedWaypoint = {
            ...keyframe.waypoint,
            jointAngles: jointAngles
        };
        return {
            ...keyframe,
            waypoint: updatedWaypoint
        };
    });
/**
 * @param {import('../model/types').Keyframe} keyframe
 * @returns {boolean}
 */ const $cfe42de372e617bc$export$40ac058dfb167390 = (keyframe)=>!!keyframe.waypoint;


var $c9d8763776ebfa1b$exports = {};

$parcel$export($c9d8763776ebfa1b$exports, "updateFromPoseDisplacement", () => $c9d8763776ebfa1b$export$2e8c804cf36be98);




/**
 * Returns an array of reference frames with respect to the world from an array of 2D points which are in reference to `TeachingReferenceFrame__arrayStart`
 * @param {Array<
 *    import('../model/types').Point2
 * >} ArrayOfPoint2D__array array of 2D points which are in reference to `TeachingReferenceFrame__arrayStart`
 * @param {import('../model/types').ArrayTeachingReferenceFrame} TeachingReferenceFrame__arrayStart
 * @returns {Array<import('../model/types').ArrayExecutionReferenceFrame>}
 */ const $0d3588c60e71877c$var$ArrayOfArrayReferenceFrame__fromArrayOfPoint2DxExecutionReferenceFrame = (ArrayOfPoint2D__array, { arrayMatrix__referenceFrame_vidAssociatedModel: arrayMatrix__referenceFrame_vidAssociatedModel , arrayMatrix__vidAssociatedModel_world: arrayMatrix__vidAssociatedModel_world  })=>{
    return ArrayOfPoint2D__array.map(({ x: x , y: y  })=>{
        const Matrix__arrayOrigin_vidAssociatedModel = new $gXNCa$three.Matrix4().fromArray(arrayMatrix__referenceFrame_vidAssociatedModel);
        const Matrix__vidAssociatedModel_world = new $gXNCa$three.Matrix4().fromArray(arrayMatrix__vidAssociatedModel_world);
        const Matrix__arrayPoint_vidAssociatedModel = (0, $6623923a1bb51858$export$71cf47b8291c00ec)(new $gXNCa$three.Matrix4().setPosition(x, y, 0), Matrix__arrayOrigin_vidAssociatedModel);
        const Matrix__arrayPoint_world = (0, $6623923a1bb51858$export$71cf47b8291c00ec)(Matrix__arrayPoint_vidAssociatedModel, Matrix__vidAssociatedModel_world);
        return {
            arrayMatrix__referenceFrame_world: Matrix__arrayPoint_world.toArray()
        };
    });
};
var $0d3588c60e71877c$export$2e2bcd8739ae039 = $0d3588c60e71877c$var$ArrayOfArrayReferenceFrame__fromArrayOfPoint2DxExecutionReferenceFrame;



/**
 * @param {import('./types').CalibrationReferenceFrame | undefined} referenceFrame
 * @returns {(poseDisplacement: import('./types').ArrayMatrix | undefined) => import('./types').CalibrationReferenceFrame | undefined}
 */ const $684e98d8b32554e6$export$2e8c804cf36be98 = (referenceFrame)=>(poseDisplacement)=>{
        if (!referenceFrame) return referenceFrame;
        if (!poseDisplacement) return referenceFrame;
        return {
            ...referenceFrame,
            arrayMatrix__referenceFrame_world: (0, $6623923a1bb51858$export$71cf47b8291c00ec)((0, $6623923a1bb51858$export$6448d436208f8b31)(referenceFrame.arrayMatrix__referenceFrame_world), (0, $6623923a1bb51858$export$6448d436208f8b31)(poseDisplacement)).toArray(),
            arrayMatrix__referenceFrame_robotKinematicsChainRoot: (0, $6623923a1bb51858$export$71cf47b8291c00ec)((0, $6623923a1bb51858$export$6448d436208f8b31)(poseDisplacement), (0, $6623923a1bb51858$export$6448d436208f8b31)(referenceFrame.arrayMatrix__referenceFrame_robotKinematicsChainRoot)).toArray()
        };
    };


var $9d027f087dff6128$exports = {};

$parcel$export($9d027f087dff6128$exports, "updateFromPoseDisplacement", () => $9d027f087dff6128$export$2e8c804cf36be98);

/**
 * @typedef {import('./types').ClipTeachingReferenceFrame | import('./types').InstructionExecutionReferenceFrame | import('./types').ArrayTeachingReferenceFrame} ReferenceFrame
 */ /**
 * @param {ReferenceFrame | undefined} referenceFrame
 * @returns {(poseDisplacement: import('./types').ArrayMatrix | undefined) => ReferenceFrame | undefined}
 */ const $9d027f087dff6128$export$2e8c804cf36be98 = (referenceFrame)=>(poseDisplacement)=>{
        if (!referenceFrame) return referenceFrame;
        if (!poseDisplacement) return referenceFrame;
        return {
            ...referenceFrame,
            arrayMatrix__referenceFrame_world: (0, $6623923a1bb51858$export$71cf47b8291c00ec)((0, $6623923a1bb51858$export$6448d436208f8b31)(referenceFrame.arrayMatrix__referenceFrame_world), (0, $6623923a1bb51858$export$6448d436208f8b31)(poseDisplacement)).toArray()
        };
    };



/**
 * @param {import('./types').MachineLogicApplication} application
 * @param {import('./types').ArrayMatrix} poseDisplacement
 * @param {import('./types').ArrayMatrix} arrayMatrixOfVIDAssociatedModel
 * @returns {(vid: import('./types').VID) => void}
 */ const $c9d8763776ebfa1b$export$2e8c804cf36be98 = (application, poseDisplacement, arrayMatrixOfVIDAssociatedModel)=>(vid)=>{
        if (!application) return;
        if (!poseDisplacement) return;
        const update = (0, $fc4cc7fd1f26364a$export$8a83211c878a3f1f)($9d027f087dff6128$export$2e8c804cf36be98)(poseDisplacement);
        // Robot Arrays
        $38a8465f65c74a57$export$4d9493d8089bd729(application.robotParameters, vid, arrayMatrixOfVIDAssociatedModel, update);
        const getRobotParametersArrayFromInstructionArrayId = (instructionArrayId)=>application.robotParameters?.arrays?.find((array)=>instructionArrayId === array.id);
        application.mSequences.forEach((sequence)=>{
            sequence.mInstructions.filter((instruction)=>instruction.mCategory === "robotLoop" && instruction.mName === "array").filter((instruction)=>{
                const selectedArray = getRobotParametersArrayFromInstructionArrayId(instruction.mParameters.arrayId);
                return selectedArray && vid === selectedArray.arrayMatrixReferenceFrame.vid;
            }).forEach((instruction)=>{
                const selectedArray = getRobotParametersArrayFromInstructionArrayId(instruction.mParameters.arrayId);
                const referenceFrames = (0, $0d3588c60e71877c$export$2e2bcd8739ae039)(selectedArray.arrayArrayPoint2D, selectedArray.arrayMatrixReferenceFrame);
                instruction.mParameters.arrayValue = referenceFrames;
            });
        });
        // Robot Clips
        $38a8465f65c74a57$export$9726b7c76651ed3b(application.robotParameters, vid, update);
        application.mSequences.forEach((sequence)=>{
            $38a8465f65c74a57$export$9726b7c76651ed3b(sequence.robotParameters, vid, update);
        });
        application.mSequences.forEach((sequence)=>{
            sequence.mInstructions.filter((instruction)=>vid === instruction.mParameters.executionReferenceFrame?.vid).forEach((instruction)=>{
                instruction.mParameters.executionReferenceFrame = update(instruction.mParameters.executionReferenceFrame);
            });
        });
        // Calibration Reference Frame
        const calibrationParts = application.robotParameters.calibrationParts;
        const updateCalibrationPartsReferenceFrame = (0, $fc4cc7fd1f26364a$export$8a83211c878a3f1f)($684e98d8b32554e6$export$2e8c804cf36be98)(poseDisplacement);
        application.mSequences.forEach((sequence)=>{
            const instructionsWithCalibrationReferenceFrameWithAssociatedVid = sequence.mInstructions.filter((instruction)=>{
                if (instruction.mParameters.calibrationReferenceFrame?.vid) instruction.mParameters.calibrationReferenceFrame?.vid;
                else return;
            });
            if (instructionsWithCalibrationReferenceFrameWithAssociatedVid.length == 0) return;
            const [instructionsWithCalibrationPartReferenceFrameWithAssociatedVid, instructionsWithRobotBaseCalibrationReferenceFrameWithAssociatedVid] = (0, ($parcel$interopDefault($gXNCa$lodash))).partition(instructionsWithCalibrationReferenceFrameWithAssociatedVid, (i)=>calibrationParts.find((c)=>c.vid === i.mParameters.calibrationReferenceFrame.vid));
            instructionsWithCalibrationPartReferenceFrameWithAssociatedVid.forEach((instruction)=>{
                instruction.mParameters.calibrationReferenceFrame = updateCalibrationPartsReferenceFrame(instruction.mParameters.calibrationReferenceFrame);
            });
            instructionsWithRobotBaseCalibrationReferenceFrameWithAssociatedVid.forEach((instruction)=>{
                instruction.mParameters.calibrationReferenceFrame = update(instruction.mParameters.calibrationReferenceFrame);
            });
        });
    };


/**
 * @param {import('./types').MachineLogicApplication} application
 * @param {import('./types').ArrayMatrix} poseDisplacement
 * @param {import('./types').ArrayMatrix} arrayMatrixOfVIDAssociatedModel
 * @returns {(vid: import('./types').VID) => void}
 */ const $1d3cf5330bb207de$export$2e8c804cf36be98 = (application, poseDisplacement, arrayMatrixOfVIDAssociatedModel)=>(0, $fc4cc7fd1f26364a$export$342c33653c71264)((0, $fc4cc7fd1f26364a$export$c983f826f44ff86))($c9d8763776ebfa1b$export$2e8c804cf36be98(application, poseDisplacement, arrayMatrixOfVIDAssociatedModel))($cfe42de372e617bc$export$2e8c804cf36be98(application, poseDisplacement));
const $1d3cf5330bb207de$export$64c313e59f94d976 = (application)=>(name)=>(0, $b7c3f63a1efa4cdf$exports).getUniqueName(name, [
            ...application.robotParameters.clips,
            ...application.mSequences.map((s)=>s.robotParameters.clips).flat()
        ].map((clip)=>clip.name));
/**
 * @param {import('../model/types').MachineLogicApplication} application
 * @param {import('../model/types').UUID} robotId
 * @param {import('../model/types').ArrayMatrix} endEffectorToolCenterPoint
 */ const $1d3cf5330bb207de$export$3fd6c15374412e0 = (application, robotId, endEffectorToolCenterPoint)=>{
    application.mSequences.forEach((sequence)=>{
        sequence.mInstructions.filter((instruction)=>instruction.getRobotId() === robotId).forEach((instruction)=>{
            // HACK: it seems instruction.setParameter is causing an infinite loop in the debounced function. We will set the parameter directly for now.
            instruction.mParameters["endEffectorToolCenterPoint"] = endEffectorToolCenterPoint;
        });
    });
};
/**
 * @param {import('../model/types').MachineLogicApplication} application
 * @param {(clip: import('../model/types').RobotParametersClip) => import('../model/types').RobotParametersClip} updateClip
 */ const $1d3cf5330bb207de$export$2704a7f0b64bdf92 = (application, updateClip)=>{
    application.setRobotParametersClips(application.robotParameters.clips.map(updateClip));
    application.mSequences.forEach((sequence)=>{
        sequence.setRobotParametersClips(sequence.robotParameters.clips.map(updateClip));
    });
};
// Update robot ID from all ML applications to the robot id in the configuration. This function will need to be revised when multiple robot configurations are allowed.
const $1d3cf5330bb207de$export$f39c10a7b99a6467 = (applications, robotIdFromConfig)=>{
    applications.forEach((app)=>{
        app?.mSequences.forEach((seq)=>{
            seq?.robotParameters.clips.forEach((clip)=>clip.robotId = robotIdFromConfig);
            seq?.mInstructions?.forEach((instr)=>instr.mParameters.robotId = robotIdFromConfig);
        });
        app?.robotParameters.clips.forEach((clip)=>clip.robotId = robotIdFromConfig);
    });
};







var $0c88886b9d748222$export$2e2bcd8739ae039 = {
    MachineLogicRobotApplication: $1d3cf5330bb207de$exports,
    MachineLogicRobotApplicationKeyframe: $cf5bdb72f7cf2ab5$exports,
    MachineLogicRobotApplicationKeyframes: $cfe42de372e617bc$exports,
    MachineLogicRobotApplicationReferenceFrame: $9d027f087dff6128$exports,
    MachineLogicRobotApplicationReferenceFrames: $c9d8763776ebfa1b$exports,
    RobotParameters: $38a8465f65c74a57$exports
};





// https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
function $a2bde123201d8861$var$polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}
// https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
function $a2bde123201d8861$var$describeArc(x, y, radius, startAngle, endAngle) {
    var start = $a2bde123201d8861$var$polarToCartesian(x, y, radius, endAngle);
    var end = $a2bde123201d8861$var$polarToCartesian(x, y, radius, startAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    var d = [
        "M",
        start.x,
        start.y,
        "A",
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y
    ].join(" ");
    return d;
}
// https://github.com/mhnpd/react-loader-spinner/blob/master/src/loader/Oval.js
const $a2bde123201d8861$export$3b0d6d7590275603 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
        style: props.style,
        width: props.width,
        height: props.height,
        viewBox: "0 0 44 44",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": props.label,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("g", {
                transform: "translate(1 1)",
                strokeWidth: "6",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                        stroke: props.secondaryColor,
                        cx: "20",
                        cy: "20",
                        r: props.radius
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                        fill: "none",
                        stroke: props.color,
                        strokeWidth: "6",
                        d: $a2bde123201d8861$var$describeArc(20, 20, props.radius, 0, 90),
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            from: "0 20 20",
                            to: "360 20 20",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
function $a2bde123201d8861$export$92102e06f68899d9({ robotName: robotName , onChange: onChange , style: style  }) {
    const [name, setName] = (0, ($parcel$interopDefault($gXNCa$react))).useState("");
    const [previousName, setPreviousName] = (0, ($parcel$interopDefault($gXNCa$react))).useState("");
    (0, ($parcel$interopDefault($gXNCa$react))).useEffect(function() {
        setName(robotName || "");
    }, [
        robotName
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "ml_parameter v_layout spaced ml_sensor",
        style: {
            marginBottom: "15px",
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "h_layout",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "ml_error_icon icon-help"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        className: "ml_widget_label",
                        children: "Robot Name"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "text",
                className: "ml_parameter_widget truncated_text",
                title: "Robot name",
                value: name,
                maxLength: 30,
                onChange: (event)=>{
                    setName(event.target.value);
                    onChange(event.target.value);
                },
                onFocus: (event)=>{
                    setPreviousName(event.target.value);
                },
                onBlur: (event)=>{
                    if (event.target.value === "" || event.target.value.trim().length === 0) {
                        setName(previousName);
                        onChange(previousName);
                    } else {
                        setName(event.target.value);
                        onChange(event.target.value);
                    }
                }
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "ml_input_validation_error"
            })
        ]
    });
}
function $a2bde123201d8861$export$53e3a918ec73881({ robotTypes: robotTypes , selectedRobotActuatorVID: selectedRobotActuatorVID , getRobotVidsOfType: getRobotVidsOfType , getDisplayName: getDisplayName , disabled: disabled , onChange: onChange  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "ml_parameter v_layout spaced ml_sensor",
        style: {
            marginBottom: "20px"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "h_layout",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "ml_error_icon icon-help"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        className: "ml_widget_label",
                        children: "Robot Model"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "ml_select_widget",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("select", {
                    className: selectedRobotActuatorVID ? "ml_actuators_select_option" : "no_selection",
                    title: "select robot model",
                    value: selectedRobotActuatorVID || "Select",
                    disabled: disabled,
                    onChange: (event)=>{
                        onChange(event.target.value);
                    },
                    "data-cy": "select-robot-model",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                            className: "ml_actuators_select_option",
                            hidden: true,
                            children: "Select"
                        }),
                        robotTypes.map((robotType)=>{
                            const robotActuatorVIDs = getRobotVidsOfType(robotType);
                            if (robotActuatorVIDs.length > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("optgroup", {
                                label: robotType,
                                className: "ml_actuators_select_label",
                                children: robotActuatorVIDs.map((robotActuatorVID)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                                        value: robotActuatorVID,
                                        className: "ml_actuators_select_option",
                                        children: getDisplayName(robotActuatorVID)
                                    }, robotActuatorVID))
                            }, robotType);
                        })
                    ]
                })
            })
        ]
    });
}
const $a2bde123201d8861$export$de1eee5bf3ce169c = {
    Loader: $a2bde123201d8861$export$3b0d6d7590275603,
    RobotName: $a2bde123201d8861$export$92102e06f68899d9
};






function $bfdf450689e65c89$export$2e2bcd8739ae039({ referenceFrames: referenceFrames , selectedReferenceFrame: selectedReferenceFrame , onReferenceFrameSelected: onReferenceFrameSelected , onCalibrationReferenceFrameCollapseToggleClick: onCalibrationReferenceFrameCollapseToggleClick , isCalibrationReferenceFrameOpened: isCalibrationReferenceFrameOpened , onCalibrationReferenceFrameToolTipClick: onCalibrationReferenceFrameToolTipClick  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
        style: {
            margin: "1rem",
            alignItems: "flex-end"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "h_layout",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                        style: {
                            border: "0px",
                            backgroundColor: "transparent",
                            marginRight: "0.2rem"
                        },
                        className: "ml_tooltip_icon ml_label_icon icon-help",
                        onClick: ()=>onCalibrationReferenceFrameToolTipClick()
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                        onClick: onCalibrationReferenceFrameCollapseToggleClick,
                        style: {
                            textAlign: "right",
                            textDecorationLine: "underline",
                            border: "none",
                            background: "none",
                            fontSize: "14px",
                            color: "#667A99",
                            cursor: "pointer",
                            alignSelf: "flex-end"
                        },
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                            children: [
                                "Calibration Frame",
                                " ",
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                    className: isCalibrationReferenceFrameOpened ? "fas fa-chevron-up" : "fas fa-chevron-down"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$reactcollapsible))), {
                open: isCalibrationReferenceFrameOpened,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                    title: "Select reference frame",
                    optionItems: referenceFrames,
                    value: selectedReferenceFrame?.name || "",
                    getOptionValue: (referenceFrame)=>referenceFrame.name,
                    getOptionTextContent: (referenceFrame)=>referenceFrame.name,
                    onChange: (event)=>onReferenceFrameSelected(event.target.value),
                    "data-cy": "select-reference-frame"
                })
            })
        ]
    });
}






// TODO: copied from `vention_assembler`, should be moved to a shared location
/**
 * Configurations for robots for Forward Kinematics(FK) and Inverse Kinematics(IK) by`robot_type`
 *
 * @property { Object } defs
 * @property { number } defs.hid_rel  Hoops id relative to the base of the robot model used by RobotModelInterface
 * @property { Object } DHParameters  Denavit–Hartenberg parameters used by OrocosKDLRobot(see https://en.wikipedia.org/wiki/Denavit–Hartenberg_parameters) with units in m
 * @property { number } startJointAngles Upon inserting the robot in the assembler, these joint angles will be used for the initial configuration of OrocosKDL; subsequently applied to the hoops links.
 */ /**
 * @typedef JoggerDeltas
 * @property {number} jointAngle   in degree
 * @property {number} rotation     in degree
 * @property {number} translation  in millimeter
 */ function $100592030dab1e52$var$generateDigitalIOValuesArray(start, length) {
    return Array.from({
        length: length
    }, (_, index)=>index + start);
}
const $100592030dab1e52$var$defaultJoggerDeltas = {
    jointAngle: 5,
    rotation: 7.5,
    translation: 30
};
/**
 * Returns the values used in the jogger to increase the current position by a given amount.
 * This will be multiplied by the joggerSpeedPercentage.
 *
 * Those values are mostly based on the max values jog_control uses and also manually tweaked to have the similar speed for the robots.
 * UR5_e: https://cdn.shopify.com/s/files/1/1750/5061/files/ur5e-32528_ur_technical_details.pdf?15354598079155669439
 *        Max Speed: Minimum 180deg/sec
 *        I/O port: 500Hz
 *        URSim display updated at 10Hz
 *
 * Usually Half_max_speed multiplied by the delay should be the maximum for the value
 *
 * @param {string} robotType
 * @returns {JoggerDeltas}
 */ function $100592030dab1e52$export$ad234c564cfb367d(robotType) {
    const joggerDeltas = $100592030dab1e52$export$870007c5ab074d14()[robotType]?.joggerDeltas || $100592030dab1e52$var$defaultJoggerDeltas;
    return joggerDeltas;
}
/**
 * Returns the cartesian velocity limit in mm/s
 *
 * @param {string} robotType
 * @returns {number}
 */ function $100592030dab1e52$export$c1a264ee9405bea8(robotType) {
    return $100592030dab1e52$export$870007c5ab074d14()[robotType]?.cartesianVelocityLimit || 1000;
}
function $100592030dab1e52$export$870007c5ab074d14() {
    return {
        ur3_e: {
            defs: [
                {
                    hid_rel: 5
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 7
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            // https://rgl.co.nz/wp-content/uploads/2018/03/UR3e-Fact-Sheet.pdf
            jointLimits: [
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -Infinity,
                    max: Infinity
                }
            ],
            cartesianVelocityLimit: 3000,
            startJointAngles: [
                0,
                -110,
                105,
                -60,
                -70,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 10),
            reachDistanceInMM: 691.14
        },
        ur5_e: {
            defs: [
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 4
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            // https://www.universal-robots.com/media/1807465/ur5e-rgb-fact-sheet-landscape-a4.pdf
            jointLimits: [
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                }
            ],
            cartesianVelocityLimit: 3000,
            startJointAngles: [
                0,
                -110,
                105,
                -60,
                -70,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 10),
            reachDistanceInMM: 1076.98
        },
        ur10_e: {
            defs: [
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 5
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 7
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            // https://www.universal-robots.com/media/1807466/ur10e-rgb-fact-sheet-landscape-a4-125-kg.pdf
            jointLimits: [
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                }
            ],
            cartesianVelocityLimit: 3000,
            startJointAngles: [
                0,
                -110,
                105,
                -60,
                -70,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 10),
            reachDistanceInMM: 1481.27
        },
        ur16_e: {
            defs: [
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 5
                },
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 8
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            // https://www.universal-robots.com/media/1811483/ur16e-rgb-fact-sheet-landscape-a4.pdf
            jointLimits: [
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                }
            ],
            cartesianVelocityLimit: 3000,
            startJointAngles: [
                0,
                -110,
                105,
                -60,
                -70,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 10),
            reachDistanceInMM: 1141.32
        },
        crx10ia: {
            defs: [
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 5
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 4
                }
            ],
            joggerDeltas: {
                jointAngle: 7.5,
                rotation: 7.5,
                translation: 45
            },
            // https://crx.fanucamerica.com/wp-content/uploads/2021/08/CRX-10iA-data-sheet.pdf
            jointLimits: [
                {
                    min: -190,
                    max: 190
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -285,
                    max: 285
                },
                {
                    min: -190,
                    max: 190
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -225,
                    max: 225
                }
            ],
            cartesianVelocityLimit: 2000,
            startJointAngles: [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(1, 20),
            reachDistanceInMM: 1469.21
        },
        crx10ial: {
            defs: [
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 5
                }
            ],
            joggerDeltas: {
                jointAngle: 7.5,
                rotation: 7.5,
                translation: 45
            },
            // https://www.fanuc.eu/~/media/files/pdf/products/robots/robots-datasheets-en/crx/datasheet%20crx-10ial.pdf?la=en
            jointLimits: [
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -270,
                    max: 270
                },
                {
                    min: -190,
                    max: 190
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -190,
                    max: 190
                }
            ],
            cartesianVelocityLimit: 2000,
            startJointAngles: [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(1, 20),
            reachDistanceInMM: 1639.57
        },
        meca500: {
            // TODO: configure their angle limits...
            defs: [
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 5
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            startJointAngles: [
                0,
                0,
                0,
                0,
                0
            ],
            enableMachineLogic: false,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 1)
        },
        "franka-emika-panda": {
            // TODO: configure their angle limits...
            mat_on_parents: false,
            defs: [
                {
                    hid_rel: 87,
                    axis_def: {
                        hid_rel: 87,
                        face_index: 383
                    }
                },
                {
                    hid_rel: 68,
                    axis_def: {
                        hid_rel: 87,
                        face_index: 143
                    } /*  hids_aux: [64, 67, 78, 99], */  /*bone_info: [{ hid_rel: 64, face_index: 28 }] , bone_info: [{ hid_rel: 68, face_index: 268 }] */ 
                },
                {
                    hid_rel: 64,
                    axis_def: {
                        hid_rel: 64,
                        face_index: 9
                    },
                    hids_aux: [
                        67,
                        78,
                        99
                    ]
                },
                {
                    hid_rel: 63,
                    axis_def: {
                        hid_rel: 63,
                        face_index: 27
                    },
                    hids_aux: [
                        62,
                        66,
                        77,
                        98
                    ]
                },
                {
                    hid_rel: 61,
                    axis_def: {
                        hid_rel: 61,
                        face_index: 93
                    },
                    hids_aux: [
                        60,
                        65
                    ]
                },
                {
                    hid_rel: 102,
                    axis_def: {
                        hid_rel: 101,
                        face_index: 52
                    },
                    hids_aux: [
                        100,
                        101,
                        103,
                        104,
                        105
                    ]
                },
                {
                    hid_rel: 72,
                    axis_def: {
                        hid_rel: 72,
                        face_index: 96
                    },
                    hids_aux: [
                        73,
                        74,
                        75,
                        76,
                        89,
                        90,
                        91,
                        92,
                        93,
                        94,
                        95,
                        96,
                        97
                    ]
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            startJointAngles: [
                0,
                0,
                0,
                0,
                0
            ],
            enableMachineLogic: false,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 1)
        },
        "kinova-gen3-lite": {
            defs: [
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 5
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            startJointAngles: [
                -90,
                45,
                120,
                -90,
                -45,
                0
            ],
            enableMachineLogic: false,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 1)
        },
        "kinova-gen3-ultralight-no-vision": {
            defs: [
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 9
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 4
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            startJointAngles: [
                -90,
                45,
                120,
                -180,
                -45,
                45,
                -45
            ],
            enableMachineLogic: false,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 1)
        },
        "kinova-gen3-ultralight-vision": {
            defs: [
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 9
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 5
                },
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 3
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            startJointAngles: [
                -90,
                45,
                120,
                -180,
                -45,
                45,
                -45
            ],
            enableMachineLogic: false,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 1)
        },
        doosan_h2515: {
            defs: [
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 5
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 6
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            // https://ddddppddrrpubblobstr01.blob.core.windows.net/statics/down/211101_DoosanRobotics_ENG_web.pdf
            jointLimits: [
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -125,
                    max: 125
                },
                {
                    min: -160,
                    max: 160
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                }
            ],
            cartesianVelocityLimit: 1000,
            startJointAngles: [
                0,
                -45,
                70,
                -10,
                70,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(1, 16),
            reachDistanceInMM: 1845
        },
        doosan_h2017: {
            defs: [
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 8
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            jointLimits: [
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -125,
                    max: 125
                },
                {
                    min: -160,
                    max: 160
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                },
                {
                    min: -360,
                    max: 360
                }
            ],
            cartesianVelocityLimit: 1000,
            startJointAngles: [
                0,
                -45,
                70,
                -10,
                70,
                0
            ],
            enableMachineLogic: true,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(1, 16),
            reachDistanceInMM: 2045
        },
        "generic-robot": {
            defs: [
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 7
                },
                {
                    hid_rel: 2
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 8
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            startJointAngles: [
                0,
                -110,
                105,
                -60,
                -70,
                0
            ],
            enableMachineLogic: false,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 1)
        },
        eva: {
            defs: [
                {
                    hid_rel: 6
                },
                {
                    hid_rel: 3
                },
                {
                    hid_rel: 4
                },
                {
                    hid_rel: 8
                },
                {
                    hid_rel: 5
                },
                {
                    hid_rel: 7
                }
            ],
            joggerDeltas: $100592030dab1e52$var$defaultJoggerDeltas,
            startJointAngles: [
                180,
                30,
                120,
                0,
                -30,
                0
            ],
            enableMachineLogic: false,
            digitalIOValues: $100592030dab1e52$var$generateDigitalIOValuesArray(0, 1)
        }
    };
}
function $100592030dab1e52$export$185802fd694ee1f5(OrocosKDL) {
    if (undefined == OrocosKDL) {
        // eslint-disable-next-line functional/no-expression-statements
        console.warn("OrocosKDL is unavailable: robots will not be editable.");
        return {};
    }
    return $100592030dab1e52$export$870007c5ab074d14();
}
function $100592030dab1e52$export$8c5250b64895fef2() {
    const robotLinks = $100592030dab1e52$export$870007c5ab074d14();
    return Object.keys(robotLinks).filter((robotType)=>robotLinks[robotType].enableMachineLogic);
}


/**
 * Extract a number from a string and return the number as a number
 * If the string is empty return 0
 * Warning: The string should start with digit, leading whitespace are ignored
 * @param {String} str
 * returns {Number}
 */ var $8741cf8df591a8a9$export$2e2bcd8739ae039 = (str)=>str === "" ? 0 : parseFloat(str);



const $775c0625e2e82dfd$var$moveCursorToEnd = (event)=>{
    const target = event.target;
    const length = target.value.length;
    if (target.type !== "number") setTimeout(()=>{
        target.focus();
        target.setSelectionRange(length, length);
    }, 0);
};
const $775c0625e2e82dfd$var$KeyframeRobotCommand = ({ item: item , robotType: robotType , playState: playState , onKeyframeDeleteClicked: onKeyframeDeleteClicked , onKeyframeRobotCommandChanged: onKeyframeRobotCommandChanged , onKeyframeRobotCommandWaitForTimeTimeChanged: onKeyframeRobotCommandWaitForTimeTimeChanged , onKeyframeRobotCommandSetPayloadWeightChanged: onKeyframeRobotCommandSetPayloadWeightChanged , onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged , onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged  })=>{
    const robotCommandKeyframeOptions = new Map([
        [
            "setPayload",
            "Set Payload"
        ],
        [
            "waitForTime",
            "Wait for amount of time"
        ],
        [
            "setSpeed",
            "Set Speed"
        ]
    ]);
    const robotCommand = item.waitForTime && "waitForTime" || item.setPayload && "setPayload" || item.setSpeed && "setSpeed";
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        containerStyle: {
            position: "relative",
            margin: "0.5rem 1rem",
            padding: "0.65rem 1.5rem 0.65rem 0.65rem",
            background: "#FAFAFA",
            borderLeft: "4px solid #1C344F"
        },
        className: (0, $b7c3f63a1efa4cdf$exports).getRobotInstructionPlayStateClass(playState),
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                alignItems: "center",
                padding: "0",
                backgroundColor: "transparent",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            marginRight: "0.65rem"
                        },
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                            className: "fas fa-grip-vertical"
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gap: "5px",
                        padding: "0",
                        style: {
                            alignItems: "center",
                            flex: "1"
                        },
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: "Choose type of command"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                                        "data-cy": "robot-command-type-select",
                                        value: robotCommand,
                                        optionItems: Array.from(robotCommandKeyframeOptions.keys()),
                                        getOptionTextContent: (option)=>robotCommandKeyframeOptions.get(option),
                                        onClick: (event)=>event.stopPropagation(),
                                        onChange: (event)=>{
                                            onKeyframeRobotCommandChanged(item.index, event.target.value);
                                        }
                                    })
                                ]
                            }),
                            robotCommand === "setPayload" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($775c0625e2e82dfd$var$SetPayloadRobotCommandKeyframe, {
                                item: item,
                                onKeyframeRobotCommandSetPayloadWeightChanged: onKeyframeRobotCommandSetPayloadWeightChanged
                            }),
                            robotCommand === "waitForTime" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($775c0625e2e82dfd$var$WaitForTimeRobotCommandKeyframe, {
                                item: item,
                                onKeyframeRobotCommandWaitForTimeTimeChanged: onKeyframeRobotCommandWaitForTimeTimeChanged
                            }),
                            robotCommand === "setSpeed" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($775c0625e2e82dfd$var$SetSpeedRobotCommandKeyframe, {
                                item: item,
                                robotType: robotType,
                                onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged,
                                onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                style: {
                    paddingRight: "0.65rem"
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    onKeyframeDeleteClicked(item.index);
                }
            })
        ]
    });
};
const $775c0625e2e82dfd$var$WaitForTimeRobotCommandKeyframe = ({ item: item , onKeyframeRobotCommandWaitForTimeTimeChanged: onKeyframeRobotCommandWaitForTimeTimeChanged  })=>{
    const WAIT_FOR_TIME_INPUT_MIN = 1;
    const WAIT_FOR_TIME_INPUT_MAX = 30000000000;
    const onEnterKeyupOrBlur = (targetValue)=>{
        const value = (0, ($parcel$interopDefault($gXNCa$clamp)))((0, $8741cf8df591a8a9$export$2e2bcd8739ae039)(targetValue), WAIT_FOR_TIME_INPUT_MIN, WAIT_FOR_TIME_INPUT_MAX);
        const valueFixed = Number(value.toFixed(0));
        onKeyframeRobotCommandWaitForTimeTimeChanged(item.index, valueFixed);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: "Milliseconds"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                unit: "ms",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                    type: "number",
                    minValue: WAIT_FOR_TIME_INPUT_MIN,
                    maxValue: WAIT_FOR_TIME_INPUT_MAX,
                    defaultValue: item.waitForTime.time,
                    onClick: (event)=>event.stopPropagation(),
                    onKeyUp: (event)=>{
                        if (event.key === "Enter") onEnterKeyupOrBlur(event.target.value);
                    },
                    onFocus: $775c0625e2e82dfd$var$moveCursorToEnd,
                    onBlur: (event)=>onEnterKeyupOrBlur(event.target.value)
                })
            })
        ]
    });
};
const $775c0625e2e82dfd$var$SetPayloadRobotCommandKeyframe = ({ item: item , onKeyframeRobotCommandSetPayloadWeightChanged: onKeyframeRobotCommandSetPayloadWeightChanged  })=>{
    const SET_PAYLOAD_INPUT_MIN = 0;
    const SET_PAYLOAD_INPUT_MAX = 100;
    const onEnterKeyupOrBlur = (targetValue)=>{
        const value = (0, ($parcel$interopDefault($gXNCa$clamp)))((0, $8741cf8df591a8a9$export$2e2bcd8739ae039)(targetValue), SET_PAYLOAD_INPUT_MIN, SET_PAYLOAD_INPUT_MAX);
        const valueFixed = parseFloat(value.toFixed(3));
        onKeyframeRobotCommandSetPayloadWeightChanged(item.index, valueFixed);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: "Kilograms"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                unit: "kg",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                    type: "number",
                    minValue: SET_PAYLOAD_INPUT_MIN,
                    maxValue: SET_PAYLOAD_INPUT_MAX,
                    defaultValue: item.setPayload.weight,
                    onClick: (event)=>event.stopPropagation(),
                    onKeyUp: (event)=>{
                        if (event.key === "Enter") onEnterKeyupOrBlur(event.target.value);
                    },
                    onFocus: $775c0625e2e82dfd$var$moveCursorToEnd,
                    onBlur: (event)=>onEnterKeyupOrBlur(event.target.value)
                })
            })
        ]
    });
};
const $775c0625e2e82dfd$var$SetSpeedRobotCommandKeyframe = ({ item: item , robotType: robotType , onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged , onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged  })=>{
    const cartesianVelocityLimit = (0, $100592030dab1e52$export$c1a264ee9405bea8)(robotType);
    const jointVelocityLimitPercentage = 100;
    const MOVEL_SET_SPEED_INPUT_MIN = 1;
    const MOVEL_SET_SPEED_INPUT_MAX = cartesianVelocityLimit;
    const MOVEJ_SET_SPEED_INPUT_MIN = 1;
    const MOVEJ_SET_SPEED_INPUT_MAX = 100;
    const onMoveLInputEnterKeyupOrBlur = (targetValue)=>{
        const value = (0, ($parcel$interopDefault($gXNCa$clamp)))((0, $8741cf8df591a8a9$export$2e2bcd8739ae039)(targetValue), MOVEL_SET_SPEED_INPUT_MIN, MOVEL_SET_SPEED_INPUT_MAX);
        const valueFixed = Number(value.toFixed(1));
        onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged(item.index, valueFixed / cartesianVelocityLimit);
    };
    const onMoveJInputEnterKeyupOrBlur = (targetValue)=>{
        const value = (0, ($parcel$interopDefault($gXNCa$clamp)))((0, $8741cf8df591a8a9$export$2e2bcd8739ae039)(targetValue), MOVEJ_SET_SPEED_INPUT_MIN, MOVEJ_SET_SPEED_INPUT_MAX);
        const valueFixed = parseFloat(value.toFixed(2));
        onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged(item.index, valueFixed / jointVelocityLimitPercentage);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                        label: "MoveL Speed"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                        unit: "mm/s",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                            type: "number",
                            minValue: MOVEL_SET_SPEED_INPUT_MIN,
                            maxValue: MOVEL_SET_SPEED_INPUT_MAX,
                            defaultValue: Number(item.setSpeed.moveLVelocityScalingFactor * cartesianVelocityLimit).toFixed(1),
                            onClick: (event)=>event.stopPropagation(),
                            onKeyUp: (event)=>{
                                if (event.key === "Enter") onMoveLInputEnterKeyupOrBlur(event.target.value);
                            },
                            onFocus: $775c0625e2e82dfd$var$moveCursorToEnd,
                            onBlur: (event)=>onMoveLInputEnterKeyupOrBlur(event.target.value)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                        label: "MoveJ Speed"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                        unit: "%",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                            type: "number",
                            minValue: MOVEJ_SET_SPEED_INPUT_MIN,
                            maxValue: MOVEJ_SET_SPEED_INPUT_MAX,
                            defaultValue: Number(item.setSpeed.moveJVelocityScalingFactor * jointVelocityLimitPercentage).toFixed(1),
                            onClick: (event)=>event.stopPropagation(),
                            onKeyUp: (event)=>{
                                if (event.key === "Enter") onMoveJInputEnterKeyupOrBlur(event.target.value);
                            },
                            onFocus: $775c0625e2e82dfd$var$moveCursorToEnd,
                            onBlur: (event)=>onMoveJInputEnterKeyupOrBlur(event.target.value)
                        })
                    })
                ]
            })
        ]
    });
};
var $775c0625e2e82dfd$export$2e2bcd8739ae039 = $775c0625e2e82dfd$var$KeyframeRobotCommand;





// https://dev.to/alexandprivate/your-next-react-modal-with-your-own-usemodal-hook-context-api-3jg7



const $d8fcab4c0af78f9a$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, ($parcel$interopDefault($gXNCa$react))).createContext();
const { Provider: $d8fcab4c0af78f9a$var$Provider  } = $d8fcab4c0af78f9a$export$ab57792b9b6974a6;
const $d8fcab4c0af78f9a$export$178405afcd8c5eb = ({ onCloseButtonClick: onCloseButtonClick , children: children , robotJoggerApi: robotJoggerApi , canDisplay: canDisplay  })=>{
    const { modal: modal , handleModal: handleModal , modalContent: modalContent , setModal: setModal  } = (0, $1f0d5ae97ce3f93a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($d8fcab4c0af78f9a$var$Provider, {
        value: {
            modal: modal,
            handleModal: handleModal,
            modalContent: modalContent,
            setModal: setModal
        },
        children: [
            robotJoggerApi && canDisplay && robotJoggerApi.position && robotJoggerApi.rotation && robotJoggerApi.jointAngles && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $7c96ca9c229052f1$export$2e2bcd8739ae039), {
                isOpen: modal,
                style: {
                    width: "500px",
                    background: "#EFF2F7",
                    padding: "0.5rem",
                    border: "1px solid #CFCFCF",
                    boxSizing: "border-box",
                    borderRadius: "3px"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                        "data-cy": "close-jogger-button",
                        onClick: (event)=>{
                            event.stopPropagation();
                            handleModal();
                            onCloseButtonClick();
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fde802728f8fc0c4$export$2e2bcd8739ae039), {
                        jointLimits: robotJoggerApi.jointLimits,
                        position: robotJoggerApi.position,
                        rotation: robotJoggerApi.rotation,
                        jointAngles: robotJoggerApi.jointAngles,
                        onPoseTranslationChange: robotJoggerApi.onPoseTranslationChange,
                        onPoseRotationChange: robotJoggerApi.onPoseRotationChange,
                        onJointAnglesChange: robotJoggerApi.onJointAnglesChange,
                        "data-cy": "jogger"
                    })
                ]
            }),
            children
        ]
    });
};


/**
 * If the string is empty return default name
 * @param {String} str
 * returns {String}
 */ var $ed64c74f8c52d920$export$2e2bcd8739ae039 = (str, index)=>str === "" ? `Waypoint ${index + 1}` : str;


const { getRobotInstructionPlayStateClass: $8ded208236d68f0e$var$getRobotInstructionPlayStateClass  } = (0, $b7c3f63a1efa4cdf$exports);
const $8ded208236d68f0e$export$25f702d5469dfe2d = ({ item: item , moveWithMode: moveWithMode , onPointToPointSelected: onPointToPointSelected , onWaypointConfirmed: onWaypointConfirmed , onWaypointPathTypeChanged: onWaypointPathTypeChanged , onWaypointNameChanged: onWaypointNameChanged , onWaypointEditClicked: onWaypointEditClicked , onWaypointClicked: onWaypointClicked , onKeyframeDeleteClicked: onKeyframeDeleteClicked , onIgnoreReferenceFrameChanged: onIgnoreReferenceFrameChanged , onTriadButtonClick: onTriadButtonClick , onPointToPointButtonClick: onPointToPointButtonClick , onJoggerButtonClick: onJoggerButtonClick , onMoveJToolTipClick: onMoveJToolTipClick , onMoveLToolTipClick: onMoveLToolTipClick , style: style , WarningIcon: WarningIcon , playState: playState , disableEditing: disableEditing  })=>{
    const { setModal: setModal  } = (0, $gXNCa$react.useContext)((0, $d8fcab4c0af78f9a$export$ab57792b9b6974a6));
    const inputRef = (0, $gXNCa$react.useRef)(null);
    const handleClickOutside = (event)=>{
        if (inputRef.current && !inputRef.current.contains(event.target)) inputRef.current.blur();
    };
    (0, $gXNCa$react.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        return ()=>document.removeEventListener("click", handleClickOutside);
    }, []);
    setModal(moveWithMode === "Jogger");
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        onClick: (event)=>{
            event.stopPropagation();
            onWaypointClicked(item.index);
        },
        containerStyle: {
            position: "relative",
            margin: "0.5rem 1rem",
            padding: "0.65rem 2.5rem 0.65rem 0.65rem",
            background: "#FAFAFA",
            borderLeft: "4px solid #1C344F",
            ...style
        },
        className: $8ded208236d68f0e$var$getRobotInstructionPlayStateClass(playState),
        "data-cy": "waypoint-card",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                alignItems: "center",
                padding: "0",
                backgroundColor: "transparent",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                    gridTemplateColumns: "0fr 0.3fr 0.6fr 1fr",
                    gap: "15px",
                    padding: "0",
                    style: {
                        flex: "1",
                        justifyItems: "right",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "fas fa-grip-vertical"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                ref: inputRef,
                                type: "text",
                                defaultValue: item.waypoint.name || `Waypoint ${item.index + 1}`,
                                onBlur: (event)=>{
                                    const waypointName = (0, $ed64c74f8c52d920$export$2e2bcd8739ae039)(event.target.value, item.index);
                                    event?.target?.value && onWaypointNameChanged(item.index, waypointName);
                                },
                                onClick: (event)=>event.stopPropagation(),
                                valueOnBlur: item.waypoint.name,
                                onChange: ()=>{},
                                onMouseOver: (event)=>{
                                    event.target.style.backgroundColor = "white";
                                    event.target.style.border = "solid 1px #CFCFCF";
                                    event.target.style.borderRadius = "0.15rem";
                                },
                                onMouseLeave: (event)=>{
                                    event.target.style.backgroundColor = "transparent";
                                    event.target.style.border = "none";
                                    event.target.style.borderRadius = "0rem";
                                },
                                style: {
                                    border: "none",
                                    width: "180%"
                                },
                                className: "waypoint_name_widget truncated_text",
                                "data-cy": "name-waypoint"
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$c2e9fd968ef47d4), {
                                    label: "Path Type",
                                    style: {
                                        marginRight: "0.5rem"
                                    },
                                    onClick: ()=>{
                                        item.waypoint.pathType === "movel" && onMoveLToolTipClick();
                                        item.waypoint.pathType === "movej" && onMoveJToolTipClick();
                                    }
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                                    "data-cy": "path-type",
                                    title: "Path Type",
                                    style: {
                                        position: "relative",
                                        height: "2.5rem",
                                        float: "left",
                                        fontSize: "0.9rem",
                                        border: "1px solid rgb(207, 207, 207)",
                                        borderRadius: "0.15rem"
                                    },
                                    optionItems: [
                                        "movej",
                                        "movel"
                                    ],
                                    getOptionTextContent: (option)=>{
                                        switch(option){
                                            case "movej":
                                                return "MoveJ";
                                            case "movel":
                                                return "MoveL";
                                        }
                                    },
                                    value: item.waypoint.pathType,
                                    onClick: (event)=>event.stopPropagation(),
                                    onChange: (event)=>onWaypointPathTypeChanged(item.index, event.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            children: !item.isEditing ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                                padding: "0px",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                                        alignItems: "center",
                                        padding: "0",
                                        style: {
                                            marginRight: "2rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                                "data-cy": "fixed-checkbox",
                                                type: "checkbox",
                                                value: item.waypoint?.ignoreReferenceFrame,
                                                checked: item.waypoint?.ignoreReferenceFrame,
                                                onClick: (event)=>event.stopPropagation(),
                                                onChange: (event)=>{
                                                    onIgnoreReferenceFrameChanged(item.index, event.target.checked);
                                                },
                                                style: {
                                                    margin: "0"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                                                style: {
                                                    fontWeight: "normal",
                                                    fontSize: "14px",
                                                    margin: "0 0.5rem"
                                                },
                                                children: "Fixed waypoint"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                        style: {
                                            textAlign: "right",
                                            border: "none",
                                            background: "none",
                                            textDecorationLine: "underline",
                                            fontSize: "14px",
                                            color: "#667A99",
                                            cursor: "pointer"
                                        },
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            onWaypointEditClicked(item.index);
                                        },
                                        disabled: disableEditing,
                                        children: "Edit"
                                    }),
                                    WarningIcon
                                ]
                            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                                padding: "0px",
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                            label: "Move with",
                                            style: {
                                                marginRight: "0.5rem"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                                            padding: "0px",
                                            children: [
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                                                    style: {
                                                        alignItems: "center",
                                                        position: "relative",
                                                        height: "2.5rem",
                                                        float: "left",
                                                        fontSize: "0.9rem",
                                                        border: "1px solid #CFCFCF",
                                                        borderRadius: "0.15rem"
                                                    },
                                                    "data-cy": "select-waypoint-editing-mode",
                                                    title: "Move with",
                                                    optionItems: [
                                                        "Triad",
                                                        "Point to point",
                                                        "Jogger"
                                                    ],
                                                    value: moveWithMode,
                                                    onClick: (e)=>e.stopPropagation(),
                                                    onChange: (e)=>{
                                                        switch(e.target.value){
                                                            case "Triad":
                                                                onTriadButtonClick();
                                                                break;
                                                            case "Point to point":
                                                                onPointToPointButtonClick(onPointToPointSelected);
                                                                break;
                                                            case "Jogger":
                                                                onJoggerButtonClick();
                                                                break;
                                                            default:
                                                                break;
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                                    style: {
                                                        marginLeft: "0.5rem",
                                                        flex: "none",
                                                        background: "#1AC876",
                                                        borderRadius: "3px",
                                                        padding: "0.65rem",
                                                        fontSize: "14px",
                                                        color: "#FFFFFF"
                                                    },
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        onWaypointConfirmed(item.index);
                                                    },
                                                    "data-cy": "confirm-waypoint",
                                                    children: "Confirm waypoint"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                "data-cy": "delete-waypoint",
                style: {
                    paddingRight: "0.65rem"
                },
                onClick: (e)=>{
                    e.stopPropagation();
                    onKeyframeDeleteClicked(item.index);
                }
            })
        ]
    });
};





const { getRobotInstructionPlayStateClass: $09dbe9e4f8df3d60$var$getRobotInstructionPlayStateClass  } = (0, $b7c3f63a1efa4cdf$exports);
function $09dbe9e4f8df3d60$export$2e2bcd8739ae039({ item: item , onClick: onClick , containerStyle: containerStyle , playState: playState , warningIcon: warningIcon  }) {
    function getPathTypeText() {
        switch(item?.waypoint?.pathType){
            case "movel":
                return "MoveL";
            case "movej":
                return "MoveJ";
            default:
                return "";
        }
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        onClick: (event)=>{
            event.stopPropagation();
            onClick();
        },
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
            containerStyle: {
                position: "relative",
                margin: "0.5rem 1rem",
                padding: "18.5px 40px",
                background: "#FAFAFA",
                borderLeft: "4px solid #1C344F",
                ...containerStyle
            },
            className: $09dbe9e4f8df3d60$var$getRobotInstructionPlayStateClass(playState),
            "data-cy": "read-only-waypoint-card",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                alignItems: "center",
                padding: "0",
                backgroundColor: "transparent",
                height: "20px",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "0",
                    padding: "0",
                    style: {
                        flex: "1",
                        justifyItems: "left",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                label: item.waypoint.name || `Waypoint ${item.index + 1}`,
                                labelStyle: {
                                    fontWeight: "normal"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                                padding: "0",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: "Path Type: ",
                                        labelStyle: {
                                            marginRight: "0.5rem"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                        label: getPathTypeText(),
                                        labelStyle: {
                                            fontWeight: "normal"
                                        }
                                    })
                                ]
                            })
                        }),
                        warningIcon
                    ]
                })
            })
        })
    });
}




function $dd025f0f94b30b63$export$2e2bcd8739ae039({ fill: fill = "#F4B73A"  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("svg", {
        width: "15",
        height: "16",
        viewBox: "0 0 15 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("g", {
                clipPath: "url(#clip0_822_4149)",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                    d: "M8.82247 11.5633L6.50216 13.8834C5.01452 15.3716 2.60459 15.3723 1.11622 13.8834C-0.372032 12.3957 -0.372765 9.98579 1.11622 8.49742L3.43624 6.17711C3.47011 6.14324 3.50461 6.11 3.53972 6.07741C3.76091 5.87219 4.11965 6.0187 4.13175 6.32017C4.1374 6.461 4.14927 6.60162 4.16737 6.74157C4.18146 6.85047 4.14552 6.95975 4.06785 7.03735C3.58504 7.51984 1.86642 9.23837 1.8618 9.243C0.785487 10.3199 0.785692 12.061 1.8618 13.1377C2.93872 14.214 4.6798 14.2138 5.75652 13.1377L8.07683 10.8174L8.08738 10.8069C9.15089 9.73249 9.14617 7.99231 8.07654 6.92269C7.8359 6.68204 7.56159 6.49554 7.26839 6.36285C7.13462 6.30232 7.05083 6.16753 7.05938 6.02096C7.06821 5.86907 7.09602 5.71889 7.14218 5.57392C7.20379 5.38053 7.4214 5.28209 7.60855 5.36063C8.05015 5.54591 8.46364 5.81825 8.82247 6.17708C10.3075 7.66211 10.3072 10.0785 8.82247 11.5633ZM6.17708 8.8225C6.53591 9.18133 6.9494 9.45367 7.391 9.63894C7.57814 9.71746 7.79576 9.61902 7.85737 9.42566C7.90352 9.28069 7.93134 9.13051 7.94016 8.97862C7.94872 8.83205 7.8649 8.69726 7.73116 8.63673C7.43796 8.50407 7.16365 8.31757 6.92301 8.07689C5.85338 7.00727 5.84866 5.26709 6.91217 4.19271L6.92271 4.18217L9.24303 1.86185C10.3197 0.785751 12.0608 0.785546 13.1378 1.86185C14.2139 2.93857 14.2141 4.67966 13.1378 5.75658C13.1332 5.76118 11.4145 7.47974 10.9317 7.96223C10.854 8.03986 10.8181 8.14911 10.8322 8.25801C10.8503 8.39788 10.8621 8.53849 10.8678 8.67941C10.8799 8.98091 11.2387 9.12739 11.4598 8.92217C11.4949 8.88958 11.5294 8.85634 11.5633 8.82247L13.8833 6.50216C15.3723 5.01379 15.3716 2.60386 13.8833 1.11622C12.395 -0.372765 9.98503 -0.372032 8.49739 1.11622L6.17708 3.43624C4.69234 4.92106 4.69208 7.3375 6.17708 8.8225Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                d: "M3.979 2.14258L7 5.16357L9.5 5.5L10 8L13.8785 12.0421L12.1833 13.7373L8.5 10L5.5 10L4.75869 6.31264L2.28381 3.83777L3.979 2.14258Z",
                fill: "#FBFBFB"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("line", {
                x1: "2.35355",
                y1: "2.14645",
                x2: "13.3536",
                y2: "13.1464",
                stroke: "#F4B73A"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("clipPath", {
                    id: "clip0_822_4149",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                        width: "15",
                        height: "15",
                        fill: "white"
                    })
                })
            })
        ]
    });
}




function $8f0ef92b0addb015$export$2e2bcd8739ae039({ fill: fill = "#1AC876"  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
            d: "M8.82247 11.5633L6.50216 13.8834C5.01452 15.3716 2.60459 15.3723 1.11622 13.8834C-0.372032 12.3957 -0.372765 9.98579 1.11622 8.49742L3.43624 6.17711C3.47011 6.14324 3.50461 6.11 3.53972 6.07741C3.76091 5.87219 4.11965 6.0187 4.13175 6.32017C4.1374 6.461 4.14927 6.60162 4.16737 6.74157C4.18146 6.85047 4.14552 6.95975 4.06785 7.03735C3.58504 7.51984 1.86642 9.23837 1.8618 9.243C0.785487 10.3199 0.785692 12.061 1.8618 13.1377C2.93872 14.214 4.6798 14.2138 5.75652 13.1377L8.07683 10.8174L8.08738 10.8069C9.15089 9.73249 9.14617 7.99231 8.07654 6.92269C7.8359 6.68204 7.56159 6.49554 7.26839 6.36285C7.13462 6.30232 7.05083 6.16753 7.05938 6.02096C7.06821 5.86907 7.09602 5.71889 7.14218 5.57392C7.20379 5.38053 7.4214 5.28209 7.60855 5.36063C8.05015 5.54591 8.46364 5.81825 8.82247 6.17708C10.3075 7.66211 10.3072 10.0785 8.82247 11.5633ZM6.17708 8.8225C6.53591 9.18133 6.9494 9.45367 7.391 9.63894C7.57814 9.71746 7.79576 9.61902 7.85737 9.42566C7.90352 9.28069 7.93134 9.13051 7.94016 8.97862C7.94872 8.83205 7.8649 8.69726 7.73116 8.63673C7.43796 8.50407 7.16365 8.31757 6.92301 8.07689C5.85338 7.00727 5.84866 5.26709 6.91217 4.19271L6.92271 4.18217L9.24303 1.86185C10.3197 0.785751 12.0608 0.785546 13.1378 1.86185C14.2139 2.93857 14.2141 4.67966 13.1378 5.75658C13.1332 5.76118 11.4145 7.47974 10.9317 7.96223C10.854 8.03986 10.8181 8.14911 10.8322 8.25801C10.8503 8.39788 10.8621 8.53849 10.8678 8.67941C10.8799 8.98091 11.2387 9.12739 11.4598 8.92217C11.4949 8.88958 11.5294 8.85634 11.5633 8.82247L13.8833 6.50216C15.3723 5.01379 15.3716 2.60386 13.8833 1.11622C12.395 -0.372765 9.98503 -0.372032 8.49739 1.11622L6.17708 3.43624C4.69234 4.92106 4.69208 7.3375 6.17708 8.8225Z",
            fill: fill
        })
    });
}




// https://github.com/mhnpd/react-loader-spinner/blob/master/src/loader/Oval.js
const $07d46ce7ddfaf179$var$Loader = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
        style: props.style,
        width: props.width,
        height: props.height,
        viewBox: "0 0 44 44",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": props.label,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("g", {
                transform: "translate(1 1)",
                strokeWidth: "6",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                        stroke: props.secondaryColor,
                        cx: "20",
                        cy: "20",
                        r: props.radius
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                        fill: "none",
                        stroke: props.color,
                        strokeWidth: "6",
                        d: $07d46ce7ddfaf179$var$describeArc(20, 20, props.radius, 0, 90),
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            from: "0 20 20",
                            to: "360 20 20",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
// https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
function $07d46ce7ddfaf179$var$polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}
// https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
function $07d46ce7ddfaf179$var$describeArc(x, y, radius, startAngle, endAngle) {
    var start = $07d46ce7ddfaf179$var$polarToCartesian(x, y, radius, endAngle);
    var end = $07d46ce7ddfaf179$var$polarToCartesian(x, y, radius, startAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    var d = [
        "M",
        start.x,
        start.y,
        "A",
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y
    ].join(" ");
    return d;
}
var $07d46ce7ddfaf179$export$2e2bcd8739ae039 = $07d46ce7ddfaf179$var$Loader;






const { getRobotInstructionPlayStateClass: $105e2418246a892f$var$getRobotInstructionPlayStateClass  } = (0, $b7c3f63a1efa4cdf$exports);
function $105e2418246a892f$export$2e2bcd8739ae039({ item: item , onClick: onClick , robotType: robotType , playState: playState  }) {
    function getRobotCommandLabelFromKeyframe(keyframe) {
        if (keyframe.setPayload) return "Set Payload";
        if (keyframe.waitForTime) return "Wait for amount of time";
        if (keyframe.setSpeed) return "Set Speed";
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        containerStyle: {
            position: "relative",
            margin: "0.5rem 1rem",
            padding: "18.5px 40px",
            background: "#FAFAFA",
            borderLeft: "4px solid #1C344F"
        },
        onClick: onClick,
        className: $105e2418246a892f$var$getRobotInstructionPlayStateClass(playState),
        "data-cy": "read-only-command",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
            alignItems: "center",
            padding: "0",
            backgroundColor: "transparent",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "0px",
                padding: "0",
                style: {
                    alignItems: "center",
                    flex: "1",
                    justifyItems: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                            label: getRobotCommandLabelFromKeyframe(item),
                            labelStyle: {
                                fontWeight: "normal",
                                textTransform: "capitalize"
                            }
                        })
                    }),
                    item.setPayload && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($105e2418246a892f$var$SetPayloadRobotCommandKeyframe, {
                        item: item
                    }),
                    item.waitForTime && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($105e2418246a892f$var$WaitForTimeRobotCommandKeyframe, {
                        item: item
                    }),
                    item.setSpeed && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($105e2418246a892f$var$SetSpeedRobotCommandKeyframe, {
                        item: item,
                        robotType: robotType
                    })
                ]
            })
        })
    });
}
const $105e2418246a892f$var$SetPayloadRobotCommandKeyframe = ({ item: item  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        padding: "0",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: "Kilograms: ",
                labelStyle: {
                    marginRight: "0.5rem"
                }
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: `${item.setPayload.weight} kg`,
                labelStyle: {
                    fontWeight: "normal"
                }
            })
        ]
    });
};
const $105e2418246a892f$var$WaitForTimeRobotCommandKeyframe = ({ item: item  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        padding: "0",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: "Time: ",
                labelStyle: {
                    marginRight: "0.5rem"
                }
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: `${item.waitForTime.time} ms`,
                labelStyle: {
                    fontWeight: "normal"
                }
            })
        ]
    });
};
const $105e2418246a892f$var$SetSpeedRobotCommandKeyframe = ({ item: item , robotType: robotType  })=>{
    const cartesianVelocityLimit = (0, $100592030dab1e52$export$c1a264ee9405bea8)(robotType);
    const jointVelocityLimitPercentage = 100;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                padding: "0",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                        label: "MoveL Speed: ",
                        labelStyle: {
                            marginRight: "0.5rem"
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                        label: `${item.setSpeed.moveLVelocityScalingFactor * cartesianVelocityLimit} mm/s`,
                        labelStyle: {
                            fontWeight: "normal"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                padding: "0",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                        label: "MoveJ Speed: ",
                        labelStyle: {
                            marginRight: "0.5rem"
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                        label: `${item.setSpeed.moveJVelocityScalingFactor * jointVelocityLimitPercentage} %`,
                        labelStyle: {
                            fontWeight: "normal"
                        }
                    })
                ]
            })
        ]
    });
};




const $c4267bb63e057e4f$var$RobotSVGImage = ({ width: width = 78 , height: height = 85  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 78 85",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                opacity: "0.4",
                cx: "63.9624",
                cy: "30.7309",
                r: "14.0376",
                fill: "#D9534F"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                opacity: "0.4",
                cx: "63.9624",
                cy: "30.7309",
                r: "7.20849",
                fill: "#D9534F"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                d: "M5.41867 73.4825L0 84.9807H27.3577L21.4103 73.4825H5.41867Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                d: "M49.1642 28.1506L50.2215 23.2606L53.5256 23.6571L52.0718 27.8863L55.6402 31.4547V33.4371L49.1642 28.1506Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                d: "M60.9888 18.3113L55.9905 18.5285L55.8239 21.8521L60.2377 21.1326L63.153 25.2518L65.1071 25.5862L60.9888 18.3113Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                x: "8.4585",
                y: "29.3401",
                width: "9.51571",
                height: "29.3401",
                fill: "#192F47"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                x: "39.2917",
                y: "4.57845",
                width: "8.46378",
                height: "32.7054",
                transform: "rotate(61.309 39.2917 4.57845)",
                fill: "#192F47"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                x: "55.6117",
                y: "18.5909",
                width: "6.37999",
                height: "16.1124",
                transform: "rotate(136.66 55.6117 18.5909)",
                fill: "#192F47"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                cx: "13.3484",
                cy: "67.0065",
                r: "10.7052",
                fill: "#345172"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                cx: "13.2163",
                cy: "67.1387",
                r: "8.45841",
                fill: "#F4F4F4"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                cx: "13.3488",
                cy: "23.3929",
                r: "10.1765",
                fill: "#345172"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                cx: "13.216",
                cy: "23.5251",
                r: "7.92976",
                fill: "#F4F4F4"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                cx: "41.6311",
                cy: "7.79759",
                r: "7.79759",
                fill: "#345172"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                cx: "41.631",
                cy: "7.79759",
                r: "6.21164",
                fill: "#F4F4F4"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                cx: "53.2614",
                cy: "21.0139",
                r: "3.83272",
                fill: "#F4F4F4"
            })
        ]
    });
};
var $c4267bb63e057e4f$export$2e2bcd8739ae039 = $c4267bb63e057e4f$var$RobotSVGImage;




var $14a8afc1688fc92f$export$2e2bcd8739ae039 = {
    light_grey: "#F2F2F2",
    blueish_grey: "#c1c4ca",
    slider_grey: "#666",
    grey: "#ccc",
    orange: "#FF8000",
    border_color: "#CFCFCF",
    active_tab_color: "#EFF2F7",
    button_held_blue: "#0A121C",
    vention_blue: "#1C344F",
    bright_blue: "#027BE7",
    blue_grey: "#334257",
    line_grey: "#EEF1F5",
    border_grey: "#EFF2F7",
    green: "#1AC776",
    light_green: "#1ADC76",
    bright_green: "#1AC876",
    pale_green: "#E2F0D9",
    dark_green: "#0D261A",
    red: "#800000",
    pale_red: "#f8dbdb",
    pale_orange: "#ffeded",
    switch_off: "#ccc",
    switch_on: "#2196F3",
    scrollbar: "#D4D7DD",
    pale_yellow: "#FEFFEF",
    yellow: "#FEFFC4",
    white: "#FFFFFF",
    header: "#2D3A4D",
    text: "#333333",
    text_light: "#C1C4CA",
    text_warning: "#FFAAAA",
    background_light: "#FFFFFF",
    background_dark: "#E9ECEF",
    subheader_grey: "#D3D9E0",
    divider: "#D2D2D2",
    highlight: "#27B02B",
    disabled: "#A0A0A0",
    frame: "#CCCCCC",
    toolbar: "#EFF2F7",
    toolbar_hover: "#DAE0E9",
    catalog_light: "#F6F8FA",
    catalog_dark: "#DAE0E9",
    success_color: "#1AC876",
    danger_color: "#D9534F",
    greyscale_0: "#FBFBFB",
    green_clicked: "#189C5F",
    green_hover: "#17B169",
    pale_grey: "#A1A1A1",
    secondary_grey: "#88979B"
};


const $6753179537cb99a8$var$WarningSVGImage = ({ fill: fill = (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).yellow_secondary , width: width = "46" , height: height = "39"  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 46 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.5952 34.7378L25.4136 1.3594C24.9035 0.515825 23.9878 0 22.9999 0C22.0121 0 21.0963 0.515735 20.5863 1.3594L0.404832 34.7378C-0.120036 35.606 -0.135579 36.6888 0.364312 37.5714C0.864204 38.4542 1.8019 39 2.8184 39H43.1816C44.1981 39 45.1358 38.4541 45.6356 37.5714C46.1355 36.6887 46.1201 35.606 45.5952 34.7378ZM23.015 11.546C24.1741 11.546 25.1548 12.1981 25.1548 13.3539C25.1548 15.1174 25.0508 17.2662 24.9468 19.415L24.9468 19.4151C24.8428 21.5639 24.7388 23.7126 24.7388 25.476C24.7388 26.3949 23.7283 26.7801 23.015 26.7801C22.0641 26.7801 21.2616 26.3948 21.2616 25.476C21.2616 23.7126 21.1576 21.5638 21.0536 19.415C20.9497 17.2662 20.8457 15.1174 20.8457 13.3539C20.8457 12.1981 21.7966 11.546 23.015 11.546ZM20.7564 31.1074C20.7564 32.3226 21.7372 33.3895 23.0448 33.3895C24.2632 33.3895 25.3034 32.3226 25.3034 31.1074C25.3034 29.8626 24.2632 28.8253 23.0448 28.8253C21.7371 28.8253 20.7564 29.8626 20.7564 31.1074Z",
            fill: fill
        })
    });
};
var $6753179537cb99a8$export$2e2bcd8739ae039 = $6753179537cb99a8$var$WarningSVGImage;


var $c3e57ae7e5dd4d0a$export$2e2bcd8739ae039 = {
    CalibrationReferenceFrameSelector: $bfdf450689e65c89$export$2e2bcd8739ae039,
    KeyframeRobotCommand: $775c0625e2e82dfd$export$2e2bcd8739ae039,
    KeyframeReadOnly: $09dbe9e4f8df3d60$export$2e2bcd8739ae039,
    KeyframeWaypoint: $8ded208236d68f0e$export$25f702d5469dfe2d,
    LinkBrokenIcon: $dd025f0f94b30b63$export$2e2bcd8739ae039,
    LinkIcon: $8f0ef92b0addb015$export$2e2bcd8739ae039,
    Loader: $07d46ce7ddfaf179$export$2e2bcd8739ae039,
    RobotCommandReadOnly: $105e2418246a892f$export$2e2bcd8739ae039,
    RobotSVGImage: $c4267bb63e057e4f$export$2e2bcd8739ae039,
    WarningSVGImage: $6753179537cb99a8$export$2e2bcd8739ae039
};





const $56e9194b077be82d$var$EnableButton = ({ buttonText: buttonText , children: children , disabled: disabled , style: style , onClick: onClick  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$ed53c48188888a22), {
            className: "ml_button_green",
            style: {
                ...style
            },
            text: buttonText || "",
            disabled: disabled,
            onClick: onClick,
            onTouchStart: onClick,
            children: children
        })
    });
};
var $56e9194b077be82d$export$2e2bcd8739ae039 = $56e9194b077be82d$var$EnableButton;






/**
 * @param {Number|String} pInput
 * @returns {Number}
 */ function $e7ddd58468ef3df7$var$formatToNumber(pInput) {
    if (pInput === "") return 0;
    if (typeof pInput === "string") pInput = parseFloat(pInput);
    return parseFloat(pInput.toFixed(2));
}
var $e7ddd58468ef3df7$export$2e2bcd8739ae039 = $e7ddd58468ef3df7$var$formatToNumber;


function $29b14d633b6aaf0e$var$Jogger({ arrowStyle: arrowStyle = {
    border: "none",
    backgroundColor: "transparent"
} , isDisabled: isDisabled , values: values , valueNames: valueNames , valueUnit: valueUnit , onLeftArrowMouseDown: onLeftArrowMouseDown , onRightArrowMouseDown: onRightArrowMouseDown , onLeftArrowMouseUp: onLeftArrowMouseUp , onRightArrowMouseUp: onRightArrowMouseUp  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        flexDirection: "column",
        alignItems: "center",
        style: {
            margin: "0",
            padding: "0",
            gap: "0.8rem"
        },
        children: values.map((value, valueIndex)=>{
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateColumns: "13% 15% 30% 15% 16%",
                gap: "0.8rem",
                padding: "0",
                style: {
                    width: "100%",
                    justifyItems: "end",
                    alignItems: "center",
                    margin: "0.5rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                        className: "ml_widget_label",
                        style: {
                            fontWeight: "700",
                            fontSize: "20px",
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue
                        },
                        children: valueNames[valueIndex]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $be579d7e063d5849$export$945c94aaaae34956), {
                        style: arrowStyle,
                        class: "robot_jogger_arrow_button",
                        disabled: isDisabled,
                        onMouseDown: (event)=>onLeftArrowMouseDown(event, valueIndex),
                        onMouseLeave: (event)=>onLeftArrowMouseUp(event),
                        onMouseUp: (event)=>onLeftArrowMouseUp(event),
                        onTouchStart: (event)=>onLeftArrowMouseDown(event, valueIndex),
                        onTouchEnd: (event)=>onLeftArrowMouseUp(event, valueIndex),
                        "data-cy": "left-jogger-arrow"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$f8f3d5c775bf78be), {
                        unit: valueUnit,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $03137bd1f9354234$export$2e2bcd8739ae039), {
                            type: "number",
                            disabled: true,
                            defaultValue: (0, $e7ddd58468ef3df7$export$2e2bcd8739ae039)(value).toFixed(2),
                            style: {
                                backgroundColor: "white"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $be579d7e063d5849$export$5303cd6ad868b9f1), {
                        style: arrowStyle,
                        class: "robot_jogger_arrow_button",
                        disabled: isDisabled,
                        onMouseDown: (event)=>onRightArrowMouseDown(event, valueIndex),
                        onMouseLeave: (event)=>onRightArrowMouseUp(event),
                        onMouseUp: (event)=>onRightArrowMouseUp(event),
                        onTouchStart: (event)=>onRightArrowMouseDown(event, valueIndex),
                        onTouchEnd: (event)=>onRightArrowMouseUp(event, valueIndex),
                        "data-cy": "right-jogger-arrow"
                    })
                ]
            }, valueNames[valueIndex]);
        })
    });
}
var $29b14d633b6aaf0e$export$2e2bcd8739ae039 = $29b14d633b6aaf0e$var$Jogger;









// https://dev.to/alexandprivate/your-next-react-modal-with-your-own-usemodal-hook-context-api-3jg7
















//NOTE: this slider was copied from @ventionco/robot-components with an update to the slider track's pseudo element
const $855932f7329443e3$var$Slider = (0, ($parcel$interopDefault($gXNCa$styledcomponents))).input`
  -webkit-appearance: none;
  width: 468px;
  height: 9px;
  background: ${(0, $14a8afc1688fc92f$export$2e2bcd8739ae039).grey};
  border-radius: 5px;
  background-image: linear-gradient(
    ${(0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue},
    ${(0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue}
  );
  background-size: 70% 100%;
  background-repeat: no-repeat;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background: ${(0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue};
  }

  &::-moz-range-thumb {
    -webkit-appearance: none;
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background: ${(0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue};
  }

  &::-ms-thumb {
    -webkit-appearance: none;
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background: ${(0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue};
  }

  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }

  &::-moz-range-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }

  &::-ms-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }
`;
var $855932f7329443e3$export$2e2bcd8739ae039 = $855932f7329443e3$var$Slider;



/**
 *
 * @param {{
 *   joggerSpeedPercentage: function,
 *   onSpeedSliderChange: function
 *   sliderMinValue: number,
 *   sliderMaxValue: number
 * }}
 */ function $34a00acdec5d2901$var$RobotJoggerSpeedSlider({ joggerSpeedPercentage: joggerSpeedPercentage , onSpeedSliderChange: onSpeedSliderChange , sliderMinValue: sliderMinValue , sliderMaxValue: sliderMaxValue , isDisabled: isDisabled  }) {
    (0, $gXNCa$react.useEffect)(()=>{
        handleSliderChange({
            target: document.getElementById("slider")
        });
    }, []);
    const scale = $gXNCa$d3scale.scalePow().exponent(2).domain([
        sliderMinValue,
        sliderMaxValue
    ]).range([
        sliderMinValue,
        sliderMaxValue
    ]);
    function handleSliderChange(e) {
        let target = e.target;
        const val = target.value;
        target.style.backgroundSize = (val - sliderMinValue) * 100 / (sliderMaxValue - sliderMinValue) + "% 100%";
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        flexDirection: "column",
        padding: "0",
        style: {
            marginTop: "3rem"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                style: {
                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                    fontSize: "24px",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                    children: "Speed"
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                flexDirection: "row",
                style: {
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                        style: {
                            fontSize: "24px",
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                            position: "absolute",
                            marginRight: "5rem"
                        },
                        children: [
                            Math.floor(scale.invert(joggerSpeedPercentage)),
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $855932f7329443e3$export$2e2bcd8739ae039), {
                        id: "slider",
                        type: "range",
                        min: sliderMinValue,
                        max: sliderMaxValue,
                        step: 0.01,
                        value: scale.invert(joggerSpeedPercentage),
                        onMouseUp: (event)=>event.stopPropagation(),
                        onMouseDown: (event)=>event.stopPropagation(),
                        onMouseMove: (event)=>event.stopPropagation(),
                        onChange: (event)=>{
                            onSpeedSliderChange(scale((0, $e7ddd58468ef3df7$export$2e2bcd8739ae039)(event.target.value)));
                            handleSliderChange(event);
                        },
                        disabled: isDisabled,
                        style: {
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            opacity: isDisabled ? "0.3" : "1",
                            transform: "rotate(-90deg)",
                            position: "absolute"
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                        style: {
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).secondary_grey,
                            fontSize: "17px",
                            fontWeight: "700",
                            lineHeight: "2.85rem",
                            marginLeft: "4rem",
                            textAlign: "center"
                        },
                        children: [
                            "100% ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _",
                            " ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " 0%"
                        ]
                    })
                ]
            })
        ]
    });
}
var $34a00acdec5d2901$export$2e2bcd8739ae039 = $34a00acdec5d2901$var$RobotJoggerSpeedSlider;








const $5819304b003fef34$export$d5af2b03920283 = Object.freeze([
    "J1",
    "J2",
    "J3",
    "J4",
    "J5",
    "J6"
]);
const $5819304b003fef34$export$106db0f93c0de794 = Object.freeze([
    "X",
    "Y",
    "Z"
]);
const $5819304b003fef34$export$8c91cbcb2abce402 = Object.freeze([
    "Rx",
    "Ry",
    "Rz"
]);
const $5819304b003fef34$var$axisLabels = Object.freeze([
    "x",
    "y",
    "z"
]);
/**
 * @param {0 | 1 | 2} index
 * @returns {'x' | 'y' | 'z'} The axis label
 */ function $5819304b003fef34$var$getAxisLabelFromIndex(index) {
    // @ts-ignore
    return $5819304b003fef34$var$axisLabels[index];
}
/**
 * @param {-1|1} sign
 * @param {Number} maxDelta
 * @param {Number} percentage The percentage of the max delta. [0-100]
 */ function $5819304b003fef34$var$calculateDelta(sign, maxDelta, percentage) {
    return sign * (percentage / 100) * maxDelta;
}
const $5819304b003fef34$export$813029107829d08e = ({ joggerSpeedPercentage: joggerSpeedPercentage , robotType: robotType , onJoggerJointArrowMouseDown: onJoggerJointArrowMouseDown , onJoggerArrowMouseUp: onJoggerArrowMouseUp , onJoggerPoseRotationMouseDown: onJoggerPoseRotationMouseDown , onJoggerPoseTranslationMouseDown: onJoggerPoseTranslationMouseDown  })=>{
    const joggerDeltas = (0, $100592030dab1e52$export$ad234c564cfb367d)(robotType);
    Object.freeze(joggerDeltas);
    /**
   * @param {0 | 1 | 2 | 3 | 4 | 5} index The index of the joint in the array of joint angles to be increased by delta.
   * @param {-1|1} sign Used to decide if the delta is incremented or decremented
   */ function onJointArrowMouseDown(index, sign) {
        const delta = $5819304b003fef34$var$calculateDelta(sign, joggerDeltas.jointAngle, joggerSpeedPercentage);
        onJoggerJointArrowMouseDown(index, delta);
    }
    /**
   * @param {0 | 1 | 2} index
   * @param {-1 | 1} sign Used to decide if the delta is incremented or decremented
   */ function onRotationArrowMouseDown(index, sign) {
        const delta = $5819304b003fef34$var$calculateDelta(sign, joggerDeltas.rotation, joggerSpeedPercentage);
        onJoggerPoseRotationMouseDown($5819304b003fef34$var$getAxisLabelFromIndex(index), delta);
    }
    /**
   * @param {0 | 1 | 2} index
   * @param {-1 | 1} sign Used to decide if the delta is incremented or decremented
   */ function onTranslationArrowMouseDown(index, sign) {
        const delta = $5819304b003fef34$var$calculateDelta(sign, joggerDeltas.translation, joggerSpeedPercentage);
        onJoggerPoseTranslationMouseDown($5819304b003fef34$var$getAxisLabelFromIndex(index), delta);
    }
    function onArrowMouseUp() {
        onJoggerArrowMouseUp();
    }
    return {
        onJointArrowMouseDown: onJointArrowMouseDown,
        onRotationArrowMouseDown: onRotationArrowMouseDown,
        onTranslationArrowMouseDown: onTranslationArrowMouseDown,
        onArrowMouseUp: onArrowMouseUp
    };
};


function $c6c8dfaca663abb7$var$RobotJoggerArrows({ position: position , rotation: rotation , jointAngles: jointAngles , joggerSpeedPercentage: joggerSpeedPercentage , isFreedriveRunning: isFreedriveRunning , robotType: robotType , onJoggerJointArrowMouseDown: onJoggerJointArrowMouseDown , onJoggerArrowMouseUp: onJoggerArrowMouseUp , onJoggerPoseTranslationMouseDown: onJoggerPoseTranslationMouseDown , onJoggerPoseRotationMouseDown: onJoggerPoseRotationMouseDown  }) {
    const { onJointArrowMouseDown: onJointArrowMouseDown , onRotationArrowMouseDown: onRotationArrowMouseDown , onTranslationArrowMouseDown: onTranslationArrowMouseDown , onArrowMouseUp: onArrowMouseUp  } = (0, $5819304b003fef34$export$813029107829d08e)({
        joggerSpeedPercentage: joggerSpeedPercentage,
        robotType: robotType,
        onJoggerJointArrowMouseDown: onJoggerJointArrowMouseDown,
        onJoggerArrowMouseUp: onJoggerArrowMouseUp,
        onJoggerPoseTranslationMouseDown: onJoggerPoseTranslationMouseDown,
        onJoggerPoseRotationMouseDown: onJoggerPoseRotationMouseDown
    });
    const arrowStyle = {
        border: "none",
        backgroundColor: "transparent",
        opacity: isFreedriveRunning ? "0.3" : "1",
        cursor: isFreedriveRunning ? "not-allowed" : "pointer"
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                className: "ml_widget_label",
                style: {
                    textAlign: "center",
                    fontSize: "24px",
                    fontWeight: "700",
                    padding: "0px",
                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                    left: "50px"
                },
                children: "Joint Jogging"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                flexDirection: "column",
                alignItems: "center",
                padding: "0",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                        className: "ml_widget_label",
                        style: {
                            fontSize: "24px",
                            fontWeight: "700",
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue
                        },
                        children: "Cartesian Jogging"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                        style: {
                            fontWeight: "400",
                            fontSize: "14px",
                            fontStyle: "italic",
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).pale_grey,
                            marginTop: "0.75rem"
                        },
                        children: "with reference to robot base"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $29b14d633b6aaf0e$export$2e2bcd8739ae039), {
                    isDisabled: isFreedriveRunning,
                    arrowStyle: arrowStyle,
                    values: jointAngles,
                    valueNames: (0, $5819304b003fef34$export$d5af2b03920283),
                    valueUnit: "\xb0",
                    onLeftArrowMouseDown: (event, index)=>{
                        event.stopPropagation();
                        onJointArrowMouseDown(index, -1);
                    },
                    onRightArrowMouseDown: (event, index)=>{
                        event.stopPropagation();
                        onJointArrowMouseDown(index, 1);
                    },
                    onLeftArrowMouseUp: (event)=>{
                        event.stopPropagation();
                        onArrowMouseUp();
                    },
                    onRightArrowMouseUp: (event)=>{
                        event.stopPropagation();
                        onArrowMouseUp();
                    }
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                flexDirection: "column",
                style: {
                    gap: "0.8rem"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $29b14d633b6aaf0e$export$2e2bcd8739ae039), {
                        isDisabled: isFreedriveRunning,
                        arrowStyle: arrowStyle,
                        values: Object.values(position.mP),
                        valueNames: (0, $5819304b003fef34$export$106db0f93c0de794),
                        valueUnit: "mm",
                        onLeftArrowMouseDown: (event, index)=>{
                            event.stopPropagation();
                            onTranslationArrowMouseDown(index, -1);
                        },
                        onRightArrowMouseDown: (event, index)=>{
                            event.stopPropagation();
                            onTranslationArrowMouseDown(index, 1);
                        },
                        onLeftArrowMouseUp: (event)=>{
                            event.stopPropagation();
                            onArrowMouseUp();
                        },
                        onRightArrowMouseUp: (event)=>{
                            event.stopPropagation();
                            onArrowMouseUp();
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $29b14d633b6aaf0e$export$2e2bcd8739ae039), {
                        isDisabled: isFreedriveRunning,
                        arrowStyle: arrowStyle,
                        values: Object.values(rotation.mP),
                        valueNames: (0, $5819304b003fef34$export$8c91cbcb2abce402),
                        valueUnit: "\xb0",
                        onLeftArrowMouseDown: (event, index)=>{
                            event.stopPropagation();
                            onRotationArrowMouseDown(index, -1);
                        },
                        onRightArrowMouseDown: (event, index)=>{
                            event.stopPropagation();
                            onRotationArrowMouseDown(index, 1);
                        },
                        onLeftArrowMouseUp: (event)=>{
                            event.stopPropagation();
                            onArrowMouseUp();
                        },
                        onRightArrowMouseUp: (event)=>{
                            event.stopPropagation();
                            onArrowMouseUp();
                        }
                    })
                ]
            })
        ]
    });
}
var $c6c8dfaca663abb7$export$2e2bcd8739ae039 = $c6c8dfaca663abb7$var$RobotJoggerArrows;





const $eaff80254f7223d6$export$55e0fae517e6c4b0 = ()=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("image", {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "214",
            height: "240",
            viewBox: "0 0 215 256",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                    x: "0.630371",
                    y: "0.526855",
                    width: "214.338",
                    height: "254.964",
                    rx: "4.2027",
                    fill: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                    d: "M84.6376 120.377V117.508H75.6046V133.198H84.6376V130.329H78.6753V126.563H83.8306V123.717H78.6753V120.377H84.6376ZM92.8777 121.587C91.3759 121.587 90.3224 122.372 89.8069 123.313L89.6052 121.834H87.1172V133.198H90.0086V127.191C90.0086 125.286 90.9052 124.412 92.0035 124.412C93.1018 124.412 93.6622 125.129 93.6622 126.451V133.198H96.5536V125.824C96.5536 123.246 95.2984 121.587 92.8777 121.587ZM103.655 121.587C100.965 121.587 99.2614 123.268 99.1269 125.577H101.929C101.929 124.658 102.691 124.075 103.655 124.075C104.708 124.075 105.246 124.658 105.246 125.801V126.25L102.31 126.765C100.292 127.101 98.7907 127.953 98.7907 130.172C98.7907 132.212 100.225 133.445 102.243 133.445C103.856 133.445 104.887 132.727 105.493 131.808L105.672 133.198H108.16V125.734C108.16 122.955 106.322 121.587 103.655 121.587ZM102.982 128.648L105.246 128.177V128.513C105.246 129.074 105.089 129.634 104.843 130.015C104.439 130.688 103.744 131.046 103.027 131.046C102.153 131.046 101.682 130.598 101.682 129.925C101.682 129.163 102.22 128.827 102.982 128.648ZM113.824 123.089V116.835H110.932V133.198H113.42L113.622 131.674C114.272 132.593 115.303 133.445 117.253 133.445C120.302 133.445 122.521 130.844 122.521 127.505C122.521 124.165 120.302 121.587 117.231 121.587C115.595 121.587 114.407 122.26 113.824 123.089ZM116.648 124.299C118.24 124.299 119.517 125.555 119.517 127.505C119.517 129.477 118.284 130.732 116.648 130.732C115.214 130.732 113.757 129.612 113.757 127.572V127.437C113.779 125.42 115.236 124.299 116.648 124.299ZM127.658 133.198V116.835H124.766V133.198H127.658ZM140.807 127.482C140.807 123.493 138.543 121.587 135.54 121.587C132.155 121.587 129.891 124.098 129.891 127.527C129.891 131.113 132.178 133.445 135.54 133.445C138.274 133.445 140.045 132.032 140.74 129.634H137.916C137.602 130.508 136.75 130.957 135.607 130.957C134.016 130.957 132.985 129.903 132.895 128.401H140.807V127.482ZM132.895 126.406C133.029 124.994 133.993 123.986 135.473 123.986C136.907 123.986 137.849 124.927 137.893 126.406H132.895ZM67.156 147.377V144.508H58.2575V160.198H61.3282V153.787H66.2594V150.918H61.3282V147.377H67.156ZM75.0798 151.613V148.722C73.1298 148.722 72.1435 149.663 71.7401 150.649L71.4935 148.834H68.9831V160.198H71.897V154.393C71.9194 153.384 72.278 152.712 72.816 152.308C73.466 151.77 74.1608 151.613 75.0798 151.613ZM87.0586 154.482C87.0586 150.493 84.7947 148.587 81.7912 148.587C78.4066 148.587 76.1428 151.098 76.1428 154.527C76.1428 158.113 78.429 160.445 81.7912 160.445C84.5258 160.445 86.2965 159.032 86.9913 156.634H84.1671C83.8533 157.508 83.0016 157.957 81.8584 157.957C80.267 157.957 79.236 156.903 79.1463 155.401H87.0586V154.482ZM79.1463 153.406C79.2808 151.994 80.2446 150.986 81.724 150.986C83.1585 150.986 84.0999 151.927 84.1447 153.406H79.1463ZM99.5572 154.482C99.5572 150.493 97.2934 148.587 94.2899 148.587C90.9053 148.587 88.6414 151.098 88.6414 154.527C88.6414 158.113 90.9277 160.445 94.2899 160.445C97.0244 160.445 98.7952 159.032 99.49 156.634H96.6658C96.352 157.508 95.5002 157.957 94.3571 157.957C92.7657 157.957 91.7346 156.903 91.645 155.401H99.5572V154.482ZM91.645 153.406C91.7794 151.994 92.7433 150.986 94.2226 150.986C95.6571 150.986 96.5985 151.927 96.6434 153.406H91.645ZM112.133 144.508H106.26V160.198H112.133C117.086 160.198 120.247 156.993 120.247 152.353C120.247 147.713 117.086 144.508 112.133 144.508ZM109.331 147.377H112.133C115.271 147.377 117.064 149.193 117.064 152.353C117.064 155.513 115.248 157.329 112.133 157.329H109.331V147.377ZM128.752 151.613V148.722C126.802 148.722 125.816 149.663 125.412 150.649L125.166 148.834H122.655V160.198H125.569V154.393C125.591 153.384 125.95 152.712 126.488 152.308C127.138 151.77 127.833 151.613 128.752 151.613ZM132.298 143.768C131.334 143.768 130.549 144.53 130.549 145.494C130.549 146.48 131.334 147.22 132.298 147.22C133.284 147.22 134.068 146.48 134.068 145.494C134.068 144.53 133.284 143.768 132.298 143.768ZM133.754 160.198V148.834H130.863V160.198H133.754ZM142.532 160.198L146.634 148.834H143.518L141.277 155.827L141.053 156.813L140.828 155.827L138.587 148.834H135.471L139.573 160.198H142.532ZM158.154 154.482C158.154 150.493 155.89 148.587 152.887 148.587C149.502 148.587 147.238 151.098 147.238 154.527C147.238 158.113 149.525 160.445 152.887 160.445C155.621 160.445 157.392 159.032 158.087 156.634H155.263C154.949 157.508 154.097 157.957 152.954 157.957C151.363 157.957 150.332 156.903 150.242 155.401H158.154V154.482ZM150.242 153.406C150.377 151.994 151.34 150.986 152.82 150.986C154.254 150.986 155.196 151.927 155.24 153.406H150.242Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("g", {
                    clipPath: "url(#clip0_3437_19692)",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                        d: "M105.855 70.0335C105.863 70.0335 105.869 70.0335 105.877 70.0335C105.885 70.0335 105.891 70.0335 105.899 70.0335C105.936 70.0335 105.973 70.0335 106.012 70.0335C105.975 70.0335 105.938 70.0335 105.899 70.0335C105.891 70.0335 105.885 70.0335 105.877 70.0335H105.855ZM106.012 70.0335C106.026 70.0335 106.04 70.0335 106.055 70.0335C106.981 70.015 107.889 69.8339 108.748 69.5047V69.5067L106.012 70.0335ZM111.784 67.4533V74.1178C113.12 74.9531 114.016 76.484 114.016 78.2288V86.6463H117.374C120.977 86.6463 123.909 89.7224 123.909 93.5022V95.714H87.4863V93.5022C87.4863 89.7224 90.4184 86.6463 94.0212 86.6463H97.1749V78.2288C97.1749 76.4613 98.0928 74.914 99.4558 74.0869V66.799C100.266 67.8504 101.305 68.7022 102.496 69.266V73.5293H108.746V69.5047C109.902 69.0602 110.937 68.3524 111.786 67.4533H111.784ZM110.715 54.4041C112.332 55.6202 113.512 57.4308 113.961 59.5254L122.279 55.0317L120.439 50.5441L110.715 54.4041V54.4041ZM101.248 76.7185C100.648 76.9325 100.215 77.5272 100.215 78.2288V86.4426H110.978V78.2288C110.978 77.5272 110.545 76.9305 109.945 76.7185H101.248V76.7185ZM90.6517 92.5269H120.745C120.337 90.9775 118.98 89.8356 117.376 89.8356H94.0212C92.4169 89.8356 91.0597 90.9775 90.6517 92.5269V92.5269ZM127.47 73.1877L127.449 70.0252L119.867 74.6918L127.51 79.2473L127.49 76.4078C137.716 74.9572 145.626 65.7393 145.626 54.6202C145.626 43.5546 137.795 34.3716 127.641 32.8531L127.939 30.0281L119.888 33.7317L126.97 39.1946L127.306 36.0259C135.941 37.3674 142.586 45.1965 142.586 54.6223C142.586 63.9883 136.024 71.7762 127.469 73.1918L127.47 73.1877ZM120.19 47.2335C120.569 46.0669 121.373 45.0525 122.51 44.4722L124.658 43.3776C125.752 42.82 126.99 42.7418 128.141 43.1575C129.293 43.5731 130.218 44.4373 130.752 45.5874L134.868 54.4679C135.4 55.6161 135.474 56.9144 135.076 58.1222C134.678 59.33 133.856 60.3012 132.762 60.8608L130.614 61.9554C129.983 62.2764 129.306 62.439 128.624 62.439C128.122 62.439 127.62 62.3505 127.131 62.1735C125.98 61.7559 125.054 60.8937 124.521 59.7456L123.654 57.8753L114.003 63.0912C113.251 67.0438 109.903 70.0335 105.901 70.0335C101.346 70.0335 97.6397 66.1632 97.6397 61.4081C97.6397 56.6531 101.345 52.7828 105.901 52.7828C106.001 52.7828 106.101 52.7848 106.201 52.789L120.19 47.2335V47.2335ZM105.899 55.972C103.019 55.972 100.678 58.4102 100.678 61.4081C100.678 64.406 103.019 66.8442 105.899 66.8442C108.778 66.8442 111.119 64.406 111.119 61.4081C111.119 58.4102 108.778 55.972 105.899 55.972V55.972ZM105.928 64.2167C107.509 64.2167 108.795 62.8711 108.795 61.2168C108.795 59.5625 107.509 58.2168 105.928 58.2168C104.347 58.2168 103.061 59.5625 103.061 61.2168C103.061 62.8711 104.347 64.2167 105.928 64.2167ZM126.649 46.0833C126.421 46.0833 126.196 46.1368 125.986 46.2438L123.838 47.3384C123.473 47.5257 123.199 47.8487 123.067 48.252C122.936 48.6553 122.96 49.0874 123.136 49.4701L127.253 58.3506C127.429 58.7333 127.739 59.0213 128.124 59.1592C128.508 59.2971 128.92 59.2724 129.285 59.0851L131.432 57.9905C131.797 57.8033 132.072 57.4802 132.203 57.0769C132.334 56.6737 132.311 56.2416 132.134 55.8589L128.018 46.9784C127.841 46.5957 127.531 46.3076 127.147 46.1677C126.984 46.108 126.815 46.0792 126.649 46.0792V46.0833Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("clipPath", {
                        id: "clip0_3437_19692",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                            width: "58.8378",
                            height: "65.8423",
                            fill: "white",
                            transform: "translate(87.4863 29.9458)"
                        })
                    })
                })
            ]
        })
    });
};
const $eaff80254f7223d6$export$a3039299a222d6ea = ({ height: height , width: width , ToggleBackground: ToggleBackground , TextColor: TextColor , ...otherProps })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
        ...otherProps,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height,
            viewBox: "0 0 94 51",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                    cx: "68.3636",
                    cy: "26.212",
                    r: "21.3636",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("g", {
                    clipPath: "url(#clip0_3437_20787)",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                        d: "M27.8469 0.575684H66.7613C81.7778 0.575684 94.001 11.7433 94.001 25.4719C94.001 39.2005 81.7778 50.3681 66.7613 50.3681H27.8469C12.8304 50.3681 0.607285 39.2005 0.607285 25.4719C0.607285 11.7433 12.8304 0.575684 27.8469 0.575684ZM68.9327 45.5889C80.0749 45.5889 89.1365 36.5787 89.1365 25.4984C89.1365 14.418 80.0749 5.40943 68.9327 5.40943C57.7906 5.40943 48.7274 14.4195 48.7274 25.4984C48.7274 36.5772 57.789 45.5889 68.9327 45.5889Z",
                        fill: ToggleBackground
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                    d: "M20.0956 18.3895C16.2108 18.3895 13.475 21.1801 13.475 24.992C13.475 28.8221 16.2108 31.6309 20.0956 31.6309C23.9623 31.6309 26.6981 28.8221 26.6981 24.992C26.6981 21.1801 23.9623 18.3895 20.0956 18.3895ZM20.0956 20.7241C22.5214 20.7241 24.1082 22.5297 24.1082 24.992C24.1082 27.4725 22.5214 29.2963 20.0956 29.2963C17.6516 29.2963 16.0649 27.4725 16.0649 24.992C16.0649 22.5297 17.6516 20.7241 20.0956 20.7241ZM39.3718 31.3938V18.6266H36.8731V27.2718L36.3441 26.3781L31.1096 18.6266H28.6291V31.3938H31.1278V22.8216L31.6203 23.6605L36.8913 31.3938H39.3718Z",
                    fill: TextColor
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("clipPath", {
                        id: "clip0_3437_20787",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                            width: "94",
                            height: "49.8485",
                            fill: "white",
                            transform: "matrix(-1 0 0 1 94 0.575684)"
                        })
                    })
                })
            ]
        })
    });
};
const $eaff80254f7223d6$export$291e5412ac462041 = ({ height: height , width: width , ToggleColor: ToggleColor , ToggleBackground: ToggleBackground , TextColor: TextColor , ...otherProps })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
        ...otherProps,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width,
            height: height,
            viewBox: "0 0 93 50",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("circle", {
                    cx: "24.786",
                    cy: "24.5562",
                    r: "21.714",
                    fill: ToggleColor
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("g", {
                    clipPath: "url(#clip0_3437_19698)",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                        d: "M65.3389 0.0405273H27.0622C12.2918 0.0405273 0.268982 11.0251 0.268982 24.5287C0.268982 38.0323 12.2918 49.0169 27.0622 49.0169H65.3389C80.1093 49.0169 92.1321 38.0323 92.1321 24.5287C92.1321 11.0251 80.1093 0.0405273 65.3389 0.0405273ZM24.9264 44.316C13.9669 44.316 5.05376 35.4535 5.05376 24.5548C5.05376 13.656 13.9669 4.79505 24.9264 4.79505C35.8859 4.79505 44.8005 13.6575 44.8005 24.5548C44.8005 35.452 35.8874 44.316 24.9264 44.316V44.316Z",
                        fill: ToggleBackground
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                    d: "M56.5684 17.6637C52.6893 17.6637 49.9575 20.4501 49.9575 24.2564C49.9575 28.0808 52.6893 30.8854 56.5684 30.8854C60.4292 30.8854 63.161 28.0808 63.161 24.2564C63.161 20.4501 60.4292 17.6637 56.5684 17.6637ZM56.5684 19.9948C58.9905 19.9948 60.5749 21.7978 60.5749 24.2564C60.5749 26.7332 58.9905 28.5543 56.5684 28.5543C54.128 28.5543 52.5436 26.7332 52.5436 24.2564C52.5436 21.7978 54.128 19.9948 56.5684 19.9948ZM72.3192 20.2316V17.9005H65.0892V30.6487H67.5842V25.4401H71.5907V23.109H67.5842V20.2316H72.3192ZM81.2472 20.2316V17.9005H74.0172V30.6487H76.5122V25.4401H80.5187V23.109H76.5122V20.2316H81.2472Z",
                    fill: TextColor
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("clipPath", {
                        id: "clip0_3437_19698",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("rect", {
                            width: "92.4595",
                            height: "49.0315",
                            fill: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                            transform: "translate(0.270264 0.0405273)"
                        })
                    })
                })
            ]
        })
    });
};
function $eaff80254f7223d6$export$263016ca0ed42b1b({ onToggleConstraintButtonClick: onToggleConstraintButtonClick , freedriveConstraintState: freedriveConstraintState  }) {
    const constraint = freedriveConstraintState;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            backgroundColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).light_grey,
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.15)",
            width: "200px",
            height: "250px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr 1fr 1fr",
            paddingTop: "15px",
            paddingBottom: "25px",
            borderRadius: "3px"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    fontSize: "18px",
                    gridColumn: "1 / 3",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    paddingBottom: "15px",
                    fontWeight: "410"
                },
                children: "Constrained Control Settings"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontWeight: "400"
                },
                children: [
                    "X",
                    constraint[0] === 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$a3039299a222d6ea, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(0);
                        }
                    }),
                    constraint[0] === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$291e5412ac462041, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(0);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "400"
                },
                children: [
                    "RX",
                    constraint[3] === 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$a3039299a222d6ea, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(3);
                        }
                    }),
                    constraint[3] === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$291e5412ac462041, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(3);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontWeight: "400"
                },
                children: [
                    "Y",
                    constraint[1] === 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$a3039299a222d6ea, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(1);
                        }
                    }),
                    constraint[1] === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$291e5412ac462041, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(1);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "400"
                },
                children: [
                    "RY",
                    constraint[4] === 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$a3039299a222d6ea, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(4);
                        }
                    }),
                    constraint[4] === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$291e5412ac462041, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(4);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontWeight: "400"
                },
                children: [
                    "Z",
                    constraint[2] === 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$a3039299a222d6ea, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(2);
                        }
                    }),
                    constraint[2] === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$291e5412ac462041, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(2);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "400"
                },
                children: [
                    "RZ",
                    constraint[5] === 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$a3039299a222d6ea, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(5);
                        }
                    }),
                    constraint[5] === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($eaff80254f7223d6$export$291e5412ac462041, {
                        height: 36,
                        width: 56,
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: "transparent",
                        style: {
                            border: "none",
                            background: "none",
                            paddingLeft: "5px",
                            paddingTop: "5px"
                        },
                        onClick: ()=>{
                            onToggleConstraintButtonClick(5);
                        }
                    })
                ]
            })
        ]
    });
}


function $60e84f2912cbb71e$var$RobotJogger({ position: position , rotation: rotation , jointAngles: jointAngles , joggerSpeedPercentage: joggerSpeedPercentage , freedriveStatus: freedriveStatus , robotType: robotType , teachWaypointAndCloseButtonText: teachWaypointAndCloseButtonText , robotJoggerTitle: robotJoggerTitle , onJoggerPoseTranslationMouseDown: onJoggerPoseTranslationMouseDown , onJoggerPoseRotationMouseDown: onJoggerPoseRotationMouseDown , onJoggerJointArrowMouseDown: onJoggerJointArrowMouseDown , onJoggerArrowMouseUp: onJoggerArrowMouseUp , onSpeedSliderChange: onSpeedSliderChange , onTeachWaypointAndCloseButtonClick: onTeachWaypointAndCloseButtonClick , onCloseButtonClick: onCloseButtonClick , onEnableFreedriveButtonClick: onEnableFreedriveButtonClick , onDisableFreedriveButtonClick: onDisableFreedriveButtonClick , onToggleConstraintButtonClick: onToggleConstraintButtonClick  }) {
    const buttonRef = (0, $gXNCa$react.useRef)(null);
    // reference: https://github.com/adobe/react-spectrum/issues/1513
    (0, $gXNCa$react.useEffect)(()=>{
        buttonRef.current?.addEventListener("touchstart", (event)=>{
            event.preventDefault();
        });
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
        gridTemplateRows: "129px 675px 129px",
        gridTemplateColumns: "1fr",
        height: "933px",
        width: "1528px",
        padding: "0px",
        style: {
            fontFamily: "Larsseit"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                style: {
                    gridColumn: "1/span 2",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transparent",
                    padding: "0px"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                    style: {
                        fontSize: "42px",
                        color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        lineHeight: "50px",
                        top: "20px",
                        fontWeight: "bold",
                        textAlign: "center",
                        width: "100%",
                        padding: "0px"
                    },
                    children: robotJoggerTitle
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateColumns: "45rem 12rem 12rem",
                gridTemplateRows: "1fr",
                padding: "0px",
                top: "100px",
                style: {
                    fontFamily: "Larsseit",
                    justifyContent: "center",
                    backgroundColor: "transparent"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                        gridTemplateColumns: "50% 50%",
                        gridTemplateRows: "50px 625px",
                        padding: "0px",
                        style: {
                            justifyContent: "center",
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $c6c8dfaca663abb7$export$2e2bcd8739ae039), {
                            position: position,
                            rotation: rotation,
                            jointAngles: jointAngles,
                            joggerSpeedPercentage: joggerSpeedPercentage,
                            isFreedriveRunning: freedriveStatus.running,
                            robotType: robotType,
                            onJoggerJointArrowMouseDown: onJoggerJointArrowMouseDown,
                            onJoggerArrowMouseUp: onJoggerArrowMouseUp,
                            onJoggerPoseTranslationMouseDown: onJoggerPoseTranslationMouseDown,
                            onJoggerPoseRotationMouseDown: onJoggerPoseRotationMouseDown
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $34a00acdec5d2901$export$2e2bcd8739ae039), {
                        joggerSpeedPercentage: joggerSpeedPercentage,
                        onSpeedSliderChange: onSpeedSliderChange,
                        sliderMinValue: 1,
                        sliderMaxValue: 100,
                        isDisabled: freedriveStatus.running
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                        flexDirection: "column",
                        style: {
                            alignItems: "center",
                            marginTop: "3rem"
                        },
                        width: "100%",
                        backgroundColor: "transparent",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$55e0fae517e6c4b0), {}),
                            !freedriveStatus.running && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$291e5412ac462041), {
                                height: "3rem",
                                width: "4rem",
                                ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                                ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                                TextColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                                onClick: onEnableFreedriveButtonClick,
                                style: {
                                    position: "absolute",
                                    top: "360px",
                                    border: "none",
                                    background: "none"
                                },
                                "data-cy": "toggle-off-free-drive"
                            }),
                            freedriveStatus.running && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$a3039299a222d6ea), {
                                height: "3rem",
                                width: "4rem",
                                ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                                ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                                TextColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                                onClick: onDisableFreedriveButtonClick,
                                style: {
                                    position: "absolute",
                                    top: "360px",
                                    border: "none",
                                    background: "none"
                                },
                                "data-cy": "toggle-on-free-drive"
                            }),
                            freedriveStatus.running && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$263016ca0ed42b1b), {
                                freedriveConstraintState: freedriveStatus.constraints,
                                onToggleConstraintButtonClick: onToggleConstraintButtonClick
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                style: {
                    backgroundColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).border_grey,
                    gridColumn: "1/span 2",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: [
                    onCloseButtonClick,
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                        ref: buttonRef,
                        style: {
                            padding: "0.75em 3em",
                            textAlign: "center",
                            background: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                            borderRadius: "3px",
                            border: "none",
                            fontSize: "21px",
                            fontWeight: "700",
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white
                        },
                        onClick: onTeachWaypointAndCloseButtonClick,
                        onTouchStart: onTeachWaypointAndCloseButtonClick,
                        "data-cy": "teach-waypoint-button",
                        children: teachWaypointAndCloseButtonText
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            right: "242px",
                            bottom: "56px",
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
                            height: "20",
                            viewBox: "0 0 58 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M28.7185 15.7251L57.4369 0.315188H0L28.7185 15.7251Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $60e84f2912cbb71e$export$2e2bcd8739ae039 = $60e84f2912cbb71e$var$RobotJogger;





function $a89ab9e959a7fd4f$var$RobotJoggerDisabledOverlay({ children: children  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            background: "rgba(28, 52, 79, 0.5)",
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: "1",
            display: "flex",
            flexFlow: "column",
            justifyContent: "center"
        },
        children: children
    });
}
var $a89ab9e959a7fd4f$export$2e2bcd8739ae039 = $a89ab9e959a7fd4f$var$RobotJoggerDisabledOverlay;




const $cdf6ac17ab4b4848$var$reactModalLikeStyle = {
    border: "none",
    background: "rgb(255, 255, 255)",
    overflow: "visible",
    borderRadius: "3px",
    outline: "none",
    padding: "0px",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 14px",
    width: "737px",
    height: "237px",
    alignSelf: "center"
};
const $cdf6ac17ab4b4848$var$RobotDriverStateCard = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: $cdf6ac17ab4b4848$var$reactModalLikeStyle,
        children: children
    });
};
var $cdf6ac17ab4b4848$export$2e2bcd8739ae039 = $cdf6ac17ab4b4848$var$RobotDriverStateCard;






const $47a96663c6a20f63$var$minHeight = "11.85rem";
const $47a96663c6a20f63$var$headlineHeight = "90px";
const $47a96663c6a20f63$export$4bcb76552286dcbd = {
    overlay: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgb(28, 52, 79, 0.5)",
        zIndex: 1003
    },
    content: {
        bottom: "unset",
        overflow: "visible",
        padding: 0,
        border: "none",
        borderRadius: "3px",
        boxShadow: "0px 2px 14px rgba(0, 0, 0, 0.2)",
        width: "36.85rem",
        minHeight: $47a96663c6a20f63$var$minHeight,
        height: "auto",
        position: "unset"
    }
};
const $47a96663c6a20f63$export$703f7527c5d336fe = {
    backgroundColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).border_grey,
    height: $47a96663c6a20f63$var$headlineHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};
const $47a96663c6a20f63$export$f42854936a63861e = {
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: `calc(${$47a96663c6a20f63$var$minHeight} - ${$47a96663c6a20f63$var$headlineHeight})`
};
const $47a96663c6a20f63$export$22401119b2a9d1b1 = {
    fontSize: "1.2rem",
    fontFamily: "Larsseit",
    fontWeight: 700
};
const $47a96663c6a20f63$export$6482c9f711b887cf = {
    fontSize: "0.9rem",
    fontFamily: "Larsseit",
    fontWeight: 400
};




const $63fa3fc88f964c51$var$buttonStyleOverrides = {
    border: "none",
    borderRadius: "3px",
    width: "14rem",
    padding: "0.5rem",
    fontWeight: "700",
    fontFamily: "Larsseit",
    position: "relative"
};
const $63fa3fc88f964c51$var$RobotReadyStateNotReadyBody = ({ buttonText: buttonText , isLoading: isLoading , message: message , title: title , onClick: onClick  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: (0, $47a96663c6a20f63$export$703f7527c5d336fe),
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h2", {
                    style: (0, $47a96663c6a20f63$export$22401119b2a9d1b1),
                    children: title || ""
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: (0, $47a96663c6a20f63$export$f42854936a63861e),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                        style: (0, $47a96663c6a20f63$export$6482c9f711b887cf),
                        children: [
                            " ",
                            message || "",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $56e9194b077be82d$export$2e2bcd8739ae039), {
                        buttonText: buttonText,
                        disabled: isLoading,
                        style: $63fa3fc88f964c51$var$buttonStyleOverrides,
                        onClick: onClick,
                        children: isLoading && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $a2bde123201d8861$export$3b0d6d7590275603), {
                            style: {
                                position: "absolute",
                                right: "0",
                                top: "0",
                                margin: "0.4em 0.4em"
                            },
                            type: "Oval",
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).light_green,
                            secondaryColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).light_grey,
                            height: 36,
                            width: 36,
                            radius: 18
                        })
                    })
                ]
            })
        ]
    });
};
var $63fa3fc88f964c51$export$2e2bcd8739ae039 = $63fa3fc88f964c51$var$RobotReadyStateNotReadyBody;








function $083dbba1d7d21bc0$var$RobotJoggerDisabledOverlayRobotDisconnectedBody({ onVerifyButtonClick: onVerifyButtonClick  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        style: {
            background: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).yellow_secondary,
            margin: "15px",
            width: "fit-content",
            padding: "5px 24px",
            borderRadius: "3px",
            alignSelf: "center",
            alignItems: "center",
            fontFamily: "Larsseit"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $6753179537cb99a8$export$2e2bcd8739ae039), {
                fill: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                width: "20.79",
                height: "18px"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    color: "white",
                    fontWeight: "700",
                    fontSize: "15px",
                    margin: "0 0.5rem"
                },
                children: "Robot is not connected. Verify your Machine Configuration to jog."
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                style: {
                    background: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                    fontSize: "15px",
                    fontWeight: "700",
                    borderRadius: "3px",
                    border: "none",
                    padding: "2px 10px"
                },
                onClick: onVerifyButtonClick,
                children: "Verify"
            })
        ]
    });
}
var $083dbba1d7d21bc0$export$2e2bcd8739ae039 = $083dbba1d7d21bc0$var$RobotJoggerDisabledOverlayRobotDisconnectedBody;


const $e4328fa0a7dc23c8$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, ($parcel$interopDefault($gXNCa$react))).createContext();
const { Provider: $e4328fa0a7dc23c8$var$Provider  } = $e4328fa0a7dc23c8$export$ab57792b9b6974a6;
const $e4328fa0a7dc23c8$var$styleOverrides = {
    overlay: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgb(28, 52, 79, 0.5)",
        zIndex: 2
    },
    content: {
        bottom: "unset",
        overflow: "visible",
        padding: 0,
        border: "none",
        borderRadius: "3px",
        boxShadow: "0px 2px 14px rgba(0, 0, 0, 0.2)",
        width: "1528px",
        height: "933px",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
};
const $e4328fa0a7dc23c8$export$178405afcd8c5eb = ({ canDisplay: canDisplay , children: children , onCloseButtonClick: onCloseButtonClick , robotJoggerApi: robotJoggerApi , robotType: robotType , robotJoggerTitle: robotJoggerTitle , shouldDisplayModal: shouldDisplayModal = ()=>true , shouldDisplayRobotJoggerRobotDisconnectedOverlay: shouldDisplayRobotJoggerRobotDisconnectedOverlay , shouldDisplayRobotJoggerRobotNotReadyOverlay: shouldDisplayRobotJoggerRobotNotReadyOverlay , tooltip: tooltip , dispatch: dispatch  })=>{
    const { modal: modal , handleModal: handleModal , modalContent: modalContent , setModal: setModal  } = (0, $1f0d5ae97ce3f93a$export$2e2bcd8739ae039)();
    const DeleteButton = ()=>{
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
            style: {
                padding: "0.7em 5em",
                textAlign: "center",
                background: "none",
                borderRadius: "3px",
                borderStyle: "solid",
                borderColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                fontSize: "21px",
                fontWeight: "700",
                color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                marginRight: "50px"
            },
            onClick: (event)=>{
                event.stopPropagation();
                handleModal();
                onCloseButtonClick();
            },
            onTouchStart: (event)=>{
                event.stopPropagation();
                handleModal();
                onCloseButtonClick();
            },
            children: "Close"
        });
    };
    if (modal && shouldDisplayModal()) dispatch("RobotReadyStateNotReadyBody/joggerModal/ModalShown");
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($e4328fa0a7dc23c8$var$Provider, {
        value: {
            modal: modal,
            handleModal: handleModal,
            modalContent: modalContent,
            setModal: setModal
        },
        children: [
            robotJoggerApi && canDisplay && robotJoggerApi.position && robotJoggerApi.rotation && robotJoggerApi.jointAngles && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, ($parcel$interopDefault($gXNCa$reactmodal))), {
                ariaHideApp: false,
                isOpen: modal && shouldDisplayModal(),
                style: $e4328fa0a7dc23c8$var$styleOverrides,
                children: [
                    shouldDisplayRobotJoggerRobotDisconnectedOverlay && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $a89ab9e959a7fd4f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $083dbba1d7d21bc0$export$2e2bcd8739ae039), {
                            onVerifyButtonClick: ()=>dispatch("RobotJoggerContext/VerifyButton/onClick")
                        })
                    }),
                    !robotJoggerApi.freedriveStatus.running && shouldDisplayRobotJoggerRobotNotReadyOverlay && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $a89ab9e959a7fd4f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $cdf6ac17ab4b4848$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                                    style: {
                                        position: "absolute",
                                        top: "17.5rem",
                                        right: "20.1rem",
                                        transform: "scale(2, 1.5)",
                                        fontWeight: "normal"
                                    },
                                    onClick: (event)=>{
                                        event.stopPropagation();
                                        handleModal();
                                        onCloseButtonClick();
                                    },
                                    onTouchStart: (event)=>{
                                        event.stopPropagation();
                                        handleModal();
                                        onCloseButtonClick();
                                    }
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $63fa3fc88f964c51$export$2e2bcd8739ae039), {
                                    buttonText: "ENABLE ROBOT",
                                    isLoading: (0, $e9a5479fa42b7804$export$e1252723db1c541).isRobotReadyStateNotReadyButtonLoading(),
                                    message: "Enable robot to continue",
                                    title: "Your robot is not in a ready state",
                                    onClick: ()=>dispatch("RobotJoggerContext/EnableButton/onClick")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $60e84f2912cbb71e$export$2e2bcd8739ae039), {
                        freedriveStatus: robotJoggerApi.freedriveStatus,
                        jointAngles: robotJoggerApi.jointAngles,
                        joggerSpeedPercentage: robotJoggerApi.joggerSpeedPercentage,
                        jointLimits: robotJoggerApi.jointLimits,
                        position: robotJoggerApi.position,
                        robotType: robotType,
                        robotJoggerTitle: robotJoggerTitle,
                        rotation: robotJoggerApi.rotation,
                        teachWaypointAndCloseButtonText: "Teach Position",
                        tooltip: tooltip,
                        onCloseButtonClick: DeleteButton(),
                        onDisableFreedriveButtonClick: robotJoggerApi.onDisableFreedriveButtonClick,
                        onEnableFreedriveButtonClick: robotJoggerApi.onEnableFreedriveButtonClick,
                        onJoggerArrowMouseUp: robotJoggerApi.onJoggerArrowMouseUp,
                        onJoggerJointArrowMouseDown: robotJoggerApi.onJoggerJointArrowMouseDown,
                        onJoggerPoseRotationMouseDown: robotJoggerApi.onJoggerPoseRotationMouseDown,
                        onJoggerPoseTranslationMouseDown: robotJoggerApi.onJoggerPoseTranslationMouseDown,
                        onSpeedSliderChange: robotJoggerApi.onSpeedSliderChange,
                        onTeachWaypointAndCloseButtonClick: robotJoggerApi.onTeachWaypointAndCloseButtonClick,
                        onToggleConstraintButtonClick: robotJoggerApi.onToggleConstraintButtonClick
                    })
                ]
            }),
            children
        ]
    });
};





const $809d7da3fbe301e9$var$KeyframeWaypoint = ({ item: item , shouldDisplayJogger: shouldDisplayJogger , onWaypointPathTypeChanged: onWaypointPathTypeChanged , onWaypointNameChanged: onWaypointNameChanged , onWaypointEditClicked: onWaypointEditClicked , onWaypointMoveHereButtonMouseDown: onWaypointMoveHereButtonMouseDown , onWaypointMoveHereButtonMouseUp: onWaypointMoveHereButtonMouseUp , onKeyframeDeleteClicked: onKeyframeDeleteClicked , onIgnoreReferenceFrameChanged: onIgnoreReferenceFrameChanged , onMoveJToolTipClick: onMoveJToolTipClick , onMoveLToolTipClick: onMoveLToolTipClick , style: style , playState: playState , disableEditing: disableEditing , isIgnoreReferenceFrameButtonDisabled: isIgnoreReferenceFrameButtonDisabled  })=>{
    const { setModal: setModal  } = (0, $gXNCa$react.useContext)((0, $e4328fa0a7dc23c8$export$ab57792b9b6974a6));
    const [touchStart, setTouchStart] = (0, $gXNCa$react.useState)(false);
    const [pressed, setPressed] = (0, $gXNCa$react.useState)(false);
    const isTouchDevice = ()=>"ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    setModal(shouldDisplayJogger);
    const debouncedOnWaypointMoveHereButtonMouseDown = (0, $gXNCa$react.useCallback)((0, $gXNCa$lodash.debounce)(()=>onWaypointMoveHereButtonMouseDown({
            jointAngles: item.waypoint.jointAngles
        }), 1000, {
        leading: true,
        trailing: false
    }), [
        item.waypoint.jointAngles
    ]);
    const debouncedOnWaypointMoveHereButtonMouseUp = (0, $gXNCa$react.useCallback)((0, $gXNCa$lodash.debounce)(onWaypointMoveHereButtonMouseUp, 100), []);
    const moveHereButtonColor = pressed ? (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).button_held_blue : (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        containerStyle: {
            position: "relative",
            margin: "0.5rem 1rem",
            padding: "0.65rem 2.5rem 0.65rem 0.65rem",
            background: "#FAFAFA",
            borderLeft: "4px solid #1C344F",
            ...style
        },
        className: (0, $b7c3f63a1efa4cdf$exports).getRobotInstructionPlayStateClass(playState),
        "data-cy": "waypoint-card",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                alignItems: "center",
                padding: "0",
                backgroundColor: "transparent",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                    gridTemplateColumns: "0fr 0.2fr 0.6fr 0.5fr 0.5fr 0.3fr",
                    gap: "15px",
                    padding: "0",
                    style: {
                        flex: "1",
                        justifyItems: "right",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "fas fa-grip-vertical"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                type: "text",
                                defaultValue: item.waypoint.name || `Waypoint ${item.index + 1}`,
                                onBlur: (event)=>{
                                    const waypointName = (0, $ed64c74f8c52d920$export$2e2bcd8739ae039)(event.target.value, item.index);
                                    event?.target?.value && onWaypointNameChanged(item.index, waypointName);
                                },
                                onChange: ()=>{},
                                className: "waypoint_name_widget truncated_text",
                                "data-cy": "name-waypoint"
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                            flexDirection: "row",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                    className: "ml_tooltip_icon ml_label_icon icon-help",
                                    style: {
                                        border: "0px",
                                        backgroundColor: "transparent",
                                        marginRight: "0.2rem"
                                    },
                                    onClick: ()=>{
                                        item.waypoint.pathType === "movel" && onMoveLToolTipClick();
                                        item.waypoint.pathType === "movej" && onMoveJToolTipClick();
                                    },
                                    onTouchStart: ()=>{
                                        item.waypoint.pathType === "movel" && onMoveLToolTipClick();
                                        item.waypoint.pathType === "movej" && onMoveJToolTipClick();
                                    }
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                                    title: "Path Type",
                                    style: {
                                        position: "relative",
                                        height: "2.5rem",
                                        float: "left",
                                        border: "1px solid rgb(207, 207, 207)",
                                        borderRadius: "0.15rem"
                                    },
                                    optionItems: [
                                        "movej",
                                        "movel"
                                    ],
                                    getOptionTextContent: (option)=>{
                                        switch(option){
                                            case "movej":
                                                return "Path Type: J";
                                            case "movel":
                                                return "Path Type: L";
                                        }
                                    },
                                    value: item.waypoint.pathType,
                                    onClick: (event)=>event.stopPropagation(),
                                    onTouchStart: (event)=>event.stopPropagation(),
                                    onChange: (event)=>onWaypointPathTypeChanged(item.index, event.target.value),
                                    "data-cy": "select-path-type"
                                })
                            ]
                        }),
                        !disableEditing && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                onClick: (event)=>event.stopPropagation(),
                                onMouseDown: (event)=>{
                                    setPressed(true);
                                    event.stopPropagation();
                                    debouncedOnWaypointMoveHereButtonMouseDown();
                                },
                                onMouseUp: (event)=>{
                                    setPressed(false);
                                    event.stopPropagation();
                                    debouncedOnWaypointMoveHereButtonMouseUp();
                                },
                                onMouseLeave: (event)=>{
                                    if (isTouchDevice() && !touchStart) return;
                                    setPressed(false);
                                    event.stopPropagation();
                                    debouncedOnWaypointMoveHereButtonMouseUp();
                                },
                                onTouchStart: (event)=>{
                                    setPressed(true);
                                    event.stopPropagation();
                                    debouncedOnWaypointMoveHereButtonMouseDown();
                                    setTouchStart(true);
                                },
                                onTouchEnd: (event)=>{
                                    setPressed(false);
                                    event.stopPropagation();
                                    debouncedOnWaypointMoveHereButtonMouseUp();
                                    setTouchStart(false);
                                },
                                style: {
                                    width: "200px",
                                    backgroundColor: moveHereButtonColor,
                                    border: `1px solid ${moveHereButtonColor}`,
                                    borderRadius: "3px",
                                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                                    padding: "0.2rem 1rem",
                                    font: "Larsseit",
                                    fontSize: "15px",
                                    userSelect: "none"
                                },
                                children: pressed ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                    children: "In Motion"
                                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                            children: "Move here"
                                        }),
                                        " (hold)"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                            alignItems: "center",
                            padding: "0",
                            style: {
                                gridColumn: "5"
                            },
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                    type: "checkbox",
                                    value: item.waypoint?.ignoreReferenceFrame,
                                    checked: item.waypoint?.ignoreReferenceFrame,
                                    disabled: isIgnoreReferenceFrameButtonDisabled,
                                    onClick: (event)=>event.stopPropagation(),
                                    onTouchStart: (event)=>event.stopPropagation(),
                                    onChange: (event)=>{
                                        onIgnoreReferenceFrameChanged(item.index, event.target.checked);
                                    },
                                    style: {
                                        margin: "0"
                                    }
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                                    style: {
                                        fontWeight: "normal",
                                        fontSize: "15px",
                                        margin: "0 0.5rem"
                                    },
                                    children: "Fixed waypoint"
                                })
                            ]
                        }),
                        !disableEditing && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            style: {
                                textAlign: "right",
                                border: "none",
                                background: "none",
                                textDecorationLine: "underline",
                                fontSize: "15px",
                                color: "#667A99",
                                cursor: "pointer"
                            },
                            onClick: (e)=>{
                                e.stopPropagation();
                                onWaypointEditClicked(item.index);
                            },
                            onTouchStart: (e)=>{
                                e.stopPropagation();
                                onWaypointEditClicked(item.index);
                            },
                            disabled: disableEditing,
                            "data-cy": "edit-waypoint",
                            children: "Edit"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                onClick: (e)=>{
                    e.stopPropagation();
                    onKeyframeDeleteClicked(item.index);
                },
                "data-cy": "delete-waypoint"
            })
        ]
    });
};
var $809d7da3fbe301e9$export$2e2bcd8739ae039 = $809d7da3fbe301e9$var$KeyframeWaypoint;










function $9bd62c0ac7ab9a34$var$MotionEditor({ keyframes: keyframes , shouldDisplayJogger: shouldDisplayJogger , api: api , onMoveJToolTipClick: onMoveJToolTipClick , onMoveLToolTipClick: onMoveLToolTipClick , robotSimulationState: robotSimulationState , instructionIndex: instructionIndex , isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip , robotType: robotType  }) {
    const onAddWaypointButtonClickpoint = (event)=>{
        setModal(true);
        event.stopPropagation();
        api.onWaypointAddButtonClicked(keyframes.length);
    };
    const onClickAddRobotCommand = (event)=>{
        event.stopPropagation();
        api.onRobotCommandAdded();
    };
    (0, $gXNCa$react.useEffect)((0, $8c1dadece72da4af$export$1eb2ee5864472e77));
    const { setModal: setModal  } = (0, $gXNCa$react.useContext)((0, $e4328fa0a7dc23c8$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "App ignore_sortable_on_sequence_widget",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e4328fa0a7dc23c8$export$178405afcd8c5eb), {
            shouldDisplayRobotJoggerRobotDisconnectedOverlay: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotJoggerRobotDisconnectedOverlay(),
            shouldDisplayRobotJoggerRobotNotReadyOverlay: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotJoggerRobotNotReadyOverlay(),
            dispatch: (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch(),
            onCloseButtonClick: api.onJoggerCloseButtonClick,
            robotJoggerApi: api.robotJoggerApi,
            canDisplay: isAnyKeyframeInEditModeInClip,
            robotType: robotType,
            robotJoggerTitle: "Teach Robot Position",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $2bac9713285017a1$export$2e2bcd8739ae039), {
                    onChange: (keyframes)=>api.onKeyframeOrderChanged(keyframes),
                    items: keyframes,
                    getItemComponent: (index)=>{
                        const keyframe = keyframes[index];
                        // TODO: move state up
                        const keyframePlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === instructionIndex && keyframe.id === robotSimulationState?.keyframeId ? "running" : "completed";
                        return keyframe.waypoint ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $809d7da3fbe301e9$export$2e2bcd8739ae039), {
                            item: {
                                ...keyframe,
                                index: index
                            },
                            shouldDisplayJogger: shouldDisplayJogger,
                            isIgnoreReferenceFrameButtonDisabled: true,
                            disableEditing: !keyframe.waypoint.ignoreReferenceFrame,
                            onWaypointConfirmed: api.onWaypointConfirmed,
                            onWaypointPathTypeChanged: api.onWaypointPathTypeChanged,
                            onWaypointNameChanged: api.onWaypointNameChanged,
                            onWaypointEditClicked: (keyframeIndex)=>{
                                setModal(true);
                                api.onWaypointEditClicked(keyframeIndex);
                            },
                            onWaypointTimeChanged: api.onWaypointTimeChanged,
                            onWaypointMoveHereButtonMouseDown: api.onWaypointMoveHereButtonMouseDown,
                            onWaypointMoveHereButtonMouseUp: api.onWaypointMoveHereButtonMouseUp,
                            onKeyframeDeleteClicked: api.onKeyframeDeleteClicked,
                            onIgnoreReferenceFrameChanged: api.onIgnoreReferenceFrameChanged,
                            onWaypointClicked: api.onWaypointClicked,
                            onTriadButtonClick: api.onTriadButtonClick,
                            onPointToPointButtonClick: api.onPointToPointButtonClick,
                            onJoggerButtonClick: api.onJoggerButtonClick,
                            onMoveJToolTipClick: onMoveJToolTipClick,
                            onMoveLToolTipClick: onMoveLToolTipClick,
                            playState: keyframePlayState
                        }, keyframe.id) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $775c0625e2e82dfd$export$2e2bcd8739ae039), {
                            item: {
                                ...keyframe,
                                index: index
                            },
                            robotType: robotType,
                            playState: keyframePlayState,
                            onKeyframeDeleteClicked: api.onKeyframeDeleteClicked,
                            onKeyframeRobotCommandChanged: api.onKeyframeRobotCommandChanged,
                            onKeyframeRobotCommandWaitForTimeTimeChanged: api.onKeyframeRobotCommandWaitForTimeTimeChanged,
                            onKeyframeRobotCommandSetPayloadWeightChanged: api.onKeyframeRobotCommandSetPayloadWeightChanged,
                            onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: api.onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged,
                            onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: api.onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged
                        }, keyframe.id);
                    }
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "1rem",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                            iconClassName: "icon-add-plus",
                            text: "Add waypoint",
                            onClick: onAddWaypointButtonClickpoint,
                            onTouchStart: onAddWaypointButtonClickpoint,
                            "data-cy": "add-waypoint"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                            iconClassName: "icon-add-plus",
                            text: "Add robot command",
                            onClick: onClickAddRobotCommand,
                            onTouchStart: onClickAddRobotCommand,
                            "data-cy": "add-robot-command"
                        })
                    ]
                })
            ]
        })
    });
}
var $9bd62c0ac7ab9a34$export$2e2bcd8739ae039 = $9bd62c0ac7ab9a34$var$MotionEditor;
















const $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0 = (onMount, onUnmount)=>{
    const [, setStateUpdateIndex] = (0, $gXNCa$react.useState)(0);
    // eslint-disable-next-line functional/no-expression-statements
    (0, $gXNCa$react.useEffect)(()=>{
        const idxFunc = {
            id: (0, $gXNCa$uuid.v4)(),
            func: ()=>setStateUpdateIndex((s)=>s + 1)
        };
        // eslint-disable-next-line functional/no-expression-statements
        onMount(idxFunc);
        return ()=>{
            // eslint-disable-next-line functional/no-expression-statements
            onUnmount(idxFunc);
        };
    }, []);
};
// https://usehooks.com/useToggle/
const $d3bbe4bc45b4a8e8$export$cbe85ee05b554577 = (initialState = false)=>{
    // Initialize the state
    const [state, setState] = (0, $gXNCa$react.useState)(initialState);
    // Define and memorize toggler function in case we pass down the comopnent,
    // This function change the boolean value to it's opposite value
    const toggle = (0, $gXNCa$react.useCallback)(()=>setState((state)=>!state), []);
    return [
        state,
        toggle
    ];
};




const $16c9d989dabcdae7$var$onClick = (dispatch)=>{
    dispatch("RobotReadyStateNotReadyModal/onClick");
};
const $16c9d989dabcdae7$var$RobotReadyStateNotReadyModal = ({ selectors: selectors , title: title , message: message , buttonText: buttonText  })=>{
    const dispatch = selectors.getDispatch();
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>dispatch("RobotReadyStateNotReadyModal/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>dispatch("RobotReadyStateNotReadyModal/onUnmount", {
            idxFunc: idxFunc
        }));
    const showModal = selectors.showRobotReadyStateNotReadyModal();
    if (showModal) dispatch("RobotReadyStateNotReadyBody/playRequested/ModalShown");
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$reactmodal))), {
        ariaHideApp: false,
        isOpen: showModal,
        style: (0, $47a96663c6a20f63$export$4bcb76552286dcbd),
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $63fa3fc88f964c51$export$2e2bcd8739ae039), {
            buttonText: buttonText,
            isLoading: selectors.isRobotReadyStateNotReadyButtonLoading(),
            message: message,
            title: title,
            onClick: ()=>$16c9d989dabcdae7$var$onClick(dispatch)
        })
    });
};
var $16c9d989dabcdae7$export$2e2bcd8739ae039 = $16c9d989dabcdae7$var$RobotReadyStateNotReadyModal;




const $259821319530ea4f$var$RobotSafetyOther = ()=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            display: "flex"
        },
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
            style: {
                padding: "0 1rem"
            },
            children: "A safety issue has occured, go to robot pendant to resolve the issue."
        })
    });
};
var $259821319530ea4f$export$2e2bcd8739ae039 = $259821319530ea4f$var$RobotSafetyOther;







const $cdd2214e9f10e822$var$buttonStyleOverrides = {
    border: "none",
    borderRadius: "3px",
    width: "14rem",
    padding: "0.5rem",
    alignSelf: "center",
    fontWeight: "700"
};
const $cdd2214e9f10e822$var$RobotSafetyProtectiveStop = ({ onClick: onClick  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gridTemplateRows: "repeat(2, auto)",
            gridColumnGap: "20px",
            gridRowGap: "20px",
            padding: "2rem"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("h4", {
                        style: {
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).subheader_grey,
                            fontSize: "0.75rem",
                            margin: 0
                        },
                        children: [
                            " ",
                            "STEP 1",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                        children: "Physically move the robot away from the collision. The robot is in backdrive mode (move forcefully)."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $c4267bb63e057e4f$export$2e2bcd8739ae039), {
                width: "130",
                height: "142"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    alignSelf: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("h4", {
                        style: {
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).subheader_grey,
                            fontSize: "0.75rem",
                            margin: 0
                        },
                        children: [
                            " ",
                            "STEP 2",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                        children: "Enable robot to continue operation."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $56e9194b077be82d$export$2e2bcd8739ae039), {
                onClick: onClick,
                style: $cdd2214e9f10e822$var$buttonStyleOverrides,
                buttonText: "ENABLE ROBOT"
            })
        ]
    });
};
var $cdd2214e9f10e822$export$2e2bcd8739ae039 = $cdd2214e9f10e822$var$RobotSafetyProtectiveStop;





const $4e6baade0412958d$var$RobotSafetySafeguard = ()=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                style: {
                    padding: "0 1rem"
                },
                children: " Clear the fault to continue "
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $c4267bb63e057e4f$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4e6baade0412958d$export$2e2bcd8739ae039 = $4e6baade0412958d$var$RobotSafetySafeguard;











const $cea0d0fa34c57db4$var$onClick = (send)=>{
    send("RobotSafetyStateModal/onClick");
};
const $cea0d0fa34c57db4$var$RobotSafetyStateModal = ({ selectors: selectors , send: send  })=>{
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>send("RobotSafetyStateModal/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>send("RobotSafetyStateModal/onUnmount", {
            idxFunc: idxFunc
        }));
    const showModal = selectors.showRobotSafetyStateModal();
    const showRobotSafetySafeguard = selectors.isRobotDriverStateRobotSafetyStateSafeguardStop();
    const showRobotSafetyOther = selectors.isRobotDriverStateRobotSafetyStateOther();
    const showRobotSafetyProtectiveStop = selectors.isRobotDriverStateRobotSafetyStateProtectiveStop();
    const title = selectors.getRobotSafetyStateModalTitle();
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, ($parcel$interopDefault($gXNCa$reactmodal))), {
        isOpen: showModal,
        style: (0, $47a96663c6a20f63$export$4bcb76552286dcbd),
        ariaHideApp: false,
        portalClassName: "ReactModalPortal",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: (0, $47a96663c6a20f63$export$703f7527c5d336fe),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $6753179537cb99a8$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h2", {
                        style: (0, $47a96663c6a20f63$export$22401119b2a9d1b1),
                        children: title || ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: (0, $47a96663c6a20f63$export$f42854936a63861e),
                children: [
                    showRobotSafetySafeguard && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $4e6baade0412958d$export$2e2bcd8739ae039), {}),
                    showRobotSafetyOther && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $259821319530ea4f$export$2e2bcd8739ae039), {}),
                    showRobotSafetyProtectiveStop && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $cdd2214e9f10e822$export$2e2bcd8739ae039), {
                        onClick: ()=>$cea0d0fa34c57db4$var$onClick(send)
                    })
                ]
            })
        ]
    });
};
var $cea0d0fa34c57db4$export$2e2bcd8739ae039 = $cea0d0fa34c57db4$var$RobotSafetyStateModal;



var $6e14a26a864ddf12$export$2e2bcd8739ae039 = {
    EnableButton: $56e9194b077be82d$export$2e2bcd8739ae039,
    Jogger: $29b14d633b6aaf0e$export$2e2bcd8739ae039,
    KeyframeWaypoint: $809d7da3fbe301e9$export$2e2bcd8739ae039,
    MotionEditor: $9bd62c0ac7ab9a34$export$2e2bcd8739ae039,
    RobotDriverModalStyle: {
        bodyStyle: $47a96663c6a20f63$export$f42854936a63861e,
        headlineStyle: $47a96663c6a20f63$export$703f7527c5d336fe,
        messageStyle: $47a96663c6a20f63$export$6482c9f711b887cf,
        modalStyleOverrides: $47a96663c6a20f63$export$4bcb76552286dcbd,
        titleStyle: $47a96663c6a20f63$export$22401119b2a9d1b1
    },
    RobotDriverStateCard: $cdf6ac17ab4b4848$export$2e2bcd8739ae039,
    RobotJoggerArrows: $c6c8dfaca663abb7$export$2e2bcd8739ae039,
    RobotJoggerDisabledOverlay: $a89ab9e959a7fd4f$export$2e2bcd8739ae039,
    RobotJoggerDisabledOverlayRobotDisconnectedBody: $083dbba1d7d21bc0$export$2e2bcd8739ae039,
    RobotJogger: $60e84f2912cbb71e$export$2e2bcd8739ae039,
    robotJoggerModalContext: {
        ModalContext: $e4328fa0a7dc23c8$export$ab57792b9b6974a6,
        ModalProvider: $e4328fa0a7dc23c8$export$178405afcd8c5eb
    },
    RobotJoggerSpeedSlider: $34a00acdec5d2901$export$2e2bcd8739ae039,
    RobotReadyStateNotReadyBody: $63fa3fc88f964c51$export$2e2bcd8739ae039,
    RobotReadyStateNotReadyModal: $16c9d989dabcdae7$export$2e2bcd8739ae039,
    RobotSafetyOther: $259821319530ea4f$export$2e2bcd8739ae039,
    RobotSafetyProtectiveStop: $cdd2214e9f10e822$export$2e2bcd8739ae039,
    RobotSafetySafeguard: $4e6baade0412958d$export$2e2bcd8739ae039,
    RobotSafetyStateModal: $cea0d0fa34c57db4$export$2e2bcd8739ae039,
    Slider: $855932f7329443e3$export$2e2bcd8739ae039
};


/**
 * This module contains the UI
 * to build the trigger instruction category
 */ /* eslint no-unused-vars:0 */ 





const $7a793d301b3aae05$var$CalibrationReferenceFrameEditor = ({ name: name , vid: vid , onMouseEnter: onMouseEnter , onMouseLeave: onMouseLeave , onReferenceFrameNameEdit: onReferenceFrameNameEdit , onReferenceFrameNameCreate: onReferenceFrameNameCreate , onReferenceFrameDeleteById: onReferenceFrameDeleteById , robotAppsService: robotAppsService  })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
            containerStyle: {
                position: "relative",
                backgroundColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).greyscale_0
            },
            onMouseEnter: ()=>onMouseEnter(robotAppsService, vid),
            onMouseLeave: ()=>onMouseLeave(robotAppsService, vid),
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                iconClassName: "icon-calibration-frame",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                label: "Reference Frame Name"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                type: "text",
                                defaultValue: name,
                                onChange: (event)=>onReferenceFrameNameEdit(vid, event.target.value),
                                onMount: (name)=>onReferenceFrameNameCreate(vid, name)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                        style: {
                            paddingRight: "0.65rem"
                        },
                        onClick: ()=>onReferenceFrameDeleteById(vid)
                    })
                ]
            })
        })
    });
};
var $7a793d301b3aae05$export$2e2bcd8739ae039 = $7a793d301b3aae05$var$CalibrationReferenceFrameEditor;



const $c7e59276dc2fb724$var$CalibrationReferenceFramesEditor = ({ referenceFrames: referenceFrames , robotAppsService: robotAppsService , shouldDisplayAddDigitalCalibrationToolButton: shouldDisplayAddDigitalCalibrationToolButton = true , onReferenceFramesChanged: onReferenceFramesChanged , onReferenceFrameCreate: onReferenceFrameCreate , onReferenceFrameCreateCancel: onReferenceFrameCreateCancel , onReferenceFrameDelete: onReferenceFrameDelete , onReferenceFrameMouseEnter: onReferenceFrameMouseEnter , onReferenceFrameMouseLeave: onReferenceFrameMouseLeave , getReferenceFrameDefaultName: getReferenceFrameDefaultName  })=>{
    const [isInserting, setIsInserting] = (0, $gXNCa$react.useState)(false);
    const onReferenceFrameCreateSet = (vid)=>{
        setIsInserting(false);
        const newReferenceFrames = referenceFrames;
        const newReferenceFrameName = getReferenceFrameDefaultName(vid);
        onReferenceFramesChanged(newReferenceFrames.concat({
            vid: vid,
            name: newReferenceFrameName
        }));
    };
    const onReferenceFrameCreateEscPressed = ()=>{
        setIsInserting(false);
    };
    const onReferenceFrameDeleteById = (vid)=>{
        const newReferenceFrames = referenceFrames.filter((referenceFrame)=>referenceFrame.vid !== vid);
        onReferenceFramesChanged(newReferenceFrames);
        onReferenceFrameDelete(vid);
    };
    const onReferenceFrameNameEdit = (vid, name)=>{
        const newReferenceFrames = referenceFrames;
        newReferenceFrames.find((referenceFrame)=>referenceFrame.vid === vid).name = (0, $b7c3f63a1efa4cdf$exports).getUniqueName(name, referenceFrames.map((calibrationPart)=>calibrationPart.name));
        onReferenceFramesChanged(newReferenceFrames);
    };
    const onReferenceFrameNameCreate = (vid, name)=>{
        const newReferenceFrames = referenceFrames;
        newReferenceFrames.find((referenceFrame)=>referenceFrame.vid === vid).name = name;
        onReferenceFramesChanged(newReferenceFrames);
    };
    return referenceFrames ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            referenceFrames.map((referenceFrame)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $7a793d301b3aae05$export$2e2bcd8739ae039), {
                    name: referenceFrame.name,
                    vid: referenceFrame.vid,
                    onMouseEnter: onReferenceFrameMouseEnter,
                    onMouseLeave: onReferenceFrameMouseLeave,
                    onReferenceFrameNameEdit: onReferenceFrameNameEdit,
                    onReferenceFrameNameCreate: onReferenceFrameNameCreate,
                    onReferenceFrameDeleteById: onReferenceFrameDeleteById,
                    robotAppsService: robotAppsService
                }, `CalibrationReferenceFrameEditor-${referenceFrame.vid}`)),
            isInserting && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
                containerStyle: {
                    position: "relative",
                    marginBottom: "0.5rem"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                    alignItems: "flex-start",
                    padding: "0.65rem 1.5rem 0.65rem 0",
                    backgroundColor: "#FBFBFB",
                    style: {
                        borderLeft: "6px solid #1C344F"
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                            label: `Add a digital calibration tool in the 3D workspace.`,
                            labelStyle: {
                                fontWeight: "bold",
                                padding: "30px"
                            }
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                            style: {
                                paddingRight: "0.65rem"
                            },
                            onClick: ()=>{
                                setIsInserting(false);
                                onReferenceFrameCreateCancel();
                            }
                        })
                    ]
                })
            }),
            shouldDisplayAddDigitalCalibrationToolButton && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                iconClassName: "icon-add-plus",
                text: "Add digital calibration tool",
                disabled: isInserting,
                onClick: ()=>{
                    setIsInserting(true);
                    return onReferenceFrameCreate(onReferenceFrameCreateSet, onReferenceFrameCreateEscPressed);
                }
            })
        ]
    }) : null;
};
var $c7e59276dc2fb724$export$2e2bcd8739ae039 = $c7e59276dc2fb724$var$CalibrationReferenceFramesEditor;









function $d1a08e0d09791fc6$var$MotionEditor({ keyframes: keyframes , moveWithMode: moveWithMode , api: api , onMoveJToolTipClick: onMoveJToolTipClick , onMoveLToolTipClick: onMoveLToolTipClick , robotSimulationState: robotSimulationState , instructionIndex: instructionIndex , validatePoseWaypoint: validatePoseWaypoint , isAnyKeyframeInEditMode: isAnyKeyframeInEditMode , isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip , doesRobotConfigExist: doesRobotConfigExist , referenceFrame: referenceFrame , robotType: robotType  }) {
    function getTooltipWarningIcon() {
        const textStyle = {
            padding: 0,
            margin: 0
        };
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            style: {
                paddingLeft: "20px"
            },
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $8c1dadece72da4af$export$f7dc499a72baa103), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                            style: textStyle,
                            children: "Invalid waypoint: the selected start point puts this waypoint out of the playable area."
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                            style: textStyle,
                            children: "Select a different start point or adjust your waypoint"
                        })
                    ]
                })
            })
        });
    }
    (0, $gXNCa$react.useEffect)((0, $8c1dadece72da4af$export$1eb2ee5864472e77));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "App ignore_sortable_on_sequence_widget",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $d8fcab4c0af78f9a$export$178405afcd8c5eb), {
            onCloseButtonClick: api.onJoggerCloseButtonClick,
            robotJoggerApi: api.robotJoggerApi,
            canDisplay: isAnyKeyframeInEditModeInClip,
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $2bac9713285017a1$export$2e2bcd8739ae039), {
                    onChange: (keyframes)=>api.onKeyframeOrderChanged(keyframes),
                    items: keyframes,
                    getItemComponent: (index)=>{
                        const keyframe = keyframes[index];
                        const isValidWaypoint = keyframe.waypoint ? keyframe.waypoint.ignoreReferenceFrame ? true : validatePoseWaypoint(keyframe.waypoint.pose) : false;
                        // TODO: move state up
                        const keyframePlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === instructionIndex && keyframe.id === robotSimulationState?.keyframeId ? "running" : "completed";
                        return keyframe.waypoint ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $8ded208236d68f0e$export$25f702d5469dfe2d), {
                            item: {
                                ...keyframe,
                                index: index
                            },
                            moveWithMode: moveWithMode,
                            disableEditing: isAnyKeyframeInEditMode || !doesRobotConfigExist,
                            onWaypointConfirmed: api.onWaypointConfirmed,
                            onWaypointPathTypeChanged: api.onWaypointPathTypeChanged,
                            onWaypointNameChanged: api.onWaypointNameChanged,
                            onWaypointEditClicked: api.onWaypointEditClicked,
                            onWaypointTimeChanged: api.onWaypointTimeChanged,
                            onKeyframeDeleteClicked: api.onKeyframeDeleteClicked,
                            onIgnoreReferenceFrameChanged: api.onIgnoreReferenceFrameChanged,
                            onWaypointClicked: api.onWaypointClicked,
                            style: keyframe.isSelected && (0, ($parcel$interopDefault($gXNCa$lodash))).isEqual(keyframe.selectedReferenceFrame, referenceFrame) ? {
                                borderColor: "rgb(28, 52, 79) rgb(28, 52, 79) rgb(28, 52, 79) rgb(28, 52, 79)",
                                borderWidth: "2px 2px 2px 4px"
                            } : {
                                borderColor: "rgb(160, 160, 160) rgb(160, 160, 160) rgb(160, 160, 160) rgb(28, 52, 79)",
                                borderWidth: "1px 1px 1px 4px"
                            },
                            onTriadButtonClick: api.onTriadButtonClick,
                            onPointToPointButtonClick: api.onPointToPointButtonClick,
                            onJoggerButtonClick: api.onJoggerButtonClick,
                            onMoveJToolTipClick: onMoveJToolTipClick,
                            onMoveLToolTipClick: onMoveLToolTipClick,
                            playState: keyframePlayState,
                            WarningIcon: isValidWaypoint ? null : getTooltipWarningIcon()
                        }, keyframe.id) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $775c0625e2e82dfd$export$2e2bcd8739ae039), {
                            item: {
                                ...keyframe,
                                index: index
                            },
                            robotType: robotType,
                            onKeyframeDeleteClicked: api.onKeyframeDeleteClicked,
                            onKeyframeRobotCommandChanged: api.onKeyframeRobotCommandChanged,
                            onKeyframeRobotCommandWaitForTimeTimeChanged: api.onKeyframeRobotCommandWaitForTimeTimeChanged,
                            onKeyframeRobotCommandSetPayloadWeightChanged: api.onKeyframeRobotCommandSetPayloadWeightChanged,
                            onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: api.onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged,
                            onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: api.onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged,
                            playState: keyframePlayState
                        }, keyframe.id);
                    }
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "0.65rem 1rem",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                            iconClassName: "icon-add-plus",
                            text: "Add waypoint",
                            "data-cy": "add-waypoint",
                            disabled: isAnyKeyframeInEditMode || !doesRobotConfigExist,
                            onClick: (event)=>{
                                event.stopPropagation();
                                api.onWaypointAdded();
                            }
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                            iconClassName: "icon-add-plus",
                            text: "Add robot command",
                            disabled: isAnyKeyframeInEditMode || !doesRobotConfigExist,
                            onClick: (event)=>{
                                event.stopPropagation();
                                api.onRobotCommandAdded();
                            },
                            "data-cy": "add-robot-command"
                        })
                    ]
                })
            ]
        })
    });
}
var $d1a08e0d09791fc6$export$2e2bcd8739ae039 = $d1a08e0d09791fc6$var$MotionEditor;












function $4201e907103ad5ec$export$2e2bcd8739ae039({ robotName: robotName  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: "Robot Name"
            }),
            robotName ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$9cad5df6f2ba047a), {
                title: "Select Robot",
                text: robotName,
                style: {
                    display: "flex",
                    alignItems: "center"
                }
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$9cad5df6f2ba047a), {
                title: "Select Robot",
                text: "(Not Configured)",
                style: {
                    display: "flex",
                    alignItems: "center",
                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).danger_color
                }
            })
        ]
    });
}



function $17e4fcea6fcfce4b$export$2e2bcd8739ae039({ onWaypointAdded: onWaypointAdded , onWaypointConfirmed: onWaypointConfirmed , onWaypointPathTypeChanged: onWaypointPathTypeChanged , onWaypointNameChanged: onWaypointNameChanged , onWaypointEditClicked: onWaypointEditClicked , onWaypointTimeChanged: onWaypointTimeChanged , onWaypointClicked: onWaypointClicked , onRobotCommandAdded: onRobotCommandAdded , onKeyframeRobotCommandChanged: onKeyframeRobotCommandChanged , onKeyframeRobotCommandWaitForTimeTimeChanged: onKeyframeRobotCommandWaitForTimeTimeChanged , onKeyframeRobotCommandSetPayloadWeightChanged: onKeyframeRobotCommandSetPayloadWeightChanged , onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged , onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged , onKeyframeDeleteClicked: onKeyframeDeleteClicked , onKeyframeOrderChanged: onKeyframeOrderChanged , onIgnoreReferenceFrameChanged: onIgnoreReferenceFrameChanged , isEditingReferenceFrame: isEditingReferenceFrame , robotClip: robotClip , robotClipIdsUsed: robotClipIdsUsed , robotClipIndex: robotClipIndex , robotConfigs: robotConfigs , robotName: robotName , onReferenceFrameCreate: onReferenceFrameCreate , onExitReferenceFrameCreate: onExitReferenceFrameCreate , referenceFrameLabel: referenceFrameLabel , moveWithMode: moveWithMode , onRobotClipChange: onRobotClipChange , onDeleteClick: onDeleteClick , onLockedDeleteClick: onLockedDeleteClick , onTriadButtonClick: onTriadButtonClick , onPointToPointButtonClick: onPointToPointButtonClick , onJoggerButtonClick: onJoggerButtonClick , onJoggerCloseButtonClick: onJoggerCloseButtonClick , robotJoggerApi: robotJoggerApi , onClick: onClick = ()=>{} , onReferenceFrameToolTipClick: onReferenceFrameToolTipClick , onMoveJToolTipClick: onMoveJToolTipClick , onMoveLToolTipClick: onMoveLToolTipClick , SaveToRobotAssetsButton: SaveToRobotAssetsButton , validatePoseWaypoint: validatePoseWaypoint , children: children , robotSimulationState: robotSimulationState , isAnyKeyframeInEditMode: isAnyKeyframeInEditMode , isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip , doesRobotConfigExist: doesRobotConfigExist , getUniqueClipName: getUniqueClipName  }) {
    // TODO: move state up
    const instructionPlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === robotClipIndex && robotClip.keyframes.find((keyframe)=>keyframe.id === robotSimulationState?.keyframeId) ? "running" : "completed";
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        "data-cy": "editable-robot-path",
        className: "ml_card bordered spaced",
        style: {
            width: "100%"
        },
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                iconClassName: "icon-robot-sequence",
                index: robotClipIndex + 1,
                backgroundColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).greyscale_0,
                style: {
                    padding: "1.3rem 1.3rem 0.65rem 0.65rem",
                    margin: "-0.65rem -0.65rem 0rem -0.65rem"
                },
                playState: instructionPlayState,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                label: "Robot Path Name"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                type: "text",
                                defaultValue: robotClip.name,
                                onChange: (event)=>event?.target?.value && onRobotClipChange({
                                        ...robotClip,
                                        name: getUniqueClipName(event.target.value)
                                    })
                            })
                        ]
                    }),
                    robotClip.name !== "" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $4201e907103ad5ec$export$2e2bcd8739ae039), {
                        robotName: robotName
                    }),
                    SaveToRobotAssetsButton && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)(SaveToRobotAssetsButton, {})
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    borderBottom: "0.5px solid rgb(160, 160, 160)",
                    margin: "0 -0.65rem"
                }
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $412c4cb105f2bacf$export$2e2bcd8739ae039), {
                referenceFrame: robotClip.teachingReferenceFrame,
                referenceFrameLabel: referenceFrameLabel,
                isEditingReferenceFrame: isEditingReferenceFrame,
                onReferenceFrameCreate: ()=>onReferenceFrameCreate({
                        robotClip: robotClip
                    }),
                onReferenceFrameToolTipClick: onReferenceFrameToolTipClick,
                onExitReferenceFrameCreate: onExitReferenceFrameCreate,
                "data-cy": "edit-reference-frame"
            }),
            robotClip.teachingReferenceFrame && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $d1a08e0d09791fc6$export$2e2bcd8739ae039), {
                keyframes: robotClip.keyframes,
                isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip,
                isAnyKeyframeInEditMode: isAnyKeyframeInEditMode,
                doesRobotConfigExist: doesRobotConfigExist,
                robotClipId: robotClip.id,
                moveWithMode: moveWithMode,
                api: {
                    onWaypointAdded: ()=>onWaypointAdded({
                            robotClip: robotClip
                        }),
                    onWaypointPathTypeChanged: (keyframeIndex, pathType)=>onWaypointPathTypeChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            pathType: pathType
                        }),
                    onWaypointNameChanged: (keyframeIndex, name)=>{
                        onWaypointNameChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            name: name
                        });
                    },
                    onWaypointConfirmed: (keyframeIndex)=>onWaypointConfirmed({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex
                        }),
                    onWaypointEditClicked: (keyframeIndex)=>onWaypointEditClicked({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex
                        }),
                    onWaypointTimeChanged: (keyframeIndex, time)=>onWaypointTimeChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            time: time
                        }),
                    onWaypointClicked: (keyframeIndex)=>onWaypointClicked({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex
                        }),
                    onRobotCommandAdded: (keyframeIndex)=>onRobotCommandAdded({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex
                        }),
                    onKeyframeRobotCommandChanged: (keyframeIndex, robotCommandType)=>onKeyframeRobotCommandChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            robotCommandType: robotCommandType
                        }),
                    onKeyframeRobotCommandWaitForTimeTimeChanged: (keyframeIndex, time)=>onKeyframeRobotCommandWaitForTimeTimeChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            time: time
                        }),
                    onKeyframeRobotCommandSetPayloadWeightChanged: (keyframeIndex, weight)=>onKeyframeRobotCommandSetPayloadWeightChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            weight: weight
                        }),
                    onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: (keyframeIndex, moveLVelocityScalingFactor)=>onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            moveLVelocityScalingFactor: moveLVelocityScalingFactor
                        }),
                    onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: (keyframeIndex, moveJVelocityScalingFactor)=>onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            moveJVelocityScalingFactor: moveJVelocityScalingFactor
                        }),
                    onKeyframeDeleteClicked: (keyframeIndex)=>onKeyframeDeleteClicked({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex
                        }),
                    onKeyframeOrderChanged: (keyframes)=>onKeyframeOrderChanged({
                            robotClip: robotClip,
                            keyframes: keyframes
                        }),
                    onIgnoreReferenceFrameChanged: (keyframeIndex, ignoreReferenceFrame)=>onIgnoreReferenceFrameChanged({
                            robotClip: robotClip,
                            keyframeIndex: keyframeIndex,
                            ignoreReferenceFrame: ignoreReferenceFrame
                        }),
                    onTriadButtonClick: onTriadButtonClick,
                    onPointToPointButtonClick: onPointToPointButtonClick,
                    onJoggerButtonClick: onJoggerButtonClick,
                    onJoggerCloseButtonClick: onJoggerCloseButtonClick,
                    robotJoggerApi: robotJoggerApi
                },
                validatePoseWaypoint: validatePoseWaypoint,
                onMoveJToolTipClick: onMoveJToolTipClick,
                onMoveLToolTipClick: onMoveLToolTipClick,
                robotSimulationState: robotSimulationState,
                instructionIndex: robotClipIndex,
                referenceFrame: robotClip.teachingReferenceFrame,
                robotType: robotConfigs[0]?.mType
            }),
            robotClip.id && robotClipIdsUsed?.includes(robotClip.id) ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$3a9efa6242d14e94), {
                style: {
                    paddingRight: "0.65rem"
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    onLockedDeleteClick?.();
                }
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                style: {
                    paddingRight: "0.65rem"
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    onDeleteClick?.();
                },
                "data-cy": "delete-robot-path"
            }),
            children
        ]
    });
}


// https://redux.js.org/recipes/structuring-reducers/immutable-update-patterns
/**
 * @typedef Action
 * @property {Number} index
 * @property {Object} item
 */ /**
 *
 * @param {Action} action
 * @param {Array<{ index: number, item: any }>} array
 */ function $a85f490c61764882$export$2e2bcd8739ae039(array, action) {
    return array.map((item, index)=>{
        if (index !== action.index) // This isn't the item we care about - keep it as-is
        return item;
        // Otherwise, this is the one we want - return an updated value
        return {
            ...item,
            ...action.item
        };
    });
}



const $d5cc77669caa91ad$export$a8b22829e538b5fc = (array)=>(robotClip)=>array.findIndex((el)=>el.id === robotClip.id);
const $d5cc77669caa91ad$export$aa1a1894961eafab = ()=>`robotClipsEditor-${(0, $gXNCa$uuid.v4)()}`;
function $d5cc77669caa91ad$export$75ff2183706c7173() {
    return {
        id: $d5cc77669caa91ad$export$aa1a1894961eafab(),
        robotId: "",
        keyframes: [],
        /** @type {{ arrayMatrix__referenceFrame_world: THREE.Matrix4Tuple } | null} */ teachingReferenceFrame: null,
        name: ""
    };
}



const { removeItem: $7b36627f41554d51$var$removeItem , insertItem: $7b36627f41554d51$var$insertItem  } = (0, $b7c3f63a1efa4cdf$exports);
function $7b36627f41554d51$export$2e2bcd8739ae039({ robotClips: robotClips , getUniqueClipName: getUniqueClipName , shouldShowAddRobotPathButton: shouldShowAddRobotPathButton = true , getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame , onRobotClipChange: onRobotClipChange , onRobotClipsChange: onRobotClipsChange , onRobotClipsChangeNoConfig: onRobotClipsChangeNoConfig , robotConfigs: robotConfigs , moveWithMode: moveWithMode , isAnyKeyframeInEditMode: isAnyKeyframeInEditMode , isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip , onJoggerCloseButtonClick: onJoggerCloseButtonClick , onDeleteClick: onDeleteClick , selectors: selectors , ...otherProps }) {
    const [clipWaypointSelectedIndex, setClipWaypointSelectedIndex] = (0, $gXNCa$react.useState)({
        clipIndex: -1,
        waypointIndex: -1
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            robotClips.map((robotClip, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $17e4fcea6fcfce4b$export$2e2bcd8739ae039), {
                    "data-cy": "waypoint-card",
                    ...otherProps,
                    robotConfigs: robotConfigs,
                    robotClip: robotClip,
                    isAnyKeyframeInEditMode: isAnyKeyframeInEditMode(robotClips),
                    isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip(robotClip),
                    doesRobotConfigExist: robotConfigs.length > 0,
                    moveWithMode: moveWithMode,
                    robotClipNames: (robotClips || []).map((clip)=>clip.name),
                    robotClipIndex: i,
                    isEditingReferenceFrame: selectors.getRobotAppsServiceState().matches("app.creatingReferenceFrame") && selectors.getRobotClipReferenceFrameEditingId() === robotClip.id,
                    getUniqueClipName: getUniqueClipName,
                    onJoggerCloseButtonClick: onJoggerCloseButtonClick,
                    onRobotClipChange: (robotClip)=>{
                        onRobotClipChange(robotClip);
                        const newRobotClips = (0, $a85f490c61764882$export$2e2bcd8739ae039)(robotClips, {
                            index: i,
                            item: robotClip
                        });
                        onRobotClipsChange(newRobotClips);
                    },
                    onCopyClick: ()=>onRobotClipsChange($7b36627f41554d51$var$insertItem(robotClips, {
                            index: i,
                            item: JSON.parse(JSON.stringify(robotClips[i]))
                        })),
                    onDeleteClick: ()=>{
                        onDeleteClick();
                        onRobotClipsChange($7b36627f41554d51$var$removeItem(robotClips, {
                            index: i
                        }));
                    },
                    waypointSelectedIndex: clipWaypointSelectedIndex["clipIndex"] === i ? clipWaypointSelectedIndex["waypointIndex"] : -1,
                    onWaypointSelected: (waypointIndex)=>setClipWaypointSelectedIndex({
                            clipIndex: i,
                            waypointIndex: waypointIndex
                        })
                }, robotClip.id)),
            shouldShowAddRobotPathButton && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                "data-cy": "add-robot-path",
                iconClassName: "icon-add-plus",
                text: "Add robot path",
                onClick: ()=>{
                    const newRobotClip = (0, $d5cc77669caa91ad$export$75ff2183706c7173)();
                    newRobotClip.name = getUniqueClipName("Robot path");
                    newRobotClip.robotId = robotConfigs[0].mRobotId;
                    newRobotClip.teachingReferenceFrame = getDefaultTeachingReferenceFrame(robotConfigs[0].mVID);
                    return robotConfigs.length ? onRobotClipsChange(robotClips.concat(newRobotClip)) : onRobotClipsChangeNoConfig();
                },
                onTouchStart: ()=>{
                    const newRobotClip = (0, $d5cc77669caa91ad$export$75ff2183706c7173)();
                    newRobotClip.name = getUniqueClipName("Robot path");
                    newRobotClip.robotId = robotConfigs[0].mRobotId;
                    newRobotClip.teachingReferenceFrame = getDefaultTeachingReferenceFrame(robotConfigs[0].mVID);
                    return robotConfigs.length ? onRobotClipsChange(robotClips.concat(newRobotClip)) : onRobotClipsChangeNoConfig();
                }
            })
        ]
    });
}


var $83195ab73a09d9e3$export$2e2bcd8739ae039 = {
    CalibrationReferenceFramesEditor: $c7e59276dc2fb724$export$2e2bcd8739ae039,
    MotionEditor: $d1a08e0d09791fc6$export$2e2bcd8739ae039,
    RobotClipsEditor: $7b36627f41554d51$export$2e2bcd8739ae039
};


var $dbd3670ef76bb404$exports = {};

$parcel$export($dbd3670ef76bb404$exports, "create", () => $dbd3670ef76bb404$export$185802fd694ee1f5);






// https://redux.js.org/recipes/structuring-reducers/immutable-update-patterns
/**
 * @typedef Action
 * @property {Number} index
 * @property {Object} item
 */ /**
 *
 * @param {Action} action
 * @param {Array<Object>} array
 */ function $9dda2f46fd3e5aaf$var$updateObjectInArray(array, action) {
    return array.map((item, index)=>{
        if (index !== action.index) // This isn't the item we care about - keep it as-is
        return item;
        // Otherwise, this is the one we want - return an updated value
        return {
            ...item,
            ...action.item
        };
    });
}
function $9dda2f46fd3e5aaf$var$replaceObjectInArray(array, action) {
    return array.map((item, index)=>{
        if (index !== action.index) // This isn't the item we care about - keep it as-is
        return item;
        // Otherwise, this is the one we want - return an updated value
        return {
            ...action.item
        };
    });
}
function $9dda2f46fd3e5aaf$var$removeItem(array, action) {
    return [
        ...array.slice(0, action.index),
        ...array.slice(action.index + 1)
    ];
}
function $9dda2f46fd3e5aaf$var$insertItem(array, action) {
    return [
        ...array.slice(0, action.index),
        action.item,
        ...array.slice(action.index)
    ];
}
const $9dda2f46fd3e5aaf$export$d4c72bab9d6cc13a = {
    keyframes: []
};
const $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32 = (state = $9dda2f46fd3e5aaf$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case "motionEditor/initializeKeyframeState":
            return {
                ...action.payload
            };
        case "motionEditor/keyframeAdded":
            return {
                ...state,
                keyframes: state.keyframes.concat([
                    action.payload.keyframe
                ])
            };
        case "motionEditor/waypointTimeChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        timeStamp: action.payload.timeStamp
                    }
                })
            };
        case "motionEditor/waypointPathTypeChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            pathType: action.payload.pathType
                        }
                    }
                })
            };
        case "motionEditor/waypointNameChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            name: action.payload.name
                        }
                    }
                })
            };
        case "motionEditor/keyframeIsEditingChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        isEditing: action.payload.isEditing
                    }
                })
            };
        case "motionEditor/keyframeIsSelectedChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        isSelected: action.payload.isSelected,
                        selectedReferenceFrame: action.payload.selectedReferenceFrame
                    }
                })
            };
        case "motionEditor/keyframeOrderChanged":
            return {
                ...state,
                keyframes: action.payload.keyframes
            };
        case "motionEditor/waypointIgnoreReferenceFrameChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            ignoreReferenceFrame: action.payload.ignoreReferenceFrame
                        }
                    }
                })
            };
        case "jogger/teachWaypointAndCloseButtonClicked":
        case "motionEditor/waypointConfirmed":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        isEditing: action.payload.isEditing,
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            jointAngles: action.payload.jointAngles,
                            pose: action.payload.pose
                        }
                    }
                })
            };
        case "motionEditor/keyframeRemoved":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$removeItem(state.keyframes, {
                    index: action.payload.keyframeIndex
                })
            };
        case "motionEditor/keyframeCopyAsNext":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$insertItem(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: JSON.parse(JSON.stringify(state.keyframes[action.payload.keyframeIndex]))
                })
            };
        case "motionEditor/keyframeCopyAsLast":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$insertItem(state.keyframes, {
                    index: state.keyframes.length,
                    item: JSON.parse(JSON.stringify(state.keyframes[action.payload.keyframeIndex]))
                })
            };
        case "motionEditor/robotCommandChanged":
            {
                const robotCommandInitialState = (robotCommandType, id)=>{
                    switch(robotCommandType){
                        case "waitForTime":
                            return {
                                id: id,
                                timeStamp: -1,
                                waitForTime: {
                                    time: 0
                                }
                            };
                        case "setPayload":
                            return {
                                id: id,
                                timeStamp: -1,
                                setPayload: {
                                    weight: 0
                                }
                            };
                        case "setSpeed":
                            return {
                                id: id,
                                timeStamp: -1,
                                setSpeed: {
                                    moveLVelocityScalingFactor: 0.1,
                                    moveJVelocityScalingFactor: 0.1
                                }
                            };
                    }
                };
                return {
                    ...state,
                    keyframes: $9dda2f46fd3e5aaf$var$replaceObjectInArray(state.keyframes, {
                        index: action.payload.keyframeIndex,
                        item: robotCommandInitialState(action.payload.robotCommandType, state.keyframes[action.payload.keyframeIndex].id)
                    })
                };
            }
        case "motionEditor/robotCommandWaitForTimeTimeChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        waitForTime: {
                            ...state.keyframes[action.payload.keyframeIndex].waitForTime,
                            time: action.payload.time
                        }
                    }
                })
            };
        case "motionEditor/robotCommandSetPayloadWeightChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        setPayload: {
                            ...state.keyframes[action.payload.keyframeIndex].setPayload,
                            weight: action.payload.weight
                        }
                    }
                })
            };
        case "motionEditor/robotCommandSetSpeedMoveLVelocityScalingFactorChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        setSpeed: {
                            ...state.keyframes[action.payload.keyframeIndex].setSpeed,
                            moveLVelocityScalingFactor: action.payload.moveLVelocityScalingFactor
                        }
                    }
                })
            };
        case "motionEditor/robotCommandSetSpeedMoveJVelocityScalingFactorChanged":
            return {
                ...state,
                keyframes: $9dda2f46fd3e5aaf$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        setSpeed: {
                            ...state.keyframes[action.payload.keyframeIndex].setSpeed,
                            moveJVelocityScalingFactor: action.payload.moveJVelocityScalingFactor
                        }
                    }
                })
            };
        default:
            return state;
    }
};
const $9dda2f46fd3e5aaf$var$initializeKeyframeState = (payload)=>({
        type: "motionEditor/initializeKeyframeState",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$keyframeAdded = (payload)=>({
        type: "motionEditor/keyframeAdded",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$waypointTimeChanged = (payload)=>({
        type: "motionEditor/waypointTimeChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$waypointPathTypeChanged = (payload)=>({
        type: "motionEditor/waypointPathTypeChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$waypointNameChanged = (payload)=>({
        type: "motionEditor/waypointNameChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$keyframeIsEditingChanged = (payload)=>({
        type: "motionEditor/keyframeIsEditingChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$keyframeIsSelectedChanged = (payload)=>({
        type: "motionEditor/keyframeIsSelectedChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$keyframeOrderChanged = (payload)=>({
        type: "motionEditor/keyframeOrderChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$waypointIgnoreReferenceFrameChanged = (payload)=>({
        type: "motionEditor/waypointIgnoreReferenceFrameChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$waypointConfirmed = (payload)=>({
        type: "motionEditor/waypointConfirmed",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$teachWaypointAndCloseButtonClicked = (payload)=>({
        type: "jogger/teachWaypointAndCloseButtonClicked",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$keyframeRemoved = (payload)=>({
        type: "motionEditor/keyframeRemoved",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$keyframeCopyAsNext = (payload)=>({
        type: "motionEditor/keyframeCopyAsNext",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$keyframeCopyAsLast = (payload)=>({
        type: "motionEditor/keyframeCopyAsLast",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$robotCommandChanged = (payload)=>({
        type: "motionEditor/robotCommandChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$robotCommandWaitForTimeTimeChanged = (payload)=>({
        type: "motionEditor/robotCommandWaitForTimeTimeChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$robotCommandSetPayloadWeightChanged = (payload)=>({
        type: "motionEditor/robotCommandSetPayloadWeightChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$robotCommandSetSpeedMoveLVelocityScalingFactorChanged = (payload)=>({
        type: "motionEditor/robotCommandSetSpeedMoveLVelocityScalingFactorChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$var$robotCommandSetSpeedMoveJVelocityScalingFactorChanged = (payload)=>({
        type: "motionEditor/robotCommandSetSpeedMoveJVelocityScalingFactorChanged",
        payload: payload
    });
const $9dda2f46fd3e5aaf$export$197c291619fe9a2e = {
    initializeKeyframeState: $9dda2f46fd3e5aaf$var$initializeKeyframeState,
    keyframeAdded: $9dda2f46fd3e5aaf$var$keyframeAdded,
    keyframeRemoved: $9dda2f46fd3e5aaf$var$keyframeRemoved,
    keyframeCopyAsNext: $9dda2f46fd3e5aaf$var$keyframeCopyAsNext,
    keyframeCopyAsLast: $9dda2f46fd3e5aaf$var$keyframeCopyAsLast,
    waypointTimeChanged: $9dda2f46fd3e5aaf$var$waypointTimeChanged,
    waypointPathTypeChanged: $9dda2f46fd3e5aaf$var$waypointPathTypeChanged,
    waypointNameChanged: $9dda2f46fd3e5aaf$var$waypointNameChanged,
    keyframeIsEditingChanged: $9dda2f46fd3e5aaf$var$keyframeIsEditingChanged,
    keyframeIsSelectedChanged: $9dda2f46fd3e5aaf$var$keyframeIsSelectedChanged,
    keyframeOrderChanged: $9dda2f46fd3e5aaf$var$keyframeOrderChanged,
    waypointIgnoreReferenceFrameChanged: $9dda2f46fd3e5aaf$var$waypointIgnoreReferenceFrameChanged,
    waypointConfirmed: $9dda2f46fd3e5aaf$var$waypointConfirmed,
    teachWaypointAndCloseButtonClicked: $9dda2f46fd3e5aaf$var$teachWaypointAndCloseButtonClicked,
    robotCommandChanged: $9dda2f46fd3e5aaf$var$robotCommandChanged,
    robotCommandWaitForTimeTimeChanged: $9dda2f46fd3e5aaf$var$robotCommandWaitForTimeTimeChanged,
    robotCommandSetPayloadWeightChanged: $9dda2f46fd3e5aaf$var$robotCommandSetPayloadWeightChanged,
    robotCommandSetSpeedMoveLVelocityScalingFactorChanged: $9dda2f46fd3e5aaf$var$robotCommandSetSpeedMoveLVelocityScalingFactorChanged,
    robotCommandSetSpeedMoveJVelocityScalingFactorChanged: $9dda2f46fd3e5aaf$var$robotCommandSetSpeedMoveJVelocityScalingFactorChanged
};


const $0ecc74569f33ab77$export$e65215519ed506a1 = (sequence, newRobotClips)=>{
    sequence.setRobotParametersClips([
        ...newRobotClips
    ]);
    sequence.setDirty();
};




function $617ae29c292e8fe0$export$2e2bcd8739ae039({ position: position , rotation: rotation  }) {
    return new $gXNCa$three.Matrix4().makeTranslation(...position.toArray()).multiply(new $gXNCa$three.Matrix4().makeRotationFromQuaternion(rotation)).toArray();
}


const $2ace2e9d5c226f9c$export$2703143e0251f0 = (sequence, instruction, clipId)=>{
    instruction.setParameter("clipId", clipId);
    const getClipById = (id)=>sequence?.mApp?.robotParameters?.clips.find((clip)=>clip.id === id) || sequence?.robotParameters?.clips.find((clip)=>clip.id === id);
    const existingClip = getClipById(clipId);
    sequence.mApp.notify("onInstructionChanged", existingClip);
};
const $2ace2e9d5c226f9c$export$667527877a795588 = (sequence, instruction)=>{
    const robot = (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotConfig();
    const newClip = $d5cc77669caa91ad$export$75ff2183706c7173();
    newClip.name = (0, $1d3cf5330bb207de$export$64c313e59f94d976)(sequence.mApp)("Robot path");
    newClip.robotId = robot.parameters.robotId;
    newClip.teachingReferenceFrame = {
        arrayMatrix__referenceFrame_world: new $gXNCa$three.Matrix4().toArray(),
        arrayMatrix__referenceFrame_robotKinematicsChainRoot: new $gXNCa$three.Matrix4().toArray()
    };
    sequence.robotParameters.clips = [
        ...sequence?.robotParameters?.clips || [],
        newClip
    ];
    instruction.setParameter("clipId", newClip.id);
    instruction.setParameter("executionReferenceFrame", newClip.teachingReferenceFrame);
    instruction.setParameter("endEffectorToolCenterPoint", new $gXNCa$three.Matrix4().toArray());
    sequence.mApp.notify("onInstructionChanged", newClip);
};
const $2ace2e9d5c226f9c$export$54d6f365d65dbbe9 = ({ application: application , robotClip: robotClip  })=>{
    const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(application.robotParameters.clips, {
        index: application.robotParameters.clips.findIndex((clip)=>clip.id === robotClip.id),
        item: robotClip
    });
    application.robotParameters.clips = [
        ...newRobotClips
    ];
    application.robotParameters.clips.forEach((clip)=>application.notify("onInstructionChanged", clip));
    application.setDirty();
};
const $2ace2e9d5c226f9c$export$590ba4bde3690df4 = (ctx3D)=>ctx3D.setTopManipulator("manip-rotate-translate");
const $2ace2e9d5c226f9c$export$24c0dc7a46687103 = (g3DContext)=>()=>g3DContext.robotAppsService.send("RobotInstruction/onPartsMoved");
const $2ace2e9d5c226f9c$export$93ec683ddcc6fd5c = (context, event, actionMeta)=>{
    Object.values(context.reactStateUpdateFunctions).forEach((f)=>f(actionMeta.state.value));
};
const $2ace2e9d5c226f9c$export$9cd1b7e07a4d109e = ()=>{};
const $2ace2e9d5c226f9c$export$1a3cf5ffcf3bfed5 = ()=>{};
const $2ace2e9d5c226f9c$export$711758442dc6f794 = ({ sequence: sequence , instruction: instruction , robotClip: robotClip  })=>{
    instruction.setParameter("clipId", robotClip.id);
    const saveableRobotClip = {
        ...robotClip,
        keyframes: robotClip.keyframes.map(({ ...restOfKeyframe })=>restOfKeyframe)
    };
    const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(sequence.robotParameters.clips, {
        index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(saveableRobotClip),
        item: saveableRobotClip
    });
    (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, newRobotClips);
    sequence.mApp.notify("onInstructionChanged", saveableRobotClip);
};
const $2ace2e9d5c226f9c$export$d7ce143e51c6582e = ()=>{
    return {
        jointAngles: (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotJointStatesInRad(),
        pose: (0, $617ae29c292e8fe0$export$2e2bcd8739ae039)((0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotStateCartesianPoseInMM())
    };
};
const $2ace2e9d5c226f9c$export$a1d3a812a86859b6 = (sequence)=>{
    const clip = sequence.robotParameters?.clips.find((clip)=>clip.keyframes.some((keyframe)=>keyframe.isSelected));
    if (clip) {
        const keyframeIndex = clip.keyframes.findIndex((keyframe)=>keyframe.isSelected);
        const updatedClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(clip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeIsSelectedChanged({
            keyframeIndex: keyframeIndex,
            isSelected: false,
            selectedReferenceFrame: null
        }));
        const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(sequence.robotParameters.clips, {
            index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(clip),
            item: updatedClip
        });
        sequence.robotParameters.clips = newRobotClips;
    }
};
const $2ace2e9d5c226f9c$export$f132b7f1a8fec800 = (sequence)=>{
    const application = sequence.mApp;
    const clip = application.robotParameters?.clips.find((clip)=>clip.keyframes.some((keyframe)=>keyframe.isSelected));
    if (clip) {
        const keyframeIndex = clip.keyframes.findIndex((keyframe)=>keyframe.isSelected);
        const updatedClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(clip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeIsSelectedChanged({
            keyframeIndex: keyframeIndex,
            isSelected: false,
            selectedReferenceFrame: null
        }));
        const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(application.robotParameters.clips, {
            index: $d5cc77669caa91ad$export$a8b22829e538b5fc(application.robotParameters.clips)(clip),
            item: updatedClip
        });
        application.robotParameters.clips = newRobotClips;
    }
};
const $2ace2e9d5c226f9c$export$93c0804a1c339b09 = ({ id: id , sequence: sequence  })=>sequence?.robotParameters?.clips.find((clip)=>clip.id === id);
const $2ace2e9d5c226f9c$export$8587ccd1159a53ed = ({ id: id , application: application  })=>application.robotParameters?.clips.find((clip)=>clip.id === id);
const $2ace2e9d5c226f9c$export$5ddd3c8da8487977 = (application)=>application?.robotParameters?.clips.some((clip)=>clip.keyframes.some((keyframe)=>keyframe.isEditing)) || application?.mSequences.some((sequence)=>sequence.robotParameters?.clips.some((clip)=>clip.keyframes.some((keyframe)=>keyframe.isEditing)));


var $1b81f7b87aae9d14$export$2e2bcd8739ae039 = {
    RobotAssetsRobotArraysOnRegenerateClick: (pLibrary)=>(context, event, actionMeta)=>{
            const { newArrays: newArrays  } = event;
            pLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onRegenerateClick",
                payload: {
                    newArrays: newArrays,
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
            (0, $2ace2e9d5c226f9c$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnDeleteClick: (pLibrary)=>(context, event, actionMeta)=>{
            const { newArrays: newArrays  } = event;
            pLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onDeleteClick",
                payload: {
                    newArrays: newArrays,
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
            (0, $2ace2e9d5c226f9c$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnLockedDeleteClick: (widgets)=>(context, event, actionMeta)=>{
            widgets.messageBox("Before deleting this robot array, remove the robot loop command from any sequences using this robot array.", "warning");
            (0, $2ace2e9d5c226f9c$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnCopyClick: (pLibrary)=>(context, event, actionMeta)=>{
            const { newArrays: newArrays  } = event;
            pLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onCopyClick",
                payload: {
                    newArrays: newArrays,
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
            (0, $2ace2e9d5c226f9c$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        }
};




var $1f45cbeb3437c37b$export$2e2bcd8739ae039 = {
    addReactStateUpdateFunction: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>({
                    ...context.reactStateUpdateFunctions,
                    [event.idxFunc.id]: event.idxFunc.func
                })
        }),
    removeReactStateUpdateFunction: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        }),
    reactUpdateState: ()=>(0, $2ace2e9d5c226f9c$export$93ec683ddcc6fd5c),
    onReactComponentMount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>({
                    ...context.reactStateUpdateFunctions,
                    [event.idxFunc.id]: event.idxFunc.func
                })
        }),
    onReactComponentUnmount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        })
};


var $084cd0ab38537745$exports = {};

$parcel$export($084cd0ab38537745$exports, "create", () => $084cd0ab38537745$export$185802fd694ee1f5);

var $762e52de3d957256$exports = {};
//https://github.com/jkomyno/fetch-timeout/blob/master/src/index.js
/* eslint-disable */ /**
 * [timeoutPromise description]
 * @param  {Promise} promise
 * @param  {number} timeout
 * @param  {string} error
 * @return
 */ function $762e52de3d957256$var$timeoutPromise(promise, timeout, error) {
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            reject(error);
        }, timeout);
        promise.then(resolve, reject);
    });
}
/**
 * adds the possibility to set a timeout after which
 * a custom error is returned.
 * @param  {string} url     url to pass to node-fetch
 * @param  {object} [options] options to pass to node-fetch
 * @param  {number} [timeout] maximum acceptable timeout before considering the request as failed
 * @param  {string} [error]   custom error string after the timeout is expired
 * @return {Promise}
 */ $762e52de3d957256$exports = function fetchTimeout(url, options, timeout, error) {
    error = error || "Timeout error";
    options = options || {};
    timeout = timeout || 10000;
    return $762e52de3d957256$var$timeoutPromise(fetch(url, options), timeout, error);
};


const $084cd0ab38537745$export$185802fd694ee1f5 = (getRemoteHost, doAjaxPromise)=>{
    const _fetch = doAjaxPromise;
    async function get(url) {
        const response = await fetch(url);
        if (!response.ok) {
            const error = await response.json();
            throw error;
        }
        const data = await response.json();
        return data;
    }
    /**
   * getTimeout.
   *
   * @param {string} url
   * @param {number} timeout
   * @param {string} error
   * @returns {Promise<any>}
   */ async function getWithTimeout(url, timeout, error) {
        const response = await (0, (/*@__PURE__*/$parcel$interopDefault($762e52de3d957256$exports)))(url, {}, timeout, error);
        if (!response.ok) {
            const error = await response.json();
            throw error;
        }
        const data = await response.json();
        return data;
    }
    /**
   * post.
   *
   * @param {string} url
   * @param {Object} body
   */ async function post(url, body = {}) {
        const response = await _fetch(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) {
            const error = await response.json();
            throw error;
        }
        const data = await response.json();
        return data;
    }
    /**
   * put.
   *
   * @param {string} url
   * @param {Object} body
   */ async function put(url, body = {}) {
        return await _fetch(url, {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    async function getRosConnectionStatus() {
        const path = `/v1/robot/get-ros-connection-status`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error, data] = await (0, $gXNCa$toawait.to)(get(URL));
        if (error) throw error;
        return data;
    }
    /**
   * startStreamingFrameDeltas.
   *
   * @param {import('../model/types').ExecuteFrameDeltasRequestBody} payload
   * @returns {Promise<any>}
   */ async function startStreamingJoggerFrameDeltas(payload) {
        const path = `/v1/robot-jogger/start-streaming-frame-deltas`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error] = await (0, $gXNCa$toawait.to)(post(URL, payload));
        if (error) {
            console.error(error);
            throw error;
        }
    }
    /**
   * startStreamingJointDeltas.
   *
   * @param {import('../model/types').ExecuteJointDeltaRequestBody} payload
   * @returns {Promise<any>}
   */ async function startStreamingJoggerJointDeltas(payload) {
        const path = `/v1/robot-jogger/start-streaming-joint-deltas`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error] = await (0, $gXNCa$toawait.to)(post(URL, payload));
        if (error) {
            console.error(error);
            throw error;
        }
    }
    /**
   * stopStreamingDeltas.
   *
   * @returns {Promise<any>}
   */ async function stopStreamingJoggerDeltas() {
        const path = `/v1/robot-jogger/stop-streaming-deltas`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error] = await (0, $gXNCa$toawait.to)(post(URL));
        if (error) {
            console.error(error);
            throw error;
        }
    }
    /**
   * fetchRobotState.
   * @returns {Promise<any>}
   */ async function fetchRobotState() {
        const path = `/v1/robot-jogger/get-robot-state`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error, response] = await (0, $gXNCa$toawait.to)(getWithTimeout(URL, 1000, "fetchRobotState timeout error"));
        if (error) {
            console.error(error);
            throw error;
        }
        return response;
    }
    /**
   * setMachineBuilderRobotModelCurrentState.
   * @returns {Promise<any>}
   */ async function setMachineBuilderRobotModelCurrentState(sequenceName, nextInstructionIndex, data) {
        const path = `/v1/application/set_machinebuilder_robot_model_current_state/${sequenceName}`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error, response] = await (0, $gXNCa$toawait.to)(put(URL, {
            ...data,
            nextInstructionIndex: nextInstructionIndex
        }));
        if (error) {
            console.error(error);
            throw error;
        }
        return response;
    }
    /**
   * moveJ
   *
   * @param {import('../model/types').JointState} payload
   */ async function moveJ(payload) {
        const path = `/v1/robot/move-j`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error, data] = await (0, $gXNCa$toawait.to)(post(URL, payload));
        if (error) {
            console.error(error);
            throw error;
        }
        return data;
    }
    /**
   * moveStop
   *
   */ async function moveStop() {
        const path = `/v1/robot/move-stop`;
        const remoteHost = getRemoteHost();
        const URL = `${remoteHost}${path}`;
        const [error] = await (0, $gXNCa$toawait.to)(post(URL));
        if (error) {
            console.error(error);
            throw error;
        }
    }
    return {
        startStreamingJoggerFrameDeltas: startStreamingJoggerFrameDeltas,
        startStreamingJoggerJointDeltas: startStreamingJoggerJointDeltas,
        stopStreamingJoggerDeltas: stopStreamingJoggerDeltas,
        fetchRobotState: fetchRobotState,
        getRosConnectionStatus: getRosConnectionStatus,
        setMachineBuilderRobotModelCurrentState: setMachineBuilderRobotModelCurrentState,
        moveJ: moveJ,
        moveStop: moveStop
    };
};



var $6e3a5bfdf5c148fb$export$2e2bcd8739ae039 = {
    onMount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>({
                    ...context.reactStateUpdateFunctions,
                    [event.idxFunc.id]: event.idxFunc.func
                })
        }),
    onUnmount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        }),
    robotLoopInstructionOnArraySelected: ()=>(context, event)=>{
            const { application: application , arrayId: arrayId , instruction: instruction  } = event;
            application.transition({
                type: "robot_loop_instruction/onArraySelected",
                payload: {
                    arrayId: arrayId,
                    instruction: instruction
                }
            });
        },
    robotLoopInstructionOnChildSequenceNameChange: ()=>(context, event)=>{
            const { sequenceName: sequenceName , instruction: instruction  } = event;
            instruction.setParameter("sequenceName", sequenceName);
        },
    robotLoopInstructionOnStartFromChange: (helpers, widgets)=>(context, event)=>{
            const { startFrom: startFrom , instruction: instruction , application: application , setStartFrom: setStartFrom  } = event;
            const storedStartFrom = instruction.getParameter("startFrom");
            const expressionValidationError = helpers.getExpressionValidationFunction(application.getParametersObject())(startFrom);
            const minValueValidationError = expressionValidationError ? true : helpers.getMinMaxValidationFunction({
                min: 1
            })(startFrom);
            const maxValueValidationError = expressionValidationError ? true : helpers.getMinMaxValidationFunction({
                max: instruction.getParameter("arrayValue").length
            })(startFrom);
            // Update instruction parameter if no error, else revert react state to previous valid state
            if (!minValueValidationError && !maxValueValidationError) instruction.setParameter("startFrom", startFrom);
            else {
                setStartFrom(storedStartFrom);
                widgets.messageBox(expressionValidationError ?? minValueValidationError + ". Your changes have been reverted." ?? maxValueValidationError + ". Your changes have been reverted.", "warning");
            }
        },
    robotLoopInstructionOnDeleteButtonClick: ()=>(context, event)=>{
            const { sequence: sequence , instruction: instruction  } = event;
            sequence.removeInstruction(sequence.getInstructionIndex(instruction));
        }
};




/**
 * @typedef {{
 *  id: import("./UUID").UUID,
 *  waypoint: {
 *    pathType: "movel" | "movej",
 *    ignoreReferenceFrame: boolean,
 *    blendRadius: number,
 *    velocityScalingFactor: number,
 *    accelerationScalingFactor: number,
 *    name: `Waypoint ${number}`
 *  },
 *  setPayload: {
 *    weight: number,
 *  },
 *  timeStamp: number,
 *  isEditing: boolean,
 * }} WaypointKeyframe
 */ /**
 * Creates a new object representing a waypoint.
 *
 * @param {boolean} [ignoreReferenceFrame=true] - Specifies whether to ignore the reference frame.
 * @param {number} index - The index of the waypoint.
 * @returns {WaypointKeyframe} - An object representing the newly created waypoint.
 */ function $7eced89b6dbac1bc$export$185802fd694ee1f5(ignoreReferenceFrame = true, index, jointAngles, pose) {
    return {
        id: (0, $gXNCa$uuid.v4)(),
        waypoint: {
            pathType: "movel",
            ignoreReferenceFrame: ignoreReferenceFrame,
            blendRadius: -1,
            velocityScalingFactor: 0.1,
            accelerationScalingFactor: 0.1,
            jointAngles: jointAngles,
            pose: pose,
            name: `Waypoint ${index + 1}`
        },
        setPayload: {
            weight: -1
        },
        timeStamp: -1,
        isEditing: true
    };
}



function $2054c3e627b764ce$export$2e2bcd8739ae039() {
    return {
        id: (0, $gXNCa$uuid.v4)(),
        setPayload: {
            weight: 0
        },
        timeStamp: -1
    };
}




const $ae7047bb41ee4dcc$export$68338063a6e2e619 = ()=>(context, event)=>{
        const { newRobotClips: newRobotClips , application: application  } = event;
        // TODO: if you don't click in a sequence before or
        // application the mCurrentApplication will be undefined
        // maybe we could check with ML team if is the desired behavior
        if (application) {
            application.robotParameters.clips = newRobotClips.map((clip)=>{
                return {
                    ...clip,
                    robotId: context.robotConfig.parameters.robotId
                };
            });
            application.robotParameters.clips.forEach((clip)=>application.notify("onInstructionChanged", clip));
            application.setDirty();
        }
    };
const $ae7047bb41ee4dcc$export$e3cf3fb0b32c3649 = (widgets)=>()=>{
        widgets.messageBox("Add a robot to the configuration before creating a robot path.", "info");
    };
const $ae7047bb41ee4dcc$export$536e74aba0527273 = (widgets)=>()=>{
        widgets.messageBox("Before deleting this robot path, remove it from any sequences using it.", "warning");
    };
const $ae7047bb41ee4dcc$var$onRobotPathClipsChange = ({ application: application , robotClip: robotClip  })=>{
    const newRobotClips = (0, $a85f490c61764882$export$2e2bcd8739ae039)(application.robotParameters.clips, {
        index: application.robotParameters.clips.findIndex((clip)=>clip.id === robotClip.id),
        item: robotClip
    });
    application.robotParameters.clips = [
        ...newRobotClips
    ];
    application.robotParameters.clips.forEach((clip)=>application.notify("onInstructionChanged", clip));
    application.setDirty();
};
const $ae7047bb41ee4dcc$export$af092cc620242b4e = (gLibrary)=>(context, event)=>{
        const { robotClip: newRobotClip  } = event;
        const application = gLibrary.mCurrentApplication;
        // TODO: if you don't click in a sequence before or
        // application the mCurrentApplication will be undefined
        // maybe we could check with ML team if is the desired behavior
        if (application) {
            const { jointAngles: jointAngles , pose: pose  } = (0, $2ace2e9d5c226f9c$export$d7ce143e51c6582e)();
            const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(newRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeAdded({
                keyframe: {
                    ...$7eced89b6dbac1bc$export$185802fd694ee1f5(true, newRobotClip.keyframes.length, jointAngles, pose)
                }
            }));
            $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
                application: application,
                robotClip: robotClip
            });
        }
    };
const $ae7047bb41ee4dcc$export$80213a83a121a8bd = (gLibrary)=>(context, event)=>{
        const { robotClip: robotClipTemporary , keyframeIndex: keyframeIndex  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(robotClipTemporary, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointConfirmed({
            keyframeIndex: keyframeIndex,
            ...(0, $2ace2e9d5c226f9c$export$d7ce143e51c6582e)(),
            isEditing: false
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$69813a61a23def19 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).teachWaypointAndCloseButtonClicked({
            keyframeIndex: parseInt(context.previousEditingKeyframePath?.split("/")[1]),
            ...(0, $2ace2e9d5c226f9c$export$d7ce143e51c6582e)(),
            isEditing: false
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$f65d30b37d4dd6c2 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip  } = event;
        const application = gLibrary.mCurrentApplication;
        const { jointAngles: jointAngles , pose: pose  } = (0, $2ace2e9d5c226f9c$export$d7ce143e51c6582e)();
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeAdded({
            keyframe: {
                ...$7eced89b6dbac1bc$export$185802fd694ee1f5(true, oldRobotClip.keyframes.length, jointAngles, pose)
            }
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$a9cc21c25d411771 = (gLibrary)=>(context, event)=>{
        const { robotClip: robotClip , keyframeIndex: keyframeIndex , pathType: pathType  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(robotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointPathTypeChanged({
            keyframeIndex: keyframeIndex,
            pathType: pathType
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };
const $ae7047bb41ee4dcc$export$f548665b4fc479c9 = (gLibrary)=>(context, event)=>{
        const { robotClip: robotClip , keyframeIndex: keyframeIndex , name: name  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(robotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointNameChanged({
            keyframeIndex: keyframeIndex,
            name: name
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };
const $ae7047bb41ee4dcc$export$43394ddf6ea70c20 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeAdded({
            keyframe: (0, $2054c3e627b764ce$export$2e2bcd8739ae039)()
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$92992eb6a840f30b = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeIsEditingChanged({
            keyframeIndex: keyframeIndex,
            isEditing: true
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$1fcf560cbf094d10 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeRemoved({
            keyframeIndex: keyframeIndex
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$3f0bf6e188739e63 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointTimeChanged({
            keyframeIndex: keyframeIndex,
            time: time
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$470204a8b22b88a2 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframes: keyframes  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeOrderChanged({
            keyframes: keyframes
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClip
        });
    };
const $ae7047bb41ee4dcc$export$2fe1c947be810161 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointIgnoreReferenceFrameChanged({
            keyframeIndex: keyframeIndex,
            ignoreReferenceFrame: ignoreReferenceFrame
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };
const $ae7047bb41ee4dcc$export$1480ee1b32bd10a6 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandChanged({
            keyframeIndex: keyframeIndex,
            robotCommandType: robotCommandType
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };
const $ae7047bb41ee4dcc$export$a4de9465e26e8de8 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandWaitForTimeTimeChanged({
            keyframeIndex: keyframeIndex,
            time: time
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };
const $ae7047bb41ee4dcc$export$59137f7a27c54d49 = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandSetSpeedMoveLVelocityScalingFactorChanged({
            keyframeIndex: keyframeIndex,
            moveLVelocityScalingFactor: moveLVelocityScalingFactor
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };
const $ae7047bb41ee4dcc$export$921fdd77ef87c57d = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandSetSpeedMoveJVelocityScalingFactorChanged({
            keyframeIndex: keyframeIndex,
            moveJVelocityScalingFactor: moveJVelocityScalingFactor
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };
const $ae7047bb41ee4dcc$export$45cdef97f44ff02b = (gLibrary)=>(context, event)=>{
        const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , weight: weight  } = event;
        const application = gLibrary.mCurrentApplication;
        const robotClipUpdated = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandSetPayloadWeightChanged({
            keyframeIndex: keyframeIndex,
            weight: weight
        }));
        $ae7047bb41ee4dcc$var$onRobotPathClipsChange({
            application: application,
            robotClip: robotClipUpdated
        });
    };




const $594b2a3d5ca43856$export$7810d5cd38112d26 = (context, event)=>{
    const { instruction: instruction  } = event;
    instruction.parameters["robotId"] = context.robotConfig.parameters.robotId;
};
const $594b2a3d5ca43856$export$6d7bf92a58d71c43 = (library)=>(context, event)=>{
        const calibrationParts = library.getCurrentApplication().robotParameters.calibrationParts;
        const robotBaseCalibrationReferenceFrame = calibrationParts.find((item)=>item.name === "Robot_Base") || (0, $5736410646f0466e$export$d9d8d55d63ce489c)();
        const { instruction: instruction  } = event;
        // NOTE we don't use `instruction.setParameter` since this is not instance of MachineLogic Instruction
        instruction.parameters["calibrationReferenceFrame"] = robotBaseCalibrationReferenceFrame;
        console.log("### RobotInstructionSequencePrototypeNewInstructionParameterCalibrationReferenceFrame", instruction);
    };
const $594b2a3d5ca43856$export$dd177d09c1b890fb = (context, event)=>{
    const getReferenceFrameByName = (name)=>{
        return Object.values(referenceFrames).find((item)=>item.name === name);
    };
    const getReferenceFrame = (name)=>{
        return getReferenceFrameByName(name) || name == "Robot_Base" && (0, $5736410646f0466e$export$d9d8d55d63ce489c)();
    };
    const application = event.instruction.mApp;
    const applicationId = application.mId;
    const referenceFrames = (0, $e9a5479fa42b7804$export$e1252723db1c541).getReferenceFramesByApplicationId(applicationId);
    const { instruction: instruction , selectedReferenceFrameName: selectedReferenceFrameName  } = event;
    const parentConfig = application.getLibrary().getConfigManager().getParentConfiguration();
    const selectedReferenceFrame = getReferenceFrame(selectedReferenceFrameName);
    instruction.setParameter("calibrationReferenceFrame", selectedReferenceFrame);
    parentConfig.updateApplicationInCalibrationPart(application);
};
const $594b2a3d5ca43856$export$c773dd8118651fdc = (context, event)=>{
    const { instruction: instruction  } = event;
    console.log("### RobotInstructionSequencePrototypeNewInstruction", instruction);
// instruction.parameters['robotId'] = gLibrary.getConfig().mRobots[0].mVID;
};
const $594b2a3d5ca43856$export$8469d2d33791cafa = (context, event)=>{
    const { instruction: instruction , instructionIndex: instructionIndex  } = event;
    instruction.setParameter("instructionIndex", instructionIndex);
};





function $2395189d05dd8ef4$export$2b6febbbdf03a058(context, event) {
    const { movedInstruction: movedInstruction , destinationSequence: destinationSequence  } = event;
    const { mSequence: sourceSequence  } = movedInstruction;
    const localRobotClip = sourceSequence.robotParameters.clips.find((clip)=>clip.id === movedInstruction.getParameter("clipId"));
    // remove the clip from the start sequence
    (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sourceSequence, (0, $b7c3f63a1efa4cdf$exports).removeItem(sourceSequence.robotParameters.clips, {
        index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sourceSequence.robotParameters.clips)(localRobotClip)
    }));
    // add the clip to the end sequence
    (0, $0ecc74569f33ab77$export$e65215519ed506a1)(destinationSequence, (0, $b7c3f63a1efa4cdf$exports).insertItem(destinationSequence.robotParameters.clips, {
        index: destinationSequence.robotParameters.clips.length,
        item: localRobotClip
    }));
}
function $2395189d05dd8ef4$export$48fe590476b7edd2(context, event) {
    const { sequence: sequence  } = event;
    sequence.mInstructions.forEach((instruction)=>{
        instruction.mCategory === "robot" && instruction.mName === "simulate" && instruction.setParameter("instructionIndex", sequence.getInstructionIndex(instruction));
    });
    sequence.setDirty();
}







/**
 *
 * @param {{keyframes: Array.<{isEditing: Boolean}>}} clip
 * @returns Boolean
 */ function $bedf83968cd4d388$export$2e2bcd8739ae039(clip) {
    return clip.keyframes.some((keyframe)=>keyframe.isEditing);
}





function $6d54af42eac2d2e5$var$onRemoveKeyframe(sequence, instruction, curRobotClip, keyframeIndex) {
    const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(curRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeRemoved({
        keyframeIndex: keyframeIndex
    }));
    (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
        sequence: sequence,
        instruction: instruction,
        robotClip: robotClip
    });
}
var $6d54af42eac2d2e5$export$2e2bcd8739ae039 = {
    RobotInstructionEditableOnDeleteClicked: (context, event)=>{
        const { sequence: sequence , instruction: instruction  } = event;
        (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, (0, $b7c3f63a1efa4cdf$exports).removeItem(sequence.robotParameters.clips, {
            index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)({
                id: instruction.mParameters.clipId
            })
        }));
        sequence.removeInstruction(sequence.getInstructionIndex(instruction));
    },
    RobotInstructionEditableOnRobotClipChange: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: robotClip  } = event;
        instruction.setParameter("clipId", robotClip.id);
        const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(sequence.robotParameters.clips, {
            index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(robotClip),
            item: robotClip
        });
        (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, newRobotClips);
        sequence.mApp.notify("onInstructionChanged", robotClip);
    },
    RobotInstructionEditableSaveToRobotAssetsButtonOnClick: (g3DContext)=>(context, event)=>{
            const { sequence: sequence , selectedClip: localRobotClip  } = event;
            const clipToMove = {
                ...sequence.robotParameters.clips.find((c)=>c.id === localRobotClip.id),
                keyframes: sequence.robotParameters.clips.find((c)=>c.id === localRobotClip.id).keyframes.map((keyframe)=>({
                        ...keyframe,
                        isEditing: false
                    }))
            };
            const newApplicationClips = [
                ...sequence.mApp.robotParameters.clips,
                clipToMove
            ];
            sequence.mApp.robotParameters.clips = newApplicationClips;
            const newRobotParameters = {
                ...sequence.mApp.robotParameters
            };
            g3DContext.mGraph.setVertexAttr(sequence.mApp.mVID, "robotParameters", newRobotParameters);
            (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, (0, $b7c3f63a1efa4cdf$exports).removeItem(sequence.robotParameters.clips, {
                index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(localRobotClip)
            }));
        },
    RobotInstructionEditableOnWaypointConfirmed: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointConfirmed({
            keyframeIndex: keyframeIndex,
            ...(0, $2ace2e9d5c226f9c$export$d7ce143e51c6582e)(),
            isEditing: false
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    /**
   * @param {import('../../../model/types').RobotAppsContext} context
   * @param {*} event
   */ RobotInstructionEditableEditWaypointOnTeachWaypointAndCloseButtonClick: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).teachWaypointAndCloseButtonClicked({
            keyframeIndex: parseInt(context.previousEditingKeyframePath?.split("/")[1]),
            ...(0, $2ace2e9d5c226f9c$export$d7ce143e51c6582e)(),
            isEditing: false
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    /**
   * @param {import('../../../model/types').RobotAppsContext} context
   * @param {*} event
   */ RobotInstructionEditableAddWaypointOnTeachWaypointAndCloseButtonClick: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip  } = event;
        const { jointAngles: jointAngles , pose: pose  } = (0, $2ace2e9d5c226f9c$export$d7ce143e51c6582e)();
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeAdded({
            keyframe: {
                ...$7eced89b6dbac1bc$export$185802fd694ee1f5(true, oldRobotClip.keyframes.length, jointAngles, pose)
            }
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnWaypointPathTypeChanged: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , pathType: pathType  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointPathTypeChanged({
            keyframeIndex: keyframeIndex,
            pathType: pathType
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnWaypointNameChanged: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , name: name  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointNameChanged({
            keyframeIndex: keyframeIndex,
            name: name
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnRobotCommandAdded: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeAdded({
            keyframe: (0, $2054c3e627b764ce$export$2e2bcd8739ae039)()
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnWaypointEditClicked: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeIsEditingChanged({
            keyframeIndex: keyframeIndex,
            isEditing: true
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnKeyframeDeleteClicked: (context, event)=>{
        $6d54af42eac2d2e5$var$onRemoveKeyframe(event.sequence, event.instruction, event.robotClip, event.keyframeIndex);
    },
    RobotInstructionJoggerCloseButtonClicked: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip  } = event;
        if ((0, $bedf83968cd4d388$export$2e2bcd8739ae039)(oldRobotClip)) {
            const keyframeIndex = oldRobotClip.keyframes.findIndex((keyframe)=>keyframe.isEditing);
            const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeIsEditingChanged({
                keyframeIndex: keyframeIndex,
                isEditing: false
            }));
            (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
        }
    },
    RobotInstructionEditableOnWaypointTimeChanged: ()=>(context, event)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
            const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointTimeChanged({
                keyframeIndex: keyframeIndex,
                time: time
            }));
            (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
        },
    RobotInstructionEditableOnWaypointClicked: ()=>(context, event)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            sequence.mApp.mSequences.forEach((sequence)=>(0, $2ace2e9d5c226f9c$export$a1d3a812a86859b6)(sequence));
            (0, $2ace2e9d5c226f9c$export$f132b7f1a8fec800)(sequence);
            const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)((0, $2ace2e9d5c226f9c$export$93c0804a1c339b09)({
                id: oldRobotClip.id,
                sequence: sequence
            }), (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeIsSelectedChanged({
                keyframeIndex: keyframeIndex,
                isSelected: true,
                selectedReferenceFrame: oldRobotClip.teachingReferenceFrame
            }));
            (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
        },
    RobotInstructionEditableOnKeyframeOrderChanged: ()=>(context, event)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframes: keyframes  } = event;
            const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).keyframeOrderChanged({
                keyframes: keyframes
            }));
            (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
        },
    RobotInstructionEditableOnIgnoreReferenceFrameChanged: ()=>(context, event)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  } = event;
            const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).waypointIgnoreReferenceFrameChanged({
                keyframeIndex: keyframeIndex,
                ignoreReferenceFrame: ignoreReferenceFrame
            }));
            (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
        },
    RobotInstructionEditableOnKeyframeRobotCommandChanged: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandChanged({
            keyframeIndex: keyframeIndex,
            robotCommandType: robotCommandType
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnKeyframeRobotCommandWaitForTimeTimeChanged: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandWaitForTimeTimeChanged({
            keyframeIndex: keyframeIndex,
            time: time
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnKeyframeRobotCommandSetPayloadWeightChanged: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , weight: weight  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandSetPayloadWeightChanged({
            keyframeIndex: keyframeIndex,
            weight: weight
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandSetSpeedMoveLVelocityScalingFactorChanged({
            keyframeIndex: keyframeIndex,
            moveLVelocityScalingFactor: moveLVelocityScalingFactor
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    },
    RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: (context, event)=>{
        const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  } = event;
        const robotClip = (0, $9dda2f46fd3e5aaf$export$b55a2b8a15f09f32)(oldRobotClip, (0, $9dda2f46fd3e5aaf$export$197c291619fe9a2e).robotCommandSetSpeedMoveJVelocityScalingFactorChanged({
            keyframeIndex: keyframeIndex,
            moveJVelocityScalingFactor: moveJVelocityScalingFactor
        }));
        (0, $2ace2e9d5c226f9c$export$711758442dc6f794)({
            sequence: sequence,
            instruction: instruction,
            robotClip: robotClip
        });
    }
};



var $c8cbcac83f7bb757$export$2e2bcd8739ae039 = {
    RobotInstructionSelectorClipSelectorOnClipMounted: ()=>(context, event)=>{
            const { instruction: instruction , clipId: clipId  } = event;
            instruction.setParameter("clipId", clipId);
        },
    RobotInstructionSelectorClipSelectorOnClipSelected: (context, event)=>{
        const { sequence: sequence , instruction: instruction , clipId: clipId  } = event;
        (0, $2ace2e9d5c226f9c$export$2703143e0251f0)(sequence, instruction, clipId);
    },
    RobotInstructionSelectorClipSelectorOnNewClipSelected: (context, event)=>{
        const { sequence: sequence , instruction: instruction  } = event;
        (0, $2ace2e9d5c226f9c$export$667527877a795588)(sequence, instruction);
    },
    RobotInstructionSelectorClipSelectorOnNewClipMounted: (context, event)=>{
        const { sequence: sequence , instruction: instruction  } = event;
        (0, $2ace2e9d5c226f9c$export$667527877a795588)(sequence, instruction);
    },
    RobotInstructionSelectorStyledDeleteButtonOnClick: (context, event)=>{
        const { sequence: sequence , instruction: instruction  } = event;
        sequence.removeInstruction(sequence.getInstructionIndex(instruction));
    }
};







// https://stackoverflow.com/questions/9907419/how-to-get-a-key-in-a-javascript-object-by-its-value
const $c26706bb9097827e$var$getKeyByValue = (object, value)=>{
    return Object.keys(object).find((key)=>object[key] === value);
};
const $c26706bb9097827e$export$caaae8a880834d95 = (widgets)=>(moveItErrorCodeValue)=>{
        // http://docs.ros.org/en/api/moveit_msgs/html/msg/MoveItErrorCodes.html
        const MoveItErrorCodes = Object.freeze({
            // overall behavior
            // SUCCESS: 1,
            FAILURE: 99999,
            PLANNING_FAILED: -1,
            INVALID_MOTION_PLAN: -2,
            MOTION_PLAN_INVALIDATED_BY_ENVIRONMENT_CHANGE: -3,
            CONTROL_FAILED: -4,
            UNABLE_TO_AQUIRE_SENSOR_DATA: -5,
            TIMED_OUT: -6,
            PREEMPTED: -7,
            // planning & kinematics request errors
            START_STATE_IN_COLLISION: -10,
            START_STATE_VIOLATES_PATH_CONSTRAINTS: -11,
            GOAL_IN_COLLISION: -12,
            GOAL_VIOLATES_PATH_CONSTRAINTS: -13,
            GOAL_CONSTRAINTS_VIOLATED: -14,
            INVALID_GROUP_NAME: -15,
            INVALID_GOAL_CONSTRAINTS: -16,
            INVALID_ROBOT_STATE: -17,
            INVALID_LINK_NAME: -18,
            INVALID_OBJECT_NAME: -19,
            // system errors
            FRAME_TRANSFORM_FAILURE: -21,
            COLLISION_CHECKING_UNAVAILABLE: -22,
            ROBOT_STATE_STALE: -23,
            SENSOR_INFO_STALE: -24,
            COMMUNICATION_FAILURE: -25,
            // kinematics errors
            NO_IK_SOLUTION: -31
        });
        const MoveItErrorTips = Object.freeze({
            PLANNING_FAILED: "Tip: set robot to a lower speed",
            INVALID_MOTION_PLAN: "Tip: ensure robot path does not cause self-collision",
            NO_IK_SOLUTION: "Tip: ensure all robot waypoints are within reach"
        });
        const moveItErrorMessage = $c26706bb9097827e$var$getKeyByValue(MoveItErrorCodes, moveItErrorCodeValue);
        const messageBoxOptions = {
            timeOut: 0,
            extendedTimeOut: 0
        };
        MoveItErrorTips[`${moveItErrorMessage}`] && widgets.messageBox(MoveItErrorTips[`${moveItErrorMessage}`], "warning", messageBoxOptions);
        widgets.messageBox(`Robot Motion Planner: ${moveItErrorMessage}`, "warning", messageBoxOptions);
    };
const $c26706bb9097827e$export$6f80848eed99044 = (library)=>({ data: { applicationName: applicationName , sequenceName: sequenceName , robotSimulationState: robotSimulationState  }  })=>{
        const application = library.getApplication(applicationName);
        const sequence = application.getSequence(sequenceName);
        const instruction = sequence.mInstructions[robotSimulationState.instructionIndex];
        // update the tree view simulation state
        instruction.notify("onRobotSimulationStateChange", robotSimulationState);
        // update the robot instruction card waypoints simulation state
        instruction.robotSimulationState = robotSimulationState;
    };
const $c26706bb9097827e$export$85e3680ebb9483d2 = (library)=>({ data: { applicationName: applicationName , sequenceName: sequenceName , instructionIndex: instructionIndex , keyframes: keyframes  }  })=>{
        const application = library.getApplication(applicationName);
        const sequence = application.getSequence(sequenceName);
        const instruction = sequence.mInstructions[instructionIndex];
        // update the tree view simulation state
        instruction.notify("onRobotSimulationInstructionCompleted", keyframes);
        // update the robot instruction card waypoints simulation state
        instruction.robotSimulationState = "completed";
    };


const $19d97d44cbd0fd8d$export$e25a7f1a95f0e46d = (remoteHost, widgets)=>()=>{
        const websocketHost = remoteHost.replace("http", "ws");
        const socket = (0, ($parcel$interopDefault($gXNCa$socketioclient)))(`${websocketHost}/robot`, {
            transports: [
                "websocket"
            ]
        });
        socket.on("connect", ()=>{
            console.warn("### execution engine websocket client connected");
            (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.onWebsocketClientConnect(socket));
        });
        socket.on("disconnect", (reason)=>{
            console.warn("### execution engine websocket client disconnected", reason);
            socket.off("vention_ros_connecting", $19d97d44cbd0fd8d$var$onVentionRosConnecting);
            socket.off("vention_ros_connected", $19d97d44cbd0fd8d$var$onVentionRosConnected);
            socket.off("vention_ros_disconnecting", $19d97d44cbd0fd8d$var$onVentionRosDisconnecting);
            socket.off("vention_ros_disconnected", $19d97d44cbd0fd8d$var$onVentionRosDisconnected);
            socket.off("vention_ros_error", $19d97d44cbd0fd8d$var$onVentionRosError);
            socket.off("vention_ros_unexpectedly_disconnected", $19d97d44cbd0fd8d$var$onVentionRosUnexpectedlyDisconnected);
            socket.off("on_sequence_move_group_result_error", (0, $c26706bb9097827e$export$caaae8a880834d95)(widgets));
            socket.off("robot_simulation_state_change", $19d97d44cbd0fd8d$var$onRobotSimulationStateChange);
            socket.off("robot_simulation_motion_completed", $19d97d44cbd0fd8d$var$onRobotSimulationMotionCompleted);
        });
        window.addEventListener("unload", ()=>{
            socket.disconnect();
        });
    };
const $19d97d44cbd0fd8d$export$ddb559f5920e68a4 = (0, $9c35425985377ff1$export$2f952c48dd3bb7b0).assign({
    websocketClient: (_, event)=>event.socket
});
/**
 *
 * @param {import('../../../model/types').ContextFromRobotAppsContext} context
 * @param {WebsocketSubscribeEvent} event
 */ const $19d97d44cbd0fd8d$export$7db4f664be73a05f = (context, event)=>{
    const { websocketClient: websocketClient  } = context;
    if (!websocketClient) {
        console.warn("### websocket client is no defined, not possible to add a listener to a topic");
        return;
    }
    const { topic: topic , handler: handler  } = event;
    websocketClient.on(topic, handler);
};
/**
 *
 * @param {import('../../../model/types').ContextFromRobotAppsContext} context
 * @param {WebsocketSubscribeEvent} event
 */ const $19d97d44cbd0fd8d$export$17ac8c06b1034c74 = (context, event)=>{
    const { websocketClient: websocketClient  } = context;
    if (!websocketClient) {
        console.warn("### websocket client is no defined, not possible to remove a listener to a topic");
        return;
    }
    const { topic: topic , handler: handler  } = event;
    websocketClient.off(topic, handler);
};
function $19d97d44cbd0fd8d$var$onVentionRosConnected() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("onVentionRosConnected");
}
function $19d97d44cbd0fd8d$var$onVentionRosDisconnected() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("onVentionRosDisconnected");
}
function $19d97d44cbd0fd8d$var$onVentionRosConnecting() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("onVentionRosConnecting");
}
function $19d97d44cbd0fd8d$var$onVentionRosDisconnecting() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("onVentionRosDisconnecting");
}
function $19d97d44cbd0fd8d$var$onVentionRosUnexpectedlyDisconnected() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("onVentionRosUnexpectedlyDisconnected");
}
const $19d97d44cbd0fd8d$var$messageBox__PositionUnreachable = (widgets)=>()=>{
        // eslint-disable-next-line functional/no-expression-statements
        widgets.messageBox("Position unreachable.", "warning");
    };
function $19d97d44cbd0fd8d$var$onRobotSimulationStateChange(data) {
    // eslint-disable-next-line functional/no-expression-statements
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("MachineLogic/Simulation/onRobotSimulationStateChange", {
        data: data
    });
}
function $19d97d44cbd0fd8d$var$onRobotSimulationMotionCompleted(data) {
    // eslint-disable-next-line functional/no-expression-statements
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("MachineLogic/Simulation/onRobotSimulationMotionCompleted", {
        data: data
    });
}
/**
 * @param {{ connectedRobotType: string }} data
 */ function $19d97d44cbd0fd8d$var$onVentionRosConnectedRobotType(data) {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()("onVentionRosConnectedRobotType", data);
}
function $19d97d44cbd0fd8d$var$onVentionRosError(message) {
    console.warn(message);
}
function $19d97d44cbd0fd8d$var$onVentionRosRobotDriverState(ventionRosRobotDriverState) {
    const { getDispatch: getDispatch , getVentionRosRobotDriverState: getVentionRosRobotDriverState , isVentionRosConnected: isVentionRosConnected  } = (0, $e9a5479fa42b7804$export$e1252723db1c541);
    const dispatch = getDispatch();
    const prevVentionRosRobotDriverState = getVentionRosRobotDriverState();
    if (prevVentionRosRobotDriverState?.robot_safety_state.state !== ventionRosRobotDriverState.robot_safety_state.state || prevVentionRosRobotDriverState?.robot_ready_state.state !== ventionRosRobotDriverState.robot_ready_state.state) {
        dispatch("onVentionRosRobotDriverState", {
            ventionRosRobotDriverState: ventionRosRobotDriverState
        });
        if (ventionRosRobotDriverState.robot_ready_state.state === (0, $49b61417b640529d$export$2a603a1db86c460f).READY) // eslint-disable-next-line functional/no-expression-statements
        dispatch("onVentionRosRobotDriverState/robotReadyState/ready");
        if (isVentionRosConnected() && ventionRosRobotDriverState.robot_ready_state.state === (0, $49b61417b640529d$export$2a603a1db86c460f).DISCONNECTED) dispatch("onVentionRosUnexpectedlyDisconnected");
    }
}
function $19d97d44cbd0fd8d$export$889ba87d660d0cc9(context) {
    const { websocketClient: websocketClient  } = context;
    websocketClient.emit("recover_robot_ready_state_to_ready");
}
function $19d97d44cbd0fd8d$export$cff3ba0a2598ba98(context) {
    const { websocketClient: websocketClient  } = context;
    websocketClient.emit("request_vention_ros_connection_status");
}
function $19d97d44cbd0fd8d$export$3aa9d910fc64e633() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_connecting", $19d97d44cbd0fd8d$var$onVentionRosConnecting));
}
function $19d97d44cbd0fd8d$export$e7b48d4dfe57cd7d() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_connected", $19d97d44cbd0fd8d$var$onVentionRosConnected));
}
function $19d97d44cbd0fd8d$export$2b24a89f8e6ec06a() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_disconnecting", $19d97d44cbd0fd8d$var$onVentionRosDisconnecting));
}
function $19d97d44cbd0fd8d$export$185ade5f1f88b9c7() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_disconnected", $19d97d44cbd0fd8d$var$onVentionRosDisconnected));
}
function $19d97d44cbd0fd8d$export$cdedf8642d5bfe7e() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_unexpectedly_disconnected", $19d97d44cbd0fd8d$var$onVentionRosUnexpectedlyDisconnected));
}
function $19d97d44cbd0fd8d$export$47cbeee0d1cf0fcd() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_error", $19d97d44cbd0fd8d$var$onVentionRosError));
}
function $19d97d44cbd0fd8d$export$20441db47207d5c9() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_connected_robot_type", $19d97d44cbd0fd8d$var$onVentionRosConnectedRobotType));
}
function $19d97d44cbd0fd8d$export$e65306603daf27f5() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("vention_ros_robot_driver_state", $19d97d44cbd0fd8d$var$onVentionRosRobotDriverState));
}
function $19d97d44cbd0fd8d$export$2aea949bc15990c4() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("vention_ros_connecting", $19d97d44cbd0fd8d$var$onVentionRosConnecting));
}
function $19d97d44cbd0fd8d$export$b45d4ee102b32fd5() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("vention_ros_connected", $19d97d44cbd0fd8d$var$onVentionRosConnected));
}
function $19d97d44cbd0fd8d$export$2307129451fa6e2e() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("vention_ros_disconnecting", $19d97d44cbd0fd8d$var$onVentionRosDisconnecting));
}
function $19d97d44cbd0fd8d$export$4f0838f8255b13b5() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("vention_ros_disconnected", $19d97d44cbd0fd8d$var$onVentionRosDisconnected));
}
function $19d97d44cbd0fd8d$export$9289e6175d574dd7() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("vention_ros_unexpectedly_disconnected", $19d97d44cbd0fd8d$var$onVentionRosUnexpectedlyDisconnected));
}
function $19d97d44cbd0fd8d$export$f245d609b5feb083() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("vention_ros_error", $19d97d44cbd0fd8d$var$onVentionRosError));
}
function $19d97d44cbd0fd8d$export$8fbb1072887c6e2f() {
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("vention_ros_robot_driver_state", $19d97d44cbd0fd8d$var$onVentionRosRobotDriverState));
}
const $19d97d44cbd0fd8d$export$d1c00bd82524f7a0 = (widgets)=>()=>{
        // eslint-disable-next-line functional/no-expression-statements
        (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("on_jog_controller_error", $19d97d44cbd0fd8d$var$messageBox__PositionUnreachable(widgets)));
    };
const $19d97d44cbd0fd8d$export$a844665721a81be4 = (widgets)=>()=>{
        // eslint-disable-next-line functional/no-expression-statements
        (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.unsubscribe("on_jog_controller_error", $19d97d44cbd0fd8d$var$messageBox__PositionUnreachable(widgets)));
    };
const $19d97d44cbd0fd8d$export$71c9e1ea970cc265 = (widgets)=>(data)=>{
        // eslint-disable-next-line functional/no-expression-statements
        (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("on_sequence_move_group_result_error", (0, $c26706bb9097827e$export$caaae8a880834d95)(widgets)), data);
    };
function $19d97d44cbd0fd8d$export$3d2781b49a06f17c() {
    // eslint-disable-next-line functional/no-expression-statements
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("robot_simulation_state_change", $19d97d44cbd0fd8d$var$onRobotSimulationStateChange));
}
function $19d97d44cbd0fd8d$export$6d60e17d5da7f959() {
    // eslint-disable-next-line functional/no-expression-statements
    (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("robot_simulation_motion_completed", $19d97d44cbd0fd8d$var$onRobotSimulationMotionCompleted));
}
function $19d97d44cbd0fd8d$export$1108607d191e860d(context) {
    const { websocketClient: websocketClient  } = context;
    websocketClient.emit("enable_freedrive");
}
function $19d97d44cbd0fd8d$export$f10ab6b5265ce2f(context) {
    const { websocketClient: websocketClient  } = context;
    websocketClient.emit("disable_freedrive");
}
function $19d97d44cbd0fd8d$export$2e971a3a567db44f(context, event) {
    const { websocketClient: websocketClient  } = context;
    const { constraintIndex: constraintIndex  } = event;
    websocketClient.emit("toggle_freedrive_constraint", constraintIndex);
}




function $805d9d09d6e22601$export$2e2bcd8739ae039(object, existingPath, remainingPath, value) {
    return (0, ($parcel$interopDefault($gXNCa$lodash))).has(object, existingPath) ? (0, ($parcel$interopDefault($gXNCa$lodash))).set(object, existingPath.concat(remainingPath), value) : object;
}







const $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running = (context)=>{
    if ((0, $e9a5479fa42b7804$export$e1252723db1c541).getFreedriveStatus().running) (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)(context);
};
const { getRobotStateCartesianPoseInMM: $dbd3670ef76bb404$var$getRobotStateCartesianPoseInMM  } = (0, $e9a5479fa42b7804$export$e1252723db1c541);
const $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction = (0, $gXNCa$xstate.assign)({
    reactStateUpdateFunctions: (context, event)=>({
            ...context.reactStateUpdateFunctions,
            [event.idxFunc.id]: event.idxFunc.func
        })
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction = (0, $gXNCa$xstate.assign)({
    reactStateUpdateFunctions: (context, event)=>{
        /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
        return newReactStateUpdateFunctions;
    }
});
const $dbd3670ef76bb404$var$RobotConfig__updateRobotType = (0, $gXNCa$xstate.assign)((context, { robotType: robotType  })=>(0, $gXNCa$lodash.set)(context, [
        "robotConfig",
        "parameters",
        "robotType"
    ], robotType));
const $dbd3670ef76bb404$var$RobotConfig__updateRobotName = (0, $gXNCa$xstate.assign)((context, { robotName: robotName  })=>(0, $gXNCa$lodash.set)(context, [
        "robotConfig",
        "parameters",
        "friendlyName"
    ], robotName));
const $dbd3670ef76bb404$var$robotAppsMachineContext__addRobotConfigFromInstruction = (0, $gXNCa$xstate.assign)({
    robotConfig: (context, event)=>event.robotConfig
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__addRobotConfig = (0, $gXNCa$xstate.assign)({
    robotConfig: (context, event)=>(0, $a94c350358e784aa$export$678e4b22a1ba9af5)({
            uniqueRobotName: event.uniqueRobotName,
            uniqueRobotId: (0, $gXNCa$uuid.v4)(),
            controllerId: event.controllerId
        })
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__removeRobotConfig = (0, $gXNCa$xstate.assign)({
    robotConfig: ()=>null
});
const $dbd3670ef76bb404$var$reactUpdateState = (context, event, actionMeta)=>{
    // eslint-disable-next-line functional/no-expression-statements
    Object.values(context.reactStateUpdateFunctions).forEach((f)=>f(actionMeta.state.value));
};
const $dbd3670ef76bb404$var$DEG_TO_RAD = Math.PI / 180;
const $dbd3670ef76bb404$var$MM_TO_M = 1e-3;
/**
 * @param {import("../../model/types").RobotAppsContext} _
 * @param {Object} event
 * @param {'x' | 'y' | 'z'} event.letter The axisLabel of the translation to apply the delta
 * @param {Number} event.value The delta value of the translation (in mm).
 */ const $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas = (ExecutionEngineAPI)=>(_, { letter: letter , value: value  })=>{
        // eslint-disable-next-line functional/no-expression-statements
        ExecutionEngineAPI.startStreamingJoggerFrameDeltas((0, $gXNCa$lodash.set)((0, $a94c350358e784aa$export$b2a985e8ea03724b)(), [
            "linearDelta",
            letter
        ], value * $dbd3670ef76bb404$var$MM_TO_M));
    };
/**
 * @param {import("../../model/types").RobotAppsContext} _
 * @param {Object} event
 * @param {'x' | 'y' | 'z'} event.letter The label of the rotation axis to apply the delta
 * @param {Number} event.value The delta value of the rotation (in degrees).
 */ const $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas = (ExecutionEngineAPI)=>(_, { letter: letter , value: value  })=>{
        // eslint-disable-next-line functional/no-expression-statements
        ExecutionEngineAPI.startStreamingJoggerFrameDeltas((0, $gXNCa$lodash.set)((0, $a94c350358e784aa$export$b2a985e8ea03724b)(), [
            "angularDelta",
            letter
        ], value * $dbd3670ef76bb404$var$DEG_TO_RAD));
    };
/**
 * @param {import("../../model/types").RobotAppsContext} _
 * @param {Object} event
 * @param {0 | 1 | 2 | 3 | 4 | 5} event.index The index of the joint to apply the delta to.
 * @param {Number} event.delta The delta to be applied to the joint (in degrees).
 */ const $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas = (ExecutionEngineAPI)=>(_, { index: index , delta: delta  })=>{
        // eslint-disable-next-line functional/no-expression-statements
        ExecutionEngineAPI.startStreamingJoggerJointDeltas((0, $gXNCa$lodash.set)((0, $a94c350358e784aa$export$114d07bef9113991)(), [
            "deltas",
            index
        ], delta * $dbd3670ef76bb404$var$DEG_TO_RAD));
    };
const $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas = (ExecutionEngineAPI)=>()=>{
        // eslint-disable-next-line functional/no-expression-statements
        ExecutionEngineAPI.stopStreamingJoggerDeltas();
    };
const $dbd3670ef76bb404$var$robotAppsMachineContext__updateRobotState = (0, $gXNCa$xstate.assign)({
    /**
   * @param {{
   *   data: import("../../model/types").ExecutionEngineRobotState
   * }} event
   * @returns {import("../../model/types").RobotState}
   */ robotState: (_, event)=>({
            jointStates: event.data.jointStates,
            cartesianPose: (0, $a94c350358e784aa$export$a2a01fea32009ccc)(...event.data.cartesianPose),
            freedriveStatus: event.data.freedriveStatus
        })
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__addNewReferenceFrame = (0, $gXNCa$xstate.assign)((context, { applicationId: applicationId  })=>(0, $gXNCa$lodash.set)(context, [
        "referenceFrames",
        (0, $c1079e917223b83f$export$d177d65704b00822)(applicationId)
    ], (0, $a94c350358e784aa$export$eb141b764bb7abbb)()));
const $dbd3670ef76bb404$var$robotAppsMachineContext__addReferenceFrames = (0, $gXNCa$xstate.assign)((context, { applicationId: applicationId , referenceFrames: referenceFrames  })=>{
    // eslint-disable-next-line functional/no-expression-statements
    referenceFrames.forEach((referenceFrame)=>{
        // eslint-disable-next-line functional/no-expression-statements
        (0, $gXNCa$lodash.set)(context, [
            "referenceFrames",
            (0, $c1079e917223b83f$export$d177d65704b00822)(applicationId)
        ], referenceFrame);
    });
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__removeApplicationReferenceFrames = (0, $gXNCa$xstate.assign)((context, { applicationId: applicationId  })=>({
        referenceFrames: (0, $7a9e5387fae80ef8$export$2e2bcd8739ae039)(context.referenceFrames, (_, id)=>!(0, $c1079e917223b83f$export$e7fbeaf048afc774)(id, applicationId))
    }));
const $dbd3670ef76bb404$var$robotAppsMachineContext__removeReferenceFrame = (0, $gXNCa$xstate.assign)((context, { referenceFrameId: referenceFrameId  })=>{
    delete context.referenceFrames[referenceFrameId]; // eslint-disable-line functional/no-expression-statements, functional/immutable-data
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__updateReferenceFrameName = (0, $gXNCa$xstate.assign)((context, { referenceFrameId: referenceFrameId , name: name  })=>(0, $805d9d09d6e22601$export$2e2bcd8739ae039)(context, [
        "referenceFrames",
        referenceFrameId
    ], [
        "name"
    ], name));
const $dbd3670ef76bb404$var$robotAppsMachineContext__updateEditingReferenceFrameReferenceFrame = (0, $gXNCa$xstate.assign)((context)=>(0, $805d9d09d6e22601$export$2e2bcd8739ae039)(context, [
        "referenceFrames",
        context.editingReferenceFrameId
    ], [
        "arrayMatrix__referenceFrame_robotKinematicsChainRoot"
    ], (0, $617ae29c292e8fe0$export$2e2bcd8739ae039)($dbd3670ef76bb404$var$getRobotStateCartesianPoseInMM())));
const $dbd3670ef76bb404$var$robotAppsMachineContext__updateEditingReferenceFrameId = (0, $gXNCa$xstate.assign)({
    editingReferenceFrameId: (_, { referenceFrameId: referenceFrameId  })=>referenceFrameId
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId = (0, $gXNCa$xstate.assign)({
    previousEditingReferenceFrameId: ({ editingReferenceFrameId: editingReferenceFrameId  })=>editingReferenceFrameId,
    editingReferenceFrameId: ""
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__updateJoggerSpeedPercentage = (0, $gXNCa$xstate.assign)({
    joggerSpeedPercentage: (_, { joggerSpeedPercentage: joggerSpeedPercentage  })=>joggerSpeedPercentage
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__setEditingKeyframePath = (0, $gXNCa$xstate.assign)({
    editingKeyframePath: (_, { robotClip: robotClip , keyframeIndex: keyframeIndex  })=>`${robotClip.id}/${keyframeIndex}`
});
const $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath = (0, $gXNCa$xstate.assign)({
    editingKeyframePath: ()=>"",
    previousEditingKeyframePath: (context)=>context.editingKeyframePath
});
const $dbd3670ef76bb404$var$messageBox__RobotSafetyReduced = (widgets)=>()=>{
        if ((0, $e9a5479fa42b7804$export$e1252723db1c541).isRobotDriverStateRobotSafetyStateReduced()) // eslint-disable-next-line functional/no-expression-statements
        widgets.messageBox("Robot Safety Mode: Reduced Speed", "warning", {
            timeOut: "0",
            extendedTimeOut: "0"
        });
        else // eslint-disable-next-line functional/no-expression-statements
        widgets.clearMessageBox();
    };
const $dbd3670ef76bb404$var$messageBox_moveHereOnDone = (widgets)=>(_, event)=>{
        // eslint-disable-next-line functional/no-expression-statements
        event.data.waypointReached && widgets.messageBox("Waypoint position reached!", "success");
    };
const $dbd3670ef76bb404$var$messageBox__robotNotConnected = (widgets)=>()=>{
        // eslint-disable-next-line functional/no-expression-statements
        widgets.messageBox("Your robot is not connected. Go to the configuration pane to connect your robot", "error");
    };
const $dbd3670ef76bb404$var$messageBox__FetchRobotStateTimedout = (widgets)=>()=>{
        // eslint-disable-next-line functional/no-expression-statements
        widgets.messageBox("Failed to fetch robot state", "warning");
    };
const $dbd3670ef76bb404$var$ManualControlPageTransition = {
    "ManualControl/pageLoad": {
        target: "manualControlJogger",
        actions: [
            $dbd3670ef76bb404$var$robotAppsMachineContext__addRobotConfigFromInstruction,
            $dbd3670ef76bb404$var$reactUpdateState
        ]
    }
};
const $dbd3670ef76bb404$export$185802fd694ee1f5 = ({ doAjaxPromise: doAjaxPromise , helpers: helpers , library: library , getRemoteHost: getRemoteHost , widgets: widgets , onRobotConfigChanged: onRobotConfigChanged , onRobotConfigAdded: onRobotConfigAdded , onRobotConfigRemoved: onRobotConfigRemoved , onRobotNameChanged: onRobotNameChanged , RobotClipsOnRobotClipChange: RobotClipsOnRobotClipChange , ReferenceFramesOnTeachWaypointAndCloseButtonClick: ReferenceFramesOnTeachWaypointAndCloseButtonClick , ReferenceFramesOnDeleteButtonClick: ReferenceFramesOnDeleteButtonClick , onVerifyConfigurationClick: onVerifyConfigurationClick  })=>{
    const ExecutionEngineAPI = $084cd0ab38537745$export$185802fd694ee1f5(getRemoteHost, doAjaxPromise);
    return {
        websocket: {
            initial: "connecting",
            states: {
                connecting: {
                    entry: (0, $19d97d44cbd0fd8d$export$e25a7f1a95f0e46d)(getRemoteHost(), widgets),
                    on: {
                        onWebsocketClientConnect: {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$ddb559f5920e68a4),
                                (0, $19d97d44cbd0fd8d$export$71c9e1ea970cc265)(widgets),
                                (0, $19d97d44cbd0fd8d$export$3d2781b49a06f17c),
                                (0, $19d97d44cbd0fd8d$export$6d60e17d5da7f959),
                                (0, $19d97d44cbd0fd8d$export$3aa9d910fc64e633),
                                (0, $19d97d44cbd0fd8d$export$e7b48d4dfe57cd7d),
                                (0, $19d97d44cbd0fd8d$export$2b24a89f8e6ec06a),
                                (0, $19d97d44cbd0fd8d$export$185ade5f1f88b9c7),
                                (0, $19d97d44cbd0fd8d$export$47cbeee0d1cf0fcd),
                                (0, $19d97d44cbd0fd8d$export$cdedf8642d5bfe7e),
                                (0, $19d97d44cbd0fd8d$export$20441db47207d5c9),
                                (0, $19d97d44cbd0fd8d$export$e65306603daf27f5),
                                (0, $19d97d44cbd0fd8d$export$cff3ba0a2598ba98)
                            ],
                            target: "connected"
                        }
                    }
                },
                connected: {
                    type: "final"
                }
            },
            transitions: {
                subscribe: {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$7db4f664be73a05f)
                    ]
                },
                unsubscribe: {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$17ac8c06b1034c74)
                    ]
                },
                onVentionRosConnected: {
                    actions: [
                        (0, $gXNCa$xstate.assign)({
                            ventionRosConnectionState: "connected"
                        }),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onVentionRosConnecting: {
                    actions: [
                        (0, $gXNCa$xstate.assign)({
                            ventionRosConnectionState: "connecting"
                        }),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onVentionRosDisconnected: {
                    actions: [
                        (0, $gXNCa$xstate.assign)({
                            ventionRosConnectionState: "disconnected"
                        }),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onVentionRosDisconnecting: {
                    actions: [
                        (0, $gXNCa$xstate.assign)({
                            ventionRosConnectionState: "disconnecting"
                        }),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onVentionRosUnexpectedlyDisconnected: {
                    actions: [
                        (0, $gXNCa$xstate.assign)({
                            ventionRosConnectionState: "unexpectedly_disconnected"
                        }),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onVentionRosConnectedRobotType: {
                    actions: [
                        (0, $gXNCa$xstate.assign)((context, { connectedRobotType: connectedRobotType  })=>(0, $gXNCa$lodash.set)(context, [
                                "connectedRobotType"
                            ], connectedRobotType)),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onVentionRosRobotDriverState: {
                    actions: [
                        (0, $gXNCa$xstate.assign)({
                            ventionRosRobotDriverState: (_, { ventionRosRobotDriverState: ventionRosRobotDriverState  })=>ventionRosRobotDriverState
                        }),
                        $dbd3670ef76bb404$var$messageBox__RobotSafetyReduced(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotReadyStateNotReadyBody/joggerModal/ModalShown": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "modalShown"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        })
                    ]
                },
                "RobotReadyStateNotReadyBody/playRequested/ModalShown": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "modalShown"
                        }, {
                            to: (context)=>context.playRequestedEnableRobotMachineActorRef
                        })
                    ]
                }
            }
        },
        arrayEditor: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                notInArrayEditor: {
                    "RobotArrays/onMount": {
                        actions: [
                            (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).addReactStateUpdateFunction(),
                            (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                        ]
                    },
                    "RobotArrays/onUnmount": {
                        actions: [
                            (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).removeReactStateUpdateFunction(),
                            (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                        ]
                    },
                    "RobotAssets/RobotArrays/onCopyClick": {
                        actions: [
                            (0, $1b81f7b87aae9d14$export$2e2bcd8739ae039).RobotAssetsRobotArraysOnCopyClick(library)
                        ]
                    },
                    "RobotAssets/RobotArrays/onArrayCardEditClick": {
                        target: "inArrayEditor.editingArray"
                    },
                    "RobotAssets/RobotArrays/onLockedDeleteClick": {
                        actions: [
                            (0, $1b81f7b87aae9d14$export$2e2bcd8739ae039).RobotAssetsRobotArraysOnLockedDeleteClick(widgets)
                        ]
                    },
                    "RobotAssets/RobotArrays/onDeleteClick": {
                        target: "idle",
                        actions: [
                            (0, $1b81f7b87aae9d14$export$2e2bcd8739ae039).RobotAssetsRobotArraysOnDeleteClick(library)
                        ]
                    }
                },
                inArrayEditor: {
                    "RobotArrays/onUnmount": {
                        target: "idle",
                        actions: [
                            (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).removeReactStateUpdateFunction(),
                            (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                        ]
                    },
                    "RobotAssets/RobotArrays/onEditFrameDoneClick": {
                        target: "idle"
                    },
                    "RobotAssets/RobotArrays/onRegenerateClick": {
                        actions: [
                            (0, $1b81f7b87aae9d14$export$2e2bcd8739ae039).RobotAssetsRobotArraysOnRegenerateClick(library)
                        ]
                    }
                }
            },
            states: {
                inArrayEditor: {
                    initial: "creatingArrayReferenceFrame",
                    states: {
                        creatingArrayReferenceFrame: {
                            on: {
                                "RobotAssets/RobotArrays/manip-robot-create-reference-frame/onReferenceFrameSet": {
                                    target: "editingArray"
                                }
                            }
                        },
                        editingArray: {
                            on: {}
                        }
                    }
                }
            }
        },
        protectiveStopModal: {
            transitions: {
                enable: {
                    "RobotSafetyStateModal/onClick": {
                        actions: [
                            (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                        ]
                    }
                }
            }
        },
        robotConfig: {
            transitions: {
                idle: {
                    ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                    "Configuration/ApplyConfigurationButtonClicked/WithRobotConfig": {
                        actions: [
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "Configuration/ApplyConfigurationButtonClicked/WithNoRobotConfig": {
                        actions: [
                            (0, $gXNCa$xstate.assign)({
                                connectedRobotType: ""
                            }),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "Configuration/fromJson/addRobotConfigFromInstruction": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__addRobotConfigFromInstruction,
                            $dbd3670ef76bb404$var$reactUpdateState,
                            onRobotConfigChanged,
                            (context, event)=>onRobotConfigAdded(event.config, context.robotConfig)
                        ]
                    },
                    "Configuration/AddRobotButtonClicked": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__addRobotConfig,
                            $dbd3670ef76bb404$var$reactUpdateState,
                            onRobotConfigChanged,
                            (context, event)=>onRobotConfigAdded(event.config, context.robotConfig)
                        ]
                    },
                    "Configuration/RemoveRobotButtonClicked": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__removeRobotConfig,
                            $dbd3670ef76bb404$var$reactUpdateState,
                            onRobotConfigChanged,
                            (context, event)=>onRobotConfigRemoved(event.config)
                        ]
                    },
                    "RobotConfig/RobotTypeSelector/onChange": {
                        actions: [
                            $dbd3670ef76bb404$var$RobotConfig__updateRobotType,
                            $dbd3670ef76bb404$var$reactUpdateState,
                            onRobotConfigChanged
                        ]
                    },
                    "RobotConfig/RobotName/onChange": {
                        actions: [
                            $dbd3670ef76bb404$var$RobotConfig__updateRobotName,
                            $dbd3670ef76bb404$var$reactUpdateState,
                            onRobotConfigChanged,
                            (context, event)=>onRobotNameChanged(event.config, event.robotName)
                        ]
                    },
                    "RobotConfig/onMount": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction,
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotConfig/onUnmount": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction,
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotSafetyStateModal/onMount": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction,
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotSafetyStateModal/onUnmount": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction,
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    }
                }
            }
        },
        robotClips: {
            transitions: {
                idle: {
                    ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                    "RobotClips/onMount": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction
                        ]
                    },
                    "RobotClips/onUnmount": {
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction
                        ]
                    },
                    "RobotClips/onRobotClipsChange": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$68338063a6e2e619)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onRobotClipChange": {
                        actions: [
                            (context, event)=>RobotClipsOnRobotClipChange(event.robotClip),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onRobotClipsChangeNoConfig": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$e3cf3fb0b32c3649)(widgets),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onLockedDeleteClick": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$536e74aba0527273)(widgets),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onDeleteClick": {
                        actions: []
                    },
                    "RobotClips/onClipSelected": {
                        actions: []
                    },
                    "RobotClips/onWaypointAddButtonClicked": {
                        target: "robotClipsJogger",
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__setEditingKeyframePath,
                            (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onWaypointConfirmed": {
                        target: "idle",
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$80213a83a121a8bd)(library),
                            (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onWaypointPathTypeChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$a9cc21c25d411771)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onWaypointNameChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$f548665b4fc479c9)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onRobotCommandAdded": {
                        target: "idle",
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$43394ddf6ea70c20)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onWaypointEditClicked": {
                        target: "robotClipsJogger",
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$92992eb6a840f30b)(library),
                            $dbd3670ef76bb404$var$robotAppsMachineContext__setEditingKeyframePath,
                            (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onKeyframeDeleteClicked": {
                        target: "idle",
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$1fcf560cbf094d10)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onWaypointTimeChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$3f0bf6e188739e63)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onWaypointClicked": {
                        actions: []
                    },
                    "RobotClips/onWaypointMoveHereButtonMouseDown": [
                        {
                            target: "robotReadyStateNotReady",
                            cond: (0, $e9a5479fa42b7804$export$e1252723db1c541).isRobotDriverStateRobotReadyStateNotReady
                        },
                        {
                            actions: [
                                $dbd3670ef76bb404$var$messageBox__robotNotConnected(widgets)
                            ],
                            cond: (0, $e9a5479fa42b7804$export$e1252723db1c541).isRobotNotSimulatable
                        },
                        {
                            target: "moveHere"
                        }
                    ],
                    "RobotClips/onKeyframeOrderChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$470204a8b22b88a2)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onIgnoreReferenceFrameChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$2fe1c947be810161)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$1480ee1b32bd10a6)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandWaitForTimeTimeChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$a4de9465e26e8de8)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$59137f7a27c54d49)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$921fdd77ef87c57d)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandSetPayloadWeightChanged": {
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$45cdef97f44ff02b)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    }
                },
                triad: {
                    "RobotClips/onWaypointConfirmed": {
                        target: "idle",
                        actions: [
                            (0, $ae7047bb41ee4dcc$export$80213a83a121a8bd)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    }
                }
            }
        },
        referenceFrames: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                "Application.prototype.fromJson": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__addReferenceFrames
                    ]
                },
                "RobotAssets/ReferenceFrames/onMount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction
                    ]
                },
                "RobotAssets/ReferenceFrames/onUnmount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction
                    ]
                },
                "RobotAssets/ReferenceFrames/onAddButtonClick": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__addNewReferenceFrame,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateEditingReferenceFrameId,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotAssets/ReferenceFrames/onNameChange": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateReferenceFrameName,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotAssets/ReferenceFrames/onRecalibrateButtonClick": {
                    target: "referenceFramesJogger",
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateEditingReferenceFrameId,
                        (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotAssets/ReferenceFrames/onDeleteButtonClick": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__removeReferenceFrame,
                        ReferenceFramesOnDeleteButtonClick,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                }
            }
        },
        robotInstruction: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                "RobotInstruction/CalibrationReferenceFrameSelector/onReferenceFrameSelected": {
                    actions: [
                        (0, $594b2a3d5ca43856$export$dd177d09c1b890fb),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstruction/Sequence.prototype.newInstruction/parameter/robotId": {
                    actions: [
                        (0, $594b2a3d5ca43856$export$7810d5cd38112d26),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstruction/Sequence.prototype.newInstruction/parameter/calibrationReferenceFrame": {
                    actions: [
                        (0, $594b2a3d5ca43856$export$6d7bf92a58d71c43)(library),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstruction/onMount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction
                    ]
                },
                "RobotInstruction/onUnmount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction
                    ]
                },
                "RobotInstruction/onRender": {
                    actions: [
                        (0, $594b2a3d5ca43856$export$8469d2d33791cafa)
                    ]
                }
            }
        },
        robotInstructionSelector: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                "RobotInstructionSelector/ClipSelector/onClipMounted": {
                    actions: [
                        (0, $c8cbcac83f7bb757$export$2e2bcd8739ae039).RobotInstructionSelectorClipSelectorOnClipMounted,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionSelector/ClipSelector/onClipSelected": {
                    actions: [
                        (0, $c8cbcac83f7bb757$export$2e2bcd8739ae039).RobotInstructionSelectorClipSelectorOnClipSelected,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionSelector/ClipSelector/onNewClipSelected": {
                    actions: [
                        (0, $c8cbcac83f7bb757$export$2e2bcd8739ae039).RobotInstructionSelectorClipSelectorOnNewClipSelected,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionSelector/ClipSelector/onNewClipMounted": {
                    actions: [
                        (0, $c8cbcac83f7bb757$export$2e2bcd8739ae039).RobotInstructionSelectorClipSelectorOnNewClipMounted,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionSelector/StyledDeleteButton/onClick": {
                    actions: [
                        (0, $c8cbcac83f7bb757$export$2e2bcd8739ae039).RobotInstructionSelectorStyledDeleteButtonOnClick,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                }
            }
        },
        robotLoopInstruction: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                "RobotLoopInstruction/onMount": {
                    actions: [
                        (0, $6e3a5bfdf5c148fb$export$2e2bcd8739ae039).onMount(),
                        (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                    ]
                },
                "RobotLoopInstruction/onUnmount": {
                    actions: [
                        (0, $6e3a5bfdf5c148fb$export$2e2bcd8739ae039).onUnmount(),
                        (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                    ]
                },
                "RobotLoopInstruction/onArraySelected": {
                    actions: [
                        (0, $6e3a5bfdf5c148fb$export$2e2bcd8739ae039).robotLoopInstructionOnArraySelected(),
                        (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                    ]
                },
                "RobotLoopInstruction/onChildSequenceNameChange": {
                    actions: [
                        (0, $6e3a5bfdf5c148fb$export$2e2bcd8739ae039).robotLoopInstructionOnChildSequenceNameChange(),
                        (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                    ]
                },
                "RobotLoopInstruction/onStartFromChange": {
                    actions: [
                        (0, $6e3a5bfdf5c148fb$export$2e2bcd8739ae039).robotLoopInstructionOnStartFromChange(helpers, widgets),
                        (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                    ]
                },
                "RobotLoopInstruction/StyledDeleteButton/onClick": {
                    actions: [
                        (0, $6e3a5bfdf5c148fb$export$2e2bcd8739ae039).robotLoopInstructionOnDeleteButtonClick(),
                        (0, $1f45cbeb3437c37b$export$2e2bcd8739ae039).reactUpdateState()
                    ]
                }
            }
        },
        robotInstructionEditable: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                "RobotInstructionEditable/onDeleteClicked": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnDeleteClicked,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onRobotClipChange": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnRobotClipChange,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onWaypointAddButtonClicked": {
                    target: "robotInstructionEditableJogger",
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__setEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onWaypointConfirmed": {
                    target: "idle",
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnWaypointConfirmed,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onWaypointMoveHereButtonMouseDown": [
                    {
                        target: "robotReadyStateNotReady",
                        cond: (0, $e9a5479fa42b7804$export$e1252723db1c541).isRobotDriverStateRobotReadyStateNotReady
                    },
                    {
                        actions: [
                            $dbd3670ef76bb404$var$messageBox__robotNotConnected(widgets)
                        ],
                        cond: (0, $e9a5479fa42b7804$export$e1252723db1c541).isRobotNotSimulatable
                    },
                    {
                        target: "moveHere"
                    }
                ],
                "RobotInstructionEditable/START": {
                    target: "robotInstructionEditableJogger"
                },
                "RobotInstructionEditable/STOP": {
                    target: "idle"
                },
                "RobotInstructionEditable/onWaypointPathTypeChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnWaypointPathTypeChanged,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onWaypointNameChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnWaypointNameChanged,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onRobotCommandAdded": {
                    target: "idle",
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnRobotCommandAdded,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onWaypointEditClicked": {
                    target: "robotInstructionEditableJogger",
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnWaypointEditClicked,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__setEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onKeyframeDeleteClicked": {
                    target: "idle",
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnKeyframeDeleteClicked,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onWaypointTimeChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnWaypointTimeChanged(),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onWaypointClicked": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnWaypointClicked(),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onKeyframeOrderChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnKeyframeOrderChanged(),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onIgnoreReferenceFrameChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnIgnoreReferenceFrameChanged(),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onKeyframeRobotCommandChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnKeyframeRobotCommandChanged,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onKeyframeRobotCommandWaitForTimeTimeChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnKeyframeRobotCommandWaitForTimeTimeChanged,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onKeyframeRobotCommandSetPayloadWeightChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnKeyframeRobotCommandSetPayloadWeightChanged,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged": {
                    actions: [
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                }
            }
        },
        robotInstructionEditableJoggerTicked: {
            invoke: {
                src: ()=>ExecutionEngineAPI.fetchRobotState,
                onDone: {
                    target: "robotInstructionEditableJogger",
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateRobotState,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateEditingReferenceFrameReferenceFrame,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onError: {
                    target: "robotInstructionEditableJogger",
                    actions: [
                        $dbd3670ef76bb404$var$messageBox__FetchRobotStateTimedout(widgets)
                    ]
                }
            },
            transitions: {
                "RobotInstructionEditable/onJoggerPoseTranslationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/onJoggerPoseRotationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/onJoggerJointArrowMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/onJoggerArrowMouseUp": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/EditWaypoint/onTeachWaypointAndCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableEditWaypointOnTeachWaypointAndCloseButtonClick,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/AddWaypoint/onTeachWaypointAndCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableAddWaypointOnTeachWaypointAndCloseButtonClick,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onEnableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                    ]
                },
                "RobotInstructionEditable/onDisableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                    ]
                },
                "RobotInstructionEditable/onToggleConstraintButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                    ]
                },
                "RobotInstructionEditable/JOGGER_CLOSE_BUTTON_CLICKED": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionJoggerCloseButtonClicked,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                }
            }
        },
        robotInstructionEditableJogger: {
            invoke: {
                src: ()=>(cb)=>{
                        const timeout = setTimeout(()=>{
                            // eslint-disable-next-line functional/no-expression-statements
                            cb("TICK");
                        }, 500);
                        return ()=>{
                            // eslint-disable-next-line functional/no-expression-statements
                            clearTimeout(timeout);
                        };
                    }
            },
            transitions: {
                "RobotSafetyStateModal/onClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotJoggerContext/EnableButton/onClick": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "enableRobotButtonClick"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        }),
                        (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                    ]
                },
                "RobotJoggerContext/VerifyButton/onClick": {
                    target: "idle",
                    actions: [
                        onVerifyConfigurationClick,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/STOP": {
                    target: "idle"
                },
                "RobotInstructionEditable/JOGGER_CLOSE_BUTTON_CLICKED": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionJoggerCloseButtonClicked,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onJoggerPoseTranslationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/onJoggerPoseRotationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/onJoggerJointArrowMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/onJoggerArrowMouseUp": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/JOGGER_SPEED_SLIDER_CHANGED": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateJoggerSpeedPercentage,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/EditWaypoint/onTeachWaypointAndCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableEditWaypointOnTeachWaypointAndCloseButtonClick,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/AddWaypoint/onTeachWaypointAndCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        (0, $6d54af42eac2d2e5$export$2e2bcd8739ae039).RobotInstructionEditableAddWaypointOnTeachWaypointAndCloseButtonClick,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotInstructionEditable/onEnableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                    ]
                },
                "RobotInstructionEditable/onDisableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                    ]
                },
                "RobotInstructionEditable/onToggleConstraintButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                    ]
                },
                TICK: {
                    target: "robotInstructionEditableJoggerTicked",
                    cond: (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosConnected
                },
                "onVentionRosRobotDriverState/robotReadyState/ready": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        }),
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.playRequestedEnableRobotMachineActorRef
                        })
                    ],
                    target: "robotInstructionEditableJogger"
                }
            }
        },
        referenceFramesJoggerTicked: {
            invoke: {
                src: ()=>ExecutionEngineAPI.fetchRobotState,
                onDone: {
                    target: "referenceFramesJogger",
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateRobotState,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateEditingReferenceFrameReferenceFrame,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onError: {
                    target: "referenceFramesJogger",
                    actions: [
                        $dbd3670ef76bb404$var$messageBox__FetchRobotStateTimedout(widgets)
                    ]
                }
            },
            transitions: {
                "RobotAssets/ReferenceFrames/onJoggerPoseTranslationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onJoggerPoseRotationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onJoggerJointArrowMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onJoggerArrowMouseUp": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onTeachWaypointAndCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId,
                        ({ previousEditingReferenceFrameId: previousEditingReferenceFrameId , referenceFrames: referenceFrames  })=>ReferenceFramesOnTeachWaypointAndCloseButtonClick(referenceFrames[previousEditingReferenceFrameId]),
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotAssets/ReferenceFrames/onEnableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                    ]
                },
                "RobotAssets/ReferenceFrames/onDisableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                    ]
                },
                "RobotAssets/ReferenceFrames/onToggleConstraintButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                    ]
                },
                "RobotAssets/ReferenceFrames/onCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                }
            }
        },
        referenceFramesJogger: {
            invoke: {
                src: ()=>(cb)=>{
                        const timeout = setTimeout(()=>{
                            // eslint-disable-next-line functional/no-expression-statements
                            cb("TICK");
                        }, 500);
                        return ()=>{
                            // eslint-disable-next-line functional/no-expression-statements
                            clearTimeout(timeout);
                        };
                    }
            },
            transitions: {
                "RobotSafetyStateModal/onClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotJoggerContext/EnableButton/onClick": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "enableRobotButtonClick"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        }),
                        (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                    ]
                },
                "RobotJoggerContext/VerifyButton/onClick": {
                    target: "idle",
                    actions: [
                        onVerifyConfigurationClick,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotAssets/ReferenceFrames/onJoggerPoseTranslationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onJoggerPoseRotationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onJoggerJointArrowMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onJoggerArrowMouseUp": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotAssets/ReferenceFrames/onSpeedSliderChange": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateJoggerSpeedPercentage,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotAssets/ReferenceFrames/onTeachWaypointAndCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId,
                        ({ previousEditingReferenceFrameId: previousEditingReferenceFrameId , referenceFrames: referenceFrames  })=>ReferenceFramesOnTeachWaypointAndCloseButtonClick(referenceFrames[previousEditingReferenceFrameId]),
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotAssets/ReferenceFrames/onEnableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                    ]
                },
                "RobotAssets/ReferenceFrames/onDisableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                    ]
                },
                "RobotAssets/ReferenceFrames/onToggleConstraintButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                    ]
                },
                "RobotAssets/ReferenceFrames/onCloseButtonClick": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                TICK: {
                    target: "referenceFramesJoggerTicked",
                    cond: (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosConnected
                },
                "onVentionRosRobotDriverState/robotReadyState/ready": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        }),
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.playRequestedEnableRobotMachineActorRef
                        })
                    ],
                    target: "referenceFramesJogger"
                }
            }
        },
        robotClipsJoggerTicked: {
            invoke: {
                src: ()=>ExecutionEngineAPI.fetchRobotState,
                onDone: {
                    target: "robotClipsJogger",
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateRobotState,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateEditingReferenceFrameReferenceFrame,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                onError: {
                    target: "robotClipsJogger",
                    actions: [
                        $dbd3670ef76bb404$var$messageBox__FetchRobotStateTimedout(widgets)
                    ]
                }
            },
            transitions: {
                "RobotClips/onJoggerPoseTranslationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotClips/onJoggerPoseRotationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotClips/onJoggerJointArrowMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotClips/onJoggerArrowMouseUp": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotClips/onEnableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                    ]
                },
                "RobotClips/onDisableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                    ]
                },
                "RobotClips/onToggleConstraintButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                    ]
                },
                idle: {
                    "RobotClips/EditWaypoint/onTeachWaypointAndCloseButtonClick": {
                        target: "exitJogger",
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                            (0, $ae7047bb41ee4dcc$export$69813a61a23def19)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/AddWaypoint/onTeachWaypointAndCloseButtonClick": {
                        target: "exitJogger",
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                            (0, $ae7047bb41ee4dcc$export$f65d30b37d4dd6c2)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    }
                },
                "RobotClips/JOGGER_CLOSE_BUTTON_CLICKED": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                }
            }
        },
        robotClipsJogger: {
            invoke: {
                src: ()=>(cb)=>{
                        const timeout = setTimeout(()=>{
                            // eslint-disable-next-line functional/no-expression-statements
                            cb("TICK");
                        }, 500);
                        return ()=>{
                            // eslint-disable-next-line functional/no-expression-statements
                            clearTimeout(timeout);
                        };
                    }
            },
            transitions: {
                "RobotSafetyStateModal/onClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotJoggerContext/EnableButton/onClick": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "enableRobotButtonClick"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        }),
                        (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                    ]
                },
                "RobotJoggerContext/VerifyButton/onClick": {
                    target: "idle",
                    actions: [
                        onVerifyConfigurationClick,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotClips/onJoggerPoseTranslationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotClips/onJoggerPoseRotationMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotClips/onJoggerJointArrowMouseDown": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotClips/onJoggerArrowMouseUp": {
                    actions: [
                        $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                    ]
                },
                "RobotInstructionEditable/JOGGER_SPEED_SLIDER_CHANGED": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__updateJoggerSpeedPercentage,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotClips/onEnableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                    ]
                },
                "RobotClips/onDisableFreedriveButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                    ]
                },
                "RobotClips/onToggleConstraintButtonClick": {
                    actions: [
                        (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                    ]
                },
                idle: {
                    "RobotClips/EditWaypoint/onTeachWaypointAndCloseButtonClick": {
                        target: "exitJogger",
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                            (0, $ae7047bb41ee4dcc$export$69813a61a23def19)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    },
                    "RobotClips/AddWaypoint/onTeachWaypointAndCloseButtonClick": {
                        target: "exitJogger",
                        actions: [
                            $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                            (0, $ae7047bb41ee4dcc$export$f65d30b37d4dd6c2)(library),
                            $dbd3670ef76bb404$var$reactUpdateState
                        ]
                    }
                },
                "RobotClips/JOGGER_CLOSE_BUTTON_CLICKED": {
                    target: "exitJogger",
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingKeyframePath,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                TICK: {
                    target: "robotClipsJoggerTicked",
                    cond: (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosConnected
                },
                "onVentionRosRobotDriverState/robotReadyState/ready": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        }),
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.playRequestedEnableRobotMachineActorRef
                        })
                    ],
                    target: "robotClipsJogger"
                }
            }
        },
        moveHere: {
            invoke: {
                src: (_, { jointAngles: jointAngles  })=>ExecutionEngineAPI.moveJ(jointAngles),
                onDone: {
                    target: "#robotApps.app.idle",
                    actions: [
                        $dbd3670ef76bb404$var$messageBox_moveHereOnDone(widgets)
                    ]
                },
                onError: {
                    target: "#robotApps.app.idle"
                }
            },
            transitions: {
                "RobotInstructionEditable/onWaypointMoveHereButtonMouseUp": {
                    actions: [
                        ExecutionEngineAPI.moveStop
                    ]
                },
                "RobotClips/onWaypointMoveHereButtonMouseUp": {
                    actions: [
                        ExecutionEngineAPI.moveStop
                    ]
                }
            }
        },
        manualControlJogger: {
            initial: "idle",
            states: {
                idle: {
                    on: {
                        "ManualControl/pageUnload": {
                            target: "#robotApps.app.idle"
                        },
                        "ManualControl/pageLoad": {
                            actions: [
                                $dbd3670ef76bb404$var$robotAppsMachineContext__addRobotConfigFromInstruction,
                                $dbd3670ef76bb404$var$reactUpdateState
                            ]
                        },
                        "ManualControl/RobotJogger/onMount": {
                            actions: [
                                $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction,
                                (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets)
                            ],
                            target: "jogger"
                        },
                        "RobotSafetyStateModal/onClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                            ]
                        }
                    }
                },
                ticked: {
                    invoke: {
                        src: ()=>ExecutionEngineAPI.fetchRobotState,
                        onDone: {
                            target: "jogger",
                            actions: [
                                $dbd3670ef76bb404$var$robotAppsMachineContext__updateRobotState,
                                $dbd3670ef76bb404$var$reactUpdateState
                            ]
                        },
                        onError: {
                            target: "jogger"
                        }
                    },
                    on: {
                        "ManualControl/pageUnload": {
                            target: "#robotApps.app.idle",
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f),
                                (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets)
                            ]
                        },
                        "ManualControl/RobotJogger/onUnmount": {
                            target: "idle",
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f),
                                $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction,
                                (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets)
                            ]
                        },
                        "ManualControl/RobotJogger/onMount": {
                            actions: [
                                $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction,
                                (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets)
                            ],
                            target: "jogger"
                        },
                        "ManualControl/RobotJogger/onJoggerPoseTranslationMouseDown": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "ManualControl/RobotJogger/onJoggerPoseRotationMouseDown": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "ManualControl/RobotJogger/onJoggerJointArrowMouseDown": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "ManualControl/RobotJogger/onJoggerArrowMouseUp": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "RobotSafetyStateModal/onClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                            ]
                        },
                        "ManualControl/RobotJogger/onEnableFreedriveButtonClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                            ]
                        },
                        "ManualControl/RobotJogger/onDisableFreedriveButtonClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                            ]
                        },
                        "ManualControl/RobotJogger/onToggleConstraintButtonClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                            ]
                        }
                    }
                },
                jogger: {
                    entry: [
                        $dbd3670ef76bb404$var$reactUpdateState
                    ],
                    invoke: {
                        src: ()=>(cb)=>{
                                const timeout = setTimeout(()=>{
                                    // eslint-disable-next-line functional/no-expression-statements
                                    cb("TICK");
                                }, 500);
                                return ()=>{
                                    // eslint-disable-next-line functional/no-expression-statements
                                    clearTimeout(timeout);
                                };
                            }
                    },
                    on: {
                        "ManualControl/pageUnload": {
                            target: "#robotApps.app.idle",
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f),
                                (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets)
                            ]
                        },
                        "ManualControl/RobotJogger/onMount": {
                            actions: [
                                $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction,
                                (0, $19d97d44cbd0fd8d$export$d1c00bd82524f7a0)(widgets)
                            ],
                            target: "jogger"
                        },
                        "RobotJoggerContainer/EnableButton/onClick": {
                            actions: [
                                (0, $gXNCa$xstate.send)({
                                    type: "enableRobotButtonClick"
                                }, {
                                    to: (context)=>context.joggerEnableRobotMachineActorRef
                                }),
                                (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                            ]
                        },
                        "RobotJoggerContainer/VerifyButton/onClick": {
                            target: "#robotApps.app.idle",
                            actions: [
                                onVerifyConfigurationClick,
                                $dbd3670ef76bb404$var$reactUpdateState
                            ]
                        },
                        "ManualControl/RobotJogger/onUnmount": {
                            target: "idle",
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f),
                                $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction,
                                (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets)
                            ]
                        },
                        "ManualControl/RobotJogger/onJoggerPoseTranslationMouseDown": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseTranslationDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "ManualControl/RobotJogger/onJoggerPoseRotationMouseDown": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__startStreamingFramePoseRotationDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "ManualControl/RobotJogger/onJoggerJointArrowMouseDown": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__startStreamingJointDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "ManualControl/RobotJogger/onJoggerArrowMouseUp": {
                            actions: [
                                $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
                            ]
                        },
                        "ManualControl/RobotJogger/onSpeedSliderChange": {
                            actions: [
                                $dbd3670ef76bb404$var$robotAppsMachineContext__updateJoggerSpeedPercentage,
                                $dbd3670ef76bb404$var$reactUpdateState
                            ]
                        },
                        "ManualControl/RobotJogger/onEnableFreedriveButtonClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$1108607d191e860d)
                            ]
                        },
                        "ManualControl/RobotJogger/onDisableFreedriveButtonClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$f10ab6b5265ce2f)
                            ]
                        },
                        "ManualControl/RobotJogger/onToggleConstraintButtonClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$2e971a3a567db44f)
                            ]
                        },
                        TICK: {
                            target: "ticked",
                            cond: (context)=>context.ventionRosConnectionState === (0, $49b61417b640529d$export$c80eb66b670f184a).CONNECTED
                        },
                        "RobotSafetyStateModal/onClick": {
                            actions: [
                                (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9)
                            ]
                        },
                        "RobotReadyStateNotReadyBody/joggerModal/ModalShown": {
                            actions: [
                                (0, $gXNCa$xstate.send)({
                                    type: "modalShown"
                                }, {
                                    to: (context)=>context.joggerEnableRobotMachineActorRef
                                })
                            ]
                        },
                        "onVentionRosRobotDriverState/robotReadyState/ready": {
                            actions: [
                                (0, $gXNCa$xstate.send)({
                                    type: "readyStateChangeToREADY"
                                }, {
                                    to: (context)=>context.joggerEnableRobotMachineActorRef
                                })
                            ],
                            target: "jogger"
                        }
                    }
                }
            }
        },
        machineLogic: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                "MachineLogic/RobotInstructionEditable/MovedToAnotherSequence": {
                    actions: [
                        (0, $2395189d05dd8ef4$export$2b6febbbdf03a058)
                    ]
                },
                "MachineLogic/Sequence.prototype.moveInstruction/MovedToSameSequence": {
                    actions: [
                        (0, $2395189d05dd8ef4$export$48fe590476b7edd2)
                    ]
                },
                "MachineLogic/Simulation/onRobotSimulationStateChange": {
                    actions: [
                        (_, event)=>(0, $c26706bb9097827e$export$6f80848eed99044)(library)(event),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "MachineLogic/Simulation/onRobotSimulationMotionCompleted": {
                    actions: [
                        (_, event)=>(0, $c26706bb9097827e$export$85e3680ebb9483d2)(library)(event),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "MachineLogic/Library.prototype.removeApplication": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__removeApplicationReferenceFrames
                    ]
                }
            }
        },
        idle: {
            transitions: {
                ...$dbd3670ef76bb404$var$ManualControlPageTransition,
                "RobotReadyStateNotReadyModal/onMount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotReadyStateNotReadyModal/onUnmount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotSafetyStateModal/onMount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__addReactStateUpdateFunction,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "RobotSafetyStateModal/onUnmount": {
                    actions: [
                        $dbd3670ef76bb404$var$robotAppsMachineContext__removeReactStateUpdateFunction,
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "MachineLogic/PlayButton/Clicked": {
                    target: "robotReadyStateNotReady"
                },
                "RobotAssets/ReferenceFrames/onCloseButtonClick": {
                    actions: [
                        $dbd3670ef76bb404$var$websocketEmit__disable_freedrive_if_running,
                        $dbd3670ef76bb404$var$robotAppsMachineContext__unsetEditingReferenceFrameId,
                        (0, $19d97d44cbd0fd8d$export$a844665721a81be4)(widgets),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                }
            }
        },
        robotReadyStateNotReady: {
            entry: [
                $dbd3670ef76bb404$var$reactUpdateState
            ],
            transitions: {
                "RobotReadyStateNotReadyModal/onClick": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "enableRobotButtonClick"
                        }, {
                            to: (context)=>context.playRequestedEnableRobotMachineActorRef
                        }),
                        (0, $19d97d44cbd0fd8d$export$889ba87d660d0cc9),
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "playRequestedEnableRobotMachine/READYING/timedout": {
                    target: "idle",
                    actions: [
                        $dbd3670ef76bb404$var$reactUpdateState
                    ]
                },
                "onVentionRosRobotDriverState/robotReadyState/ready": {
                    actions: [
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.joggerEnableRobotMachineActorRef
                        }),
                        (0, $gXNCa$xstate.send)({
                            type: "readyStateChangeToREADY"
                        }, {
                            to: (context)=>context.playRequestedEnableRobotMachineActorRef
                        })
                    ],
                    target: "idle"
                }
            }
        },
        exitJogger: {
            entry: [
                $dbd3670ef76bb404$var$RobotJogger__stopStreamingDeltas(ExecutionEngineAPI)
            ],
            on: {
                "": {
                    target: "idle"
                }
            }
        }
    };
};


var $42663375bb38ee89$exports = {};

$parcel$export($42663375bb38ee89$exports, "create", () => $42663375bb38ee89$export$185802fd694ee1f5);




// https://redux.js.org/recipes/structuring-reducers/immutable-update-patterns
/**
 * @typedef Action
 * @property {Number} index
 * @property {Object} item
 */ /**
 *
 * @param {Action} action
 * @param {Array<Object>} array
 */ function $d184beb076db587a$var$updateObjectInArray(array, action) {
    return array.map((item, index)=>{
        if (index !== action.index) // This isn't the item we care about - keep it as-is
        return item;
        // Otherwise, this is the one we want - return an updated value
        return {
            ...item,
            ...action.item
        };
    });
}
function $d184beb076db587a$var$replaceObjectInArray(array, action) {
    return array.map((item, index)=>{
        if (index !== action.index) // This isn't the item we care about - keep it as-is
        return item;
        // Otherwise, this is the one we want - return an updated value
        return {
            ...action.item
        };
    });
}
function $d184beb076db587a$var$removeItem(array, action) {
    return [
        ...array.slice(0, action.index),
        ...array.slice(action.index + 1)
    ];
}
function $d184beb076db587a$var$insertItem(array, action) {
    return [
        ...array.slice(0, action.index),
        action.item,
        ...array.slice(action.index)
    ];
}
const $d184beb076db587a$export$d4c72bab9d6cc13a = {
    keyframes: []
};
const $d184beb076db587a$export$b55a2b8a15f09f32 = (state = $d184beb076db587a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case "motionEditor/initializeKeyframeState":
            return {
                ...action.payload
            };
        case "motionEditor/keyframeAdded":
            return {
                ...state,
                keyframes: state.keyframes.concat([
                    action.payload.keyframe
                ])
            };
        case "motionEditor/waypointTimeChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        timeStamp: action.payload.timeStamp
                    }
                })
            };
        case "motionEditor/waypointPathTypeChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            pathType: action.payload.pathType
                        }
                    }
                })
            };
        case "motionEditor/waypointNameChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            name: action.payload.name
                        }
                    }
                })
            };
        case "motionEditor/keyframeIsEditingChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        isEditing: action.payload.isEditing
                    }
                })
            };
        case "motionEditor/keyframeIsSelectedChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        isSelected: action.payload.isSelected,
                        selectedReferenceFrame: action.payload.selectedReferenceFrame
                    }
                })
            };
        case "motionEditor/keyframeOrderChanged":
            return {
                ...state,
                keyframes: action.payload.keyframes
            };
        case "motionEditor/waypointIgnoreReferenceFrameChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            ignoreReferenceFrame: action.payload.ignoreReferenceFrame
                        }
                    }
                })
            };
        case "motionEditor/waypointConfirmed":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex],
                        isEditing: action.payload.isEditing,
                        waypoint: {
                            ...state.keyframes[action.payload.keyframeIndex].waypoint,
                            jointAngles: action.payload.jointAngles,
                            pose: action.payload.pose
                        }
                    }
                })
            };
        case "motionEditor/keyframeRemoved":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$removeItem(state.keyframes, {
                    index: action.payload.keyframeIndex
                })
            };
        case "motionEditor/keyframeCopyAsNext":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$insertItem(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: JSON.parse(JSON.stringify(state.keyframes[action.payload.keyframeIndex]))
                })
            };
        case "motionEditor/keyframeCopyAsLast":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$insertItem(state.keyframes, {
                    index: state.keyframes.length,
                    item: JSON.parse(JSON.stringify(state.keyframes[action.payload.keyframeIndex]))
                })
            };
        case "motionEditor/robotCommandChanged":
            {
                const robotCommandInitialState = (robotCommandType, id)=>{
                    switch(robotCommandType){
                        case "setPayload":
                            return {
                                id: id,
                                timeStamp: -1,
                                setPayload: {
                                    weight: 0
                                }
                            };
                        case "waitForTime":
                            return {
                                id: id,
                                timeStamp: -1,
                                waitForTime: {
                                    time: 0
                                }
                            };
                        case "setSpeed":
                            return {
                                id: id,
                                timeStamp: -1,
                                setSpeed: {
                                    moveLVelocityScalingFactor: 0.1,
                                    moveJVelocityScalingFactor: 0.1
                                }
                            };
                    }
                };
                return {
                    ...state,
                    keyframes: $d184beb076db587a$var$replaceObjectInArray(state.keyframes, {
                        index: action.payload.keyframeIndex,
                        item: robotCommandInitialState(action.payload.robotCommandType, state.keyframes[action.payload.keyframeIndex].id)
                    })
                };
            }
        case "motionEditor/robotCommandWaitForTimeTimeChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        waitForTime: {
                            ...state.keyframes[action.payload.keyframeIndex].waitForTime,
                            time: action.payload.time
                        }
                    }
                })
            };
        case "motionEditor/robotCommandSetPayloadWeightChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        setPayload: {
                            ...state.keyframes[action.payload.keyframeIndex].setPayload,
                            weight: action.payload.weight
                        }
                    }
                })
            };
        case "motionEditor/robotCommandSetSpeedMoveLVelocityScalingFactorChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        setSpeed: {
                            ...state.keyframes[action.payload.keyframeIndex].setSpeed,
                            moveLVelocityScalingFactor: action.payload.moveLVelocityScalingFactor
                        }
                    }
                })
            };
        case "motionEditor/robotCommandSetSpeedMoveJVelocityScalingFactorChanged":
            return {
                ...state,
                keyframes: $d184beb076db587a$var$updateObjectInArray(state.keyframes, {
                    index: action.payload.keyframeIndex,
                    item: {
                        ...state.keyframes[action.payload.keyframeIndex].waypoint,
                        setSpeed: {
                            ...state.keyframes[action.payload.keyframeIndex].setSpeed,
                            moveJVelocityScalingFactor: action.payload.moveJVelocityScalingFactor
                        }
                    }
                })
            };
        default:
            return state;
    }
};
const $d184beb076db587a$var$initializeKeyframeState = (payload)=>({
        type: "motionEditor/initializeKeyframeState",
        payload: payload
    });
const $d184beb076db587a$var$keyframeAdded = (payload)=>({
        type: "motionEditor/keyframeAdded",
        payload: payload
    });
const $d184beb076db587a$var$waypointTimeChanged = (payload)=>({
        type: "motionEditor/waypointTimeChanged",
        payload: payload
    });
const $d184beb076db587a$var$waypointPathTypeChanged = (payload)=>({
        type: "motionEditor/waypointPathTypeChanged",
        payload: payload
    });
const $d184beb076db587a$var$waypointNameChanged = (payload)=>({
        type: "motionEditor/waypointNameChanged",
        payload: payload
    });
const $d184beb076db587a$var$keyframeIsEditingChanged = (payload)=>({
        type: "motionEditor/keyframeIsEditingChanged",
        payload: payload
    });
const $d184beb076db587a$var$keyframeIsSelectedChanged = (payload)=>({
        type: "motionEditor/keyframeIsSelectedChanged",
        payload: payload
    });
const $d184beb076db587a$var$keyframeOrderChanged = (payload)=>({
        type: "motionEditor/keyframeOrderChanged",
        payload: payload
    });
const $d184beb076db587a$var$waypointIgnoreReferenceFrameChanged = (payload)=>({
        type: "motionEditor/waypointIgnoreReferenceFrameChanged",
        payload: payload
    });
const $d184beb076db587a$var$waypointConfirmed = (payload)=>({
        type: "motionEditor/waypointConfirmed",
        payload: payload
    });
const $d184beb076db587a$var$keyframeRemoved = (payload)=>({
        type: "motionEditor/keyframeRemoved",
        payload: payload
    });
const $d184beb076db587a$var$keyframeCopyAsNext = (payload)=>({
        type: "motionEditor/keyframeCopyAsNext",
        payload: payload
    });
const $d184beb076db587a$var$keyframeCopyAsLast = (payload)=>({
        type: "motionEditor/keyframeCopyAsLast",
        payload: payload
    });
const $d184beb076db587a$var$robotCommandChanged = (payload)=>({
        type: "motionEditor/robotCommandChanged",
        payload: payload
    });
const $d184beb076db587a$var$robotCommandWaitForTimeTimeChanged = (payload)=>({
        type: "motionEditor/robotCommandWaitForTimeTimeChanged",
        payload: payload
    });
const $d184beb076db587a$var$robotCommandSetPayloadWeightChanged = (payload)=>({
        type: "motionEditor/robotCommandSetPayloadWeightChanged",
        payload: payload
    });
const $d184beb076db587a$var$robotCommandSetSpeedMoveLVelocityScalingFactorChanged = (payload)=>({
        type: "motionEditor/robotCommandSetSpeedMoveLVelocityScalingFactorChanged",
        payload: payload
    });
const $d184beb076db587a$var$robotCommandSetSpeedMoveJVelocityScalingFactorChanged = (payload)=>({
        type: "motionEditor/robotCommandSetSpeedMoveJVelocityScalingFactorChanged",
        payload: payload
    });
const $d184beb076db587a$export$197c291619fe9a2e = {
    initializeKeyframeState: $d184beb076db587a$var$initializeKeyframeState,
    keyframeAdded: $d184beb076db587a$var$keyframeAdded,
    keyframeRemoved: $d184beb076db587a$var$keyframeRemoved,
    keyframeCopyAsNext: $d184beb076db587a$var$keyframeCopyAsNext,
    keyframeCopyAsLast: $d184beb076db587a$var$keyframeCopyAsLast,
    waypointTimeChanged: $d184beb076db587a$var$waypointTimeChanged,
    waypointPathTypeChanged: $d184beb076db587a$var$waypointPathTypeChanged,
    waypointNameChanged: $d184beb076db587a$var$waypointNameChanged,
    keyframeIsEditingChanged: $d184beb076db587a$var$keyframeIsEditingChanged,
    keyframeIsSelectedChanged: $d184beb076db587a$var$keyframeIsSelectedChanged,
    keyframeOrderChanged: $d184beb076db587a$var$keyframeOrderChanged,
    waypointIgnoreReferenceFrameChanged: $d184beb076db587a$var$waypointIgnoreReferenceFrameChanged,
    waypointConfirmed: $d184beb076db587a$var$waypointConfirmed,
    robotCommandChanged: $d184beb076db587a$var$robotCommandChanged,
    robotCommandWaitForTimeTimeChanged: $d184beb076db587a$var$robotCommandWaitForTimeTimeChanged,
    robotCommandSetPayloadWeightChanged: $d184beb076db587a$var$robotCommandSetPayloadWeightChanged,
    robotCommandSetSpeedMoveLVelocityScalingFactorChanged: $d184beb076db587a$var$robotCommandSetSpeedMoveLVelocityScalingFactorChanged,
    robotCommandSetSpeedMoveJVelocityScalingFactorChanged: $d184beb076db587a$var$robotCommandSetSpeedMoveJVelocityScalingFactorChanged
};



/**
 * @typedef {number} VID
 */ /**
 * @param {vid}
 * @returns {boolean}
 */ const $4f71ac8ef89a5f2d$export$1ea939691cdc45b8 = (vid)=>vid > -1;


const $3f65195cd5e8f23a$export$2703143e0251f0 = (g3DContext)=>(sequence, instruction, clipId)=>{
        instruction.setParameter("clipId", clipId);
        const getClipById = (id)=>sequence?.mApp?.robotParameters?.clips.find((clip)=>clip.id === id) || sequence?.robotParameters?.clips.find((clip)=>clip.id === id);
        const existingClip = getClipById(clipId);
        const newExecutionReferenceFrame = existingClip.teachingReferenceFrame;
        instruction.setParameter("executionReferenceFrame", {
            ...newExecutionReferenceFrame,
            arrayMatrix__referenceFrame_world: g3DContext.robotUtils.tmMatrix(newExecutionReferenceFrame.arrayMatrix__referenceFrame_vidAssociatedModel).multiply(g3DContext.getNodeMatrix(g3DContext.mGraph.getHID(newExecutionReferenceFrame.vid))).toArray()
        });
        sequence.mApp.notify("onInstructionChanged", existingClip);
    };
const $3f65195cd5e8f23a$export$667527877a795588 = (g3DContext, gLibrary)=>(sequence, instruction)=>{
        const calibrationReferenceFrameVid = instruction.getParameter("calibrationReferenceFrame").vid;
        const robot = gLibrary.mLibrary.getConfigManager().listRobots().find((pRobot)=>pRobot.mRobotId === instruction.getParameter("robotId"));
        if (!robot) return;
        const getRobotActuatorVID = ()=>robot?.mRobotActuators && parseInt(Object.keys(robot.mRobotActuators)[0]);
        const calibrationReferenceFrame = g3DContext.robotUtils.getInstructionCalibrationReferenceFrame(calibrationReferenceFrameVid, getRobotActuatorVID());
        const robotVID = getRobotActuatorVID();
        const newClip = $d5cc77669caa91ad$export$75ff2183706c7173();
        newClip.name = (0, $1d3cf5330bb207de$export$64c313e59f94d976)(sequence.mApp)("Robot path");
        newClip.robotId = gLibrary.mLibrary.getConfigManager().listRobots()[0].mRobotId;
        newClip.teachingReferenceFrame = g3DContext.robotUtils.createTeachingReferenceFrameAtRobotBase(robotVID);
        newClip.teachingReferenceFrame = {
            ...newClip.teachingReferenceFrame,
            arrayMatrix__referenceFrame_vidAssociatedModel: g3DContext.robotUtils.ArrayMatrix__getIdentity()
        };
        sequence.robotParameters.clips = [
            ...sequence?.robotParameters?.clips || [],
            newClip
        ];
        instruction.setParameter("clipId", newClip.id);
        instruction.setParameter("calibrationReferenceFrame", calibrationReferenceFrame);
        instruction.setParameter("endEffectorToolCenterPoint", g3DContext.robotUtils.ArrayMatrix__get_endEffector_flange(robotVID));
        instruction.setParameter("executionReferenceFrame", newClip.teachingReferenceFrame);
        sequence.mApp.notify("onInstructionChanged", newClip);
    };
const $3f65195cd5e8f23a$export$54d6f365d65dbbe9 = ({ application: application , robotClip: robotClip  })=>{
    const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(application.robotParameters.clips, {
        index: application.robotParameters.clips.findIndex((clip)=>clip.id === robotClip.id),
        item: robotClip
    });
    application.robotParameters.clips = [
        ...newRobotClips
    ];
    application.robotParameters.clips.forEach((clip)=>application.notify("onInstructionChanged", clip));
    application.setDirty();
};
const $3f65195cd5e8f23a$export$a8eadffee6cd0dc7 = ({ application: application , newCalibrationParts: newCalibrationParts  })=>{
    application.robotParameters.calibrationParts = [
        ...newCalibrationParts
    ];
};
const $3f65195cd5e8f23a$export$47c8134d907f9e08 = ({ application: application , robotBaseCalibrationReferenceFrame: robotBaseCalibrationReferenceFrame  })=>{
    const isRobotBasePartOfCalibrationParts = application.robotParameters.calibrationParts.find((calibrationPart)=>calibrationPart.vid === robotBaseCalibrationReferenceFrame.vid);
    if (isRobotBasePartOfCalibrationParts) return;
    application.robotParameters.calibrationParts = [
        ...application.robotParameters.calibrationParts,
        robotBaseCalibrationReferenceFrame
    ];
    application.setDirty();
};
/**
 *
 * @param {{
 * ctx3D: Object,
 * vid: Number,
 * endEffectorVisible?: Boolean
 * rotatorVisible?: Boolean,
 * referenceFrameVisible?: Boolean,
 * referenceFrame?: *
 * }} dummy
 */ const $3f65195cd5e8f23a$export$bff04ed0ef06d271 = ({ ctx3D: ctx3D , vid: vid , endEffectorVisible: endEffectorVisible = true , rotatorVisible: rotatorVisible = false , referenceFrameVisible: referenceFrameVisible = false , referenceFrame: referenceFrame  })=>{
    if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
    ctx3D.setTopManipulator("manip-robot", vid);
    const manipRobotState = ctx3D.getManipulatorOfType("manip-robot").mState;
    referenceFrame && manipRobotState.transition({
        type: "SET_REFERENCE_FRAME",
        payload: {
            newReferenceFrame: ctx3D.robotUtils.tmMatrix(ctx3D.robotUtils.ArrayMatrix__getChangeOfBasis_referenceFrame_world(referenceFrame))
        }
    });
    manipRobotState.transition({
        type: "RENDER_SCENE",
        payload: {
            endEffectorVisible: endEffectorVisible,
            rotatorVisible: rotatorVisible,
            referenceFrameVisible: referenceFrameVisible
        }
    });
};
const $3f65195cd5e8f23a$export$590ba4bde3690df4 = (ctx3D)=>ctx3D.setTopManipulator("manip-rotate-translate");
const $3f65195cd5e8f23a$export$24c0dc7a46687103 = (g3DContext)=>()=>g3DContext.robotAppsService.send("RobotInstruction/onPartsMoved");
const $3f65195cd5e8f23a$export$93ec683ddcc6fd5c = (context, event, actionMeta)=>{
    Object.values(context.reactStateUpdateFunctions).forEach((f)=>f(actionMeta.state.value));
};
const $3f65195cd5e8f23a$export$c3a9dc16787feaa1 = ({ ctx3D: ctx3D , vid: vid , robotClips: robotClips , referenceFrames: referenceFrames  })=>{
    const showKeyframesManipId = ctx3D.mViewer.getOperatorManager().indexOf(ctx3D.mManipulators["manip-robot-show-keyframes"].id);
    const manipShowKeyframe = ctx3D.getManipulatorOfType("manip-robot-show-keyframes");
    if (showKeyframesManipId == -1) ctx3D.unshiftManipulator("manip-robot-show-keyframes", {
        robotClips: robotClips,
        vid: vid,
        referenceFrames: referenceFrames
    });
    else manipShowKeyframe.mState.transition({
        type: "rerenderRequested",
        payload: {
            robotClips: robotClips,
            vid: vid,
            referenceFrames: referenceFrames
        }
    });
};
const $3f65195cd5e8f23a$export$691f53c15bbb5f8f = ({ ctx3D: ctx3D , referenceFrame: referenceFrame  })=>{
    const showReferenceFramesManipId = ctx3D.mViewer.getOperatorManager().indexOf(ctx3D.mManipulators["manip-robot-show-reference-frame"].id);
    const manipShowReferenceFrame = ctx3D.getManipulatorOfType("manip-robot-show-reference-frame");
    if (showReferenceFramesManipId == -1) ctx3D.unshiftManipulator("manip-robot-show-reference-frame", {
        referenceFrame: referenceFrame
    });
    else manipShowReferenceFrame.mState.transition({
        type: "onClipSelected",
        payload: {
            referenceFrame: referenceFrame
        }
    });
};
const $3f65195cd5e8f23a$export$9cd1b7e07a4d109e = ({ ctx3D: ctx3D , robotClip: robotClip , vid: vid  })=>{
    const referenceFrame = robotClip.teachingReferenceFrame;
    $3f65195cd5e8f23a$export$691f53c15bbb5f8f({
        ctx3D: ctx3D,
        referenceFrame: referenceFrame
    });
    $3f65195cd5e8f23a$export$c3a9dc16787feaa1({
        ctx3D: ctx3D,
        robotClips: [
            robotClip
        ],
        referenceFrames: [
            referenceFrame
        ],
        vid: vid
    });
};
const $3f65195cd5e8f23a$export$1a3cf5ffcf3bfed5 = ({ ctx3D: ctx3D , robotClip: robotClip , referenceFrame: referenceFrame , vid: vid  })=>{
    if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
    $3f65195cd5e8f23a$export$691f53c15bbb5f8f({
        ctx3D: ctx3D,
        referenceFrame: referenceFrame
    });
    $3f65195cd5e8f23a$export$c3a9dc16787feaa1({
        ctx3D: ctx3D,
        robotClips: [
            robotClip
        ],
        referenceFrames: [
            referenceFrame
        ],
        vid: vid
    });
};
const $3f65195cd5e8f23a$export$711758442dc6f794 = ({ sequence: sequence , instruction: instruction , robotClip: robotClip  })=>{
    instruction.setParameter("clipId", robotClip.id);
    instruction.setParameter("executionReferenceFrame", robotClip.teachingReferenceFrame);
    const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(sequence.robotParameters.clips, {
        index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(robotClip),
        item: robotClip
    });
    (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, newRobotClips);
    sequence.mApp.notify("onInstructionChanged", robotClip);
};
const $3f65195cd5e8f23a$export$d7ce143e51c6582e = (g3DContext)=>({
        jointAngles: g3DContext.getManipulatorOfType("manip-robot").mState.getJointAngles(),
        pose: g3DContext.getManipulatorOfType("manip-robot").mState.getMatrixEndEffectorFromWorld().toArray()
    });
const $3f65195cd5e8f23a$export$a1d3a812a86859b6 = (sequence)=>{
    const clip = sequence.robotParameters?.clips.find((clip)=>clip.keyframes.some((keyframe)=>keyframe.isSelected));
    if (clip) {
        const keyframeIndex = clip.keyframes.findIndex((keyframe)=>keyframe.isSelected);
        const updatedClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(clip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeIsSelectedChanged({
            keyframeIndex: keyframeIndex,
            isSelected: false,
            selectedReferenceFrame: null
        }));
        const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(sequence.robotParameters.clips, {
            index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(clip),
            item: updatedClip
        });
        sequence.setRobotParametersClips(newRobotClips);
        sequence.mApp.updateApplicationInGraph();
    }
};
const $3f65195cd5e8f23a$export$f132b7f1a8fec800 = (sequence)=>{
    const application = sequence.mApp;
    const clip = application.robotParameters?.clips.find((clip)=>clip.keyframes.some((keyframe)=>keyframe.isSelected));
    if (clip) {
        const keyframeIndex = clip.keyframes.findIndex((keyframe)=>keyframe.isSelected);
        const updatedClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(clip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeIsSelectedChanged({
            keyframeIndex: keyframeIndex,
            isSelected: false,
            selectedReferenceFrame: null
        }));
        const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(application.robotParameters.clips, {
            index: $d5cc77669caa91ad$export$a8b22829e538b5fc(application.robotParameters.clips)(clip),
            item: updatedClip
        });
        application.robotParameters.clips = newRobotClips;
        application.updateApplicationInGraph();
    }
};
const $3f65195cd5e8f23a$export$93c0804a1c339b09 = ({ id: id , sequence: sequence  })=>sequence?.robotParameters?.clips.find((clip)=>clip.id === id);
const $3f65195cd5e8f23a$export$8587ccd1159a53ed = ({ id: id , application: application  })=>application.robotParameters?.clips.find((clip)=>clip.id === id);
const $3f65195cd5e8f23a$export$5ddd3c8da8487977 = (application)=>application?.robotParameters?.clips.some((clip)=>clip.keyframes.some((keyframe)=>keyframe.isEditing)) || application?.mSequences.some((sequence)=>sequence.robotParameters?.clips.some((clip)=>clip.keyframes.some((keyframe)=>keyframe.isEditing)));



var $f85a033c6813f831$export$2e2bcd8739ae039 = {
    setTopManipulatorManipRotateTranslate: (g3DContext)=>()=>g3DContext.setTopManipulator("manip-rotate-translate"),
    setTopManipulatorManipRobot: (g3DContext)=>(context)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            g3DContext.getManipulatorType() !== "manip-robot" && g3DContext.setTopManipulator("manip-robot", context.vid);
        },
    addVid: ()=>(0, $gXNCa$xstate.assign)({
            vid: (context, event)=>parseInt(Object.keys(event.robotConfig.mRobotActuators)[0])
        }),
    removeVid: ()=>(0, $gXNCa$xstate.assign)({
            vid: (context, event)=>{
                if (event.vid === context.vid) return -1;
            }
        }),
    updateVid: ()=>(0, $gXNCa$xstate.assign)({
            vid: (context, event)=>parseInt(event.vid)
        }),
    addReactStateUpdateFunction: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>({
                    ...context.reactStateUpdateFunctions,
                    [event.idxFunc.id]: event.idxFunc.func
                })
        }),
    removeReactStateUpdateFunction: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        }),
    reactUpdateState: ()=>(0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c),
    onReactComponentMount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>({
                    ...context.reactStateUpdateFunctions,
                    [event.idxFunc.id]: event.idxFunc.func
                })
        }),
    onReactComponentUnmount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        })
};




var $969c09977ac4dd80$export$2e2bcd8739ae039 = {
    RobotClipsOnUmount: (g3DContext)=>(context, event, actionMeta)=>{
            const onPartsMoved = (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
            g3DContext.unregisterForNotification("parts_moved", onPartsMoved);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    onUnmount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        })
};







/**
 * NOTE:
 * in MachineBuilder,
 * since `use_first_waypoint_as_start_state` is `true`
 * and we use the joint angles of the first keyframe's waypoint as start state,
 * when the kinematic chain segments change,
 * we need to update the joint angles by doing inverse kinematics using the waypoint pose
 *
 * @param {*} robotUtils
 * @param {import('../../../../model/types').VID} robotVid
 * @returns {(clip: import("../../../../model/types").RobotParametersClip) => import("../../../../model/types").RobotParametersClip}
 */ const $d2fb268b08586fb9$var$RobotClip__updateAfterKinematicChainSegmentsChange = (robotUtils, robotVid, robotId)=>(clip)=>{
        if (clip.robotId !== robotId) return clip;
        const firstWaypointKeyframeIndex = clip.keyframes.findIndex($cfe42de372e617bc$export$40ac058dfb167390);
        if (firstWaypointKeyframeIndex < 0) return clip;
        const firstWaypoint = clip.keyframes[firstWaypointKeyframeIndex].waypoint;
        if (!firstWaypoint || firstWaypoint.ignoreReferenceFrame) return clip;
        const ArrayMatrix__teachingReferenceFrame_world = robotUtils.ArrayMatrix__getChangeOfBasis_referenceFrame_world(clip.teachingReferenceFrame);
        const updatedFirstWaypointJointAngles = robotUtils.JointAngle__updateFromPoseUsingOrocosKDLRobot(robotVid, firstWaypoint.jointAngles, {
            ArrayMatrix__endEffectorFrame_world: firstWaypoint.pose,
            ArrayMatrix__teachingReferenceFrame_world: ArrayMatrix__teachingReferenceFrame_world,
            ArrayMatrix__executionReferenceFrame_world: ArrayMatrix__teachingReferenceFrame_world,
            ArrayMatrix__calibrationReferenceFrame_world: robotUtils.ArrayMatrix__getChangeOfBasis_hoopsModel_world(robotVid)
        });
        const updatedClip = {
            ...clip,
            keyframes: $cfe42de372e617bc$export$c8aaa594a0bf3665(clip.keyframes, firstWaypointKeyframeIndex, updatedFirstWaypointJointAngles)
        };
        return updatedClip;
    };
const $d2fb268b08586fb9$var$couplingOrEndEffectorAddedOrRemoved = (g3DContext, application, robotId, robotVid, hid, robotType)=>{
    // update orocosKDLRobot
    const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
    manipRobotState.transition({
        type: "KINEMATIC_CHAIN_SEGMENTS_CHANGED",
        payload: {
            vid: robotVid,
            hid: hid,
            robotType: robotType
        }
    });
    if (robotId !== undefined) {
        $1d3cf5330bb207de$export$3fd6c15374412e0(application, robotId, g3DContext.robotUtils?.ArrayMatrix__get_endEffector_flange());
        $1d3cf5330bb207de$export$2704a7f0b64bdf92(application, $d2fb268b08586fb9$var$RobotClip__updateAfterKinematicChainSegmentsChange(g3DContext.robotUtils, robotVid, robotId));
        application?.setDirty(0);
    }
};
var $d2fb268b08586fb9$export$2e2bcd8739ae039 = $d2fb268b08586fb9$var$couplingOrEndEffectorAddedOrRemoved;



/**
 * @param {import('../../../model/types').MachineLogicApplication[]} applications
 * @param {(vid: import('../../../model/types').VID) => import('../../../model/types').ArrayMatrix} getArrayMatrixOfVIDAssociatedModel
 * @returns {(topic: String, movedParts: import('../../../model/types').VID[], partsPoseDisplacement: import('../../../model/types').ArrayMatrix) => void}
 */ const $cabdcf2db8eb40bd$var$onPartsMoved = (applications, getArrayMatrixOfVIDAssociatedModel)=>(_, movedParts, partsPoseDisplacement)=>{
        applications.forEach((application)=>{
            movedParts.forEach((vid)=>{
                const arrayMatrixOfVIDAssociatedModel = getArrayMatrixOfVIDAssociatedModel(vid);
                $1d3cf5330bb207de$export$2e8c804cf36be98(application, partsPoseDisplacement, arrayMatrixOfVIDAssociatedModel)(vid);
            });
            application?.setDirty();
        });
    };
const $cabdcf2db8eb40bd$var$callCouplingOrEndEffectorAddedOrRemoved = (g3DContext, gLibrary)=>(context)=>{
        const robotType = g3DContext.robotUtils.getRobotTypeFromVID(context.vid);
        if (robotType === undefined) return;
        const hid = g3DContext.mGraph.getHID(context.vid);
        const robotConfig = gLibrary.mLibrary.mConfigManager.mConfigurationList.map((config)=>config.mRobots.find((robotConfig)=>robotConfig.mRobotActuators[context.vid]))[0];
        gLibrary.getMachineLogicAppList().forEach((application)=>{
            (0, $d2fb268b08586fb9$export$2e2bcd8739ae039)(g3DContext, application, robotConfig?.mRobotId, context.vid, hid, robotType);
        });
    };
let $cabdcf2db8eb40bd$var$onPartsMovedState;
var $cabdcf2db8eb40bd$export$2e2bcd8739ae039 = {
    registerPartsMoved: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            /**
       *
       * @param {import('../../../model/types').VID} vid
       * @returns {import('../../../model/types').ArrayMatrix}
       */ const getArrayMatrixOfVIDAssociatedModel = (vid)=>g3DContext.getNodeMatrix(g3DContext.mGraph.getHID(vid)).toArray();
            $cabdcf2db8eb40bd$var$onPartsMovedState = $cabdcf2db8eb40bd$var$onPartsMoved(gLibrary.mLibrary.mApplications, getArrayMatrixOfVIDAssociatedModel);
            g3DContext.registerForNotification("parts_moved", $cabdcf2db8eb40bd$var$onPartsMovedState);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    unRegisterPartsMoved: (g3DContext)=>(context, event, actionMeta)=>{
            g3DContext.unregisterForNotification("parts_moved", $cabdcf2db8eb40bd$var$onPartsMovedState);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    onRobotActuatorAddedInitializeManipRobot: (g3DContext)=>(context)=>{
            const { vid: vid  } = context;
            const hid = g3DContext.mGraph.getHID(vid);
            const robotType = g3DContext.robotUtils.getRobotTypeFromVID(vid);
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "MachineLogic/Config/RobotPartNumber/onChange",
                payload: {
                    vid: vid,
                    hid: hid,
                    robotType: robotType
                }
            });
        },
    onRobotAddedInitializeManipRobot: (g3DContext)=>(context)=>{
            const { vid: vid  } = context;
            if (!vid) return;
            const hid = g3DContext.mGraph.getHID(vid);
            const robotType = g3DContext.robotUtils.getRobotTypeFromVID(vid);
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "MachineLogic/Config/RobotAdded",
                payload: {
                    vid: vid,
                    hid: hid,
                    robotType: robotType
                }
            });
        },
    clearScene: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "CLEAR_SCENE",
                payload: {
                    endEffectorVisible: false,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    TreeViewInstructionClicked: (g3DContext)=>(context, event)=>{
            g3DContext.getCtx3js().clearScene();
            const { instruction: instruction  } = event;
            const isLoopInstruction = !!instruction.getParameter("sequenceName");
            if (isLoopInstruction) g3DContext.robotAppsService.send("RobotLoopInstruction/onCardClick", {
                instruction: instruction
            });
            else {
                const getClipBySequenceAndIdFromRobotAssets = ({ sequence: sequence , id: id  })=>sequence?.mApp?.robotParameters?.clips.find((clip)=>clip.id === id);
                const robotClipInRobotAssets = getClipBySequenceAndIdFromRobotAssets({
                    sequence: instruction.mSequence,
                    id: instruction.getParameter("clipId")
                });
                if (robotClipInRobotAssets) g3DContext.robotAppsService.send("RobotInstructionSelector/onClipSelected", {
                    robotClip: robotClipInRobotAssets,
                    instruction: instruction
                });
                else {
                    const getClipBySequenceAndIdFromSequence = ({ sequence: sequence , id: id  })=>sequence?.robotParameters?.clips.find((clip)=>clip.id === id);
                    const robotClipInSequence = getClipBySequenceAndIdFromSequence({
                        sequence: instruction.mSequence,
                        id: instruction.getParameter("clipId")
                    });
                    g3DContext.robotAppsService.send("RobotInstructionEditable/clipSelected", {
                        robotClip: robotClipInSequence,
                        instruction: instruction
                    });
                }
            }
        },
    LocalRobotInstructionMovedToAnotherSequence: ()=>(0, $2395189d05dd8ef4$export$2b6febbbdf03a058),
    setApplicationRobotParametersCalibrationParts: (g3DContext, gLibrary)=>()=>{
            const robotUtils = g3DContext.robotUtils;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const newCalibrationParts = robotUtils.ArrayOf_VID_x_Name__getCalibrationParts();
            application && (0, $3f65195cd5e8f23a$export$a8eadffee6cd0dc7)({
                application: application,
                newCalibrationParts: newCalibrationParts
            });
        },
    callCouplingOrEndEffectorAddedOrRemoved: $cabdcf2db8eb40bd$var$callCouplingOrEndEffectorAddedOrRemoved
};




var $82d0906a5e92b1c6$export$2e2bcd8739ae039 = {
    RobotAssetsRobotArraysOnMount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>({
                    ...context.reactStateUpdateFunctions,
                    [event.idxFunc.id]: event.idxFunc.func
                })
        }),
    RobotAssetsRobotArraysOnUnmount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        }),
    RobotAssetsRobotArraysOnAddRobotArray: (g3DContext)=>(context, event, actionMeta)=>{
            const { onReferenceFrameCreateSet: onReferenceFrameCreateSet , onReferenceFrameCreateCancel: onReferenceFrameCreateCancel  } = event;
            g3DContext.setTopManipulator("manip-robot-create-reference-frame", {
                onReferenceFrameSet: (newReferenceFrame)=>{
                    g3DContext.robotAppsService.send("RobotAssets/RobotArrays/manip-robot-create-reference-frame/onReferenceFrameSet");
                    onReferenceFrameCreateSet(newReferenceFrame);
                },
                onReferenceFrameCreateCancel: ()=>{
                    g3DContext.robotAppsService.send("RobotAssets/RobotArrays/manip-robot-create-reference-frame/onReferenceFrameCreateCancel", {
                        onReferenceFrameCreateCancel: onReferenceFrameCreateCancel
                    });
                }
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnArraysNameUpdated: (gLibrary)=>(context, event, actionMeta)=>{
            const { newArrays: newArrays  } = event;
            gLibrary.mLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onArraysNameUpdated",
                payload: {
                    newArrays: newArrays
                }
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnArrayReferenceFrameEditClick: (g3DContext)=>(context, event)=>{
            const { array: array , onArrayFrameSet: onArrayFrameSet , onReferenceFrameCreateCancel: onReferenceFrameCreateCancel  } = event;
            g3DContext.setTopManipulator("manip-robot-create-reference-frame", {
                onReferenceFrameSet: (referenceFrame)=>{
                    g3DContext.robotAppsService.send("RobotAssets/RobotArrays/onArrayReferenceFrameEditClick/manip-robot-create-reference-frame/onReferenceFrameSet", {
                        referenceFrame: referenceFrame,
                        array: array,
                        onArrayFrameSet: onArrayFrameSet
                    });
                },
                onReferenceFrameCreateCancel: ()=>{
                    g3DContext.robotAppsService.send("RobotAssets/RobotArrays/onArrayReferenceFrameEditClick/manip-robot-create-reference-frame/onReferenceFrameCreateCancel", {
                        onReferenceFrameCreateCancel: onReferenceFrameCreateCancel
                    });
                }
            });
        },
    RobotAssetsRobotArraysOnArrayReferenceFrameEditClickOnReferenceFrameSet: (g3DContext)=>(context, event)=>{
            const { referenceFrame: referenceFrame , array: array , onArrayFrameSet: onArrayFrameSet  } = event;
            g3DContext.setTopManipulator("manip-robot-create-array", {
                referenceFrame: referenceFrame,
                array: array,
                onArrayFrameSet: onArrayFrameSet
            });
        },
    RobotAssetsRobotArraysOnReferenceFrameCreateCancel: (g3DContext)=>(context, event, actionMeta)=>{
            event.onReferenceFrameCreateCancel();
            g3DContext.setTopManipulator("manip-rotate-translate");
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnArrayReferenceFrameEditClickOnReferenceFrameCreateCancel: (g3DContext)=>(context, event, actionMeta)=>{
            g3DContext.setTopManipulator("manip-rotate-translate");
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnGenerateClick: (g3DContext)=>(context, event, actionMeta)=>{
            const { payload: { referenceFrame: referenceFrame , array: array , onArrayFrameSet: onArrayFrameSet  }  } = event;
            g3DContext.setTopManipulator("manip-robot-create-array", {
                referenceFrame: referenceFrame,
                array: array,
                onArrayFrameSet: onArrayFrameSet
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnRegenerateClick: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { payload: { referenceFrame: referenceFrame , array: array , onArrayFrameSet: onArrayFrameSet , newArrays: newArrays  }  } = event;
            gLibrary.mLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onRegenerateClick",
                payload: {
                    newArrays: newArrays
                }
            });
            g3DContext.setTopManipulator("manip-robot-create-array", {
                referenceFrame: referenceFrame,
                array: array,
                onArrayFrameSet: onArrayFrameSet
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnArrayCardClick: (g3DContext)=>(context, event, actionMeta)=>{
            const { payload: payload  } = event;
            g3DContext.setTopManipulator("manip-robot-create-array", {
                referenceFrame: payload.referenceFrame,
                array: payload.array,
                onArrayFrameSet: payload.onArrayFrameSet
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnArrayCardEditClick: (g3DContext)=>(context, event, actionMeta)=>{
            const { payload: payload  } = event;
            g3DContext.setTopManipulator("manip-robot-create-array", {
                referenceFrame: payload.referenceFrame,
                array: payload.array,
                onArrayFrameSet: payload.onArrayFrameSet
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnPatternChange: (g3DContext)=>(context, event, actionMeta)=>{
            const { payload: payload  } = event;
            g3DContext.setTopManipulator("manip-robot-create-array", {
                referenceFrame: payload.referenceFrame,
                array: payload.array,
                onArrayFrameSet: payload.onArrayFrameSet
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnDeleteClick: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { newArrays: newArrays  } = event;
            g3DContext.setTopManipulator("manip-rotate-translate");
            gLibrary.mLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onDeleteClick",
                payload: {
                    newArrays: newArrays,
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnLockedDeleteClick: (g3DContext)=>(context, event, actionMeta)=>{
            g3DContext.robotUtils.guiWidgetsMessageBox("Before deleting this robot array, remove the robot loop command from any sequences using this robot array.", "warning");
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnCopyClick: (gLibrary)=>(context, event, actionMeta)=>{
            const { newArrays: newArrays  } = event;
            gLibrary.mLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onCopyClick",
                payload: {
                    newArrays: newArrays,
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotAssetsRobotArraysOnEditFrameDoneClick: (gLibrary)=>(context, event)=>{
            const { newArrays: newArrays  } = event;
            gLibrary.mLibrary.mCurrentApplication.transition({
                type: "robot_arrays/onEditFrameDoneClick",
                payload: {
                    newArrays: newArrays,
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
        }
};



var $7db62daec3796c68$export$2e2bcd8739ae039 = {
    setTopManipulatorSelectFeature: (g3DContext)=>()=>{
            g3DContext.setTopManipulator("manip-robot-select-feature");
        },
    onPointToPointEscPressed: (g3DContext)=>(context)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            g3DContext.setTopManipulator("manip-robot", context.vid);
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "RENDER_SCENE",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    pointToPointFeatureSelected: (g3DContext)=>(context, event)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            g3DContext.setTopManipulator("manip-robot", context.vid);
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "SNAP_TO_FEATURE",
                payload: {
                    hid: g3DContext.mGraph.getVertexAttr(context.vid, "hoops_id"),
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    matrix__endEffector_world: event.matrixEndEffectorFromWorld,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    pointToPointTriadSelected: (g3DContext)=>(context)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            g3DContext.setTopManipulator("manip-robot", context.vid);
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "RENDER_SCENE",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        }
};


var $08fb73621a1ba093$export$2e2bcd8739ae039 = {
    editRobotClicked: (g3DContext)=>(context)=>{
            const { vid: vid  } = context;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EDIT_ROBOT_CLICKED",
                payload: {
                    vid: vid,
                    hid: g3DContext.mGraph.getHID(vid),
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(vid),
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: false
                }
            });
        },
    ManipRobotEFFECTOR_DRAG_STARTED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAG_STARTED",
                payload: {
                    hid: hid,
                    position: position,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    ManipRobotROTATOR_DRAG_STARTED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAG_STARTED",
                payload: {
                    hid: hid,
                    position: position,
                    endEffectorVisible: false,
                    rotatorVisible: true,
                    referenceFrameVisible: false
                }
            });
        },
    ManipRobotEFFECTOR_DRAGGED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAGGED",
                payload: {
                    hid: hid,
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    position: position,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    ManipRobotROTATOR_DRAGGED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAGGED",
                payload: {
                    hid: hid,
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    position: position,
                    endEffectorVisible: false,
                    rotatorVisible: true,
                    referenceFrameVisible: false
                }
            });
        },
    ManipRobotEFFECTOR_DRAG_ENDED: (g3DContext)=>(context, event)=>{
            const { vid: vid , hid: hid  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAG_ENDED",
                payload: {
                    vid: vid,
                    hid: hid,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    ManipRobotROTATOR_DRAG_ENDED: (g3DContext)=>(context, event)=>{
            const { vid: vid , hid: hid  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAG_ENDED",
                payload: {
                    vid: vid,
                    hid: hid,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    updateWidgetSizes: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "CAMERA_CHANGED",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: false
                }
            });
        },
    updateSelectedLink: (g3DContext)=>(context, event)=>{
            const { hid: hid , selectedLinkIndex: selectedLinkIndex , selectionItem: selectionItem  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "LINK_SELECTED",
                payload: {
                    hid: hid,
                    selectedLinkIndex: selectedLinkIndex,
                    selectionItem: selectionItem
                }
            });
        },
    onMouseUpPick: (g3DContext)=>(context, event)=>{
            const { position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ON_MOUSE_UP_PICK",
                payload: {
                    position: position
                }
            });
        },
    onMouseMovePick: (g3DContext)=>(context, event)=>{
            const { position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ON_MOUSE_MOVE_PICK",
                payload: {
                    position: position
                }
            });
        }
};



var $ea4929b387659f81$export$2e2bcd8739ae039 = {
    RobotInstructionSequencePrototypeNewInstructionParameterRobotId: (gLibrary)=>(context, event, actionMeta)=>{
            const { instruction: instruction  } = event;
            instruction.parameters["robotId"] = gLibrary.getConfigManager().listRobots()[0].mRobotId;
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSequencePrototypeUpdateInstructionParameterRobotId: (gLibrary)=>(context, event, actionMeta)=>{
            const { instruction: instruction  } = event;
            instruction.parameters["robotId"] = gLibrary.getConfigManager().listRobots()[0].mRobotId;
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSequencePrototypeNewInstructionParameterCalibrationReferenceFrame: (g3DContext)=>(context, event, actionMeta)=>{
            // ASSUMPTION: every time this function is called (on new instruction), the robot base is the default calibration frame
            const { instruction: instruction  } = event;
            const calibrationReferenceFrame = g3DContext.robotUtils.ArrayOf_VID_x_Name__getRobotKinematicsChainRootCalibrationParts()[0];
            instruction.parameters["calibrationReferenceFrame"] = calibrationReferenceFrame;
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionNewInstructionAddRobotBaseCalibrationReferenceFrame: (g3DContext, gLibrary)=>(context, event)=>{
            const { instruction: instruction  } = event;
            const robotId = instruction.parameters["robotId"];
            const robotVid = gLibrary.getConfigManager().getParentConfiguration().listRobots().find((r)=>r.mRobotId === robotId)?.mVID;
            const robotBaseCalibrationReferenceFrame = g3DContext.robotUtils.createCalibrationReferenceFrame(Number(robotVid));
            const application = gLibrary.getCurrentApplication();
            (0, $3f65195cd5e8f23a$export$47c8134d907f9e08)({
                application: application,
                robotBaseCalibrationReferenceFrame: robotBaseCalibrationReferenceFrame
            });
        },
    CalibrationReferenceFrameSelectorOnReferenceFrameSelected: (g3DContext)=>(context, event, actionMeta)=>{
            const { instruction: instruction , selectedReferenceFrameName: selectedReferenceFrameName  } = event;
            const getCalibrationReferenceFrameByName = (name)=>g3DContext.robotUtils.ArrayOf_VID_x_Name__getCalibrationParts().find((c)=>c.name === name);
            const selectedReferenceFrame = getCalibrationReferenceFrameByName(selectedReferenceFrameName);
            instruction.setParameter("calibrationReferenceFrame", selectedReferenceFrame);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSequencePrototypeNewInstruction: (gLibrary)=>(context, event, actionMeta)=>{
            const { instruction: instruction  } = event;
            instruction.parameters["robotId"] = gLibrary.getConfig().mRobots[0].mRobotId;
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionOnRender: ()=>(context, event)=>{
            const { instruction: instruction , instructionIndex: instructionIndex  } = event;
            instruction.setParameter("instructionIndex", instructionIndex);
        },
    onMount: (g3DContext)=>()=>g3DContext.registerForNotification("parts_moved", (0, $3f65195cd5e8f23a$export$24c0dc7a46687103)(g3DContext)),
    onUnmount: (g3DContext)=>()=>g3DContext.unregisterForNotification("parts_moved", (0, $3f65195cd5e8f23a$export$24c0dc7a46687103)(g3DContext)),
    onPartsMoved: ()=>()=>{}
};







let $3aa900a6c468a9ef$var$onPartsMoved;
var $3aa900a6c468a9ef$export$2e2bcd8739ae039 = {
    RobotClipsOnMount: (g3DContext)=>(context, event, actionMeta)=>{
            $3aa900a6c468a9ef$var$onPartsMoved = ()=>(0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
            g3DContext.registerForNotification("parts_moved", $3aa900a6c468a9ef$var$onPartsMoved);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnUmount: (g3DContext)=>(context, event, actionMeta)=>{
            g3DContext.unregisterForNotification("parts_moved", $3aa900a6c468a9ef$var$onPartsMoved);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnRobotClipsChange: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { newRobotClips: newRobotClips  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            // TODO: if you don't click in a sequence before or
            // application the mCurrentApplication will be undefined
            // maybe we could check with ML team if is the desired behavior
            if (application) {
                application.robotParameters.clips = newRobotClips.map((clip)=>{
                    const { teachingReferenceFrame: teachingReferenceFrame  } = clip;
                    if (!teachingReferenceFrame) return clip;
                    const arrayMatrix__teachingReferenceFrame_teachingReferenceFramePart = clip.teachingReferenceFrame.arrayMatrix__referenceFrame_vidAssociatedModel;
                    const { vid: vid  } = teachingReferenceFrame;
                    return {
                        ...clip,
                        teachingReferenceFrame: {
                            ...teachingReferenceFrame,
                            arrayMatrix__referenceFrame_world: g3DContext.robotUtils.tmMatrix(arrayMatrix__teachingReferenceFrame_teachingReferenceFramePart).multiply(g3DContext.getNodeMatrix(g3DContext.mGraph.getHID(vid))).toArray()
                        }
                    };
                });
                application.robotParameters.clips.forEach((clip)=>application.notify("onInstructionChanged", clip));
                application.setDirty();
            }
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnRobotClipChange: (gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: robotClip  } = event;
            gLibrary.mLibrary.mCurrentApplication?.notify("onInstructionChanged", robotClip);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnRobotClipsChangeNoConfig: (g3DContext)=>(context, event, actionMeta)=>{
            g3DContext.robotUtils.guiWidgetsMessageBox("Add a robot to the configuration before creating a robot path.", "info");
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnLockedDeleteClick: (g3DContext)=>(context, event, actionMeta)=>{
            g3DContext.robotUtils.guiWidgetsMessageBox("Before deleting this robot path, remove it from any sequences using it.", "warning");
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnDeleteClick: (g3DContext)=>()=>{
            g3DContext.setTopManipulator("manip-rotate-translate");
        },
    RobotClipsOnClipSelected: (g3DContext)=>(context, event)=>{
            g3DContext.getCtx3js().clearScene();
            const { robotClip: robotClip  } = event;
            const { vid: vid  } = context;
            const referenceFrame = robotClip.teachingReferenceFrame;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            if (!referenceFrame) return;
            (0, $3f65195cd5e8f23a$export$691f53c15bbb5f8f)({
                ctx3D: g3DContext,
                referenceFrame: referenceFrame
            });
            (0, $3f65195cd5e8f23a$export$c3a9dc16787feaa1)({
                ctx3D: g3DContext,
                referenceFrames: [
                    referenceFrame
                ],
                robotClips: [
                    robotClip
                ],
                vid: vid
            });
        },
    RobotClipsOnWaypointAdded: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: newRobotClip  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const application = gLibrary.mLibrary.mCurrentApplication;
            // TODO: if you don't click in a sequence before or
            // application the mCurrentApplication will be undefined
            // maybe we could check with ML team if is the desired behavior
            if (application) {
                const { jointAngles: jointAngles , pose: pose  } = (0, $3f65195cd5e8f23a$export$d7ce143e51c6582e)(g3DContext);
                const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(newRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeAdded({
                    keyframe: {
                        ...$7eced89b6dbac1bc$export$185802fd694ee1f5(true, newRobotClip.keyframes.length, jointAngles, pose)
                    }
                }));
                (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                    ctx3D: g3DContext,
                    application: application,
                    robotClip: robotClip
                });
                (0, $3f65195cd5e8f23a$export$bff04ed0ef06d271)({
                    ctx3D: g3DContext,
                    vid: vid,
                    referenceFrame: robotClip.teachingReferenceFrame
                });
                (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                    ctx3D: g3DContext,
                    robotClip: robotClip,
                    vid: vid
                });
                (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
            }
        },
    RobotClipsOnWaypointConfirmed: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: robotClipTemporary , keyframeIndex: keyframeIndex  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(robotClipTemporary, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointConfirmed({
                keyframeIndex: keyframeIndex,
                ...(0, $3f65195cd5e8f23a$export$d7ce143e51c6582e)(g3DContext),
                isEditing: false
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$590ba4bde3690df4)(g3DContext);
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnWaypointPathTypeChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: robotClip , keyframeIndex: keyframeIndex , pathType: pathType  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(robotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointPathTypeChanged({
                keyframeIndex: keyframeIndex,
                pathType: pathType
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnWaypointNameChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: robotClip , keyframeIndex: keyframeIndex , name: name  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(robotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointNameChanged({
                keyframeIndex: keyframeIndex,
                name: name
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnRobotCommandAdded: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeAdded({
                keyframe: (0, $2054c3e627b764ce$export$2e2bcd8739ae039)()
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnWaypointEditClicked: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            const { vid: vid  } = context;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeIsEditingChanged({
                keyframeIndex: keyframeIndex,
                isEditing: true
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$bff04ed0ef06d271)({
                ctx3D: g3DContext,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnKeyframeDeleteClicked: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const { vid: vid  } = context;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeRemoved({
                keyframeIndex: keyframeIndex
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnWaypointTimeChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointTimeChanged({
                keyframeIndex: keyframeIndex,
                time: time
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnWaypointClicked: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const isEditing = (0, $3f65195cd5e8f23a$export$5ddd3c8da8487977)(application);
            application.mSequences.forEach((sequence)=>(0, $3f65195cd5e8f23a$export$a1d3a812a86859b6)(sequence));
            (0, $3f65195cd5e8f23a$export$f132b7f1a8fec800)(application.mSequences[0]);
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)((0, $3f65195cd5e8f23a$export$8587ccd1159a53ed)({
                id: oldRobotClip.id,
                application: application
            }), (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeIsSelectedChanged({
                keyframeIndex: keyframeIndex,
                isSelected: true,
                selectedReferenceFrame: oldRobotClip.teachingReferenceFrame
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            g3DContext.getManipulatorType() !== "manip-robot" && g3DContext.setTopManipulator("manip-robot", context.vid);
            !isEditing && g3DContext.setTopManipulator("manip-rotate-translate");
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            if (robotClip.keyframes[keyframeIndex].waypoint.ignoreReferenceFrame) {
                const jointAngles = robotClip.keyframes[keyframeIndex].waypoint.jointAngles;
                manipRobotState.transition({
                    type: "ROBOT_JOINT_ANGLES_WAYPOINT_SELECTED",
                    payload: {
                        hid: g3DContext.mGraph.getHID(context.vid),
                        jointAngles: jointAngles,
                        endEffectorVisible: isEditing,
                        rotatorVisible: isEditing
                    }
                });
            } else if (robotClip.keyframes[keyframeIndex].waypoint.pathType === "movej") {
                const ArrayMatrix__teachingReferenceFrame_world = g3DContext.robotUtils.ArrayMatrix__getChangeOfBasis_referenceFrame_world(robotClip.teachingReferenceFrame);
                const jointAngles = g3DContext.robotUtils.JointAngle__updateFromPoseUsingOrocosKDLRobot(context.vid, robotClip.keyframes[keyframeIndex].waypoint.jointAngles, {
                    ArrayMatrix__endEffectorFrame_world: robotClip.keyframes[keyframeIndex].waypoint.pose,
                    ArrayMatrix__teachingReferenceFrame_world: ArrayMatrix__teachingReferenceFrame_world,
                    ArrayMatrix__executionReferenceFrame_world: ArrayMatrix__teachingReferenceFrame_world,
                    ArrayMatrix__calibrationReferenceFrame_world: g3DContext.robotUtils.ArrayMatrix__getChangeOfBasis_hoopsModel_world(context.vid)
                });
                manipRobotState.transition({
                    type: "ROBOT_JOINT_ANGLES_WAYPOINT_SELECTED",
                    payload: {
                        hid: g3DContext.mGraph.getHID(context.vid),
                        jointAngles: jointAngles,
                        endEffectorVisible: isEditing,
                        rotatorVisible: isEditing
                    }
                });
            } else if (robotClip.keyframes[keyframeIndex].waypoint.pathType === "movel") {
                const pose = robotClip.keyframes[keyframeIndex].waypoint.pose;
                manipRobotState.transition({
                    type: "ROBOT_POSE_WAYPOINT_SELECTED",
                    payload: {
                        hid: g3DContext.mGraph.getHID(context.vid),
                        robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                        pose: pose,
                        endEffectorVisible: isEditing,
                        rotatorVisible: isEditing,
                        vid: context.vid
                    }
                });
            }
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnKeyframeOrderChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframes: keyframes  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeOrderChanged({
                keyframes: keyframes
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnIgnoreReferenceFrameChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointIgnoreReferenceFrameChanged({
                keyframeIndex: keyframeIndex,
                ignoreReferenceFrame: ignoreReferenceFrame
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnKeyframeRobotCommandChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandChanged({
                keyframeIndex: keyframeIndex,
                robotCommandType: robotCommandType
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            const { vid: vid  } = context;
            const referenceFrame = oldRobotClip.teachingReferenceFrame;
            (0, $3f65195cd5e8f23a$export$c3a9dc16787feaa1)({
                ctx3D: g3DContext,
                referenceFrames: [
                    referenceFrame
                ],
                robotClips: [
                    robotClipUpdated
                ],
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnKeyframeRobotCommandWaitForTimeTimeChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandWaitForTimeTimeChanged({
                keyframeIndex: keyframeIndex,
                time: time
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnKeyframeRobotCommandSetPayloadWeightChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , weight: weight  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandSetPayloadWeightChanged({
                keyframeIndex: keyframeIndex,
                weight: weight
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandSetSpeedMoveLVelocityScalingFactorChanged({
                keyframeIndex: keyframeIndex,
                moveLVelocityScalingFactor: moveLVelocityScalingFactor
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotClipsOnKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  } = event;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const robotClipUpdated = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandSetSpeedMoveJVelocityScalingFactorChanged({
                keyframeIndex: keyframeIndex,
                moveJVelocityScalingFactor: moveJVelocityScalingFactor
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClipUpdated
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        }
};










var $88fa1fd9d6e4baa7$export$2e2bcd8739ae039 = {
    RobotInstructionEditableOnDeleteClicked: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction  } = event;
            (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, (0, $b7c3f63a1efa4cdf$exports).removeItem(sequence.robotParameters.clips, {
                index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)({
                    id: instruction.mParameters.clipId
                })
            }));
            sequence.removeInstruction(sequence.getInstructionIndex(instruction));
            g3DContext.setTopManipulator("manip-rotate-translate");
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnRobotClipChange: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: robotClip  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            instruction.setParameter("clipId", robotClip.id);
            instruction.setParameter("executionReferenceFrame", {
                ...robotClip.teachingReferenceFrame,
                arrayMatrix__referenceFrame_world: g3DContext.robotUtils.tmMatrix(robotClip.teachingReferenceFrame.arrayMatrix__referenceFrame_vidAssociatedModel).multiply(g3DContext.getNodeMatrix(g3DContext.mGraph.getHID(vid))).toArray()
            });
            const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(sequence.robotParameters.clips, {
                index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(robotClip),
                item: robotClip
            });
            (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, newRobotClips);
            sequence.mApp.notify("onInstructionChanged", robotClip);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableSaveToRobotAssetsButtonOnClick: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , selectedClip: localRobotClip  } = event;
            const clipToMove = {
                ...sequence.robotParameters.clips.find((c)=>c.id === localRobotClip.id),
                keyframes: sequence.robotParameters.clips.find((c)=>c.id === localRobotClip.id).keyframes.map((keyframe)=>({
                        ...keyframe,
                        isEditing: false
                    }))
            };
            const newApplicationClips = [
                ...sequence.mApp.robotParameters.clips,
                clipToMove
            ];
            sequence.mApp.robotParameters.clips = newApplicationClips;
            const newRobotParameters = {
                ...sequence.mApp.robotParameters
            };
            g3DContext.mGraph.setVertexAttr(sequence.mApp.mVID, "robotParameters", newRobotParameters);
            (0, $0ecc74569f33ab77$export$e65215519ed506a1)(sequence, (0, $b7c3f63a1efa4cdf$exports).removeItem(sequence.robotParameters.clips, {
                index: $d5cc77669caa91ad$export$a8b22829e538b5fc(sequence.robotParameters.clips)(localRobotClip)
            }));
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnClipSelected: (g3DContext)=>(context, event)=>{
            g3DContext.getCtx3js().clearScene();
            const { robotClip: robotClip , sequence: sequence  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const robotClipFromSequence = (0, $3f65195cd5e8f23a$export$93c0804a1c339b09)({
                id: robotClip.id,
                sequence: sequence
            });
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                vid: vid,
                robotClip: robotClipFromSequence
            });
        },
    RobotInstructionEditableOnWaypointAdded: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const { jointAngles: jointAngles , pose: pose  } = (0, $3f65195cd5e8f23a$export$d7ce143e51c6582e)(g3DContext);
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeAdded({
                keyframe: {
                    ...$7eced89b6dbac1bc$export$185802fd694ee1f5(true, oldRobotClip.keyframes.length, jointAngles, pose)
                }
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$bff04ed0ef06d271)({
                ctx3D: g3DContext,
                vid: vid,
                referenceFrame: instruction.getParameter("executionReferenceFrame")
            });
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnWaypointConfirmed: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointConfirmed({
                keyframeIndex: keyframeIndex,
                ...(0, $3f65195cd5e8f23a$export$d7ce143e51c6582e)(g3DContext),
                isEditing: false
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$590ba4bde3690df4)(g3DContext);
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnWaypointPathTypeChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , pathType: pathType  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointPathTypeChanged({
                keyframeIndex: keyframeIndex,
                pathType: pathType
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnWaypointNameChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , name: name  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointNameChanged({
                keyframeIndex: keyframeIndex,
                name: name
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnRobotCommandAdded: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeAdded({
                keyframe: (0, $2054c3e627b764ce$export$2e2bcd8739ae039)()
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnWaypointEditClicked: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeIsEditingChanged({
                keyframeIndex: keyframeIndex,
                isEditing: true
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$bff04ed0ef06d271)({
                ctx3D: g3DContext,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnKeyframeDeleteClicked: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            const { vid: vid  } = context;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeRemoved({
                keyframeIndex: keyframeIndex
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnWaypointTimeChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointTimeChanged({
                keyframeIndex: keyframeIndex,
                time: time
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnWaypointClicked: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            sequence.mApp.mSequences.forEach((sequence)=>(0, $3f65195cd5e8f23a$export$a1d3a812a86859b6)(sequence));
            (0, $3f65195cd5e8f23a$export$f132b7f1a8fec800)(sequence);
            const isEditing = (0, $3f65195cd5e8f23a$export$5ddd3c8da8487977)(sequence.mApp);
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)((0, $3f65195cd5e8f23a$export$93c0804a1c339b09)({
                id: oldRobotClip.id,
                sequence: sequence
            }), (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeIsSelectedChanged({
                keyframeIndex: keyframeIndex,
                isSelected: true,
                selectedReferenceFrame: oldRobotClip.teachingReferenceFrame
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            g3DContext.getManipulatorType() !== "manip-robot" && g3DContext.setTopManipulator("manip-robot", context.vid);
            !isEditing && g3DContext.setTopManipulator("manip-rotate-translate");
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            if (robotClip.keyframes[keyframeIndex].waypoint.ignoreReferenceFrame) {
                const jointAngles = robotClip.keyframes[keyframeIndex].waypoint.jointAngles;
                manipRobotState.transition({
                    type: "ROBOT_JOINT_ANGLES_WAYPOINT_SELECTED",
                    payload: {
                        hid: g3DContext.mGraph.getHID(context.vid),
                        jointAngles: jointAngles,
                        endEffectorVisible: isEditing,
                        rotatorVisible: isEditing
                    }
                });
            } else {
                const pose = robotClip.keyframes[keyframeIndex].waypoint.pose;
                manipRobotState.transition({
                    type: "ROBOT_POSE_WAYPOINT_SELECTED",
                    payload: {
                        hid: g3DContext.mGraph.getHID(context.vid),
                        robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                        pose: pose,
                        endEffectorVisible: isEditing,
                        rotatorVisible: isEditing,
                        vid: context.vid
                    }
                });
            }
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnKeyframeOrderChanged: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframes: keyframes  } = event;
            const { vid: vid  } = context;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeOrderChanged({
                keyframes: keyframes
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnIgnoreReferenceFrameChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).waypointIgnoreReferenceFrameChanged({
                keyframeIndex: keyframeIndex,
                ignoreReferenceFrame: ignoreReferenceFrame
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnKeyframeRobotCommandChanged: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandChanged({
                keyframeIndex: keyframeIndex,
                robotCommandType: robotCommandType
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            const { vid: vid  } = context;
            const referenceFrame = robotClip.teachingReferenceFrame;
            (0, $3f65195cd5e8f23a$export$c3a9dc16787feaa1)({
                ctx3D: g3DContext,
                referenceFrames: [
                    referenceFrame
                ],
                robotClips: [
                    robotClip
                ],
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnKeyframeRobotCommandWaitForTimeTimeChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , time: time  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandWaitForTimeTimeChanged({
                keyframeIndex: keyframeIndex,
                time: time
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnKeyframeRobotCommandSetPayloadWeightChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , weight: weight  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandSetPayloadWeightChanged({
                keyframeIndex: keyframeIndex,
                weight: weight
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandSetSpeedMoveLVelocityScalingFactorChanged({
                keyframeIndex: keyframeIndex,
                moveLVelocityScalingFactor: moveLVelocityScalingFactor
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: ()=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction , robotClip: oldRobotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  } = event;
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)(oldRobotClip, (0, $d184beb076db587a$export$197c291619fe9a2e).robotCommandSetSpeedMoveJVelocityScalingFactorChanged({
                keyframeIndex: keyframeIndex,
                moveJVelocityScalingFactor: moveJVelocityScalingFactor
            }));
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        }
};




function $ca0dfdf8b548132d$export$2e2bcd8739ae039({ ArrayMatrix__endEffectorFrame_world: ArrayMatrix__endEffectorFrame_world , ArrayMatrix__teachingReferenceFrame_world: ArrayMatrix__teachingReferenceFrame_world , ArrayMatrix__executionReferenceFrame_world: ArrayMatrix__executionReferenceFrame_world  }) {
    const endEffectorFrame_world = new $gXNCa$three.Matrix4().fromArray(ArrayMatrix__endEffectorFrame_world);
    const teachingReferenceFrame_world = new $gXNCa$three.Matrix4().fromArray(ArrayMatrix__teachingReferenceFrame_world);
    const world_teachingReferenceFrame = (0, $6623923a1bb51858$export$70ae2c07e401031b)(teachingReferenceFrame_world);
    const executionReferenceFrame_world = new $gXNCa$three.Matrix4().fromArray(ArrayMatrix__executionReferenceFrame_world);
    // we use the difference matrix between the teaching and execution reference frames to transform the end effector
    return (0, $6623923a1bb51858$export$71cf47b8291c00ec)((0, $6623923a1bb51858$export$71cf47b8291c00ec)(endEffectorFrame_world, world_teachingReferenceFrame), executionReferenceFrame_world).toArray();
}





var $44b186049f97a83c$export$2e2bcd8739ae039 = {
    RobotInstructionSelectorOnClipSelected: (g3DContext, gLibrary)=>(context, event)=>{
            g3DContext.getCtx3js().clearScene();
            const { robotClip: robotClip , instruction: instruction  } = event;
            const { vid: vid  } = context;
            const referenceFrame = instruction.getParameter("executionReferenceFrame");
            const robotClipFromApplication = (0, $3f65195cd5e8f23a$export$8587ccd1159a53ed)({
                id: robotClip.id,
                application: gLibrary.getCurrentApplication()
            });
            (0, $3f65195cd5e8f23a$export$691f53c15bbb5f8f)({
                ctx3D: g3DContext,
                referenceFrame: referenceFrame
            });
            (0, $3f65195cd5e8f23a$export$c3a9dc16787feaa1)({
                ctx3D: g3DContext,
                robotClips: [
                    robotClipFromApplication
                ],
                referenceFrames: [
                    referenceFrame
                ],
                vid: vid
            });
        },
    RobotInstructionSelectorOnWaypointClicked: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , keyframeIndex: keyframeIndex , executionReferenceFrame: executionReferenceFrame , isValidWaypoint: isValidWaypoint  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const teachingReferenceFrame = oldRobotClip.teachingReferenceFrame;
            const application = gLibrary.mLibrary.mCurrentApplication;
            const isEditing = (0, $3f65195cd5e8f23a$export$5ddd3c8da8487977)(application);
            application.mSequences.forEach((sequence)=>(0, $3f65195cd5e8f23a$export$a1d3a812a86859b6)(sequence));
            (0, $3f65195cd5e8f23a$export$f132b7f1a8fec800)(application.mSequences[0]);
            const robotClip = (0, $d184beb076db587a$export$b55a2b8a15f09f32)((0, $3f65195cd5e8f23a$export$8587ccd1159a53ed)({
                id: oldRobotClip.id,
                application: application
            }), (0, $d184beb076db587a$export$197c291619fe9a2e).keyframeIsSelectedChanged({
                keyframeIndex: keyframeIndex,
                isSelected: true,
                selectedReferenceFrame: executionReferenceFrame
            }));
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            g3DContext.getManipulatorType() !== "manip-robot" && g3DContext.setTopManipulator("manip-robot", context.vid);
            !isEditing && g3DContext.setTopManipulator("manip-rotate-translate");
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$1a3cf5ffcf3bfed5)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid,
                referenceFrame: executionReferenceFrame
            });
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            if (robotClip.keyframes[keyframeIndex].waypoint.ignoreReferenceFrame) {
                const jointAngles = robotClip.keyframes[keyframeIndex].waypoint.jointAngles;
                manipRobotState.transition({
                    type: "ROBOT_JOINT_ANGLES_WAYPOINT_SELECTED",
                    payload: {
                        hid: g3DContext.mGraph.getVertexAttr(context.vid, "hoops_id"),
                        jointAngles: jointAngles,
                        endEffectorVisible: isEditing,
                        rotatorVisible: isEditing
                    }
                });
            } else if (isValidWaypoint) {
                if (robotClip.keyframes[keyframeIndex].waypoint.pathType === "movej") {
                    const jointAngles = g3DContext.robotUtils.JointAngle__updateFromPoseUsingOrocosKDLRobot(context.vid, robotClip.keyframes[keyframeIndex].waypoint.jointAngles, {
                        ArrayMatrix__endEffectorFrame_world: robotClip.keyframes[keyframeIndex].waypoint.pose,
                        ArrayMatrix__teachingReferenceFrame_world: teachingReferenceFrame.arrayMatrix__referenceFrame_world,
                        ArrayMatrix__executionReferenceFrame_world: executionReferenceFrame.arrayMatrix__referenceFrame_world,
                        ArrayMatrix__calibrationReferenceFrame_world: g3DContext.robotUtils.ArrayMatrix__getChangeOfBasis_hoopsModel_world(context.vid)
                    });
                    manipRobotState.transition({
                        type: "ROBOT_JOINT_ANGLES_WAYPOINT_SELECTED",
                        payload: {
                            hid: g3DContext.mGraph.getVertexAttr(context.vid, "hoops_id"),
                            jointAngles: jointAngles,
                            endEffectorVisible: isEditing,
                            rotatorVisible: isEditing
                        }
                    });
                } else if (robotClip.keyframes[keyframeIndex].waypoint.pathType === "movel") {
                    const pose = (0, $ca0dfdf8b548132d$export$2e2bcd8739ae039)({
                        ArrayMatrix__endEffectorFrame_world: robotClip.keyframes[keyframeIndex].waypoint.pose,
                        ArrayMatrix__teachingReferenceFrame_world: teachingReferenceFrame.arrayMatrix__referenceFrame_world,
                        ArrayMatrix__executionReferenceFrame_world: executionReferenceFrame.arrayMatrix__referenceFrame_world
                    });
                    manipRobotState.transition({
                        type: "ROBOT_POSE_WAYPOINT_SELECTED",
                        payload: {
                            hid: g3DContext.mGraph.getVertexAttr(context.vid, "hoops_id"),
                            robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                            pose: pose,
                            endEffectorVisible: isEditing,
                            rotatorVisible: isEditing,
                            vid: context.vid
                        }
                    });
                }
            }
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSelectorClipSelectorOnClipMounted: ()=>(context, event, actionMeta)=>{
            const { instruction: instruction , clipId: clipId  } = event;
            instruction.setParameter("clipId", clipId);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSelectorClipSelectorOnClipSelected: (g3DContext)=>(context, event)=>{
            const { sequence: sequence , instruction: instruction , clipId: clipId  } = event;
            (0, $3f65195cd5e8f23a$export$2703143e0251f0)(g3DContext)(sequence, instruction, clipId);
        },
    RobotInstructionSelectorClipSelectorOnNewClipSelected: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction  } = event;
            (0, $3f65195cd5e8f23a$export$667527877a795588)(g3DContext, gLibrary)(sequence, instruction);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSelectorClipSelectorOnNewClipMounted: (g3DContext, gLibrary)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction  } = event;
            (0, $3f65195cd5e8f23a$export$667527877a795588)(g3DContext, gLibrary)(sequence, instruction);
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSelectorStyledDeleteButtonOnClick: (g3DContext)=>(context, event, actionMeta)=>{
            const { sequence: sequence , instruction: instruction  } = event;
            sequence.removeInstruction(sequence.getInstructionIndex(instruction));
            g3DContext.setTopManipulator("manip-rotate-translate");
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        }
};




var $e51bbe99eb89d9ca$export$2e2bcd8739ae039 = {
    onMount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>({
                    ...context.reactStateUpdateFunctions,
                    [event.idxFunc.id]: event.idxFunc.func
                })
        }),
    onUnmount: ()=>(0, $gXNCa$xstate.assign)({
            reactStateUpdateFunctions: (context, event)=>{
                /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
                return newReactStateUpdateFunctions;
            }
        }),
    robotLoopInstructionOnArraySelected: ()=>(context, event)=>{
            const { application: application , arrayId: arrayId , instruction: instruction  } = event;
            application.transition({
                type: "robot_loop_instruction/onArraySelected",
                payload: {
                    arrayId: arrayId,
                    instruction: instruction
                }
            });
        },
    robotLoopInstructionOnChildSequenceNameChange: ()=>(context, event)=>{
            const { sequenceName: sequenceName , instruction: instruction  } = event;
            instruction.setParameter("sequenceName", sequenceName);
        },
    robotLoopInstructionOnStartFromChange: (helpers, widgets)=>(context, event)=>{
            const { startFrom: startFrom , instruction: instruction , application: application , setStartFrom: setStartFrom  } = event;
            const storedStartFrom = instruction.getParameter("startFrom");
            const expressionValidationError = helpers.getExpressionValidationFunction(application.getParametersObject())(startFrom);
            const minValueValidationError = expressionValidationError ? true : helpers.getMinMaxValidationFunction({
                min: 1
            })(startFrom);
            const maxValueValidationError = expressionValidationError ? true : helpers.getMinMaxValidationFunction({
                max: instruction.getParameter("arrayValue").length
            })(startFrom);
            // Update instruction parameter if no error, else revert react state to previous valid state
            if (!minValueValidationError && !maxValueValidationError) instruction.setParameter("startFrom", startFrom);
            else {
                setStartFrom(storedStartFrom);
                widgets.messageBox(expressionValidationError ?? minValueValidationError + ". Your changes have been reverted." ?? maxValueValidationError + ". Your changes have been reverted.", "warning");
            }
        },
    robotLoopInstructionOnDeleteButtonClick: ()=>(context, event)=>{
            const { sequence: sequence , instruction: instruction  } = event;
            sequence.removeInstruction(sequence.getInstructionIndex(instruction));
        },
    robotLoopInstructionOnCardClick: (g3DContext)=>(context, event)=>{
            g3DContext.getCtx3js().clearScene();
            // show the array of the selected loop instruction
            const { instruction: instruction  } = event;
            const arrayId = instruction.getParameter("arrayId");
            const array = instruction.mApp.robotParameters.arrays.find((array)=>array.id === arrayId);
            if (instruction.mApp.robotParameters.arrays.length == 0) //NO ARRAY TO LOOP / NO ARRAY SELECTED
            return;
            const arrayReferenceFrame = array.arrayMatrixReferenceFrame;
            const arrayPoint2D = array.arrayArrayPoint2D.flat().filter((item)=>item.isSelected).map(({ x: x , y: y  })=>({
                    x: x,
                    y: y
                }));
            const createArrayManipId = g3DContext.mViewer.getOperatorManager().indexOf(g3DContext.mManipulators["manip-robot-create-array"].id);
            const manipCreateArray = g3DContext.getManipulatorOfType("manip-robot-create-array");
            if (createArrayManipId == -1) g3DContext.unshiftManipulator("manip-robot-create-array", {
                referenceFrame: arrayReferenceFrame,
                array: arrayPoint2D
            });
            else manipCreateArray.mState.transition({
                type: "RobotLoopInstruction/onMouseEnter",
                payload: {
                    referenceFrame: arrayReferenceFrame,
                    array: arrayPoint2D
                }
            });
            // show the all keyframes inside all clips of the selected loop instruction's sequence
            const { vid: vid  } = context;
            const sequenceName = instruction.getParameter("sequenceName");
            const sequence = instruction.mApp.mSequences.find((sequence)=>sequence.mName === sequenceName);
            const getClipById = (id)=>sequence?.mApp?.robotParameters?.clips.find((clip)=>clip.id === id) || sequence?.robotParameters?.clips.find((clip)=>clip.id === id);
            const robotClips = sequence.mInstructions.filter((instruction)=>instruction.mCategory === "robot").map((robotInstruction)=>getClipById(robotInstruction.getParameter("clipId")));
            const referenceFrames = g3DContext.robotUtils.getRobotArraysReferenceFramesFromArrayOfPoint2DxReferenceFrame(arrayPoint2D, arrayReferenceFrame);
            (0, $3f65195cd5e8f23a$export$c3a9dc16787feaa1)({
                ctx3D: g3DContext,
                vid: vid,
                robotClips: robotClips,
                referenceFrames: referenceFrames
            });
        }
};



var $7aa192330929447f$export$2e2bcd8739ae039 = {
    joggerSelected: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "RENDER_SCENE",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    joggerExited: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "RENDER_SCENE",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    updateRobotModelPoseTranslation: (g3DContext)=>(context, event)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const { letter: letter , value: value  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "NUMERIC_ENTRY_INPUT_TRANSLATION",
                payload: {
                    hid: g3DContext.mGraph.getVertexAttr(context.vid, "hoops_id"),
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    letter: letter,
                    value: value,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    updateRobotModelPoseRotation: (g3DContext)=>(context, event)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const { letter: letter , value: value  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "NUMERIC_ENTRY_INPUT_ROTATION",
                payload: {
                    hid: g3DContext.mGraph.getVertexAttr(context.vid, "hoops_id"),
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    letter: letter,
                    value: value,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    updateRobotModelJointAngles: (g3DContext)=>(context, event)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const { index: index , value: value  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "NUMERIC_ENTRY_INPUT_JOINT_ANGLES",
                payload: {
                    hid: g3DContext.mGraph.getVertexAttr(context.vid, "hoops_id"),
                    index: index,
                    value: value,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    updateWidgetSizes: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "CAMERA_CHANGED",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotEFFECTOR_DRAG_STARTED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAG_STARTED",
                payload: {
                    hid: hid,
                    position: position,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotROTATOR_DRAG_STARTED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAG_STARTED",
                payload: {
                    hid: hid,
                    position: position,
                    endEffectorVisible: false,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotEFFECTOR_DRAGGED: (g3DContext)=>(context, event)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAGGED",
                payload: {
                    hid: hid,
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    position: position,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotROTATOR_DRAGGED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAGGED",
                payload: {
                    hid: hid,
                    position: position,
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    endEffectorVisible: false,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotEFFECTOR_DRAG_ENDED: (g3DContext)=>(context, event)=>{
            const { vid: vid , hid: hid  } = event;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAG_ENDED",
                payload: {
                    vid: vid,
                    hid: hid,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotROTATOR_DRAG_ENDED: (g3DContext)=>(context, event)=>{
            const { vid: vid , hid: hid  } = event;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAG_ENDED",
                payload: {
                    vid: vid,
                    hid: hid,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    updateSelectedLink: (g3DContext)=>(context, event)=>{
            const { hid: hid , selectedLinkIndex: selectedLinkIndex , selectionItem: selectionItem  } = event;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "LINK_SELECTED",
                payload: {
                    hid: hid,
                    selectedLinkIndex: selectedLinkIndex,
                    selectionItem: selectionItem
                }
            });
        },
    onMouseUpPick: (g3DContext)=>(context, event)=>{
            const { position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ON_MOUSE_UP_PICK",
                payload: {
                    position: position
                }
            });
        },
    onMouseMovePick: (g3DContext)=>(context, event)=>{
            const { position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ON_MOUSE_MOVE_PICK",
                payload: {
                    position: position
                }
            });
        }
};


var $90ab4fc3e0a35313$export$2e2bcd8739ae039 = {
    triadSelected: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "RENDER_SCENE",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    updateWidgetSizes: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "CAMERA_CHANGED",
                payload: {
                    endEffectorVisible: true,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotEFFECTOR_DRAG_STARTED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAG_STARTED",
                payload: {
                    hid: hid,
                    position: position,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotROTATOR_DRAG_STARTED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAG_STARTED",
                payload: {
                    hid: hid,
                    position: position,
                    endEffectorVisible: false,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotEFFECTOR_DRAGGED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAGGED",
                payload: {
                    hid: hid,
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    position: position,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotROTATOR_DRAGGED: (g3DContext)=>(context, event)=>{
            const { hid: hid , position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAGGED",
                payload: {
                    hid: hid,
                    robotType: g3DContext.robotUtils.getRobotTypeFromVID(context.vid),
                    position: position,
                    endEffectorVisible: false,
                    rotatorVisible: true,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotEFFECTOR_DRAG_ENDED: (g3DContext)=>(context, event)=>{
            const { vid: vid , hid: hid  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "EFFECTOR_DRAG_ENDED",
                payload: {
                    vid: vid,
                    hid: hid,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    ManipRobotROTATOR_DRAG_ENDED: (g3DContext)=>(context, event)=>{
            const { vid: vid , hid: hid  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROTATOR_DRAG_ENDED",
                payload: {
                    vid: vid,
                    hid: hid,
                    endEffectorVisible: true,
                    rotatorVisible: false,
                    referenceFrameVisible: true
                }
            });
        },
    updateSelectedLink: (g3DContext)=>(context, event)=>{
            const { hid: hid , selectedLinkIndex: selectedLinkIndex , selectionItem: selectionItem  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "LINK_SELECTED",
                payload: {
                    hid: hid,
                    selectedLinkIndex: selectedLinkIndex,
                    selectionItem: selectionItem
                }
            });
        },
    onMouseUpPick: (g3DContext)=>(context, event)=>{
            const { position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ON_MOUSE_UP_PICK",
                payload: {
                    position: position
                }
            });
        },
    onMouseMovePick: (g3DContext)=>(context, event)=>{
            const { position: position  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ON_MOUSE_MOVE_PICK",
                payload: {
                    position: position
                }
            });
        }
};




var $17a0fc1db365587e$export$2e2bcd8739ae039 = {
    RobotClips__setTopManipulatorManipRobotCreateReferenceFrame: (g3DContext, gLibrary)=>(context, event)=>{
            const { robotClip: robotClip  } = event;
            g3DContext.setTopManipulator("manip-robot-create-reference-frame", {
                onReferenceFrameSet: (newReferenceFrame)=>g3DContext.robotAppsService.send("RobotClips/setTopManipulatorManipRobotCreateReferenceFrame/onReferenceFrameSet", {
                        robotClip: robotClip,
                        newReferenceFrame: newReferenceFrame,
                        application: gLibrary.mLibrary.mCurrentApplication
                    }),
                onReferenceFrameCreateCancel: ()=>g3DContext.robotAppsService.send("RobotClips/onExitReferenceFrameCreate")
            });
        },
    RobotClips__setTopManipulatorManipRobotCreateReferenceFrame__onReferenceFrameSet: (g3DContext)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , application: application , newReferenceFrame: newReferenceFrame  } = event;
            const { vid: vid  } = context;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            const robotClip = {
                ...oldRobotClip,
                teachingReferenceFrame: newReferenceFrame
            };
            const referenceFrame = robotClip.teachingReferenceFrame;
            if (referenceFrame.arrayMatrix__referenceFrame_world?.length && referenceFrame.vid) application.notify("onInstructionChanged", robotClip);
            (0, $3f65195cd5e8f23a$export$54d6f365d65dbbe9)({
                ctx3D: g3DContext,
                application: application,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$590ba4bde3690df4)(g3DContext);
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionEditable__setTopManipulatorManipRobotCreateReferenceFrame: (g3DContext, gLibrary)=>(context, event)=>{
            const { robotClip: robotClip , sequence: sequence , instruction: instruction  } = event;
            g3DContext.setTopManipulator("manip-robot-create-reference-frame", {
                onReferenceFrameSet: (newReferenceFrame)=>g3DContext.robotAppsService.send("RobotInstructionEditable/setTopManipulatorManipRobotCreateReferenceFrame/onReferenceFrameSet", {
                        robotClip: robotClip,
                        newReferenceFrame: newReferenceFrame,
                        application: gLibrary.mLibrary.mCurrentApplication,
                        sequence: sequence,
                        instruction: instruction
                    }),
                onReferenceFrameCreateCancel: ()=>g3DContext.robotAppsService.send("RobotInstructionEditable/onExitReferenceFrameCreate")
            });
        },
    RobotInstructionEditable__setTopManipulatorManipRobotCreateReferenceFrame__onReferenceFrameSet: (g3DContext)=>(context, event, actionMeta)=>{
            const { robotClip: oldRobotClip , application: application , sequence: sequence , instruction: instruction , newReferenceFrame: newReferenceFrame  } = event;
            const { vid: vid  } = context;
            const robotClip = {
                ...oldRobotClip,
                teachingReferenceFrame: newReferenceFrame
            };
            const referenceFrame = robotClip.teachingReferenceFrame;
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            if (referenceFrame.arrayMatrix__referenceFrame_world?.length && referenceFrame.vid) application.notify("onInstructionChanged", robotClip);
            (0, $3f65195cd5e8f23a$export$711758442dc6f794)({
                sequence: sequence,
                instruction: instruction,
                robotClip: robotClip
            });
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$590ba4bde3690df4)(g3DContext);
            (0, $3f65195cd5e8f23a$export$9cd1b7e07a4d109e)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        },
    RobotInstructionSelector__setTopManipulatorManipRobotCreateReferenceFrame: (g3DContext)=>(context, event)=>{
            const { instruction: instruction , robotClip: robotClip  } = event;
            g3DContext.setTopManipulator("manip-robot-create-reference-frame", {
                onReferenceFrameSet: (newReferenceFrame)=>g3DContext.robotAppsService.send("RobotInstructionSelector/setTopManipulatorManipRobotCreateReferenceFrame/onReferenceFrameSet", {
                        instruction: instruction,
                        newReferenceFrame: newReferenceFrame,
                        robotClip: robotClip
                    }),
                onReferenceFrameCreateCancel: ()=>g3DContext.robotAppsService.send("RobotInstructionSelector/onExitReferenceFrameCreate")
            });
        },
    RobotInstructionSelector__setTopManipulatorManipRobotCreateReferenceFrame__onReferenceFrameSet: (g3DContext)=>(context, event, actionMeta)=>{
            const { instruction: instruction , robotClip: robotClip , newReferenceFrame: newReferenceFrame  } = event;
            const { vid: vid  } = context;
            instruction.setParameter("executionReferenceFrame", newReferenceFrame);
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(vid)) return;
            g3DContext.getCtx3js().clearScene();
            (0, $3f65195cd5e8f23a$export$590ba4bde3690df4)(g3DContext);
            (0, $3f65195cd5e8f23a$export$1a3cf5ffcf3bfed5)({
                ctx3D: g3DContext,
                robotClip: robotClip,
                vid: vid,
                referenceFrame: newReferenceFrame
            });
            (0, $3f65195cd5e8f23a$export$93ec683ddcc6fd5c)(context, event, actionMeta);
        }
};



const $98538caf33c9e587$var$onMount = ()=>(0, $gXNCa$xstate.assign)({
        reactStateUpdateFunctions: (context, event)=>({
                ...context.reactStateUpdateFunctions,
                [event.idxFunc.id]: event.idxFunc.func
            })
    });
const $98538caf33c9e587$var$onUnmount = ()=>(0, $gXNCa$xstate.assign)({
        reactStateUpdateFunctions: (context, event)=>{
            /* eslint-disable-next-line */ const { [event.idxFunc.id]: omit , ...newReactStateUpdateFunctions } = context.reactStateUpdateFunctions;
            return newReactStateUpdateFunctions;
        }
    });
const $98538caf33c9e587$var$updateCalibrationReferenceFrames = (selectors)=>()=>selectors.getDispatch()("RobotAssets/CalibrationParts/onPartChanged");
const $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnMount = (g3DContext)=>()=>{
        // inserting calibration parts into the assembler will trigger an update to this component
        for (const name of [
            "part_inserted",
            "parts_reinserted",
            "parts_removed"
        ])g3DContext.registerForNotification(name, $98538caf33c9e587$var$updateCalibrationReferenceFrames(g3DContext.robotAppsService.selectors));
    };
const $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnUnmount = (g3DContext)=>()=>{
        for (const name of [
            "part_inserted",
            "parts_reinserted",
            "parts_removed"
        ])g3DContext.unregisterForNotification(name, $98538caf33c9e587$var$updateCalibrationReferenceFrames(g3DContext.robotAppsService.selectors));
    };
const $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnReferenceFramesChanged = (g3DContext, gLibrary)=>(context, event)=>{
        const { newReferenceFramesWithoutRobotKinematicsChainRoots: newReferenceFramesWithoutRobotKinematicsChainRoots  } = event;
        const newReferenceFrames = newReferenceFramesWithoutRobotKinematicsChainRoots.concat(g3DContext.robotUtils.ArrayOf_VID_x_Name__getRobotKinematicsChainRootCalibrationParts());
        newReferenceFrames.forEach((n)=>g3DContext.mGraph.setVertexAttr(n.vid, "calibration_part_name", n.name));
        gLibrary.mLibrary.mCurrentApplication?.setDirty();
    };
const $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnReferenceFrameCreate = (g3DContext)=>(context, event)=>{
        const { onReferenceFrameCreateSet: onReferenceFrameCreateSet , onReferenceFrameCreateCancel: onReferenceFrameCreateCancel  } = event;
        g3DContext.setTopManipulator("manip-inserter", g3DContext.robotUtils.getDigitalCalibrationToolPartNumber(), null, onReferenceFrameCreateSet, onReferenceFrameCreateCancel);
    };
const $98538caf33c9e587$var$RobotAssetsCalibrationsPartsOnReferenceFrameCreateCancel = (g3DContext)=>()=>{
        g3DContext.setTopManipulator("manip-rotate-translate");
    };
const $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnReferenceFrameDelete = (g3DContext)=>(context, event)=>{
        const { vid: vid  } = event;
        g3DContext.robotUtils.registerPartsDeletion(vid, ()=>{});
    };
var $98538caf33c9e587$export$2e2bcd8739ae039 = {
    RobotAssetsCalibrationPartsOnMount: $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnMount,
    RobotAssetsCalibrationPartsOnReferenceFramesChanged: $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnReferenceFramesChanged,
    RobotAssetsCalibrationPartsOnReferenceFrameCreate: $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnReferenceFrameCreate,
    RobotAssetsCalibrationPartsOnReferenceFrameDelete: $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnReferenceFrameDelete,
    RobotAssetsCalibrationPartsOnUnmount: $98538caf33c9e587$var$RobotAssetsCalibrationPartsOnUnmount,
    RobotAssetsCalibrationsPartsOnReferenceFrameCreateCancel: $98538caf33c9e587$var$RobotAssetsCalibrationsPartsOnReferenceFrameCreateCancel,
    onMount: $98538caf33c9e587$var$onMount,
    onUnmount: $98538caf33c9e587$var$onUnmount
};



// https://stackoverflow.com/questions/9907419/how-to-get-a-key-in-a-javascript-object-by-its-value
function $1113ced14afd5342$export$2e2bcd8739ae039(object, value) {
    return Object.keys(object).find((key)=>object[key] === value);
}



function $32847a394fe70279$var$handleRosSimulationError(messageBox, { onRosError: onRosError , errorCodeValue: errorCodeValue  }) {
    // http://docs.ros.org/en/api/moveit_msgs/html/msg/MoveItErrorCodes.html
    const MoveItErrorCodes = {
        // overall behavior
        // SUCCESS: 1,
        FAILURE: 99999,
        PLANNING_FAILED: -1,
        INVALID_MOTION_PLAN: -2,
        MOTION_PLAN_INVALIDATED_BY_ENVIRONMENT_CHANGE: -3,
        CONTROL_FAILED: -4,
        UNABLE_TO_AQUIRE_SENSOR_DATA: -5,
        TIMED_OUT: -6,
        PREEMPTED: -7,
        // planning & kinematics request errors
        START_STATE_IN_COLLISION: -10,
        START_STATE_VIOLATES_PATH_CONSTRAINTS: -11,
        GOAL_IN_COLLISION: -12,
        GOAL_VIOLATES_PATH_CONSTRAINTS: -13,
        GOAL_CONSTRAINTS_VIOLATED: -14,
        INVALID_GROUP_NAME: -15,
        INVALID_GOAL_CONSTRAINTS: -16,
        INVALID_ROBOT_STATE: -17,
        INVALID_LINK_NAME: -18,
        INVALID_OBJECT_NAME: -19,
        // system errors
        FRAME_TRANSFORM_FAILURE: -21,
        COLLISION_CHECKING_UNAVAILABLE: -22,
        ROBOT_STATE_STALE: -23,
        SENSOR_INFO_STALE: -24,
        COMMUNICATION_FAILURE: -25,
        // kinematics errors
        NO_IK_SOLUTION: -31
    };
    const errorMessage = (0, $1113ced14afd5342$export$2e2bcd8739ae039)(MoveItErrorCodes, errorCodeValue);
    if (errorMessage) {
        messageBox("Simulation failed. Motion planning failed.");
        console.log("MoveIt ERROR :>> ", errorMessage);
        onRosError && onRosError();
    }
}
var $32847a394fe70279$export$2e2bcd8739ae039 = {
    ROBOT_SIMULATION_MOTION_STARTED: (g3DContext)=>(context)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROBOT_SIMULATION_MOTION_STARTED",
                payload: {
                    hid: g3DContext.mGraph.getHID(context.vid),
                    endEffectorVisible: false,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    ROBOT_SIMULATION_MOTION_COMPLETED: (g3DContext)=>(context)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROBOT_SIMULATION_MOTION_COMPLETED",
                payload: {
                    hid: g3DContext.mGraph.getHID(context.vid),
                    endEffectorVisible: false,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    ROBOT_SIMULATION_MOTION_PAUSED: (g3DContext)=>()=>{
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROBOT_SIMULATION_MOTION_PAUSED",
                payload: {
                    endEffectorVisible: false,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    ROBOT_SIMULATION_JOINT_STATES_RECEIVED: (g3DContext)=>(context, event)=>{
            if (!$4f71ac8ef89a5f2d$export$1ea939691cdc45b8(context.vid)) return;
            const { payload: payload  } = event;
            const manipRobotState = g3DContext.getManipulatorOfType("manip-robot").mState;
            manipRobotState.transition({
                type: "ROBOT_SIMULATION_JOINT_STATES_RECEIVED",
                payload: {
                    jointAngles: payload,
                    hid: g3DContext.mGraph.getHID(context.vid),
                    endEffectorVisible: false,
                    rotatorVisible: false,
                    referenceFrameVisible: false
                }
            });
        },
    ROBOT_SIMULATION_SEQUENCE_MOVE_GROUP_RESULT_RECEIVED: (g3DContext)=>(context, event)=>{
            const { payload: payload  } = event;
            $32847a394fe70279$var$handleRosSimulationError(g3DContext.robotUtils.guiWidgetsMessageBox, payload);
        },
    onRobotSimulationStateChange: ()=>(context, { application: application , data: { sequenceName: sequenceName , robotSimulationState: robotSimulationState  }  })=>{
            const sequence = application.getSequence(sequenceName);
            const instruction = sequence.mInstructions[robotSimulationState.instructionIndex];
            // update the tree view simulation state
            instruction.notify("onRobotSimulationStateChange", robotSimulationState);
            // update the robot instruction card waypoints simulation state
            instruction.robotSimulationState = robotSimulationState;
        },
    onRobotSimulationInstructionCompleted: (g3DContext, { ExecutionEngineAPI: ExecutionEngineAPI , ilib_machinemotion: ilib_machinemotion  })=>async (context, { application: application , data: { sequenceName: sequenceName , instructionIndex: instructionIndex , keyframes: keyframes , runtimeUuid: runtimeUuid  }  })=>{
            const sequence = application.getSequence(sequenceName);
            const instruction = sequence.mInstructions[instructionIndex];
            // reset sim state of instruction
            instruction.robotSimulationState = null;
            await (0, $70ab5576dcfb2d8a$export$2e2bcd8739ae039)({
                ctx3dInterface: g3DContext.robotUtils,
                ExecutionEngineAPI: ExecutionEngineAPI,
                instructionIndex: instructionIndex,
                robotActuatorVid: context.vid,
                sequence: sequence,
                sequenceName: sequenceName
            });
            ilib_machinemotion.concludeInstruction(runtimeUuid, false);
            instruction.notify("onRobotSimulationInstructionCompleted", keyframes);
        },
    onRobotSimulationInstructionError: (g3DContext)=>()=>{
            g3DContext.robotUtils.guiWidgetsMessageBox("Simulation failed. Position unreachable.", "error");
        }
};


// from: https://davidwalsh.name/javascript-polling
/**
 *
 * @param {Function} fn - The function to execute
 * @param {Number} timeout - The timeout in milliseconds
 * @param {Number} interval - The interval in milliseconds
 * @returns {Promise} - A promise that resolves when the function has executed
 */ function $863aef39b8b640ff$var$poll(fn, timeout, interval) {
    const endTime = Number(new Date()) + (timeout || 2000);
    // eslint-disable-next-line no-param-reassign, functional/no-expression-statements
    interval = interval || 100;
    const checkCondition = async function(resolve, reject) {
        // If the condition is met, we're done!
        const result = await fn();
        if (result) // eslint-disable-next-line functional/no-expression-statements
        resolve(result);
        else if (Number(new Date()) < endTime) // eslint-disable-next-line functional/no-expression-statements
        setTimeout(checkCondition, interval, resolve, reject);
        else // eslint-disable-next-line functional/no-expression-statements
        reject(new Error("timed out for " + fn + ": " + arguments));
    };
    return new Promise(checkCondition);
}
var $863aef39b8b640ff$export$2e2bcd8739ae039 = $863aef39b8b640ff$var$poll;




var $f78cb01495c189e2$export$2e2bcd8739ae039 = (ExecutionEngineAPI)=>async ()=>{
        const [err, result] = await (0, $gXNCa$toawait.to)(ExecutionEngineAPI.getRosConnectionStatus());
        if (err) throw err;
        return result.isConnected;
    };


var $48d21c81cb309f2e$export$2e2bcd8739ae039 = {
    connectToVentionRos: (g3DContext, ExecutionEngineAPI)=>async ()=>{
            const { getDispatch: getDispatch  } = g3DContext.robotAppsService.selectors;
            const [, connected] = await (0, $gXNCa$toawait.to)((0, $f78cb01495c189e2$export$2e2bcd8739ae039)(ExecutionEngineAPI)());
            getDispatch()("RobotConfig/connectToVentionRos/connectedToVentionRos", {
                isConnected: connected
            });
            if (!connected) {
                const [timedOut, isConnected] = await (0, $gXNCa$toawait.to)((0, $863aef39b8b640ff$export$2e2bcd8739ae039)((0, $f78cb01495c189e2$export$2e2bcd8739ae039)(ExecutionEngineAPI), 45000, 250));
                if (timedOut) // eslint-disable-next-line functional/no-expression-statements
                console.warn("Failed to connect to robot", "warning");
                getDispatch()("RobotConfig/connectToVentionRos/connectedToVentionRos", {
                    isConnected: isConnected
                });
            }
        }
};


var $fa35c81cc45061d2$export$2e2bcd8739ae039 = {
    onRobotModelDeleted: (g3DContext, gLibrary)=>(_context, event)=>{
            const { vid: vid  } = event;
            const VID__machineLogicRobotConfig = g3DContext.robotUtils.VID__getMachineLogicRobotConfig(vid);
            if (VID__machineLogicRobotConfig) {
                gLibrary.getConfigManager()?.getConfigurationList().forEach((config)=>config?.removeRobotWithVID(VID__machineLogicRobotConfig));
                g3DContext.notify("robot_removed");
            }
        }
};


const $0f59ad323b135ece$var$featureActions = {
    common: $f85a033c6813f831$export$2e2bcd8739ae039,
    robotClipsExit: $969c09977ac4dd80$export$2e2bcd8739ae039,
    machineLogic: $cabdcf2db8eb40bd$export$2e2bcd8739ae039,
    arrayEditor: $82d0906a5e92b1c6$export$2e2bcd8739ae039,
    pointToPoint: $7db62daec3796c68$export$2e2bcd8739ae039,
    editRobot: $08fb73621a1ba093$export$2e2bcd8739ae039,
    robotInstruction: $ea4929b387659f81$export$2e2bcd8739ae039,
    robotClips: $3aa900a6c468a9ef$export$2e2bcd8739ae039,
    robotConfigWidget: $48d21c81cb309f2e$export$2e2bcd8739ae039,
    robotInstructionEditable: $88fa1fd9d6e4baa7$export$2e2bcd8739ae039,
    robotInstructionSelector: $44b186049f97a83c$export$2e2bcd8739ae039,
    robotLoopInstruction: $e51bbe99eb89d9ca$export$2e2bcd8739ae039,
    jogger: $7aa192330929447f$export$2e2bcd8739ae039,
    triad: $90ab4fc3e0a35313$export$2e2bcd8739ae039,
    referenceFrameCreator: $17a0fc1db365587e$export$2e2bcd8739ae039,
    calibrationPartEditor: $98538caf33c9e587$export$2e2bcd8739ae039,
    simulation: $32847a394fe70279$export$2e2bcd8739ae039,
    machineBuilder: $fa35c81cc45061d2$export$2e2bcd8739ae039
};
var $0f59ad323b135ece$export$2e2bcd8739ae039 = $0f59ad323b135ece$var$featureActions;






const $53bcd51c01ca6b2c$export$e25a7f1a95f0e46d = (ctx3D)=>(context, event)=>{
        const { host: host , port: port  } = event;
        const url = `${host}/robot`;
        const socket = (0, ($parcel$interopDefault($gXNCa$socketioclient)))(url, {
            transports: [
                "websocket"
            ],
            path: `/socket.io/${port}`
        });
        socket.on("connect", ()=>{
            console.warn("### websocket connected", socket);
            ctx3D.robotAppsService.selectors.getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.onWebsocketClientConnect(socket));
        });
        socket.on("disconnect", (reason)=>{
            console.warn("### execution engine websocket client disconnected", reason);
            socket.off("robot_simulation_motion_completed", $53bcd51c01ca6b2c$var$onRobotSimulationMotionCompleted);
            socket.off("robot_simulation_state_change", $53bcd51c01ca6b2c$var$onRobotSimulationStateChange);
            socket.off("on_sequence_move_group_result_error", $53bcd51c01ca6b2c$var$onSequenceMoveGroupResultError);
        });
        window.addEventListener("unload", ()=>{
            socket.disconnect();
        });
    };
const $53bcd51c01ca6b2c$export$ddb559f5920e68a4 = (0, $9c35425985377ff1$export$2f952c48dd3bb7b0).assign({
    websocketClient: (_, event)=>event.socket
});
/**
 *
 * @param {import('../../../model/types').ContextFromRobotAppsContext} context
 * @param {WebsocketSubscribeEvent} event
 */ const $53bcd51c01ca6b2c$export$7db4f664be73a05f = (context, event)=>{
    const { websocketClient: websocketClient  } = context;
    if (!websocketClient) {
        console.warn("### websocket client is no defined, not possible to add a listener to a topic");
        return;
    }
    const { topic: topic , handler: handler  } = event;
    websocketClient.on(topic, handler);
};
/**
 *
 * @param {import('../../../model/types').ContextFromRobotAppsContext} context
 * @param {WebsocketSubscribeEvent} event
 */ const $53bcd51c01ca6b2c$export$17ac8c06b1034c74 = (context, event)=>{
    const { websocketClient: websocketClient  } = context;
    if (!websocketClient) {
        console.warn("### websocket client is no defined, not possible to remove a listener to a topic");
        return;
    }
    const { topic: topic , handler: handler  } = event;
    websocketClient.off(topic, handler);
};
const $53bcd51c01ca6b2c$var$_onRobotSimulationMotionCompleted = (ctx3D, library)=>(data)=>{
        const application = library.mLibrary.mCurrentApplication;
        ctx3D.robotAppsService.send("onRobotSimulationInstructionCompleted", {
            application: application,
            data: data
        });
    };
const $53bcd51c01ca6b2c$var$_onRobotSimulationStateChange = (ctx3D, library)=>(data)=>{
        const application = library.mLibrary.mCurrentApplication;
        ctx3D.robotAppsService.send("onRobotSimulationStateChange", {
            application: application,
            data: data
        });
    };
const $53bcd51c01ca6b2c$var$_onSequenceMoveGroupResultError = (ctx3D)=>()=>{
        ctx3D.robotAppsService.send("onRobotSimulationInstructionError");
    };
let $53bcd51c01ca6b2c$var$onRobotSimulationMotionCompleted;
let $53bcd51c01ca6b2c$var$onRobotSimulationStateChange;
let $53bcd51c01ca6b2c$var$onSequenceMoveGroupResultError;
const $53bcd51c01ca6b2c$export$6d60e17d5da7f959 = (ctx3D, library)=>()=>{
        $53bcd51c01ca6b2c$var$onRobotSimulationMotionCompleted = $53bcd51c01ca6b2c$var$_onRobotSimulationMotionCompleted(ctx3D, library);
        const { selectors: selectors  } = ctx3D.robotAppsService;
        selectors.getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("robot_simulation_motion_completed", $53bcd51c01ca6b2c$var$onRobotSimulationMotionCompleted));
    };
const $53bcd51c01ca6b2c$export$3d2781b49a06f17c = (ctx3D, library)=>()=>{
        $53bcd51c01ca6b2c$var$onRobotSimulationStateChange = $53bcd51c01ca6b2c$var$_onRobotSimulationStateChange(ctx3D, library);
        const { selectors: selectors  } = ctx3D.robotAppsService;
        selectors.getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("robot_simulation_state_change", $53bcd51c01ca6b2c$var$onRobotSimulationStateChange));
    };
const $53bcd51c01ca6b2c$export$71c9e1ea970cc265 = (ctx3D)=>()=>{
        $53bcd51c01ca6b2c$var$onSequenceMoveGroupResultError = $53bcd51c01ca6b2c$var$_onSequenceMoveGroupResultError(ctx3D);
        const { selectors: selectors  } = ctx3D.robotAppsService;
        selectors.getDispatch()((0, $9c35425985377ff1$export$2f952c48dd3bb7b0).events.subscribe("on_sequence_move_group_result_error", $53bcd51c01ca6b2c$var$onSequenceMoveGroupResultError));
    };


const $42663375bb38ee89$export$185802fd694ee1f5 = (ExecutionEngineAPI)=>(g3DContext, gLibrary, { getRobotProgrammingState: getRobotProgrammingState , ilib_machinemotion: ilib_machinemotion  })=>({
            websocket: {
                initial: "connecting",
                states: {
                    connecting: {
                        on: {
                            onSetRemoteHost: {
                                actions: (0, $53bcd51c01ca6b2c$export$e25a7f1a95f0e46d)(g3DContext)
                            },
                            onWebsocketClientConnect: {
                                actions: [
                                    (0, $53bcd51c01ca6b2c$export$ddb559f5920e68a4),
                                    (0, $53bcd51c01ca6b2c$export$6d60e17d5da7f959)(g3DContext, gLibrary),
                                    (0, $53bcd51c01ca6b2c$export$3d2781b49a06f17c)(g3DContext, gLibrary),
                                    (0, $53bcd51c01ca6b2c$export$71c9e1ea970cc265)(g3DContext)
                                ],
                                target: "connected"
                            }
                        }
                    },
                    connected: {
                        type: "final"
                    }
                },
                transitions: {
                    subscribe: {
                        actions: [
                            (0, $53bcd51c01ca6b2c$export$7db4f664be73a05f)
                        ]
                    },
                    unsubscribe: {
                        actions: [
                            (0, $53bcd51c01ca6b2c$export$17ac8c06b1034c74)
                        ]
                    }
                }
            },
            ["/machine-builder"]: {
                transitions: {
                    MACHINE_BUILDER_TAB_CLICKED: {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    MACHINE_SCOPE_TAB_CLICKED: {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    }
                }
            },
            manipRobotExit: {
                transitions: {
                    "ManipRobot/ESC_PRESSED": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext)
                        ]
                    },
                    "ManipRobot/ON_MOUSE_UP/nothingSelected": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext)
                        ]
                    }
                }
            },
            robotClipsExit: {
                transitions: {
                    "RobotClips/onUnmount": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClipsExit.RobotClipsOnUmount(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClipsExit.onUnmount()
                        ]
                    }
                }
            },
            machineLogic: {
                transitions: {
                    notInMachineLogic: {},
                    inMachineLogic: {
                        "MachineLogic/Config/RobotAdded": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.addVid(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.onRobotAddedInitializeManipRobot(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.registerPartsMoved(g3DContext, gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotConfigWidget.connectToVentionRos(g3DContext, ExecutionEngineAPI),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "ilib_ml_core.Config.prototype.removeRobotWithVID": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.removeVid()
                            ]
                        },
                        "MachineLogic/Config/RobotPartNumber/onChange": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.addVid(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.onRobotActuatorAddedInitializeManipRobot(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "MachineApps/OTHER_APPLICATION_CLICKED": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext)
                            ]
                        },
                        OTHER_APPLICATION_CLICKED: {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/ROBOTCLIPS_TAB_CLICKED": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.clearScene(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/ROBOTARRAYS_TAB_CLICKED": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.clearScene(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/CALIBRATIONPARTS_TAB_CLICKED": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.clearScene(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        SEQUENCE_SELECTED: {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "MachineLogic/treeView/instructionElement/INSTRUCTION_CLICKED": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.TreeViewInstructionClicked(g3DContext)
                            ]
                        },
                        "MachineLogic/RobotInstructionEditable/MovedToAnotherSequence": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.LocalRobotInstructionMovedToAnotherSequence()
                            ]
                        },
                        "MachineLogic/RobotInstruction/InstructionMoved": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "MachineLogic/RobotInstruction/InstructionRemoved": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "MachineLogic/ApplicationContext/Download/onClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.setApplicationRobotParametersCalibrationParts(g3DContext, gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.callCouplingOrEndEffectorAddedOrRemoved(g3DContext, gLibrary)
                            ]
                        },
                        "MachineLogic/PlayerControl/onClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.setApplicationRobotParametersCalibrationParts(g3DContext, gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.callCouplingOrEndEffectorAddedOrRemoved(g3DContext, gLibrary)
                            ]
                        }
                    }
                }
            },
            arrayEditor: {
                transitions: {
                    notInArrayEditor: {
                        "RobotArrays/onMount": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.addReactStateUpdateFunction(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotArrays/onUnmount": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.removeReactStateUpdateFunction(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/RobotArrays/onAddRobotArray": {
                            target: "inArrayEditor",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnAddRobotArray(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onCopyClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnCopyClick(gLibrary)
                            ]
                        },
                        "RobotAssets/RobotArrays/onArrayCardClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnArrayCardClick(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onArrayCardEditClick": {
                            target: "inArrayEditor.editingArray",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnArrayCardEditClick(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onArraysNameUpdated": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnArraysNameUpdated(gLibrary)
                            ]
                        },
                        "RobotAssets/RobotArrays/onLockedDeleteClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnLockedDeleteClick(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onDeleteClick": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnDeleteClick(g3DContext, gLibrary)
                            ]
                        }
                    },
                    inArrayEditor: {
                        "RobotArrays/onUnmount": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.clearScene(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.removeReactStateUpdateFunction(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/RobotArrays/onArrayCardClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnArrayCardClick(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onGenerateClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnGenerateClick(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onRegenerateClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnRegenerateClick(g3DContext, gLibrary)
                            ]
                        },
                        "RobotAssets/RobotArrays/onPatternChange": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnPatternChange(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onEditFrameDoneClick": {
                            target: "#robotApps.app.idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnEditFrameDoneClick(gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/RobotArrays/onLockedDeleteClick": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnLockedDeleteClick(g3DContext)
                            ]
                        },
                        "RobotAssets/RobotArrays/onDeleteClick": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnDeleteClick(g3DContext, gLibrary)
                            ]
                        },
                        "RobotAssets/RobotArrays/onArrayReferenceFrameEditClick": {
                            target: "inArrayEditor.creatingArrayReferenceFrame",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnArrayReferenceFrameEditClick(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        SEQUENCE_SELECTED: {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        OTHER_APPLICATION_CLICKED: {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        MACHINE_BUILDER_TAB_CLICKED: {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        MACHINE_SCOPE_TAB_CLICKED: {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    }
                },
                states: {
                    inArrayEditor: {
                        initial: "creatingArrayReferenceFrame",
                        states: {
                            creatingArrayReferenceFrame: {
                                on: {
                                    "RobotAssets/RobotArrays/manip-robot-create-reference-frame/onReferenceFrameCreateCancel": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnReferenceFrameCreateCancel(g3DContext)
                                        ]
                                    },
                                    "RobotAssets/RobotArrays/manip-robot-create-reference-frame/onReferenceFrameSet": {
                                        target: "editingArray"
                                    },
                                    "RobotAssets/RobotArrays/onArrayReferenceFrameEditClick/manip-robot-create-reference-frame/onReferenceFrameSet": {
                                        target: "editingArray",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnArrayReferenceFrameEditClickOnReferenceFrameSet(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    }
                                }
                            },
                            editingArray: {
                                on: {
                                    "RobotAssets/RobotArrays/onArrayReferenceFrameEditClick/manip-robot-create-reference-frame/onReferenceFrameCreateCancel": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).arrayEditor.RobotAssetsRobotArraysOnArrayReferenceFrameEditClickOnReferenceFrameCreateCancel(g3DContext)
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            },
            pointToPoint: {
                transitions: {
                    notInPointToPoint: {
                        "MachineApps/RobotClips/POINT_TO_POINT_SELECTED": {
                            target: "pointToPoint",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.setTopManipulatorSelectFeature(g3DContext)
                            ]
                        },
                        "RobotClips/POINT_TO_POINT_SELECTED": {
                            target: "pointToPoint",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.setTopManipulatorSelectFeature(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotInstructionEditable/POINT_TO_POINT_SELECTED": {
                            target: "pointToPoint",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.setTopManipulatorSelectFeature(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    },
                    inPointToPoint: {
                        "MachineApps/RobotClips/TRIAD_SELECTED": {
                            target: "triad",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.pointToPointTriadSelected(g3DContext)
                            ]
                        },
                        "RobotInstructionEditable/TRIAD_SELECTED": {
                            target: "triad",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.pointToPointTriadSelected(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotClips/TRIAD_SELECTED": {
                            target: "triad",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.pointToPointTriadSelected(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        POINT_TO_POINT_FEATURE_SELECTED: {
                            target: "triad",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.pointToPointFeatureSelected(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        POINT_TO_POINT_ESC_PRESSED: {
                            target: "triad",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).pointToPoint.onPointToPointEscPressed(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    }
                }
            },
            editRobot: {
                transitions: {
                    notInEditRobot: {
                        EDIT_ROBOT_CLICKED: {
                            target: "inEditRobot",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.updateVid(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.editRobotClicked(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    }
                },
                states: {
                    inEditRobot: {
                        initial: "idle",
                        states: {
                            idle: {
                                on: {
                                    "ManipRobot/EFFECTOR_DRAG_STARTED": {
                                        target: "endEffectorDragging",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.ManipRobotEFFECTOR_DRAG_STARTED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/ROTATOR_DRAG_STARTED": {
                                        target: "rotatorDragging",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.ManipRobotROTATOR_DRAG_STARTED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/LINK_SELECTED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.updateSelectedLink(g3DContext)
                                        ]
                                    },
                                    "ManipRobot/ON_MOUSE_UP_PICK": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.onMouseUpPick(g3DContext)
                                        ]
                                    },
                                    "ManipRobot/ON_MOUSE_MOVE_PICK": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.onMouseMovePick(g3DContext)
                                        ]
                                    }
                                }
                            },
                            endEffectorDragging: {
                                on: {
                                    "ManipRobot/EFFECTOR_DRAGGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.ManipRobotEFFECTOR_DRAGGED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/EFFECTOR_DRAG_ENDED": {
                                        target: "idle",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.ManipRobotEFFECTOR_DRAG_ENDED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    }
                                }
                            },
                            rotatorDragging: {
                                on: {
                                    "ManipRobot/ROTATOR_DRAGGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.ManipRobotROTATOR_DRAGGED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/ROTATOR_DRAG_ENDED": {
                                        target: "idle",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.ManipRobotROTATOR_DRAG_ENDED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).editRobot.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            },
            robotInstruction: {
                transitions: {
                    "RobotInstruction/Sequence.prototype.newInstruction/parameter/robotId": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.RobotInstructionSequencePrototypeNewInstructionParameterRobotId(gLibrary)
                        ]
                    },
                    "RobotInstruction/Sequence.prototype.newInstruction/parameter/calibrationReferenceFrame": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.RobotInstructionSequencePrototypeNewInstructionParameterCalibrationReferenceFrame(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.RobotInstructionNewInstructionAddRobotBaseCalibrationReferenceFrame(g3DContext, gLibrary)
                        ]
                    },
                    "RobotInstruction/onRender": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.RobotInstructionOnRender(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.callCouplingOrEndEffectorAddedOrRemoved(g3DContext, gLibrary)
                        ]
                    },
                    "RobotInstruction/onMount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.addReactStateUpdateFunction(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.onMount(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotInstruction/onUnmount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.removeReactStateUpdateFunction(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.onUnmount(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotInstruction/onPartsMoved": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.onPartsMoved(g3DContext)
                        ]
                    }
                }
            },
            robotClips: {
                transitions: {
                    "RobotClips/onMount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnMount(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.onReactComponentMount()
                        ]
                    },
                    "RobotClips/onUnmount": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnUmount(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.onReactComponentUnmount()
                        ]
                    },
                    "RobotClips/onRobotClipsChange": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnRobotClipsChange(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onRobotClipChange": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnRobotClipChange(gLibrary)
                        ]
                    },
                    "RobotClips/onRobotClipsChangeNoConfig": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnRobotClipsChangeNoConfig(g3DContext)
                        ]
                    },
                    "RobotClips/onLockedDeleteClick": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnLockedDeleteClick(g3DContext)
                        ]
                    },
                    "RobotClips/onDeleteClick": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnDeleteClick(g3DContext)
                        ]
                    },
                    "RobotClips/onClipSelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnClipSelected(g3DContext)
                        ]
                    },
                    "RobotClips/onWaypointAdded": {
                        target: "triad",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnWaypointAdded(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onWaypointConfirmed": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnWaypointConfirmed(g3DContext, gLibrary),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.callCouplingOrEndEffectorAddedOrRemoved(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onWaypointPathTypeChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnWaypointPathTypeChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onWaypointNameChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnWaypointNameChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onRobotCommandAdded": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnRobotCommandAdded(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onWaypointEditClicked": {
                        target: "triad",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnWaypointEditClicked(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onKeyframeDeleteClicked": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnKeyframeDeleteClicked(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onWaypointTimeChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnWaypointTimeChanged()
                        ]
                    },
                    "RobotClips/onWaypointClicked": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnWaypointClicked(g3DContext, gLibrary),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.callCouplingOrEndEffectorAddedOrRemoved(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onKeyframeOrderChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnKeyframeOrderChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onIgnoreReferenceFrameChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnIgnoreReferenceFrameChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnKeyframeRobotCommandChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandWaitForTimeTimeChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnKeyframeRobotCommandWaitForTimeTimeChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandSetPayloadWeightChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnKeyframeRobotCommandSetPayloadWeightChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged(g3DContext, gLibrary)
                        ]
                    },
                    "RobotClips/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotClips.RobotClipsOnKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged(g3DContext, gLibrary)
                        ]
                    }
                }
            },
            robotInstructionEditable: {
                transitions: {
                    "RobotInstructionEditable/CalibrationReferenceFrameSelector/onReferenceFrameSelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.CalibrationReferenceFrameSelectorOnReferenceFrameSelected(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onDeleteClicked": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnDeleteClicked(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onRobotClipChange": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnRobotClipChange(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/SaveToRobotAssetsButton/onClick": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableSaveToRobotAssetsButtonOnClick(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onClipSelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnClipSelected(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onWaypointAdded": {
                        target: "triad",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnWaypointAdded(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onWaypointConfirmed": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnWaypointConfirmed(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onWaypointPathTypeChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnWaypointPathTypeChanged()
                        ]
                    },
                    "RobotInstructionEditable/onWaypointNameChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnWaypointNameChanged()
                        ]
                    },
                    "RobotInstructionEditable/onRobotCommandAdded": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnRobotCommandAdded(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onWaypointEditClicked": {
                        target: "triad",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnWaypointEditClicked(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onKeyframeDeleteClicked": {
                        target: "idle",
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnKeyframeDeleteClicked(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onWaypointTimeChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnWaypointTimeChanged()
                        ]
                    },
                    "RobotInstructionEditable/onWaypointClicked": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnWaypointClicked(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onKeyframeOrderChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnKeyframeOrderChanged(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onIgnoreReferenceFrameChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnIgnoreReferenceFrameChanged()
                        ]
                    },
                    "RobotInstructionEditable/onKeyframeRobotCommandChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnKeyframeRobotCommandChanged(g3DContext)
                        ]
                    },
                    "RobotInstructionEditable/onKeyframeRobotCommandWaitForTimeTimeChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnKeyframeRobotCommandWaitForTimeTimeChanged()
                        ]
                    },
                    "RobotInstructionEditable/onKeyframeRobotCommandSetPayloadWeightChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnKeyframeRobotCommandSetPayloadWeightChanged()
                        ]
                    },
                    "RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged()
                        ]
                    },
                    "RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionEditable.RobotInstructionEditableOnKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged()
                        ]
                    }
                }
            },
            robotInstructionSelector: {
                transitions: {
                    "RobotInstructionSelector/CalibrationReferenceFrameSelector/onReferenceFrameSelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.CalibrationReferenceFrameSelectorOnReferenceFrameSelected(g3DContext)
                        ]
                    },
                    "RobotInstructionSelector/onClipSelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionSelector.RobotInstructionSelectorOnClipSelected(g3DContext, gLibrary)
                        ]
                    },
                    "RobotInstructionSelector/onWaypointClicked": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionSelector.RobotInstructionSelectorOnWaypointClicked(g3DContext, gLibrary)
                        ]
                    },
                    "RobotInstructionSelector/ClipSelector/onClipMounted": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionSelector.RobotInstructionSelectorClipSelectorOnClipMounted()
                        ]
                    },
                    "RobotInstructionSelector/ClipSelector/onClipSelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionSelector.RobotInstructionSelectorClipSelectorOnClipSelected(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotInstructionSelector/ClipSelector/onNewClipSelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionSelector.RobotInstructionSelectorClipSelectorOnNewClipSelected(g3DContext, gLibrary)
                        ]
                    },
                    "RobotInstructionSelector/ClipSelector/onNewClipMounted": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionSelector.RobotInstructionSelectorClipSelectorOnNewClipMounted(g3DContext, gLibrary)
                        ]
                    },
                    "RobotInstructionSelector/StyledDeleteButton/onClick": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstructionSelector.RobotInstructionSelectorStyledDeleteButtonOnClick(g3DContext)
                        ]
                    }
                }
            },
            robotLoopInstruction: {
                transitions: {
                    "RobotLoopInstruction/onMount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.onMount(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/onUnmount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.onUnmount(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/onArraySelected": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.robotLoopInstructionOnArraySelected(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/onChildSequenceNameChange": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.robotLoopInstructionOnChildSequenceNameChange(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/onStartFromChange": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.robotLoopInstructionOnStartFromChange(g3DContext.robotUtils.helpers, {
                                messageBox: g3DContext.robotUtils.guiWidgetsMessageBox
                            }),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/StyledDeleteButton/onClick": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.robotLoopInstructionOnDeleteButtonClick(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/onCardClick": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.robotLoopInstructionOnCardClick(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    }
                }
            },
            jogger: {
                transitions: {
                    notJogger: {
                        "RobotClips/JOGGER_SELECTED": {
                            target: "jogger",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.joggerSelected(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotInstructionEditable/JOGGER_SELECTED": {
                            target: "jogger",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.joggerSelected(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    }
                },
                states: {
                    jogger: {
                        on: {
                            "RobotClips/JOGGER_CLOSE_BUTTON_CLICKED": {
                                target: "triad",
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.joggerExited(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            },
                            "RobotClips/JOGGER_POSE_TRANSLATION_CHANGED": {
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateRobotModelPoseTranslation(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            },
                            "RobotClips/JOGGER_POSE_ROTATION_CHANGED": {
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateRobotModelPoseRotation(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            },
                            "RobotClips/JOGGER_JOINT_ANGLE_CHANGED": {
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateRobotModelJointAngles(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            },
                            "RobotInstructionEditable/JOGGER_CLOSE_BUTTON_CLICKED": {
                                target: "triad",
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.joggerExited(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            },
                            "RobotInstructionEditable/JOGGER_POSE_TRANSLATION_CHANGED": {
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateRobotModelPoseTranslation(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            },
                            "RobotInstructionEditable/JOGGER_POSE_ROTATION_CHANGED": {
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateRobotModelPoseRotation(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            },
                            "RobotInstructionEditable/JOGGER_JOINT_ANGLE_CHANGED": {
                                actions: [
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateRobotModelJointAngles(g3DContext),
                                    (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                ]
                            }
                        },
                        initial: "idle",
                        states: {
                            idle: {
                                on: {
                                    "ManipRobot/EFFECTOR_DRAG_STARTED": {
                                        target: "endEffectorDragging",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.ManipRobotEFFECTOR_DRAG_STARTED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/ROTATOR_DRAG_STARTED": {
                                        target: "rotatorDragging",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.ManipRobotROTATOR_DRAG_STARTED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/LINK_SELECTED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateSelectedLink(g3DContext)
                                        ]
                                    },
                                    "ManipRobot/ON_MOUSE_UP_PICK": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.onMouseUpPick(g3DContext)
                                        ]
                                    },
                                    "ManipRobot/ON_MOUSE_MOVE_PICK": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.onMouseMovePick(g3DContext)
                                        ]
                                    }
                                }
                            },
                            endEffectorDragging: {
                                on: {
                                    "ManipRobot/EFFECTOR_DRAGGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.ManipRobotEFFECTOR_DRAGGED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/EFFECTOR_DRAG_ENDED": {
                                        target: "idle",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.ManipRobotEFFECTOR_DRAG_ENDED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    }
                                }
                            },
                            rotatorDragging: {
                                on: {
                                    "ManipRobot/ROTATOR_DRAGGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.ManipRobotROTATOR_DRAGGED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/ROTATOR_DRAG_ENDED": {
                                        target: "idle",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.ManipRobotROTATOR_DRAG_ENDED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).jogger.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            },
            triad: {
                transitions: {
                    notInTriad: {
                        "RobotClips/TRIAD_SELECTED": {
                            target: "triad",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.triadSelected(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotInstructionEditable/TRIAD_SELECTED": {
                            target: "triad",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.triadSelected(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRobot(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    }
                },
                states: {
                    triad: {
                        initial: "idle",
                        states: {
                            idle: {
                                on: {
                                    "ManipRobot/EFFECTOR_DRAG_STARTED": {
                                        target: "endEffectorDragging",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.ManipRobotEFFECTOR_DRAG_STARTED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/ROTATOR_DRAG_STARTED": {
                                        target: "rotatorDragging",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.ManipRobotROTATOR_DRAG_STARTED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/LINK_SELECTED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.updateSelectedLink(g3DContext)
                                        ]
                                    },
                                    "ManipRobot/ON_MOUSE_UP_PICK": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.onMouseUpPick(g3DContext)
                                        ]
                                    },
                                    "ManipRobot/ON_MOUSE_MOVE_PICK": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.onMouseMovePick(g3DContext)
                                        ]
                                    }
                                }
                            },
                            endEffectorDragging: {
                                on: {
                                    "ManipRobot/EFFECTOR_DRAGGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.ManipRobotEFFECTOR_DRAGGED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/EFFECTOR_DRAG_ENDED": {
                                        target: "idle",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.ManipRobotEFFECTOR_DRAG_ENDED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    }
                                }
                            },
                            rotatorDragging: {
                                on: {
                                    "ManipRobot/ROTATOR_DRAGGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.ManipRobotROTATOR_DRAGGED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/ROTATOR_DRAG_ENDED": {
                                        target: "idle",
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.ManipRobotROTATOR_DRAG_ENDED(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    },
                                    "ManipRobot/CAMERA_CHANGED": {
                                        actions: [
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).triad.updateWidgetSizes(g3DContext),
                                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            },
            referenceFrameCreator: {
                transitions: {
                    notCreatingReferenceFrame: {
                        "RobotClips/onReferenceFrameCreate": {
                            target: "creatingReferenceFrame",
                            actions: [
                                (0, $gXNCa$xstate.assign)({
                                    robotClipReferenceFrameEditingId: (_, event)=>event.robotClip.id || ""
                                }),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).referenceFrameCreator.RobotClips__setTopManipulatorManipRobotCreateReferenceFrame(g3DContext, gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotInstructionEditable/onReferenceFrameCreate": {
                            target: "creatingReferenceFrame",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).referenceFrameCreator.RobotInstructionEditable__setTopManipulatorManipRobotCreateReferenceFrame(g3DContext, gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotInstructionSelector/ReferenceFrameCreator/onReferenceFrameCreate": {
                            target: "creatingReferenceFrame",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).referenceFrameCreator.RobotInstructionSelector__setTopManipulatorManipRobotCreateReferenceFrame(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    },
                    creatingReferenceFrame: {
                        "ManipRobotCreateReferenceFrame/ESC_PRESSED": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotClips/onExitReferenceFrameCreate": {
                            target: "idle",
                            actions: [
                                (0, $gXNCa$xstate.assign)({
                                    robotClipReferenceFrameEditingId: ()=>""
                                }),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotClips/setTopManipulatorManipRobotCreateReferenceFrame/onReferenceFrameSet": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).referenceFrameCreator.RobotClips__setTopManipulatorManipRobotCreateReferenceFrame__onReferenceFrameSet(g3DContext)
                            ]
                        },
                        "RobotInstructionEditable/onExitReferenceFrameCreate": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotInstructionSelector/onExitReferenceFrameCreate": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotInstructionEditable/setTopManipulatorManipRobotCreateReferenceFrame/onReferenceFrameSet": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).referenceFrameCreator.RobotInstructionEditable__setTopManipulatorManipRobotCreateReferenceFrame__onReferenceFrameSet(g3DContext)
                            ]
                        },
                        "RobotInstructionSelector/setTopManipulatorManipRobotCreateReferenceFrame/onReferenceFrameSet": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).referenceFrameCreator.RobotInstructionSelector__setTopManipulatorManipRobotCreateReferenceFrame__onReferenceFrameSet(g3DContext)
                            ]
                        },
                        "RobotInstruction/Sequence.prototype.newInstruction/parameter/robotId": {
                            target: "idle",
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.RobotInstructionSequencePrototypeNewInstructionParameterRobotId(gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.setTopManipulatorManipRotateTranslate(g3DContext)
                            ]
                        }
                    }
                }
            },
            calibrationPartEditor: {
                transitions: {
                    notInCalibrationPartEditor: {},
                    inCalibrationPartEditor: {
                        "RobotAssets/CalibrationParts/onMount": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.onMount(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.RobotAssetsCalibrationPartsOnMount(g3DContext)
                            ]
                        },
                        "RobotAssets/CalibrationParts/onUnmount": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.onUnmount(),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.RobotAssetsCalibrationPartsOnUnmount(g3DContext)
                            ]
                        },
                        "RobotAssets/CalibrationParts/onReferenceFrameMouseEnter": {
                            actions: [
                                (0, $gXNCa$xstate.assign)({
                                    calibrationHighlights: ()=>{
                                        return {
                                            previous: g3DContext.robotUtils.getHighlights()
                                        };
                                    }
                                }),
                                (context, event)=>{
                                    g3DContext.robotUtils.highlightParts([
                                        event.vid
                                    ]);
                                }
                            ]
                        },
                        "RobotAssets/CalibrationParts/onReferenceFrameMouseLeave": {
                            actions: [
                                (0, $gXNCa$xstate.assign)({
                                    calibrationHighlights: (context)=>context.calibrationHighlights
                                }),
                                (context)=>{
                                    g3DContext.robotUtils.highlightParts(context.calibrationHighlights.previous);
                                }
                            ]
                        },
                        "RobotAssets/CalibrationParts/onReferenceFramesChanged": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.RobotAssetsCalibrationPartsOnReferenceFramesChanged(g3DContext, gLibrary),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/CalibrationParts/onReferenceFrameCreate": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.RobotAssetsCalibrationPartsOnReferenceFrameCreate(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/CalibrationParts/onReferenceFrameDelete": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.RobotAssetsCalibrationPartsOnReferenceFrameDelete(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/CalibrationParts/onPartChanged": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/CalibrationParts/manip-inserter/cancel": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        },
                        "RobotAssets/CalibrationParts/onReferenceFrameCreateCancel": {
                            actions: [
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).calibrationPartEditor.RobotAssetsCalibrationsPartsOnReferenceFrameCreateCancel(g3DContext),
                                (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                            ]
                        }
                    }
                }
            },
            simulation: {
                transitions: {
                    ROBOT_SIMULATION_MOTION_STARTED: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.ROBOT_SIMULATION_MOTION_STARTED(g3DContext)
                        ]
                    },
                    onRobotSimulationStateChange: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.onRobotSimulationStateChange(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    onRobotSimulationInstructionCompleted: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.onRobotSimulationInstructionCompleted(g3DContext, {
                                ExecutionEngineAPI: ExecutionEngineAPI,
                                getRobotProgrammingState: getRobotProgrammingState,
                                ilib_machinemotion: ilib_machinemotion
                            }),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    ROBOT_SIMULATION_MOTION_COMPLETED: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.ROBOT_SIMULATION_MOTION_COMPLETED(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    ROBOT_SIMULATION_MOTION_PAUSED: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.ROBOT_SIMULATION_MOTION_PAUSED(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    ROBOT_SIMULATION_JOINT_STATES_RECEIVED: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.ROBOT_SIMULATION_JOINT_STATES_RECEIVED(g3DContext)
                        ]
                    },
                    ROBOT_SIMULATION_SEQUENCE_MOVE_GROUP_RESULT_RECEIVED: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.ROBOT_SIMULATION_SEQUENCE_MOVE_GROUP_RESULT_RECEIVED(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    onRobotSimulationInstructionError: {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).simulation.onRobotSimulationInstructionError(g3DContext)
                        ]
                    },
                    "RobotInstruction/onRender": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.RobotInstructionOnRender()
                        ]
                    },
                    "RobotInstruction/onMount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.addReactStateUpdateFunction(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.onMount(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotInstruction/onUnmount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.removeReactStateUpdateFunction(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotInstruction.onUnmount(g3DContext),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/onMount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.onMount(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    },
                    "RobotLoopInstruction/onUnmount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotLoopInstruction.onUnmount(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    }
                }
            },
            robotConfigWidget: {
                transitions: {
                    "RobotConfigWidget/onMount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.onReactComponentMount(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotConfigWidget.connectToVentionRos(g3DContext, ExecutionEngineAPI)
                        ]
                    },
                    "RobotConfigWidget/onUnmount": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.onReactComponentUnmount(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState(),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.unRegisterPartsMoved(g3DContext, gLibrary)
                        ]
                    },
                    "RobotConfigWidget/RobotPartNumber/onChange": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).robotConfigWidget.connectToVentionRos(g3DContext, ExecutionEngineAPI),
                            ()=>{
                                $1d3cf5330bb207de$export$f39c10a7b99a6467(gLibrary.getMachineLogicAppList(), gLibrary.getConfigManager()?.listRobots()[0].mRobotId);
                            }
                        ]
                    },
                    "RobotConfig/connectToVentionRos/connectedToVentionRos": {
                        actions: [
                            (0, $gXNCa$xstate.assign)({
                                isRosConnected: (_, event)=>event.isConnected || false
                            }),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).common.reactUpdateState()
                        ]
                    }
                }
            },
            machineBuilder: {
                transitions: {
                    "undo_insertdelete/onRobotModelDeleted": {
                        actions: [
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineBuilder.onRobotModelDeleted(g3DContext, gLibrary),
                            (0, $0f59ad323b135ece$export$2e2bcd8739ae039).machineLogic.unRegisterPartsMoved(g3DContext, gLibrary)
                        ]
                    }
                }
            }
        });



const $a4b0e5373d13ed39$var$isRobotReady = (environment)=>(currentApp)=>{
        const { selectors: selectors  } = currentApp.mLibrary.getRobotAppsService();
        if (!environment.isOnCad()) {
            if (currentApp.hasRobotSimulateInstruction()) {
                if (selectors.isRobotDriverStateRobotReadyStateNotReady()) {
                    // eslint-disable-next-line functional/no-expression-statements
                    selectors.getDispatch()("MachineLogic/PlayButton/Clicked");
                    return false;
                }
            }
        }
        return true;
    };
var $a4b0e5373d13ed39$export$2e2bcd8739ae039 = $a4b0e5373d13ed39$var$isRobotReady;





const $8b66b82d3ade9884$export$cb9dc74b8199ca4e = (environment, selectors)=>(applicationId, robotParameters)=>{
        const applicationReferenceFrames = environment.isOnPendant() && selectors.getReferenceFramesByApplicationId(applicationId);
        return {
            ...robotParameters,
            ...applicationReferenceFrames && {
                calibrationParts: Object.values(applicationReferenceFrames)
            }
        };
    };
const $8b66b82d3ade9884$export$a373a095246b6248 = (config, robotConfig)=>{
    const robotConfigIndex = config.sequences[0].instructions.findIndex((inst)=>inst.name === "robot");
    return robotConfig ? {
        ...config,
        sequences: (0, $a85f490c61764882$export$2e2bcd8739ae039)(config.sequences, {
            index: 0,
            item: {
                ...config.sequences[0],
                instructions: robotConfigIndex > -1 ? (0, $a85f490c61764882$export$2e2bcd8739ae039)(config.sequences[0].instructions, {
                    index: robotConfigIndex,
                    item: robotConfig
                }) : [
                    ...config.sequences[0].instructions,
                    robotConfig
                ]
            }
        })
    } : config;
};


var $02291aaf8b5b0873$exports = {};

$parcel$export($02291aaf8b5b0873$exports, "create", () => $02291aaf8b5b0873$export$185802fd694ee1f5);
/**
 * to build the robot instruction category
 * This module contains the UI
 */ 
















function $2dd20f19a9074b5a$export$2e2bcd8739ae039({ robotName: robotName  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                label: "Robot Name"
            }),
            robotName ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$9cad5df6f2ba047a), {
                title: "Select Robot",
                text: robotName
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$9cad5df6f2ba047a), {
                title: "Select Robot",
                text: "(Not Configured)",
                style: {
                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).danger_color
                }
            })
        ]
    });
}



/**
 * @typedef {`${UUID}/${number}`} KeyframePath
 */ /**
 * @param {KeyframePath} keyframePath
 * @returns {string}
 */ function $ab21692160dc29ca$var$getRobotClipId(keyframePath) {
    return keyframePath?.split("/")[0];
}
/**
 * @param {KeyframePath} keyframePath
 * @returns {string}
 */ function $ab21692160dc29ca$var$getKeyframeIndex(keyframePath) {
    return keyframePath?.split("/")[1];
}
const $ab21692160dc29ca$var$KeyframePath = {
    getRobotClipId: $ab21692160dc29ca$var$getRobotClipId,
    getKeyframeIndex: $ab21692160dc29ca$var$getKeyframeIndex
};
var $ab21692160dc29ca$export$2e2bcd8739ae039 = $ab21692160dc29ca$var$KeyframePath;


function $6c54d82ce9f83af4$export$2e2bcd8739ae039({ onWaypointAddButtonClicked: onWaypointAddButtonClicked , onWaypointConfirmed: onWaypointConfirmed , onTeachWaypointAndCloseButtonClick: onTeachWaypointAndCloseButtonClick , onWaypointPathTypeChanged: onWaypointPathTypeChanged , onWaypointNameChanged: onWaypointNameChanged , onWaypointEditClicked: onWaypointEditClicked , onWaypointTimeChanged: onWaypointTimeChanged , onWaypointClicked: onWaypointClicked , onWaypointMoveHereButtonMouseDown: onWaypointMoveHereButtonMouseDown , onWaypointMoveHereButtonMouseUp: onWaypointMoveHereButtonMouseUp , onRobotCommandAdded: onRobotCommandAdded , onKeyframeRobotCommandChanged: onKeyframeRobotCommandChanged , onKeyframeRobotCommandWaitForTimeTimeChanged: onKeyframeRobotCommandWaitForTimeTimeChanged , onKeyframeRobotCommandSetPayloadWeightChanged: onKeyframeRobotCommandSetPayloadWeightChanged , onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged , onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged , onKeyframeDeleteClicked: onKeyframeDeleteClicked , onKeyframeOrderChanged: onKeyframeOrderChanged , onIgnoreReferenceFrameChanged: onIgnoreReferenceFrameChanged , robotClip: robotClip , robotClipIdsUsed: robotClipIdsUsed , robotClipIndex: robotClipIndex , robotConfigs: robotConfigs , shouldDisplayJogger: shouldDisplayJogger , onRobotClipChange: onRobotClipChange , onDeleteClick: onDeleteClick , onLockedDeleteClick: onLockedDeleteClick , onTriadButtonClick: onTriadButtonClick , onPointToPointButtonClick: onPointToPointButtonClick , onJoggerButtonClick: onJoggerButtonClick , onJoggerCloseButtonClick: onJoggerCloseButtonClick , robotJoggerApi: robotJoggerApi , onClick: onClick = ()=>{} , onTouchStart: onTouchStart = ()=>{} , onMoveJToolTipClick: onMoveJToolTipClick , onMoveLToolTipClick: onMoveLToolTipClick , children: children , robotSimulationState: robotSimulationState , isAnyKeyframeInEditMode: isAnyKeyframeInEditMode , isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip , getRobotClip: getRobotClip , getUniqueClipName: getUniqueClipName  }) {
    // TODO: move state up
    const instructionPlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === robotClipIndex && robotClip.keyframes.find((keyframe)=>keyframe.id === robotSimulationState?.keyframeId) ? "running" : "completed";
    const augmentedRobotJoggerApi = {
        ...robotJoggerApi,
        onTeachWaypointAndCloseButtonClick: ()=>onTeachWaypointAndCloseButtonClick({
                robotClip: robotClip
            })
    };
    const isEditingThisRobotClip = ()=>{
        const editingKeyframePath = (0, $e9a5479fa42b7804$export$e1252723db1c541).getEditingKeyframePath();
        return editingKeyframePath ? (0, $ab21692160dc29ca$export$2e2bcd8739ae039).getRobotClipId(editingKeyframePath) == robotClip.id : false;
    };
    const robotPathNameInputRef = (0, $gXNCa$react.useRef)(null);
    (0, $gXNCa$react.useEffect)(()=>{
        // NOTE to catch `kbd.js` `keydown` events
        document.addEventListener("keydown", (event)=>{
            const robotClip = getRobotClip();
            event?.target === robotPathNameInputRef.current && event?.target?.value && onRobotClipChange({
                ...robotClip,
                name: event.target.value
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $e4328fa0a7dc23c8$export$178405afcd8c5eb), {
        canDisplay: shouldDisplayJogger,
        dispatch: (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch(),
        onCloseButtonClick: ()=>onJoggerCloseButtonClick({
                robotClip: robotClip
            }),
        robotJoggerApi: augmentedRobotJoggerApi,
        robotType: robotConfigs?.getType(),
        robotJoggerTitle: "Teach Robot Position",
        shouldDisplayModal: isEditingThisRobotClip,
        shouldDisplayRobotJoggerRobotDisconnectedOverlay: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotJoggerRobotDisconnectedOverlay(),
        shouldDisplayRobotJoggerRobotNotReadyOverlay: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotJoggerRobotNotReadyOverlay(),
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "ml_card_no_padding bordered spaced ml_icon_instruction_widget",
            onClick: ()=>onClick(robotClip),
            onTouchStart: ()=>onTouchStart(robotClip),
            "data-cy": "editable-robot-path-card",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                    iconClassName: "icon-robot-sequence",
                    index: robotClipIndex + 1,
                    backgroundColor: "#FBFBFB",
                    style: {
                        paddingLeft: "0.65rem",
                        paddingRight: "0px"
                    },
                    playState: instructionPlayState,
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                    label: "Robot Path Name"
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                    type: "text",
                                    ref: robotPathNameInputRef,
                                    defaultValue: robotClip.name || getUniqueClipName("Robot path"),
                                    onChange: (event)=>event?.target?.value && onRobotClipChange({
                                            ...robotClip,
                                            name: event.target.value
                                        }),
                                    onMount: (name)=>onRobotClipChange({
                                            ...robotClip,
                                            name: name
                                        }),
                                    "data-cy": "edit-path-name"
                                })
                            ]
                        }),
                        robotClip.name !== "" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $2dd20f19a9074b5a$export$2e2bcd8739ae039), {
                            robotName: (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotConfigArray().length ? (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotConfigName() : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    style: {
                        borderBottom: "0.5px solid rgb(160, 160, 160)"
                    }
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $9bd62c0ac7ab9a34$export$2e2bcd8739ae039), {
                    keyframes: robotClip.keyframes,
                    isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip,
                    isAnyKeyframeInEditMode: isAnyKeyframeInEditMode,
                    shouldDisplayJogger: shouldDisplayJogger,
                    api: {
                        onWaypointAddButtonClicked: (keyframeIndex)=>onWaypointAddButtonClicked({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex
                            }),
                        onWaypointPathTypeChanged: (keyframeIndex, pathType)=>onWaypointPathTypeChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                pathType: pathType
                            }),
                        onWaypointNameChanged: (keyframeIndex, name)=>onWaypointNameChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                name: name
                            }),
                        onWaypointConfirmed: (keyframeIndex)=>onWaypointConfirmed({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex
                            }),
                        onWaypointEditClicked: (keyframeIndex)=>onWaypointEditClicked({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex
                            }),
                        onWaypointTimeChanged: (keyframeIndex, time)=>onWaypointTimeChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                time: time
                            }),
                        onWaypointClicked: (keyframeIndex)=>onWaypointClicked({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex
                            }),
                        onWaypointMoveHereButtonMouseDown: onWaypointMoveHereButtonMouseDown,
                        onWaypointMoveHereButtonMouseUp: onWaypointMoveHereButtonMouseUp,
                        onRobotCommandAdded: (keyframeIndex)=>onRobotCommandAdded({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex
                            }),
                        onKeyframeRobotCommandChanged: (keyframeIndex, robotCommandType)=>onKeyframeRobotCommandChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                robotCommandType: robotCommandType
                            }),
                        onKeyframeRobotCommandWaitForTimeTimeChanged: (keyframeIndex, time)=>onKeyframeRobotCommandWaitForTimeTimeChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                time: time
                            }),
                        onKeyframeRobotCommandSetPayloadWeightChanged: (keyframeIndex, weight)=>onKeyframeRobotCommandSetPayloadWeightChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                weight: weight
                            }),
                        onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: (keyframeIndex, moveLVelocityScalingFactor)=>onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                moveLVelocityScalingFactor: moveLVelocityScalingFactor
                            }),
                        onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: (keyframeIndex, moveJVelocityScalingFactor)=>onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                moveJVelocityScalingFactor: moveJVelocityScalingFactor
                            }),
                        onKeyframeDeleteClicked: (keyframeIndex)=>onKeyframeDeleteClicked({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex
                            }),
                        onKeyframeOrderChanged: (keyframes)=>onKeyframeOrderChanged({
                                robotClip: robotClip,
                                keyframes: keyframes
                            }),
                        onIgnoreReferenceFrameChanged: (keyframeIndex, ignoreReferenceFrame)=>onIgnoreReferenceFrameChanged({
                                robotClip: robotClip,
                                keyframeIndex: keyframeIndex,
                                ignoreReferenceFrame: ignoreReferenceFrame
                            }),
                        onTriadButtonClick: onTriadButtonClick,
                        onPointToPointButtonClick: onPointToPointButtonClick,
                        onJoggerButtonClick: onJoggerButtonClick,
                        onJoggerCloseButtonClick: ()=>onJoggerCloseButtonClick({
                                robotClip: robotClip
                            }),
                        robotJoggerApi: {
                            ...robotJoggerApi,
                            onTeachWaypointAndCloseButtonClick: ()=>onTeachWaypointAndCloseButtonClick({
                                    robotClip: robotClip
                                })
                        }
                    },
                    onMoveJToolTipClick: onMoveJToolTipClick,
                    onMoveLToolTipClick: onMoveLToolTipClick,
                    robotSimulationState: robotSimulationState,
                    instructionIndex: robotClipIndex,
                    referenceFrame: robotClip.teachingReferenceFrame,
                    robotType: robotConfigs?.getType()
                }),
                robotClip.id && robotClipIdsUsed?.includes(robotClip.id) ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$3a9efa6242d14e94), {
                    style: {
                        padding: "0.25rem"
                    },
                    onClick: (event)=>{
                        event.stopPropagation();
                        onLockedDeleteClick?.();
                    },
                    onTouchStart: (event)=>{
                        event.stopPropagation();
                        onLockedDeleteClick?.();
                    }
                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                    style: {
                        marginRight: "0.25rem"
                    },
                    onClick: (event)=>{
                        event.stopPropagation();
                        onDeleteClick?.();
                    },
                    "data-cy": "delete-robot-path"
                }),
                children
            ]
        })
    });
}





function $d4227912391e17b6$export$2e2bcd8739ae039({ children: children , instruction: instruction , instructionIndex: instructionIndex , jogger: jogger , robotAppsService: robotAppsService , robotSimulationState: robotSimulationState , selectedClip: selectedClip , sequence: sequence , tooltips: tooltips , waypointSelectedIndex: waypointSelectedIndex , getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame = ()=>{} , get___matrix__endEffector_referenceFrame__translation: get___matrix__endEffector_referenceFrame__translation = ()=>{} , get___matrix__endEffector_referenceFrame__rotation: get___matrix__endEffector_referenceFrame__rotation = ()=>{} , getJointAnglesDegrees: getJointAnglesDegrees = ()=>{} , getUniqueClipName: getUniqueClipName , getSelectedClip: getSelectedClip  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $6c54d82ce9f83af4$export$2e2bcd8739ae039), {
            "data-cy": "editable-robot-path-card",
            getUniqueClipName: getUniqueClipName,
            getRobotClip: getSelectedClip,
            onWaypointAddButtonClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointAddButtonClicked", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onWaypointNameChanged: ({ name: name , robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointNameChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    name: name,
                    keyframeIndex: keyframeIndex
                }),
            onWaypointPathTypeChanged: ({ pathType: pathType , keyframeIndex: keyframeIndex , robotClip: robotClip  })=>robotAppsService.send("RobotInstructionEditable/onWaypointPathTypeChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    pathType: pathType,
                    keyframeIndex: keyframeIndex
                }),
            onWaypointConfirmed: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointConfirmed", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onTeachWaypointAndCloseButtonClick: ({ robotClip: robotClip  })=>{
                const editingKeyframePath = (0, $e9a5479fa42b7804$export$e1252723db1c541).getEditingKeyframePath();
                const editingKeyframeIndex = (0, $ab21692160dc29ca$export$2e2bcd8739ae039).getKeyframeIndex(editingKeyframePath);
                robotClip.keyframes.length > editingKeyframeIndex ? robotAppsService.send("RobotInstructionEditable/EditWaypoint/onTeachWaypointAndCloseButtonClick", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }) : robotAppsService.send("RobotInstructionEditable/AddWaypoint/onTeachWaypointAndCloseButtonClick", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                });
            },
            onWaypointEditClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointEditClicked", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onWaypointTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotInstructionEditable/onWaypointTimeChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    time: time
                }),
            onWaypointClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointClicked", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onWaypointMoveHereButtonMouseDown: ({ jointAngles: jointAngles  })=>{
                robotAppsService.send("RobotInstructionEditable/onWaypointMoveHereButtonMouseDown", {
                    jointAngles: jointAngles
                });
            },
            onWaypointMoveHereButtonMouseUp: ()=>robotAppsService.send("RobotInstructionEditable/onWaypointMoveHereButtonMouseUp"),
            onRobotCommandAdded: ({ robotClip: robotClip  })=>robotAppsService.send("RobotInstructionEditable/onRobotCommandAdded", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }),
            onKeyframeRobotCommandChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    robotCommandType: robotCommandType
                }),
            onKeyframeRobotCommandWaitForTimeTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandWaitForTimeTimeChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    time: time
                }),
            onKeyframeRobotCommandSetPayloadWeightChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , weight: weight  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandSetPayloadWeightChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    weight: weight
                }),
            onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    moveLVelocityScalingFactor: moveLVelocityScalingFactor
                }),
            onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    moveJVelocityScalingFactor: moveJVelocityScalingFactor
                }),
            onKeyframeDeleteClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeDeleteClicked", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onKeyframeOrderChanged: ({ robotClip: robotClip , keyframes: keyframes  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeOrderChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframes: keyframes
                }),
            onIgnoreReferenceFrameChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  })=>robotAppsService.send("RobotInstructionEditable/onIgnoreReferenceFrameChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    ignoreReferenceFrame: ignoreReferenceFrame
                }),
            shouldDisplayJogger: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotInstructionEditableJogger(),
            isEditingReferenceFrame: (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotAppsService().state.value.app === "creatingReferenceFrame",
            onClick: ()=>robotAppsService.send("RobotInstructionEditable/onClipSelected", {
                    robotClip: selectedClip,
                    instruction: instruction
                }),
            onTouchStart: ()=>robotAppsService.send("RobotInstructionEditable/onClipSelected", {
                    robotClip: selectedClip,
                    instruction: instruction
                }),
            containerStyle: {
                width: "100%"
            },
            robotConfigs: (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotConfig(),
            robotClip: selectedClip,
            referenceFrameLabel: "LOCAL REFERENCE FRAME",
            robotClipIndex: instructionIndex,
            robotClipNames: [
                ...sequence.mApp.robotParameters.clips,
                ...sequence.robotParameters?.clips || []
            ].map((clip)=>clip.name),
            robotSimulationState: robotSimulationState,
            waypointSelectedIndex: waypointSelectedIndex,
            getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame,
            onTriadButtonClick: ()=>robotAppsService.send("RobotInstructionEditable/TRIAD_SELECTED"),
            onPointToPointButtonClick: ()=>robotAppsService.send("RobotInstructionEditable/POINT_TO_POINT_SELECTED"),
            onJoggerButtonClick: ()=>robotAppsService.send("RobotInstructionEditable/JOGGER_SELECTED"),
            onJoggerCloseButtonClick: ({ robotClip: robotClip  })=>{
                robotAppsService.send("RobotInstructionEditable/JOGGER_CLOSE_BUTTON_CLICKED", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                });
            },
            onRobotClipChange: (robotClip)=>robotAppsService.send("RobotInstructionEditable/onRobotClipChange", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }),
            onDeleteClick: ()=>robotAppsService.send("RobotInstructionEditable/onDeleteClicked", {
                    sequence: sequence,
                    instruction: instruction
                }),
            onReferenceFrameCreate: ({ robotClip: robotClip  })=>robotAppsService.send("RobotInstructionEditable/onReferenceFrameCreate", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }),
            isAnyKeyframeInEditMode: (sequence.robotParameters?.clips ? [
                ...sequence.robotParameters.clips
            ] : []).some((clip)=>(0, $bedf83968cd4d388$export$2e2bcd8739ae039)(clip)),
            isAnyKeyframeInEditModeInClip: (0, $bedf83968cd4d388$export$2e2bcd8739ae039)(selectedClip),
            robotJoggerApi: {
                jointLimits: [
                    {
                        min: -180,
                        max: 180
                    },
                    {
                        min: -180,
                        max: 180
                    },
                    {
                        min: -180,
                        max: 180
                    },
                    {
                        min: -180,
                        max: 180
                    },
                    {
                        min: -180,
                        max: 180
                    },
                    {
                        min: -180,
                        max: 180
                    }
                ],
                position: jogger.getPosition() || get___matrix__endEffector_referenceFrame__translation(),
                rotation: jogger.getRotation() || get___matrix__endEffector_referenceFrame__rotation(),
                jointAngles: jogger.getJointAngles() || getJointAnglesDegrees(),
                joggerSpeedPercentage: (0, $e9a5479fa42b7804$export$e1252723db1c541).getJoggerSpeedPercentage(),
                freedriveStatus: jogger.getFreedriveStatus(),
                onJoggerPoseTranslationMouseDown: (letter, value)=>{
                    robotAppsService.send("RobotInstructionEditable/onJoggerPoseTranslationMouseDown", {
                        letter: letter,
                        value: value
                    });
                },
                onJoggerPoseRotationMouseDown: (letter, value)=>{
                    robotAppsService.send("RobotInstructionEditable/onJoggerPoseRotationMouseDown", {
                        letter: letter,
                        value: value
                    });
                },
                onJoggerJointArrowMouseDown: (index, delta)=>robotAppsService.send("RobotInstructionEditable/onJoggerJointArrowMouseDown", {
                        index: index,
                        delta: delta
                    }),
                onJoggerArrowMouseUp: ()=>robotAppsService.send("RobotInstructionEditable/onJoggerArrowMouseUp"),
                onSpeedSliderChange: (joggerSpeedPercentage)=>robotAppsService.send("RobotInstructionEditable/JOGGER_SPEED_SLIDER_CHANGED", {
                        joggerSpeedPercentage: joggerSpeedPercentage
                    }),
                onEnableFreedriveButtonClick: ()=>{
                    robotAppsService.send("RobotInstructionEditable/onEnableFreedriveButtonClick");
                },
                onDisableFreedriveButtonClick: ()=>{
                    robotAppsService.send("RobotInstructionEditable/onDisableFreedriveButtonClick");
                },
                onToggleConstraintButtonClick: (constraintIndex)=>{
                    robotAppsService.send("RobotInstructionEditable/onToggleConstraintButtonClick", {
                        constraintIndex: constraintIndex
                    });
                }
            },
            onReferenceFrameToolTipClick: ()=>tooltips.showTips("local_reference_frame"),
            onMoveJToolTipClick: ()=>tooltips.showTips("move_j_and_l"),
            onMoveLToolTipClick: ()=>tooltips.showTips("move_j_and_l"),
            children: children
        })
    });
}









function $4279a2221e0060dd$var$getTooltipWarningIcon() {
    const textStyle = {
        padding: 0,
        margin: 0
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $8c1dadece72da4af$export$f7dc499a72baa103), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                    style: textStyle,
                    children: "Invalid waypoint: the selected start point puts this waypoint out of the playable area."
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                    style: textStyle,
                    children: "Select a different start point or adjust your waypoint"
                })
            ]
        })
    });
}
function $4279a2221e0060dd$export$2e2bcd8739ae039({ robotAppsService: robotAppsService , instructionIndex: instructionIndex , clipOptions: clipOptions , sequence: sequence , instruction: instruction , executionReferenceFrame: executionReferenceFrame , selectedClip: selectedClip , onCollapseToggleClick: onCollapseToggleClick , areRobotCommandsOpened: areRobotCommandsOpened , newClipId: newClipId , robotSimulationState: robotSimulationState , children: children  }) {
    const instructionPlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === instructionIndex && selectedClip?.keyframes.find((k)=>k.id === robotSimulationState?.keyframeId) ? "running" : "completed";
    (0, $gXNCa$react.useEffect)(()=>{
        (0, $8c1dadece72da4af$export$1eb2ee5864472e77)();
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        class: "ml_card",
        containerStyle: {
            padding: "0",
            position: "relative",
            width: "100%" /* HACK needed here since there's no min-width defined by an ancestor HTML element */ 
        },
        "data-cy": "read-only-robot-path-card",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                "data-cy": "read-only-card-top-part",
                iconClassName: "icon-robot-sequence",
                index: instructionIndex + 1,
                backgroundColor: "#FBFBFB",
                padding: "0.65rem 0",
                style: {
                    paddingLeft: "0.65rem",
                    paddingRight: "0px"
                },
                playState: instructionPlayState,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $7c72e01173199087$export$2e2bcd8739ae039), {
                        clips: clipOptions,
                        selectedClipId: selectedClip?.id,
                        onClipSelected: (clipId)=>{
                            if (clipId === newClipId) robotAppsService.send("RobotInstructionSelector/ClipSelector/onNewClipSelected", {
                                sequence: sequence,
                                instruction: instruction
                            });
                            else robotAppsService.send("RobotInstructionSelector/ClipSelector/onClipSelected", {
                                sequence: sequence,
                                instruction: instruction,
                                clipId: clipId
                            });
                        },
                        onClipMounted: (clipId)=>{
                            if (clipId === newClipId) robotAppsService.send("RobotInstructionSelector/ClipSelector/onNewClipMounted", {
                                sequence: sequence,
                                instruction: instruction
                            });
                            else robotAppsService.send("RobotInstructionSelector/ClipSelector/onClipMounted", {
                                instruction: instruction,
                                clipId: clipId
                            });
                        }
                    })
                })
            }),
            selectedClip && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            borderBottom: "0.5px solid rgb(160, 160, 160)"
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            display: "grid"
                        },
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            onClick: onCollapseToggleClick,
                            style: {
                                textAlign: "right",
                                border: "none",
                                background: "none",
                                fontSize: "14px",
                                color: "#1C344F",
                                cursor: "pointer",
                                margin: `0.5rem 1rem ${areRobotCommandsOpened ? "0rem" : "0.5rem"}`,
                                alignSelf: "flex-end"
                            },
                            children: areRobotCommandsOpened ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                                children: [
                                    "Hide commands ",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                        className: "fas fa-chevron-up"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                                children: [
                                    "Show commands ",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                        className: "fas fa-chevron-down"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, ($parcel$interopDefault($gXNCa$reactcollapsible))), {
                open: areRobotCommandsOpened,
                children: [
                    selectedClip?.id && executionReferenceFrame && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                        children: [
                            selectedClip?.keyframes.map((keyframe, index)=>{
                                const keyframePlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === instructionIndex && keyframe.id === robotSimulationState?.keyframeId ? "running" : "completed";
                                const isValidWaypoint = true;
                                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
                                    children: keyframe.waypoint ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $09dbe9e4f8df3d60$export$2e2bcd8739ae039), {
                                        item: {
                                            ...keyframe,
                                            index: index
                                        },
                                        warningIcon: isValidWaypoint ? null : $4279a2221e0060dd$var$getTooltipWarningIcon(),
                                        onClick: ()=>robotAppsService.send("RobotInstructionSelector/onWaypointClicked", {
                                                robotClip: selectedClip,
                                                keyframeIndex: index,
                                                isValidWaypoint: isValidWaypoint,
                                                executionReferenceFrame: executionReferenceFrame
                                            }),
                                        onTouchStart: ()=>robotAppsService.send("RobotInstructionSelector/onWaypointClicked", {
                                                robotClip: selectedClip,
                                                keyframeIndex: index,
                                                isValidWaypoint: isValidWaypoint,
                                                executionReferenceFrame: executionReferenceFrame
                                            }),
                                        playState: keyframePlayState
                                    }, selectedClip?.id + index) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $105e2418246a892f$export$2e2bcd8739ae039), {
                                        item: {
                                            ...keyframe,
                                            index: index
                                        },
                                        robotType: (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotConfig()?.getType()
                                    }, selectedClip?.id + index)
                                });
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                        style: {
                            marginRight: "0.25rem"
                        },
                        onClick: (event)=>{
                            event.stopPropagation();
                            robotAppsService.send("RobotInstructionSelector/StyledDeleteButton/onClick", {
                                sequence: sequence,
                                instruction: instruction
                            });
                        }
                    })
                ]
            })
        ]
    });
}



function $02291aaf8b5b0873$export$185802fd694ee1f5({ sequence: sequence , instruction: instruction , robotAppsService: robotAppsService , manipRobotState: manipRobotState , tooltips: tooltips , getJointLimits: getJointLimits , getRobotActuatorVID: getRobotActuatorVID , getSelectedClip: getSelectedClip , getExecutionReferenceFrame: getExecutionReferenceFrame , getCalibrationReferenceFrame: getCalibrationReferenceFrame , getCalibrationReferenceFrames: getCalibrationReferenceFrames , getRobotSimulationState: getRobotSimulationState , getInstructionIndex: getInstructionIndex , isLocalSequenceClip: isLocalSequenceClip , childrenApis: { editable: { getArrayRobotDigitalIOValuesFromRobotVID: getArrayRobotDigitalIOValuesFromRobotVID , getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame , get___matrix__endEffector_referenceFrame__translation: get___matrix__endEffector_referenceFrame__translation , get___matrix__endEffector_referenceFrame__rotation: get___matrix__endEffector_referenceFrame__rotation , getJointAngles: getJointAngles , getMatrixEndEffectorFromWorld: getMatrixEndEffectorFromWorld , getJointAnglesDegrees: getJointAnglesDegrees , jogger: jogger  }  }  }, reactComponentjQueryRootElement) {
    function RobotInstructionWidget() {
        // NOTE these are considered as props
        const robotActuatorVID = getRobotActuatorVID();
        const selectedClip = getSelectedClip();
        const executionReferenceFrame = getExecutionReferenceFrame();
        const calibrationReferenceFrame = getCalibrationReferenceFrame();
        const robotSimulationState = getRobotSimulationState();
        const instructionIndex = getInstructionIndex();
        (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotInstruction/onMount", {
                idxFunc: idxFunc
            }), (idxFunc)=>robotAppsService.send("RobotInstruction/onUnmount", {
                idxFunc: idxFunc
            }));
        // UI state
        const [areRobotCommandsOpened, toggleAreRobotCommandsOpened] = (0, $d3bbe4bc45b4a8e8$export$cbe85ee05b554577)(true);
        const [isCalibrationReferenceFrameOpened, toggleCalibrationReferenceFrameOpened] = (0, $d3bbe4bc45b4a8e8$export$cbe85ee05b554577)(false);
        robotAppsService.send("RobotInstruction/onRender", {
            instruction: instruction,
            instructionIndex: instructionIndex
        });
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
            children: isLocalSequenceClip(selectedClip) ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $d4227912391e17b6$export$2e2bcd8739ae039), {
                "data-cy": "editable-local-robot-path",
                jogger: jogger,
                robotAppsService: robotAppsService,
                manipRobotState: manipRobotState,
                sequence: sequence,
                instruction: instruction,
                robotActuatorVID: robotActuatorVID,
                selectedClip: selectedClip,
                instructionIndex: instructionIndex,
                robotSimulationState: robotSimulationState,
                jointLimits: getJointLimits(),
                tooltips: tooltips,
                getArrayRobotDigitalIOValuesFromRobotVID: getArrayRobotDigitalIOValuesFromRobotVID,
                getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame,
                get___matrix__endEffector_referenceFrame__translation: get___matrix__endEffector_referenceFrame__translation,
                get___matrix__endEffector_referenceFrame__rotation: get___matrix__endEffector_referenceFrame__rotation,
                getJointAngles: getJointAngles,
                getMatrixEndEffectorFromWorld: getMatrixEndEffectorFromWorld,
                getJointAnglesDegrees: getJointAnglesDegrees,
                getUniqueClipName: (0, $1d3cf5330bb207de$export$64c313e59f94d976)(sequence.mApp),
                getSelectedClip: getSelectedClip,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $bfdf450689e65c89$export$2e2bcd8739ae039), {
                    referenceFrames: getCalibrationReferenceFrames(),
                    selectedReferenceFrame: calibrationReferenceFrame,
                    isCalibrationReferenceFrameOpened: isCalibrationReferenceFrameOpened,
                    onReferenceFrameSelected: (selectedReferenceFrameName)=>robotAppsService.send("RobotInstruction/CalibrationReferenceFrameSelector/onReferenceFrameSelected", {
                            instruction: instruction,
                            selectedReferenceFrameName: selectedReferenceFrameName
                        }),
                    onCalibrationReferenceFrameCollapseToggleClick: toggleCalibrationReferenceFrameOpened,
                    onCalibrationReferenceFrameToolTipClick: ()=>tooltips.showTips("digital_calibration_tools")
                })
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $4279a2221e0060dd$export$2e2bcd8739ae039), {
                "data-cy": "robot-path-selector",
                robotAppsService: robotAppsService,
                manipRobotState: manipRobotState,
                sequence: sequence,
                instruction: instruction,
                robotActuatorVID: robotActuatorVID,
                instructionIndex: instructionIndex,
                clipOptions: [
                    ...sequence?.mApp?.robotParameters?.clips?.length ? sequence.mApp.robotParameters.clips : [
                        {
                            name: "Select",
                            id: "none"
                        }
                    ],
                    {
                        name: "Create new sequence",
                        id: (0, $49b61417b640529d$export$c45596821edb3bba)
                    }
                ],
                executionReferenceFrame: executionReferenceFrame,
                selectedClip: selectedClip,
                areRobotCommandsOpened: areRobotCommandsOpened,
                newClipId: (0, $49b61417b640529d$export$c45596821edb3bba),
                robotSimulationState: robotSimulationState,
                onCollapseToggleClick: toggleAreRobotCommandsOpened,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $bfdf450689e65c89$export$2e2bcd8739ae039), {
                    referenceFrames: getCalibrationReferenceFrames(),
                    selectedReferenceFrame: calibrationReferenceFrame,
                    isCalibrationReferenceFrameOpened: isCalibrationReferenceFrameOpened,
                    onReferenceFrameSelected: (selectedReferenceFrameName)=>robotAppsService.send("RobotInstruction/CalibrationReferenceFrameSelector/onReferenceFrameSelected", {
                            instruction: instruction,
                            selectedReferenceFrameName: selectedReferenceFrameName
                        }),
                    onCalibrationReferenceFrameCollapseToggleClick: toggleCalibrationReferenceFrameOpened,
                    onCalibrationReferenceFrameToolTipClick: ()=>tooltips.showTips("digital_calibration_tools")
                })
            })
        });
    }
    reactComponentjQueryRootElement.on("remove", ()=>(0, ($parcel$interopDefault($gXNCa$reactdom))).unmountComponentAtNode(reactComponentjQueryRootElement[0]));
    (0, ($parcel$interopDefault($gXNCa$reactdom))).render(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)(RobotInstructionWidget, {}), reactComponentjQueryRootElement[0]);
    return reactComponentjQueryRootElement;
}


var $8c0c7fef442bff47$exports = {};

$parcel$export($8c0c7fef442bff47$exports, "create", () => $8c0c7fef442bff47$export$185802fd694ee1f5);
/**
 * This module contains the UI
 * to build the robot instruction category
 */ 











function $90c9c147dc5ed8c0$export$2e2bcd8739ae039({ robotAppsService: robotAppsService , robotActuatorVID: robotActuatorVID , sequence: sequence , instruction: instruction , selectedClip: selectedClip , instructionIndex: instructionIndex , manipRobotState: manipRobotState , robotSimulationState: robotSimulationState , jointLimits: jointLimits , waypointSelectedIndex: waypointSelectedIndex , tooltips: tooltips , children: children , getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame = ()=>{} , get___matrix__endEffector_referenceFrame__translation: get___matrix__endEffector_referenceFrame__translation = ()=>{} , get___matrix__endEffector_referenceFrame__rotation: get___matrix__endEffector_referenceFrame__rotation = ()=>{} , getJointAnglesDegrees: getJointAnglesDegrees = ()=>{} , getUniqueClipName: getUniqueClipName  }) {
    const robotConfigs = sequence.mLibrary.getConfigManager().listRobots();
    const robotJoggerApi = robotActuatorVID ? {
        jointLimits: jointLimits,
        position: get___matrix__endEffector_referenceFrame__translation(),
        rotation: get___matrix__endEffector_referenceFrame__rotation(),
        jointAngles: getJointAnglesDegrees(),
        onPoseTranslationChange: (letter, value)=>robotAppsService.send("RobotInstructionEditable/JOGGER_POSE_TRANSLATION_CHANGED", {
                letter: letter,
                value: value
            }),
        onPoseRotationChange: (letter, value)=>robotAppsService.send("RobotInstructionEditable/JOGGER_POSE_ROTATION_CHANGED", {
                letter: letter,
                value: value
            }),
        onJointAnglesChange: (index, value)=>robotAppsService.send("RobotInstructionEditable/JOGGER_JOINT_ANGLE_CHANGED", {
                index: index,
                value: value
            })
    } : null;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $17e4fcea6fcfce4b$export$2e2bcd8739ae039), {
            "data-cy": "robot-editable-card",
            getUniqueClipName: getUniqueClipName,
            onWaypointAdded: ({ robotClip: robotClip  })=>robotAppsService.send("RobotInstructionEditable/onWaypointAdded", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }),
            onWaypointPathTypeChanged: ({ pathType: pathType , keyframeIndex: keyframeIndex , robotClip: robotClip  })=>{
                robotAppsService.send("RobotInstructionEditable/onWaypointPathTypeChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    pathType: pathType,
                    keyframeIndex: keyframeIndex
                });
            },
            onWaypointNameChanged: ({ name: name , keyframeIndex: keyframeIndex , robotClip: robotClip  })=>{
                robotAppsService.send("RobotInstructionEditable/onWaypointNameChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    name: name,
                    keyframeIndex: keyframeIndex
                });
            },
            onWaypointConfirmed: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointConfirmed", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onWaypointEditClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointEditClicked", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onWaypointTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotInstructionEditable/onWaypointTimeChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    time: time
                }),
            onWaypointClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onWaypointClicked", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onRobotCommandAdded: ({ robotClip: robotClip  })=>robotAppsService.send("RobotInstructionEditable/onRobotCommandAdded", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }),
            onKeyframeRobotCommandChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    robotCommandType: robotCommandType
                }),
            onKeyframeRobotCommandWaitForTimeTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandWaitForTimeTimeChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    time: time
                }),
            onKeyframeRobotCommandSetPayloadWeightChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , weight: weight  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandSetPayloadWeightChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    weight: weight
                }),
            onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    moveLVelocityScalingFactor: moveLVelocityScalingFactor
                }),
            onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    moveJVelocityScalingFactor: moveJVelocityScalingFactor
                }),
            onKeyframeDeleteClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeDeleteClicked", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex
                }),
            onKeyframeOrderChanged: ({ robotClip: robotClip , keyframes: keyframes  })=>robotAppsService.send("RobotInstructionEditable/onKeyframeOrderChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframes: keyframes
                }),
            onIgnoreReferenceFrameChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  })=>robotAppsService.send("RobotInstructionEditable/onIgnoreReferenceFrameChanged", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip,
                    keyframeIndex: keyframeIndex,
                    ignoreReferenceFrame: ignoreReferenceFrame
                }),
            moveWithMode: (0, $49b61417b640529d$export$7556d3a9f806327e)[typeof robotAppsService.selectors.getRobotAppsServiceState().value.app === "string" ? robotAppsService.selectors.getRobotAppsServiceState().value.app : Object.keys(robotAppsService.selectors.getRobotAppsServiceState().value.app)[0]] || "",
            isEditingReferenceFrame: robotAppsService.selectors.getRobotAppsServiceState().matches("app.creatingReferenceFrame"),
            validatePoseWaypoint: (pose)=>manipRobotState?.validatePoseWaypoint({
                    vid: robotActuatorVID,
                    pose: pose
                }) || false,
            onClick: ()=>robotAppsService.send("RobotInstructionEditable/onClipSelected", {
                    robotClip: selectedClip,
                    instruction: instruction,
                    sequence: sequence
                }),
            onExitReferenceFrameCreate: ()=>robotAppsService.send("RobotInstructionEditable/onExitReferenceFrameCreate", {
                    robotClip: selectedClip,
                    instruction: instruction
                }),
            SaveToRobotAssetsButton: ()=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                    style: {
                        alignSelf: "flex-end",
                        justifySelf: "flex-end",
                        margin: "0 1rem"
                    },
                    "data-cy": "save-to-robot-assets",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        onClick: ()=>robotAppsService.send("RobotInstructionEditable/SaveToRobotAssetsButton/onClick", {
                                sequence: sequence,
                                selectedClip: selectedClip
                            }),
                        className: "ml_widget_label",
                        style: {
                            color: "#667A99",
                            cursor: "pointer",
                            textDecorationLine: "underline",
                            fontSize: "14px",
                            fontWeight: "normal",
                            width: "fit-content"
                        },
                        children: "Save to Robot Assets"
                    })
                }),
            containerStyle: {
                width: "100%"
            },
            robotConfigs: robotConfigs,
            robotName: robotConfigs.length && robotConfigs[0].mName,
            robotClip: selectedClip,
            referenceFrameLabel: "LOCAL REFERENCE FRAME",
            robotClipIndex: instructionIndex,
            robotClipNames: [
                ...sequence.mApp.robotParameters.clips,
                ...sequence.robotParameters?.clips || []
            ].map((clip)=>clip.name),
            robotSimulationState: robotSimulationState,
            waypointSelectedIndex: waypointSelectedIndex,
            getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame,
            onTriadButtonClick: ()=>robotAppsService.send("RobotInstructionEditable/TRIAD_SELECTED"),
            onPointToPointButtonClick: ()=>robotAppsService.send("RobotInstructionEditable/POINT_TO_POINT_SELECTED"),
            onJoggerButtonClick: ()=>robotAppsService.send("RobotInstructionEditable/JOGGER_SELECTED"),
            onJoggerCloseButtonClick: (robotClip, keyframeIndex)=>robotAppsService.send("RobotInstructionEditable/JOGGER_CLOSE_BUTTON_CLICKED", {
                    sequence: sequence,
                    instruction: instruction,
                    keyframeIndex: keyframeIndex
                }),
            onRobotClipChange: (robotClip)=>robotAppsService.send("RobotInstructionEditable/onRobotClipChange", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }),
            onDeleteClick: ()=>robotAppsService.send("RobotInstructionEditable/onDeleteClicked", {
                    sequence: sequence,
                    instruction: instruction
                }),
            onReferenceFrameCreate: ({ robotClip: robotClip  })=>robotAppsService.send("RobotInstructionEditable/onReferenceFrameCreate", {
                    sequence: sequence,
                    instruction: instruction,
                    robotClip: robotClip
                }),
            isAnyKeyframeInEditMode: (sequence.robotParameters?.clips ? [
                ...sequence.robotParameters.clips
            ] : []).some((clip)=>(0, $bedf83968cd4d388$export$2e2bcd8739ae039)(clip)),
            isAnyKeyframeInEditModeInClip: (0, $bedf83968cd4d388$export$2e2bcd8739ae039)(selectedClip),
            doesRobotConfigExist: robotConfigs.length > 0,
            robotJoggerApi: robotJoggerApi,
            onReferenceFrameToolTipClick: ()=>tooltips.showTips("local_reference_frame"),
            onMoveJToolTipClick: ()=>tooltips.showTips("move_j_and_l"),
            onMoveLToolTipClick: ()=>tooltips.showTips("move_j_and_l"),
            children: children
        })
    });
}












const $7ca9b06a9a4e8110$var$defaultKeyframeStyle = {
    borderColor: "rgb(160, 160, 160) rgb(160, 160, 160) rgb(160, 160, 160) rgb(28, 52, 79)",
    borderWidth: "1px 1px 1px 4px"
};
const $7ca9b06a9a4e8110$var$selectedKeyframeStyle = {
    borderColor: "rgb(28, 52, 79) rgb(28, 52, 79) rgb(28, 52, 79) rgb(28, 52, 79)",
    borderWidth: "2px 2px 2px 4px"
};
function $7ca9b06a9a4e8110$var$getTooltipWarningIcon() {
    const textStyle = {
        padding: 0,
        margin: 0
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $8c1dadece72da4af$export$f7dc499a72baa103), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                    style: textStyle,
                    children: "Invalid waypoint: the selected start point puts this waypoint out of the playable area."
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                    style: textStyle,
                    children: "Select a different start point or adjust your waypoint"
                })
            ]
        })
    });
}
function $7ca9b06a9a4e8110$export$2e2bcd8739ae039({ robotAppsService: robotAppsService , robotActuatorVID: robotActuatorVID , instructionIndex: instructionIndex , clipOptions: clipOptions , sequence: sequence , instruction: instruction , getExecutionReferenceFrame: getExecutionReferenceFrame , manipRobotState: manipRobotState , selectedClip: selectedClip , onCollapseToggleClick: onCollapseToggleClick , areRobotCommandsOpened: areRobotCommandsOpened , newClipId: newClipId , robotSimulationState: robotSimulationState , robotType: robotType , tooltips: tooltips , children: children  }) {
    const instructionPlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === instructionIndex && selectedClip.keyframes.find((k)=>k.id === robotSimulationState?.keyframeId) ? "running" : "completed";
    (0, $gXNCa$react.useEffect)(()=>{
        (0, $8c1dadece72da4af$export$1eb2ee5864472e77)();
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
        containerStyle: {
            position: "relative",
            width: "100%" /* HACK needed here since there's no min-width defined by an ancestor HTML element */ 
        },
        className: "ml_card",
        onClick: ()=>robotAppsService.send("RobotInstructionSelector/onClipSelected", {
                robotClip: selectedClip,
                instruction: instruction
            }),
        "data-cy": "read-only-robot-path",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                iconClassName: "icon-robot-sequence",
                index: instructionIndex + 1,
                backgroundColor: "#FBFBFB",
                playState: instructionPlayState,
                style: {
                    padding: "1.3rem 1.3rem 0.65rem 0.65rem",
                    margin: "-0.65rem -0.65rem 0rem -0.65rem"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $7c72e01173199087$export$2e2bcd8739ae039), {
                        clips: clipOptions,
                        selectedClipId: selectedClip?.id,
                        onClipSelected: (clipId)=>{
                            if (clipId === newClipId) robotAppsService.send("RobotInstructionSelector/ClipSelector/onNewClipSelected", {
                                sequence: sequence,
                                instruction: instruction
                            });
                            else robotAppsService.send("RobotInstructionSelector/ClipSelector/onClipSelected", {
                                sequence: sequence,
                                instruction: instruction,
                                clipId: clipId
                            });
                        },
                        onClipMounted: (clipId)=>{
                            if (clipId === newClipId) robotAppsService.send("RobotInstructionSelector/ClipSelector/onNewClipMounted", {
                                sequence: sequence,
                                instruction: instruction
                            });
                            else robotAppsService.send("RobotInstructionSelector/ClipSelector/onClipMounted", {
                                instruction: instruction,
                                clipId: clipId
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    borderBottom: "0.5px solid rgb(160, 160, 160)",
                    margin: "0 -0.65rem"
                }
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    display: "grid"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                    onClick: onCollapseToggleClick,
                    style: {
                        textAlign: "right",
                        border: "none",
                        background: "none",
                        fontSize: "14px",
                        color: "#1C344F",
                        cursor: "pointer",
                        margin: `0.5rem 1rem ${areRobotCommandsOpened ? "0rem" : "0.5rem"}`,
                        alignSelf: "flex-end"
                    },
                    children: areRobotCommandsOpened ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                        children: [
                            "Hide commands ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                className: "fas fa-chevron-up"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                        children: [
                            "Show commands ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                className: "fas fa-chevron-down"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, ($parcel$interopDefault($gXNCa$reactcollapsible))), {
                open: areRobotCommandsOpened,
                children: [
                    selectedClip?.id && getExecutionReferenceFrame() && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $412c4cb105f2bacf$export$2e2bcd8739ae039), {
                                referenceFrame: getExecutionReferenceFrame(),
                                referenceFrameLabel: "LOCAL REFERENCE FRAME",
                                isEditingReferenceFrame: robotAppsService.selectors.getRobotAppsServiceState().matches("app.creatingReferenceFrame"),
                                onReferenceFrameCreate: ()=>robotAppsService.send("RobotInstructionSelector/ReferenceFrameCreator/onReferenceFrameCreate", {
                                        instruction: instruction,
                                        robotClip: selectedClip
                                    }),
                                onExitReferenceFrameCreate: ()=>robotAppsService.send("RobotInstructionSelector/onExitReferenceFrameCreate", {
                                        instruction: instruction,
                                        robotClip: selectedClip
                                    }),
                                onReferenceFrameToolTipClick: ()=>tooltips.showTips("local_reference_frame")
                            }),
                            selectedClip?.keyframes.map((keyframe, index)=>{
                                const keyframePlayState = robotSimulationState?.state === "running" && robotSimulationState?.instructionIndex === instructionIndex && keyframe.id === robotSimulationState?.keyframeId ? "running" : "completed";
                                const isValidWaypoint = keyframe.waypoint && keyframe.waypoint.ignoreReferenceFrame ? true : keyframe.waypoint && manipRobotState ? manipRobotState.validatePoseWaypoint({
                                    vid: robotActuatorVID,
                                    pose: (0, $ca0dfdf8b548132d$export$2e2bcd8739ae039)({
                                        ArrayMatrix__endEffectorFrame_world: Array.isArray(keyframe.waypoint.pose) ? keyframe.waypoint.pose : keyframe.waypoint.pose.toArray(),
                                        ArrayMatrix__teachingReferenceFrame_world: selectedClip?.teachingReferenceFrame.arrayMatrix__referenceFrame_world,
                                        ArrayMatrix__executionReferenceFrame_world: getExecutionReferenceFrame().arrayMatrix__referenceFrame_world
                                    })
                                }) : false;
                                const uniqueKey = selectedClip.id + index;
                                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$react))).Fragment, {
                                    children: keyframe.waypoint ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $09dbe9e4f8df3d60$export$2e2bcd8739ae039), {
                                        containerStyle: keyframe.isSelected && (0, ($parcel$interopDefault($gXNCa$lodash))).isEqual(keyframe.selectedReferenceFrame, getExecutionReferenceFrame()) ? {
                                            ...$7ca9b06a9a4e8110$var$selectedKeyframeStyle
                                        } : {
                                            ...$7ca9b06a9a4e8110$var$defaultKeyframeStyle
                                        },
                                        item: {
                                            ...keyframe,
                                            index: index
                                        },
                                        warningIcon: isValidWaypoint ? null : $7ca9b06a9a4e8110$var$getTooltipWarningIcon(),
                                        onClick: ()=>robotAppsService.send("RobotInstructionSelector/onWaypointClicked", {
                                                robotClip: selectedClip,
                                                keyframeIndex: index,
                                                isValidWaypoint: isValidWaypoint,
                                                executionReferenceFrame: getExecutionReferenceFrame()
                                            }),
                                        playState: keyframePlayState
                                    }, uniqueKey) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $105e2418246a892f$export$2e2bcd8739ae039), {
                                        item: {
                                            ...keyframe,
                                            index: index
                                        },
                                        robotType: robotType,
                                        playState: keyframePlayState
                                    }, uniqueKey)
                                }, uniqueKey);
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                        style: {
                            paddingRight: "0.65rem"
                        },
                        onClick: (event)=>{
                            event.stopPropagation();
                            robotAppsService.send("RobotInstructionSelector/StyledDeleteButton/onClick", {
                                sequence: sequence,
                                instruction: instruction
                            });
                        },
                        "data-cy": "delete-read-only-robot-path"
                    })
                ]
            })
        ]
    });
}



function $8c0c7fef442bff47$export$185802fd694ee1f5({ sequence: sequence , instruction: instruction , robotUtils: robotUtils , robotAppsService: robotAppsService , manipRobotState: manipRobotState , tooltips: tooltips , getJointLimits: getJointLimits , getRobotActuatorVID: getRobotActuatorVID , getSelectedClip: getSelectedClip , getExecutionReferenceFrame: getExecutionReferenceFrame , getCalibrationReferenceFrame: getCalibrationReferenceFrame , getRobotSimulationState: getRobotSimulationState , getInstructionIndex: getInstructionIndex , isLocalSequenceClip: isLocalSequenceClip , childrenApis: { common: { validatePoseWaypoint: validatePoseWaypoint  } , selector: selector , editable: { getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame , get___matrix__endEffector_referenceFrame__translation: get___matrix__endEffector_referenceFrame__translation , get___matrix__endEffector_referenceFrame__rotation: get___matrix__endEffector_referenceFrame__rotation , getJointAngles: getJointAngles , getMatrixEndEffectorFromWorld: getMatrixEndEffectorFromWorld , getJointAnglesDegrees: getJointAnglesDegrees  }  }  }, reactComponentjQueryRootElement) {
    function RobotInstructionWidget() {
        // NOTE these are considered as props
        const robotActuatorVID = getRobotActuatorVID();
        const selectedClip = getSelectedClip();
        const calibrationReferenceFrame = getCalibrationReferenceFrame();
        const robotSimulationState = getRobotSimulationState();
        const instructionIndex = getInstructionIndex();
        (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotInstruction/onMount", {
                idxFunc: idxFunc
            }), (idxFunc)=>robotAppsService.send("RobotInstruction/onUnmount", {
                idxFunc: idxFunc
            }));
        // UI state
        const [areRobotCommandsOpened, toggleAreRobotCommandsOpened] = (0, $d3bbe4bc45b4a8e8$export$cbe85ee05b554577)(true);
        const [isCalibrationReferenceFrameOpened, toggleCalibrationReferenceFrameOpened] = (0, $d3bbe4bc45b4a8e8$export$cbe85ee05b554577)(false);
        robotAppsService.send("RobotInstruction/onRender", {
            instruction: instruction,
            instructionIndex: instructionIndex
        });
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
            children: isLocalSequenceClip(selectedClip) ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $90c9c147dc5ed8c0$export$2e2bcd8739ae039), {
                robotUtils: robotUtils,
                robotAppsService: robotAppsService,
                manipRobotState: manipRobotState,
                sequence: sequence,
                instruction: instruction,
                robotActuatorVID: robotActuatorVID,
                selectedClip: selectedClip,
                instructionIndex: instructionIndex,
                robotSimulationState: robotSimulationState,
                jointLimits: getJointLimits(),
                tooltips: tooltips,
                validatePoseWaypoint: validatePoseWaypoint,
                getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame,
                get___matrix__endEffector_referenceFrame__translation: get___matrix__endEffector_referenceFrame__translation,
                get___matrix__endEffector_referenceFrame__rotation: get___matrix__endEffector_referenceFrame__rotation,
                getJointAngles: getJointAngles,
                getMatrixEndEffectorFromWorld: getMatrixEndEffectorFromWorld,
                getJointAnglesDegrees: getJointAnglesDegrees,
                getUniqueClipName: (0, $1d3cf5330bb207de$export$64c313e59f94d976)(sequence.mApp),
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $bfdf450689e65c89$export$2e2bcd8739ae039), {
                    referenceFrames: robotUtils.ArrayOf_VID_x_Name__getCalibrationParts(),
                    selectedReferenceFrame: calibrationReferenceFrame,
                    isCalibrationReferenceFrameOpened: isCalibrationReferenceFrameOpened,
                    onReferenceFrameSelected: (selectedReferenceFrameName)=>robotAppsService.send("RobotInstructionEditable/CalibrationReferenceFrameSelector/onReferenceFrameSelected", {
                            instruction: instruction,
                            selectedReferenceFrameName: selectedReferenceFrameName
                        }),
                    onCalibrationReferenceFrameCollapseToggleClick: toggleCalibrationReferenceFrameOpened,
                    onCalibrationReferenceFrameToolTipClick: ()=>tooltips.showTips("digital_calibration_tools")
                })
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $7ca9b06a9a4e8110$export$2e2bcd8739ae039), {
                "data-cy": "robot-path-selector",
                ...selector,
                robotUtils: robotUtils,
                robotAppsService: robotAppsService,
                manipRobotState: manipRobotState,
                sequence: sequence,
                instruction: instruction,
                robotActuatorVID: robotActuatorVID,
                instructionIndex: instructionIndex,
                clipOptions: [
                    ...sequence?.mApp?.robotParameters?.clips || [],
                    {
                        name: "Create new sequence",
                        id: (0, $49b61417b640529d$export$c45596821edb3bba)
                    }
                ],
                getExecutionReferenceFrame: getExecutionReferenceFrame,
                selectedClip: selectedClip,
                areRobotCommandsOpened: areRobotCommandsOpened,
                newClipId: (0, $49b61417b640529d$export$c45596821edb3bba),
                robotSimulationState: robotSimulationState,
                tooltips: tooltips,
                onCollapseToggleClick: toggleAreRobotCommandsOpened,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $bfdf450689e65c89$export$2e2bcd8739ae039), {
                    referenceFrames: robotUtils.ArrayOf_VID_x_Name__getCalibrationParts(),
                    selectedReferenceFrame: calibrationReferenceFrame,
                    isCalibrationReferenceFrameOpened: isCalibrationReferenceFrameOpened,
                    onReferenceFrameSelected: (selectedReferenceFrameName)=>robotAppsService.send("RobotInstructionEditable/CalibrationReferenceFrameSelector/onReferenceFrameSelected", {
                            instruction: instruction,
                            selectedReferenceFrameName: selectedReferenceFrameName
                        }),
                    onCalibrationReferenceFrameCollapseToggleClick: toggleCalibrationReferenceFrameOpened,
                    onCalibrationReferenceFrameToolTipClick: ()=>tooltips.showTips("digital_calibration_tools")
                })
            })
        });
    }
    reactComponentjQueryRootElement.on("remove", ()=>(0, ($parcel$interopDefault($gXNCa$reactdom))).unmountComponentAtNode(reactComponentjQueryRootElement[0]));
    (0, ($parcel$interopDefault($gXNCa$reactdom))).render(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)(RobotInstructionWidget, {}), reactComponentjQueryRootElement[0]);
    return reactComponentjQueryRootElement;
}


var $00ddc4799a8e92a9$exports = {};

$parcel$export($00ddc4799a8e92a9$exports, "create", () => $00ddc4799a8e92a9$export$185802fd694ee1f5);
/**
 * This module contains the UI
 * to build the robot loop instruction
 */ 






function $00ddc4799a8e92a9$export$185802fd694ee1f5({ sequence: sequence , instruction: instruction , instructionIndex: instructionIndex , robotAppsService: robotAppsService , tooltips: tooltips  }, reactComponentjQueryRootElement) {
    const sequenceNames = sequence?.mApp?.listSequences()?.filter((seqName)=>sequence.getName() != seqName && sequence?.mApp?.getInitialSequence()?.getName() != seqName);
    /* eslint no-unused-vars:0 */ function RobotLoopInstructionWidget() {
        const setInitialChildSequence = function() {
            instruction.setParameter("sequenceName", sequenceNames[0]);
            return instruction.getParameter("sequenceName");
        };
        const storedStartFrom = instruction.getParameter("startFrom");
        const storedSequenceName = instruction.getParameter("sequenceName") ? instruction.getParameter("sequenceName") : setInitialChildSequence();
        const [startFrom, setStartFrom] = (0, $gXNCa$react.useState)(storedStartFrom);
        const [sequenceName, setSequenceName] = (0, $gXNCa$react.useState)(storedSequenceName);
        const robotSimulationState = instruction.robotSimulationState;
        const applicationParameters = sequence?.mApp.getParametersObject().listParametersName();
        const autocompleteArray = applicationParameters.map((applicationParameter)=>({
                label: applicationParameter
            }));
        (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotLoopInstruction/onMount", {
                idxFunc: idxFunc
            }), (idxFunc)=>robotAppsService.send("RobotLoopInstruction/onUnmount", {
                idxFunc: idxFunc
            }));
        const instructionPlayState = robotSimulationState?.state === "running" ? "running" : "completed";
        function preventResetOnBlur(state, changes) {
            switch(changes.type){
                // Don't clear the field value when we leave the field
                case (0, ($parcel$interopDefault($gXNCa$downshift))).stateChangeTypes.blurInput:
                case (0, ($parcel$interopDefault($gXNCa$downshift))).stateChangeTypes.mouseUp:
                    return {
                        isOpen: false
                    };
                case (0, ($parcel$interopDefault($gXNCa$downshift))).stateChangeTypes.touchEnd:
                    return {
                        ...changes,
                        isOpen: true
                    };
                default:
                    return changes;
            }
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "ml_card bordered spaced",
            style: {
                zIndex: 1,
                padding: "0"
            },
            onClick: ()=>robotAppsService.send("RobotLoopInstruction/onCardClick", {
                    instruction: instruction
                }),
            onTouchStart: ()=>robotAppsService.send("RobotLoopInstruction/onCardClick", {
                    instruction: instruction
                }),
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                iconClassName: "icon-loop",
                index: instructionIndex + 1,
                playState: instructionPlayState,
                "data-cy": "robot-loop-card",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $beb4189ab310535e$export$2e2bcd8739ae039), {
                            arrays: sequence?.mApp?.robotParameters?.arrays,
                            selectedArrayId: instruction.getParameter("arrayId") || undefined,
                            onArraySelected: (arrayId)=>robotAppsService.send("RobotLoopInstruction/onArraySelected", {
                                    arrayId: arrayId,
                                    application: sequence?.mApp,
                                    instruction: instruction
                                }),
                            label: "For every point in",
                            onArraySelectorToolTipClick: ()=>tooltips.showTips("robot_loop")
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "ml_robot_loop ml_condition_statement_layout",
                        style: {
                            gap: "0.6rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                                style: {
                                    alignSelf: "center",
                                    fontSize: "1rem"
                                },
                                children: "DO"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "h_layout ml_execute_statement_layout",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "icon-trigger",
                                        style: {
                                            alignSelf: "flex-end",
                                            fontSize: "1.5rem",
                                            padding: "0 0.25rem 0.25rem 0",
                                            marginTop: 10
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "ml_parameter v_layout spaced",
                                        style: {
                                            flex: "1 1 0%",
                                            lineHeight: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "h_layout",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                                                    className: "ml_widget_label",
                                                    children: "Execute"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "ml_parameter_widget ml_loop_execute_widget",
                                                children: "In Series"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "ml_parameter v_layout spaced",
                                        style: {
                                            flex: "1 1 0%",
                                            lineHeight: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "h_layout",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                                                    className: "ml_widget_label",
                                                    children: "Sequence Name"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                                                optionItems: sequenceNames,
                                                value: sequenceName,
                                                onChange: (event)=>{
                                                    setSequenceName(event.target.value);
                                                    robotAppsService.send("RobotLoopInstruction/onChildSequenceNameChange", {
                                                        instruction: instruction,
                                                        sequenceName: event.target.value
                                                    });
                                                },
                                                onSelect: (sequenceName)=>{
                                                    setSequenceName(sequenceName);
                                                    robotAppsService.send("RobotLoopInstruction/onChildSequenceNameChange", {
                                                        instruction: instruction,
                                                        sequenceName: sequenceName
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "ml_robot_loop ml_condition_statement_layout",
                        style: {
                            gap: "0.6rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                                style: {
                                    alignSelf: "center",
                                    fontSize: "1rem"
                                },
                                children: "START FROM"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "h_layout ml_execute_statement_layout",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        style: {
                                            alignSelf: "flex-end",
                                            fontSize: "1.5rem",
                                            padding: "0 0.25rem 0.25rem 0",
                                            marginTop: 10
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "ml_parameter v_layout spaced",
                                        style: {
                                            flex: "1 1 0%",
                                            lineHeight: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "h_layout",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                                                    className: "ml_widget_label",
                                                    children: "Execution Point"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$downshift))), {
                                                    onChange: (selectedStartFrom)=>{
                                                        setStartFrom(selectedStartFrom.label);
                                                        robotAppsService.send("RobotLoopInstruction/onStartFromChange", {
                                                            instruction: instruction,
                                                            startFrom: startFrom,
                                                            application: sequence?.mApp,
                                                            setStartFrom: setStartFrom
                                                        });
                                                    },
                                                    itemToString: (item)=>item ? item.label : "",
                                                    inputValue: String(startFrom),
                                                    onInputValueChange: (value, stateHelpers)=>{
                                                        if (stateHelpers.type !== (0, ($parcel$interopDefault($gXNCa$downshift))).stateChangeTypes.touchEnd) setStartFrom(value);
                                                    },
                                                    stateReducer: preventResetOnBlur,
                                                    children: ({ getInputProps: getInputProps , getItemProps: getItemProps , getMenuProps: getMenuProps , isOpen: isOpen , inputValue: inputValue , highlightedIndex: highlightedIndex , selectedItem: selectedItem  })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                                                    ...getInputProps({
                                                                        style: {
                                                                            border: "1px" + (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).greyscale_0,
                                                                            borderRadius: "0.15rem",
                                                                            fontFamily: "Larsseit",
                                                                            fontSize: "0.7rem",
                                                                            padding: "0.2rem 0.5rem",
                                                                            height: "28px"
                                                                        },
                                                                        onBlur: ()=>{
                                                                            robotAppsService.send("RobotLoopInstruction/onStartFromChange", {
                                                                                instruction: instruction,
                                                                                startFrom: startFrom,
                                                                                application: sequence?.mApp,
                                                                                setStartFrom: setStartFrom
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                                                                    ...getMenuProps({
                                                                        style: {
                                                                            fontSize: "70%",
                                                                            borderRadius: "3px",
                                                                            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                                                            background: "rgba(255, 255, 255, 0.9)",
                                                                            padding: "2px 7px",
                                                                            position: "absolute",
                                                                            overflow: "auto",
                                                                            zIndex: "2",
                                                                            width: "120px",
                                                                            margin: "0"
                                                                        }
                                                                    }),
                                                                    children: autocompleteArray.filter((item)=>!inputValue || item.label.toLowerCase().includes(inputValue.toLowerCase())).map((item, index)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                                                                            ...getItemProps({
                                                                                key: item.label,
                                                                                index: index,
                                                                                item: item,
                                                                                style: {
                                                                                    backgroundColor: highlightedIndex === index ? "lightgray" : "white",
                                                                                    fontWeight: selectedItem === item ? "bold" : "normal"
                                                                                }
                                                                            }),
                                                                            children: item.label
                                                                        }, item.label))
                                                                }) : null
                                                            ]
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                        style: {
                            marginRight: "0.25rem"
                        },
                        onClick: ()=>robotAppsService.send("RobotLoopInstruction/StyledDeleteButton/onClick", {
                                sequence: sequence,
                                instruction: instruction
                            }),
                        onTouchStart: ()=>robotAppsService.send("RobotLoopInstruction/StyledDeleteButton/onClick", {
                                sequence: sequence,
                                instruction: instruction
                            })
                    })
                ]
            })
        });
    }
    (0, ($parcel$interopDefault($gXNCa$reactdom))).render(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)(RobotLoopInstructionWidget, {}), reactComponentjQueryRootElement[0]);
    return reactComponentjQueryRootElement;
}


var $ed1bbdf4286a076f$exports = {};

$parcel$export($ed1bbdf4286a076f$exports, "create", () => $ed1bbdf4286a076f$export$185802fd694ee1f5);
/**
 * This module contains the UI
 * to build the robot loop instruction
 */ 






function $ed1bbdf4286a076f$export$185802fd694ee1f5({ sequence: sequence , instruction: instruction , robotAppsService: robotAppsService , tooltips: tooltips  }, reactComponentjQueryRootElement) {
    const sequenceNames = sequence?.mApp?.listSequences()?.filter((seqName)=>sequence.getName() != seqName && sequence?.mApp?.getInitialSequence()?.getName() != seqName);
    /* eslint no-unused-vars:0 */ function RobotLoopInstructionWidget() {
        const setInitialChildSequence = function() {
            instruction.setParameter("sequenceName", sequenceNames[0]);
            return instruction.getParameter("sequenceName");
        };
        const storedStartFrom = instruction.getParameter("startFrom");
        const storedSequenceName = instruction.getParameter("sequenceName") ? instruction.getParameter("sequenceName") : setInitialChildSequence();
        const [startFrom, setStartFrom] = (0, $gXNCa$react.useState)(storedStartFrom);
        const [sequenceName, setSequenceName] = (0, $gXNCa$react.useState)(storedSequenceName);
        const robotSimulationState = instruction.robotSimulationState;
        const applicationParameters = sequence?.mApp.getParametersObject().listParametersName();
        const autocompleteArray = applicationParameters.map((applicationParameter)=>({
                label: applicationParameter
            }));
        (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotLoopInstruction/onMount", {
                idxFunc: idxFunc
            }), (idxFunc)=>robotAppsService.send("RobotLoopInstruction/onUnmount", {
                idxFunc: idxFunc
            }));
        const instructionPlayState = robotSimulationState?.state === "running" ? "running" : "completed";
        function preventResetOnBlur(state, changes) {
            switch(changes.type){
                // Don't clear the field value when we leave the field
                case (0, ($parcel$interopDefault($gXNCa$downshift))).stateChangeTypes.blurInput:
                case (0, ($parcel$interopDefault($gXNCa$downshift))).stateChangeTypes.mouseUp:
                    return {
                        isOpen: false
                    };
                default:
                    return changes;
            }
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            "data-cy": "robot-loop-instruction",
            className: "ml_card bordered spaced",
            style: {
                zIndex: 1
            },
            onClick: ()=>robotAppsService.send("RobotLoopInstruction/onCardClick", {
                    instruction: instruction
                }),
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                index: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                    className: "ml_number"
                }),
                iconClassName: "icon-loop",
                playState: instructionPlayState,
                style: {
                    padding: "0"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$1d41361302b577a1), {
                        style: {
                            paddingLeft: "0.65rem"
                        },
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $beb4189ab310535e$export$2e2bcd8739ae039), {
                            arrays: sequence?.mApp?.robotParameters?.arrays,
                            selectedArrayId: instruction.getParameter("arrayId") || undefined,
                            onArraySelected: (arrayId)=>robotAppsService.send("RobotLoopInstruction/onArraySelected", {
                                    arrayId: arrayId,
                                    application: sequence?.mApp,
                                    instruction: instruction
                                }),
                            label: "For every point in",
                            onArraySelectorToolTipClick: ()=>tooltips.showTips("robot_loop")
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "ml_robot_loop ml_condition_statement_layout",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                                style: {
                                    alignSelf: "center",
                                    fontSize: "1rem"
                                },
                                children: "DO"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "h_layout ml_execute_statement_layout",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "icon-trigger",
                                        style: {
                                            alignSelf: "flex-end",
                                            fontSize: "1.5rem",
                                            padding: "0 0.25rem 0.25rem 0",
                                            marginTop: 10
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "ml_parameter v_layout spaced",
                                        style: {
                                            flex: "1 1 0%",
                                            lineHeight: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "h_layout",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                                                    className: "ml_widget_label",
                                                    children: "Execute"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "ml_parameter_widget ml_loop_execute_widget",
                                                children: "In Series"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "ml_parameter v_layout spaced",
                                        style: {
                                            flex: "1 1 0%",
                                            lineHeight: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "h_layout",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                                                    className: "ml_widget_label",
                                                    children: "Sequence Name"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e7e6b99c949fd18a), {
                                                optionItems: sequenceNames,
                                                value: sequenceName,
                                                onChange: (event)=>{
                                                    setSequenceName(event.target.value);
                                                    robotAppsService.send("RobotLoopInstruction/onChildSequenceNameChange", {
                                                        instruction: instruction,
                                                        sequenceName: event.target.value
                                                    });
                                                },
                                                onSelect: (sequenceName)=>{
                                                    setSequenceName(sequenceName);
                                                    robotAppsService.send("RobotLoopInstruction/onChildSequenceNameChange", {
                                                        instruction: instruction,
                                                        sequenceName: sequenceName
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "ml_robot_loop ml_condition_statement_layout",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                                style: {
                                    alignSelf: "center",
                                    fontSize: "1rem"
                                },
                                children: "START FROM"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "h_layout ml_execute_statement_layout",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        style: {
                                            alignSelf: "flex-end",
                                            fontSize: "1.5rem",
                                            padding: "0 0.25rem 0.25rem 0",
                                            marginTop: 10
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "ml_parameter v_layout spaced",
                                        style: {
                                            flex: "1 1 0%",
                                            lineHeight: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "h_layout",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                                                    className: "ml_widget_label",
                                                    children: "Execution Point"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, ($parcel$interopDefault($gXNCa$downshift))), {
                                                onChange: (selectedStartFrom)=>{
                                                    setStartFrom(selectedStartFrom.label);
                                                    robotAppsService.send("RobotLoopInstruction/onStartFromChange", {
                                                        instruction: instruction,
                                                        startFrom: startFrom,
                                                        application: sequence?.mApp,
                                                        setStartFrom: setStartFrom
                                                    });
                                                },
                                                itemToString: (item)=>item ? item.label : "",
                                                inputValue: String(startFrom),
                                                onInputValueChange: (value)=>setStartFrom(value),
                                                stateReducer: preventResetOnBlur,
                                                children: ({ getInputProps: getInputProps , getItemProps: getItemProps , getMenuProps: getMenuProps , isOpen: isOpen , inputValue: inputValue , highlightedIndex: highlightedIndex , selectedItem: selectedItem  })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                                                ...getInputProps({
                                                                    style: {
                                                                        border: "1px" + (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).greyscale_0,
                                                                        borderRadius: "0.15rem",
                                                                        fontFamily: "Larsseit",
                                                                        fontSize: "0.7rem",
                                                                        padding: "0.2rem 0.5rem",
                                                                        height: "28px"
                                                                    },
                                                                    onBlur: ()=>{
                                                                        robotAppsService.send("RobotLoopInstruction/onStartFromChange", {
                                                                            instruction: instruction,
                                                                            startFrom: startFrom,
                                                                            application: sequence?.mApp,
                                                                            setStartFrom: setStartFrom
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            isOpen ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                                                                ...getMenuProps({
                                                                    style: {
                                                                        fontSize: "70%",
                                                                        borderRadius: "3px",
                                                                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                                                        background: "rgba(255, 255, 255, 0.9)",
                                                                        padding: "2px 7px",
                                                                        position: "fixed",
                                                                        overflow: "auto",
                                                                        zIndex: "2",
                                                                        width: "120px"
                                                                    }
                                                                }),
                                                                children: autocompleteArray.filter((item)=>!inputValue || item.label.includes(inputValue)).map((item, index)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                                                                        ...getItemProps({
                                                                            key: item.label,
                                                                            index: index,
                                                                            item: item,
                                                                            style: {
                                                                                backgroundColor: highlightedIndex === index ? "lightgray" : "white",
                                                                                fontWeight: selectedItem === item ? "bold" : "normal"
                                                                            }
                                                                        }),
                                                                        children: item.label
                                                                    }, item.label))
                                                            }) : null
                                                        ]
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$e5aa014779ff2b01), {
                        style: {
                            paddingRight: "0.65rem"
                        },
                        onClick: ()=>robotAppsService.send("RobotLoopInstruction/StyledDeleteButton/onClick", {
                                sequence: sequence,
                                instruction: instruction
                            })
                    })
                ]
            })
        });
    }
    (0, ($parcel$interopDefault($gXNCa$reactdom))).render(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)(RobotLoopInstructionWidget, {}), reactComponentjQueryRootElement[0]);
    return reactComponentjQueryRootElement;
}


/**
 * robotTypeFormatUR.
 * format string ur3_e to UR3e
 *
 * @param {string} robotType
 * @returns {string}
 */ const $b2581f98af3b5a81$var$robotTypeFormatUR = (robotType)=>{
    if (!/^ur/i.test(robotType)) return robotType;
    return robotType.replace(/^ur/, "UR").replace(/_/, "");
};
var $b2581f98af3b5a81$export$2e2bcd8739ae039 = $b2581f98af3b5a81$var$robotTypeFormatUR;














const $4c342ce2d960949f$var$connectionToColorEnum = Object.freeze({
    connecting: "link_secondary",
    disconnecting: "link_secondary",
    connected: "green",
    disconnected: "yellow_secondary"
});
/**
 * @param {{
 *   robotTypes: string[],
 *   selectedRobotType: string,
 *   onChange: (selectedRobotType: string) => void
 * }} props
 */ function $4c342ce2d960949f$var$RobotTypeSelector({ robotTypes: robotTypes , selectedRobotType: selectedRobotType , onChange: onChange  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "ml_parameter v_layout spaced ml_sensor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "h_layout",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "ml_error_icon icon-help"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        className: "ml_widget_label",
                        children: "Robot Model"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "ml_select_widget",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("select", {
                    data: "select robot model",
                    className: selectedRobotType,
                    title: "Select robot type",
                    value: selectedRobotType,
                    onChange: (event)=>{
                        onChange(event.target.value);
                    },
                    children: robotTypes.map((robotType)=>{
                        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                            style: {
                                color: "black"
                            },
                            value: robotType || null,
                            children: (0, $b2581f98af3b5a81$export$2e2bcd8739ae039)(robotType)
                        }, robotType);
                    })
                })
            })
        ]
    });
}
/**
 * @param {{
 *   robotTypes: string[],
 *   config: import('../../model/types').MachineLogicRobotConfig,
 * }} props
 */ function $4c342ce2d960949f$var$RobotConfigWidget({ robotTypes: robotTypes , config: config  }) {
    const { parameters: { robotType: robotType , friendlyName: friendlyName  }  } = (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotConfig() || {};
    const ventionRosConnectionStatus = (0, $e9a5479fa42b7804$export$e1252723db1c541).getVentionRosConnectionState();
    const connectedRobotType = (0, $b2581f98af3b5a81$export$2e2bcd8739ae039)((0, $e9a5479fa42b7804$export$e1252723db1c541).getConnectedRobotType());
    const dispatch = (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch();
    const isVentionRosConnecting = (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosConnecting();
    const isVentionRosConnected = (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosConnected();
    const isVentionRosDisconnecting = (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosDisconnecting();
    const isVentionRosDisconnected = (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosDisconnected();
    const isVentionRosUnexpectedlyDisconnected = (0, $e9a5479fa42b7804$export$e1252723db1c541).isVentionRosUnexpectedlyDisconnected();
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>dispatch("RobotConfig/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>dispatch("RobotConfig/onUnmount", {
            idxFunc: idxFunc
        }));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($4c342ce2d960949f$var$RobotTypeSelector, {
                            robotTypes: robotTypes,
                            selectedRobotType: robotType,
                            onChange: (robotType)=>dispatch({
                                    type: "RobotConfig/RobotTypeSelector/onChange",
                                    robotType: robotType
                                })
                        }),
                        !isVentionRosUnexpectedlyDisconnected && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            style: {
                                display: "flex"
                            },
                            children: [
                                (isVentionRosConnecting || isVentionRosDisconnecting) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $07d46ce7ddfaf179$export$2e2bcd8739ae039), {
                                    style: {
                                        alignSelf: "center"
                                    },
                                    type: "Oval",
                                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).light_green,
                                    secondaryColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).light_grey,
                                    height: 26,
                                    width: 26,
                                    radius: 13
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        isVentionRosConnected && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $8f0ef92b0addb015$export$2e2bcd8739ae039), {}),
                                        isVentionRosDisconnected && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $dd025f0f94b30b63$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                            style: {
                                                color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039)[$4c342ce2d960949f$var$connectionToColorEnum[ventionRosConnectionStatus]],
                                                fontSize: "0.75rem"
                                            },
                                            children: [
                                                "  ",
                                                "\xa0",
                                                connectedRobotType,
                                                " Robot ",
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                                    style: {
                                                        textTransform: "capitalize"
                                                    },
                                                    children: [
                                                        " ",
                                                        ventionRosConnectionStatus,
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $a2bde123201d8861$export$92102e06f68899d9), {
                    style: {
                        margin: "unset"
                    },
                    robotName: friendlyName,
                    onBlur: (robotName)=>dispatch({
                            type: "RobotConfig/RobotName/onChange",
                            config: config,
                            robotName: robotName
                        }),
                    onChange: (robotName)=>dispatch({
                            type: "RobotConfig/RobotName/onChange",
                            config: config,
                            robotName: robotName
                        })
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {}),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    gridTemplateColumns: "1fr",
                    gridColumn: "col / span 3",
                    gridRow: "row 2"
                },
                children: isVentionRosUnexpectedlyDisconnected && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                    gridTemplateColumns: "auto 1fr",
                    gap: "10px",
                    padding: "0",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            style: {
                                color: "red",
                                fontSize: 20,
                                verticalAlign: "text-bottom"
                            },
                            className: "icon-warning"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            style: {
                                color: "red",
                                fontSize: 12,
                                lineHeight: "normal"
                            },
                            children: "Robot unexpectedly disconnected. Verify your robot setup by deleting this card then press “Apply all configurations”. Re-add your robot configuration and press “Apply all configurations” again."
                        })
                    ]
                })
            })
        ]
    });
}
var $4c342ce2d960949f$export$2e2bcd8739ae039 = $4c342ce2d960949f$var$RobotConfigWidget;







function $91ad6c17f63e26bf$var$RobotName({ robotName: robotName , onChange: onChange , style: style  }) {
    const [name, setName] = (0, $gXNCa$react.useState)("");
    const [, setPreviousName] = (0, $gXNCa$react.useState)("");
    (0, $gXNCa$react.useEffect)(function() {
        setName(robotName || "");
    }, [
        robotName
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "ml_parameter v_layout spaced ml_sensor",
        style: {
            marginBottom: "15px",
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "h_layout",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "ml_error_icon icon-help"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        className: "ml_widget_label",
                        children: "Robot Name"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "text",
                className: "ml_parameter_widget truncated_text",
                title: "Robot name",
                value: name,
                maxLength: 30,
                onChange: (event)=>{
                    setName(event.target.value);
                    onChange(event.target.value);
                },
                onFocus: (event)=>{
                    setPreviousName(event.target.value);
                },
                "data-cy": "change-robot-name"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "ml_input_validation_error"
            })
        ]
    });
}
var $91ad6c17f63e26bf$export$2e2bcd8739ae039 = $91ad6c17f63e26bf$var$RobotName;



/**
 * @typedef {"ur3_e" | "ur5_e" | "ur10_e" | "ur16_e" | "doosan_h2515" | "doosan_h2017" | "crx10ia" | "crx10ial" | ""} RobotType
 */ /**
 * @param {RobotType[]} robotTypes - An array of robot types.
 * @param {(RobotType) => import('../../model/VID').VID[]} getRobotVidsOfType - A function that takes a robot type as input
 * and returns an array of actuator VIDs.
 * @returns {number} The first robot actuator VID found in the robot types array,
 * or -1 if no robot actuator VID is found.
 */ function $6c8a08f35ed28ea5$export$27f28bac88e0a0bc(robotTypes, getRobotVidsOfType) {
    const VIDsOfRobotActuatorsInDesign = robotTypes.flatMap(getRobotVidsOfType);
    const firstVIDIfItExists = VIDsOfRobotActuatorsInDesign?.[0];
    return firstVIDIfItExists || -1;
}



/**
 * gui_widgets_machinelogic-RobotConfigWidget.js
 * "MachineLogic's widget library's robot widget
 */ function $bf82d0717b3b7765$var$RobotConfigWidget({ p3DContext: p3DContext , pConfig: pConfig , robotVID: robotVID  }) {
    const { getDispatch: getDispatch , getIsRosConnected: getIsRosConnected  } = p3DContext.robotAppsService.selectors;
    const robotFromLibrary = pConfig.mRobots.find((robot)=>robot.mVID == robotVID);
    const configManager = pConfig.mLibrary.getConfigManager();
    const dispatch = getDispatch();
    const isRosConnected = getIsRosConnected();
    const getRobotVidsOfType = (robotType)=>configManager.getRobotVidsOfType(robotType);
    const [robot, setRobotState] = (0, ($parcel$interopDefault($gXNCa$react))).useState(robotFromLibrary);
    const robotTypes = robot.getConfig().getRobotTypes();
    const isVIDValid = $4f71ac8ef89a5f2d$export$1ea939691cdc45b8($6c8a08f35ed28ea5$export$27f28bac88e0a0bc(robotTypes, getRobotVidsOfType));
    const [selectedRobotActuatorVID, setSelectedRobotActuatorVID] = (0, ($parcel$interopDefault($gXNCa$react))).useState(Object.keys(robot.mRobotActuators)[0] ? Object.keys(robot.mRobotActuators)[0] : isVIDValid ? $6c8a08f35ed28ea5$export$27f28bac88e0a0bc(robotTypes, getRobotVidsOfType) : "");
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>dispatch("RobotConfigWidget/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>dispatch("RobotConfigWidget/onUnmount", {
            idxFunc: idxFunc
        }));
    // UseEffects
    (0, ($parcel$interopDefault($gXNCa$react))).useEffect(()=>{
        // State for robot
        robotFromLibrary.setRobotState = setRobotState;
        return ()=>{
            robotFromLibrary.setRobotState = null;
        };
    }, []);
    (0, ($parcel$interopDefault($gXNCa$react))).useEffect(()=>{
        robot.addRobotActuator(configManager.mRobotActuators[selectedRobotActuatorVID], p3DContext.robotUtils.getRobotTypeFromVID(selectedRobotActuatorVID));
        dispatch("RobotConfigWidget/RobotPartNumber/onChange");
    }, [
        selectedRobotActuatorVID
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($bf82d0717b3b7765$var$RobotPartNumber, {
                    "data-cy": "robot-part-number",
                    robotTypes: robot.getConfig().getRobotTypes(),
                    selectedRobotActuatorVID: selectedRobotActuatorVID,
                    getRobotVidsOfType: (robotType)=>configManager.getRobotVidsOfType(robotType),
                    getDisplayName: p3DContext.robotUtils.getDisplayNameFromVID,
                    onChange: (robotActuatorVID)=>{
                        //TODO: only store one robot model per configuration
                        // remove previously selected robot model
                        if (selectedRobotActuatorVID) {
                            const preSelectedId = selectedRobotActuatorVID;
                            robot.removeRobotActuator(configManager.mRobotActuators[preSelectedId]);
                        }
                        dispatch("RobotConfigWidget/RobotPartNumber/onChange");
                        setSelectedRobotActuatorVID(robotActuatorVID);
                        if (robotActuatorVID) {
                            const selectedId = robotActuatorVID;
                            robot.addRobotActuator(configManager.mRobotActuators[selectedId], p3DContext.robotUtils.getRobotTypeFromVID(robotActuatorVID));
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    isRosConnected && selectedRobotActuatorVID && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $91ad6c17f63e26bf$export$2e2bcd8739ae039), {
                        robotName: robot.mName,
                        onChange: (name)=>robot.setName(name)
                    }),
                    selectedRobotActuatorVID && !isRosConnected && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $07d46ce7ddfaf179$export$2e2bcd8739ae039), {
                        style: {
                            position: "absolute",
                            top: "45%",
                            transform: "translate(0, -50%)"
                        },
                        type: "Oval",
                        color: "#1AC876",
                        secondaryColor: "#EEEEEE",
                        height: 36,
                        width: 36,
                        radius: 18
                    })
                ]
            })
        ]
    });
}
function $bf82d0717b3b7765$var$RobotPartNumber({ robotTypes: robotTypes , selectedRobotActuatorVID: selectedRobotActuatorVID , getRobotVidsOfType: getRobotVidsOfType , getDisplayName: getDisplayName , disabled: disabled , onChange: onChange  }) {
    const isVIDValid = $4f71ac8ef89a5f2d$export$1ea939691cdc45b8($6c8a08f35ed28ea5$export$27f28bac88e0a0bc(robotTypes, getRobotVidsOfType));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "ml_parameter v_layout spaced ml_sensor",
        style: {
            marginBottom: "20px"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "h_layout",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "ml_error_icon icon-help"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                        className: "ml_widget_label",
                        children: "Robot Model"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "ml_select_widget",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("select", {
                    className: selectedRobotActuatorVID ? isVIDValid ? $6c8a08f35ed28ea5$export$27f28bac88e0a0bc(robotTypes, getRobotVidsOfType) : "ml_actuators_select_option" : "ml_actuators_select_option",
                    title: "select robot model",
                    value: selectedRobotActuatorVID ? selectedRobotActuatorVID : isVIDValid ? $6c8a08f35ed28ea5$export$27f28bac88e0a0bc(robotTypes, getRobotVidsOfType) : "Select",
                    disabled: disabled,
                    onChange: (event)=>{
                        onChange(event.target.value);
                    },
                    "data-cy": "select-robot-model",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                            className: "ml_actuators_select_option",
                            hidden: true,
                            children: "Select"
                        }),
                        robotTypes.map((robotType)=>{
                            const robotActuatorVIDs = getRobotVidsOfType(robotType);
                            if (robotActuatorVIDs.length > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("optgroup", {
                                label: robotType,
                                className: "ml_actuators_select_label",
                                children: robotActuatorVIDs.map((robotActuatorVID)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                                        value: robotActuatorVID,
                                        className: "ml_actuators_select_option",
                                        children: getDisplayName(robotActuatorVID)
                                    }, robotActuatorVID))
                            }, robotType);
                        })
                    ]
                })
            })
        ]
    });
}
var $bf82d0717b3b7765$export$2e2bcd8739ae039 = $bf82d0717b3b7765$var$RobotConfigWidget;









function $4f6d6e695b2202d1$var$ReferenceFrames({ dispatch: dispatch , shouldDisplayJogger: shouldDisplayJogger , getReferenceFrames: getReferenceFrames = ()=>[]  }) {
    const { setModal: setModal  } = (0, $gXNCa$react.useContext)((0, $e4328fa0a7dc23c8$export$ab57792b9b6974a6));
    setModal(shouldDisplayJogger);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: Object.entries(getReferenceFrames()).map(([referenceFrameId, referenceFrame])=>{
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $fc375b84455f4d9b$export$2e2bcd8739ae039), {
                containerStyle: {
                    position: "relative",
                    backgroundColor: "#FBFBFB",
                    paddingRight: "0px"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$598c1eea1a67754e), {
                    iconClassName: "icon-calibration-frame",
                    paddingRightValue: "0px",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $13573c04939367a2$export$1d41361302b577a1), {
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$579a1e9bab103f15), {
                                    label: "Reference Frame Name"
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$212aed895f9b9f10), {
                                    type: "text",
                                    defaultValue: referenceFrame.name,
                                    onChange: (event)=>dispatch("RobotAssets/ReferenceFrames/onNameChange", {
                                            referenceFrameId: referenceFrameId,
                                            name: event.target.value
                                        }),
                                    onMount: ()=>{}
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            style: {
                                textAlign: "right",
                                border: "none",
                                background: "none",
                                textDecorationLine: "underline",
                                fontSize: "14px",
                                color: "#667A99",
                                cursor: "pointer",
                                gridColumnStart: "3"
                            },
                            onClick: ()=>{
                                dispatch("RobotAssets/ReferenceFrames/onRecalibrateButtonClick", {
                                    referenceFrameId: referenceFrameId
                                });
                            },
                            onTouchStart: ()=>{
                                dispatch("RobotAssets/ReferenceFrames/onRecalibrateButtonClick", {
                                    referenceFrameId: referenceFrameId
                                });
                            },
                            disabled: false,
                            children: "Recalibrate"
                        })
                    ]
                })
            }, referenceFrameId);
        })
    });
}
function $4f6d6e695b2202d1$export$2e2bcd8739ae039({ dispatch: dispatch , shouldDisplayReferenceFramesJogger: shouldDisplayReferenceFramesJogger , getRobotSpec: getRobotSpec , getRobotState: getRobotState , getReferenceFrames: getReferenceFrames = ()=>[] , robotType: robotType , tooltips: tooltips  }) {
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>dispatch("RobotAssets/ReferenceFrames/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>dispatch("RobotAssets/ReferenceFrames/onUnmount", {
            idxFunc: idxFunc
        }));
    const onClickShowTipDigitalCalibrationFlow = ()=>{
        tooltips.showTips("digital_calibration_flow");
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $e4328fa0a7dc23c8$export$178405afcd8c5eb), {
            robotJoggerTitle: "Teach Robot Reference Frame",
            shouldDisplayRobotJoggerRobotDisconnectedOverlay: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotJoggerRobotDisconnectedOverlay(),
            shouldDisplayRobotJoggerRobotNotReadyOverlay: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotJoggerRobotNotReadyOverlay(),
            dispatch: (0, $e9a5479fa42b7804$export$e1252723db1c541).getDispatch(),
            onCloseButtonClick: ()=>{
                dispatch("RobotAssets/ReferenceFrames/onCloseButtonClick");
            },
            robotJoggerApi: {
                jointLimits: getRobotSpec().getJointLimits(),
                position: getRobotState().getPosition(),
                rotation: getRobotState().getRotation(),
                jointAngles: getRobotState().getJointAngles(),
                joggerSpeedPercentage: getRobotState().getJoggerSpeedPercentage(),
                freedriveStatus: getRobotState().getFreedriveStatus(),
                onJoggerPoseTranslationMouseDown: (letter, value)=>dispatch("RobotAssets/ReferenceFrames/onJoggerPoseTranslationMouseDown", {
                        letter: letter,
                        value: value
                    }),
                onJoggerPoseRotationMouseDown: (letter, value)=>dispatch("RobotAssets/ReferenceFrames/onJoggerPoseRotationMouseDown", {
                        letter: letter,
                        value: value
                    }),
                onJoggerJointArrowMouseDown: (index, delta)=>dispatch("RobotAssets/ReferenceFrames/onJoggerJointArrowMouseDown", {
                        index: index,
                        delta: delta
                    }),
                onJoggerArrowMouseUp: ()=>dispatch("RobotAssets/ReferenceFrames/onJoggerArrowMouseUp"),
                onSpeedSliderChange: (joggerSpeedPercentage)=>dispatch("RobotAssets/ReferenceFrames/onSpeedSliderChange", {
                        joggerSpeedPercentage: joggerSpeedPercentage
                    }),
                onTeachWaypointAndCloseButtonClick: ()=>{
                    dispatch("RobotAssets/ReferenceFrames/onTeachWaypointAndCloseButtonClick");
                },
                onEnableFreedriveButtonClick: ()=>{
                    dispatch("RobotAssets/ReferenceFrames/onEnableFreedriveButtonClick");
                },
                onDisableFreedriveButtonClick: ()=>{
                    dispatch("RobotAssets/ReferenceFrames/onDisableFreedriveButtonClick");
                },
                onToggleConstraintButtonClick: (constraintIndex)=>{
                    dispatch("RobotAssets/ReferenceFrames/onToggleConstraintButtonClick", {
                        constraintIndex: constraintIndex
                    });
                }
            },
            canDisplay: true,
            robotType: robotType,
            tooltip: ()=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                    style: {
                        marginTop: "auto",
                        marginInline: "auto",
                        alignSelf: "center",
                        marginBottom: "15px"
                    },
                    onClick: onClickShowTipDigitalCalibrationFlow,
                    onTouchStart: onClickShowTipDigitalCalibrationFlow,
                    text: "How do I calibrate?"
                }),
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($4f6d6e695b2202d1$var$ReferenceFrames, {
                dispatch: dispatch,
                shouldDisplayJogger: shouldDisplayReferenceFramesJogger(),
                getReferenceFrames: getReferenceFrames
            })
        })
    });
}






const $09297eee55ccfd1d$var$onReferenceFrameMouseEnter = (robotAppsService, vid)=>{
    robotAppsService.send("RobotAssets/CalibrationParts/onReferenceFrameMouseEnter", {
        vid: vid
    });
};
const $09297eee55ccfd1d$var$onReferenceFrameMouseLeave = (robotAppsService, vid)=>{
    robotAppsService.send("RobotAssets/CalibrationParts/onReferenceFrameMouseLeave", {
        vid: vid
    });
};
function $09297eee55ccfd1d$export$2e2bcd8739ae039({ robotAppsService: robotAppsService , getReferenceFrames: getReferenceFrames , getReferenceFrameDefaultName: getReferenceFrameDefaultName  }) {
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotAssets/CalibrationParts/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>robotAppsService.send("RobotAssets/CalibrationParts/onUnmount", {
            idxFunc: idxFunc
        }));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $c7e59276dc2fb724$export$2e2bcd8739ae039), {
        referenceFrames: getReferenceFrames(),
        robotAppsService: robotAppsService,
        getReferenceFrameDefaultName: getReferenceFrameDefaultName,
        onReferenceFramesChanged: (newReferenceFramesWithoutRobotKinematicsChainRoots)=>robotAppsService.send("RobotAssets/CalibrationParts/onReferenceFramesChanged", {
                newReferenceFramesWithoutRobotKinematicsChainRoots: newReferenceFramesWithoutRobotKinematicsChainRoots
            }),
        onReferenceFrameCreate: (onReferenceFrameCreateSet, onReferenceFrameCreateCancel)=>robotAppsService.send("RobotAssets/CalibrationParts/onReferenceFrameCreate", {
                onReferenceFrameCreateSet: onReferenceFrameCreateSet,
                onReferenceFrameCreateCancel: onReferenceFrameCreateCancel
            }),
        onReferenceFrameDelete: (vid)=>robotAppsService.send("RobotAssets/CalibrationParts/onReferenceFrameDelete", {
                vid: vid
            }),
        onReferenceFrameCreateCancel: ()=>robotAppsService.send("RobotAssets/CalibrationParts/onReferenceFrameCreateCancel"),
        onReferenceFrameMouseEnter: $09297eee55ccfd1d$var$onReferenceFrameMouseEnter,
        onReferenceFrameMouseLeave: $09297eee55ccfd1d$var$onReferenceFrameMouseLeave
    });
}






function $6333a886e3e8e911$export$2e2bcd8739ae039({ getRobotAppServiceStateValue: getRobotAppServiceStateValue , dispatch: dispatch , getRobotParametersArrays: getRobotParametersArrays , getRobotArrayNamesUsed: getRobotArrayNamesUsed  }) {
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>dispatch("RobotArrays/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>dispatch("RobotArrays/onUnmount", {
            idxFunc: idxFunc
        }));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $93927e55b73dd707$export$2e2bcd8739ae039), {
        shouldDisableEditName: true,
        initialState: getRobotParametersArrays(),
        robotArrayNamesUsed: getRobotArrayNamesUsed(),
        shouldHideDuplicateButton: true,
        shouldHideEditButton: true,
        isEditingReferenceFrame: getRobotAppServiceStateValue() === "creatingReferenceFrame",
        shouldShowAddRobotArrayButton: false,
        ReferenceFrameCreator_onArrayReferenceFrameEditClick: (array, onArrayFrameSet, onExitReferenceFrameCreate)=>dispatch("RobotAssets/RobotArrays/onArrayReferenceFrameEditClick", {
                array: array,
                onArrayFrameSet: onArrayFrameSet,
                onExitReferenceFrameCreate: onExitReferenceFrameCreate
            }),
        ReferenceFrameCreator_onExitArrayReferenceFrameCreate: ()=>dispatch("RobotAssets/RobotArrays/manip-robot-create-reference-frame/onExitReferenceFrameCreate"),
        onMount: (onReferenceFrameCreateSet, onReferenceFrameCreateCancel)=>dispatch("RobotAssets/RobotArrays/onAddRobotArray", {
                onReferenceFrameCreateSet: onReferenceFrameCreateSet,
                onReferenceFrameCreateCancel: onReferenceFrameCreateCancel
            }),
        onEditFrameDoneClick: (newArrays)=>dispatch("RobotAssets/RobotArrays/onEditFrameDoneClick", {
                newArrays: newArrays
            }),
        onGenerateClick: (payload)=>dispatch("RobotAssets/RobotArrays/onGenerateClick", {
                payload: payload
            }),
        onRegenerateClick: ({ newArrays: newArrays  })=>dispatch("RobotAssets/RobotArrays/onRegenerateClick", {
                newArrays: newArrays
            }),
        onArrayCardClick: (payload)=>dispatch("RobotAssets/RobotArrays/onArrayCardClick", {
                payload: payload
            }),
        onArrayCardEditClick: (payload)=>dispatch("RobotAssets/RobotArrays/onArrayCardEditClick", {
                payload: payload
            }),
        onPatternChange: (payload)=>dispatch("RobotAssets/RobotArrays/onPatternChange", {
                payload: payload
            }),
        onLockedDeleteClick: ()=>dispatch("RobotAssets/RobotArrays/onLockedDeleteClick"),
        onDeleteClick: (newArrays)=>dispatch("RobotAssets/RobotArrays/onDeleteClick", {
                newArrays: newArrays
            }),
        onCopyClick: (newArrays)=>dispatch("RobotAssets/RobotArrays/onCopyClick", {
                newArrays: newArrays
            })
    });
}






function $1507d1ceb475f753$export$2e2bcd8739ae039({ robotAppsService: robotAppsService , tooltips: tooltips , getRobotParametersArrays: getRobotParametersArrays , getRobotArrayNamesUsed: getRobotArrayNamesUsed  }) {
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotArrays/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>robotAppsService.send("RobotArrays/onUnmount", {
            idxFunc: idxFunc
        }));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $93927e55b73dd707$export$2e2bcd8739ae039), {
        initialState: getRobotParametersArrays(),
        robotArrayNamesUsed: getRobotArrayNamesUsed(),
        isEditingReferenceFrame: robotAppsService.selectors.isEditingArrayReferenceFrame(),
        ReferenceFrameCreator_onArrayReferenceFrameEditClick: (array, onArrayFrameSet, onExitReferenceFrameCreate)=>robotAppsService.send("RobotAssets/RobotArrays/onArrayReferenceFrameEditClick", {
                array: array,
                onArrayFrameSet: onArrayFrameSet,
                onExitReferenceFrameCreate: onExitReferenceFrameCreate
            }),
        ReferenceFrameCreator_onArrayReferenceFrameToolTipClick: ()=>tooltips.showTips("robot_array_reference_frame"),
        ReferenceFrameCreator_onExitArrayReferenceFrameCreate: (onReferenceFrameCreateCancel)=>robotAppsService.send("RobotAssets/RobotArrays/manip-robot-create-reference-frame/onReferenceFrameCreateCancel", {
                onReferenceFrameCreateCancel: onReferenceFrameCreateCancel
            }),
        onMount: (onReferenceFrameCreateSet, onReferenceFrameCreateCancel)=>robotAppsService.send("RobotAssets/RobotArrays/onAddRobotArray", {
                onReferenceFrameCreateSet: onReferenceFrameCreateSet,
                onReferenceFrameCreateCancel: onReferenceFrameCreateCancel
            }),
        onEditFrameDoneClick: (newArrays)=>robotAppsService.send("RobotAssets/RobotArrays/onEditFrameDoneClick", {
                newArrays: newArrays
            }),
        onGenerateClick: (payload)=>robotAppsService.send("RobotAssets/RobotArrays/onGenerateClick", {
                payload: payload
            }),
        onRegenerateClick: (payload)=>robotAppsService.send("RobotAssets/RobotArrays/onRegenerateClick", {
                payload: payload
            }),
        onArrayCardClick: (payload)=>robotAppsService.send("RobotAssets/RobotArrays/onArrayCardClick", {
                payload: payload
            }),
        onArrayCardEditClick: (payload)=>robotAppsService.send("RobotAssets/RobotArrays/onArrayCardEditClick", {
                payload: payload
            }),
        onArraysNameUpdated: (newArrays)=>{
            robotAppsService.send("RobotAssets/RobotArrays/onArraysNameUpdated", {
                newArrays: newArrays
            });
        },
        onPatternChange: (payload)=>robotAppsService.send("RobotAssets/RobotArrays/onPatternChange", {
                payload: payload
            }),
        onLockedDeleteClick: ()=>robotAppsService.send("RobotAssets/RobotArrays/onLockedDeleteClick"),
        onDeleteClick: (newArrays)=>robotAppsService.send("RobotAssets/RobotArrays/onDeleteClick", {
                newArrays: newArrays
            }),
        onCopyClick: (newArrays)=>robotAppsService.send("RobotAssets/RobotArrays/onCopyClick", {
                newArrays: newArrays
            })
    });
}










function $84c83556220339f7$export$2e2bcd8739ae039({ robotClips: robotClips , getRobotClips: getRobotClips , getUniqueClipName: getUniqueClipName , shouldShowAddRobotPathButton: shouldShowAddRobotPathButton = true , getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame , onRobotClipChange: onRobotClipChange , onRobotClipsChange: onRobotClipsChange , onRobotClipsChangeNoConfig: onRobotClipsChangeNoConfig , robotConfigs: robotConfigs , isEditingReferenceFrame: isEditingReferenceFrame , isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip , onJoggerCloseButtonClick: onJoggerCloseButtonClick , onWaypointAddButtonClicked: onWaypointAddButtonClicked , onDeleteClick: onDeleteClick , ...otherProps }) {
    const [clipWaypointSelectedIndex, setClipWaypointSelectedIndex] = (0, $gXNCa$react.useState)({
        clipIndex: -1,
        waypointIndex: -1
    });
    const onClickAddRobotPath = ()=>{
        const newRobotClip = $d5cc77669caa91ad$export$75ff2183706c7173();
        newRobotClip.name = getUniqueClipName("Robot path");
        newRobotClip.robotId = robotConfigs[0].mRobotId;
        newRobotClip.teachingReferenceFrame = getDefaultTeachingReferenceFrame(robotConfigs[0].mVID);
        return robotConfigs.length ? onRobotClipsChange(robotClips.concat(newRobotClip)) : onRobotClipsChangeNoConfig();
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            paddingTop: "0.65rem",
            paddingRight: "0.65rem",
            paddingBottom: "0.65rem"
        },
        children: [
            getRobotClips().map((robotClip, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $6c54d82ce9f83af4$export$2e2bcd8739ae039), {
                    onWaypointAddButtonClicked: onWaypointAddButtonClicked,
                    ...otherProps,
                    robotConfigs: robotConfigs,
                    robotClip: robotClip,
                    isAnyKeyframeInEditModeInClip: isAnyKeyframeInEditModeInClip(robotClip),
                    robotClipNames: (robotClips || []).map((clip)=>clip.name),
                    robotClipIndex: i,
                    isEditingReferenceFrame: isEditingReferenceFrame,
                    getUniqueClipName: getUniqueClipName,
                    onJoggerCloseButtonClick: onJoggerCloseButtonClick,
                    onRobotClipChange: (robotClip)=>{
                        onRobotClipChange(robotClip);
                        const newRobotClips = (0, $b7c3f63a1efa4cdf$exports).updateObjectInArray(robotClips, {
                            index: i,
                            item: robotClip
                        });
                        onRobotClipsChange(newRobotClips);
                    },
                    onCopyClick: ()=>onRobotClipsChange((0, $b7c3f63a1efa4cdf$exports).insertItem(robotClips, {
                            index: i,
                            item: JSON.parse(JSON.stringify(robotClips[i]))
                        })),
                    onDeleteClick: ()=>{
                        onDeleteClick();
                        onRobotClipsChange((0, $b7c3f63a1efa4cdf$exports).removeItem(robotClips, {
                            index: i
                        }));
                    },
                    waypointSelectedIndex: clipWaypointSelectedIndex["clipIndex"] === i ? clipWaypointSelectedIndex["waypointIndex"] : -1,
                    onWaypointSelected: (waypointIndex)=>setClipWaypointSelectedIndex({
                            clipIndex: i,
                            waypointIndex: waypointIndex
                        })
                }, robotClip.id)),
            shouldShowAddRobotPathButton && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $13573c04939367a2$export$a1e34fa9d184a3b6), {
                iconClassName: "icon-add-plus",
                text: "Add robot path",
                onClick: onClickAddRobotPath,
                onTouchStart: onClickAddRobotPath
            })
        ]
    });
}






function $753aa4a6c6a82c34$export$2e2bcd8739ae039({ application: application , jogger: jogger , robotAppsService: robotAppsService , robotConfigs: robotConfigs , tooltips: tooltips , getRobotClips: getRobotClips , getRobotClipIdsUsed: getRobotClipIdsUsed , getUniqueClipName: getUniqueClipName , getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame  }) {
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotClips/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>robotAppsService.send("RobotClips/onUnmount", {
            idxFunc: idxFunc
        }));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $84c83556220339f7$export$2e2bcd8739ae039), {
        robotConfigs: robotConfigs,
        referenceFrameLabel: "GLOBAL REFERENCE FRAME",
        getRobotClips: getRobotClips,
        getName: ()=>robotConfigs[0].parameters.friendlyName,
        shouldDisplayJogger: (0, $e9a5479fa42b7804$export$e1252723db1c541).shouldDisplayRobotClipsJogger(),
        shouldShowAddRobotPathButton: false,
        onWaypointAddButtonClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onWaypointAddButtonClicked", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onWaypointPathTypeChanged: ({ pathType: pathType , keyframeIndex: keyframeIndex , robotClip: robotClip  })=>{
            robotAppsService.send("RobotClips/onWaypointPathTypeChanged", {
                robotClip: robotClip,
                pathType: pathType,
                keyframeIndex: keyframeIndex
            });
        },
        onWaypointNameChanged: ({ name: name , keyframeIndex: keyframeIndex , robotClip: robotClip  })=>{
            robotAppsService.send("RobotClips/onWaypointNameChanged", {
                robotClip: robotClip,
                name: name,
                keyframeIndex: keyframeIndex
            });
        },
        onWaypointConfirmed: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onWaypointConfirmed", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onTeachWaypointAndCloseButtonClick: ({ robotClip: robotClip  })=>{
            jogger.onDisableFreedriveButtonClick();
            const editingKeyframePath = (0, $e9a5479fa42b7804$export$e1252723db1c541).getEditingKeyframePath();
            const editingKeyframeIndex = (0, $ab21692160dc29ca$export$2e2bcd8739ae039).getKeyframeIndex(editingKeyframePath);
            robotClip.keyframes.length > editingKeyframeIndex ? robotAppsService.send("RobotClips/EditWaypoint/onTeachWaypointAndCloseButtonClick", {
                robotClip: robotClip
            }) : robotAppsService.send("RobotClips/AddWaypoint/onTeachWaypointAndCloseButtonClick", {
                robotClip: robotClip
            });
        },
        onWaypointEditClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onWaypointEditClicked", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onWaypointTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotClips/onWaypointTimeChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                time: time
            }),
        onWaypointClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onWaypointClicked", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onWaypointMoveHereButtonMouseDown: ({ jointAngles: jointAngles  })=>robotAppsService.send("RobotClips/onWaypointMoveHereButtonMouseDown", {
                jointAngles: jointAngles
            }),
        onWaypointMoveHereButtonMouseUp: ()=>robotAppsService.send("RobotClips/onWaypointMoveHereButtonMouseUp"),
        onRobotCommandAdded: ({ robotClip: robotClip  })=>robotAppsService.send("RobotClips/onRobotCommandAdded", {
                robotClip: robotClip
            }),
        onKeyframeRobotCommandChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                robotCommandType: robotCommandType
            }),
        onKeyframeRobotCommandWaitForTimeTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandWaitForTimeTimeChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                time: time
            }),
        onKeyframeRobotCommandSetPayloadWeightChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , weight: weight  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandSetPayloadWeightChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                weight: weight
            }),
        onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                moveLVelocityScalingFactor: moveLVelocityScalingFactor
            }),
        onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                moveJVelocityScalingFactor: moveJVelocityScalingFactor
            }),
        onKeyframeDeleteClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onKeyframeDeleteClicked", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onKeyframeOrderChanged: ({ robotClip: robotClip , keyframes: keyframes  })=>robotAppsService.send("RobotClips/onKeyframeOrderChanged", {
                robotClip: robotClip,
                keyframes: keyframes
            }),
        onIgnoreReferenceFrameChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  })=>robotAppsService.send("RobotClips/onIgnoreReferenceFrameChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                ignoreReferenceFrame: ignoreReferenceFrame
            }),
        isEditingReferenceFrame: (0, $e9a5479fa42b7804$export$e1252723db1c541).getRobotAppsService().state.value.app === "creatingReferenceFrame",
        robotClips: getRobotClips(),
        robotClipIdsUsed: getRobotClipIdsUsed(),
        getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame,
        getUniqueClipName: getUniqueClipName,
        onClick: (robotClip)=>robotAppsService.send("RobotClips/onClipSelected", {
                robotClip: robotClip
            }),
        onTouchStart: (robotClip)=>robotAppsService.send("RobotClips/onClipSelected", {
                robotClip: robotClip
            }),
        isAnyKeyframeInEditModeInClip: (0, $bedf83968cd4d388$export$2e2bcd8739ae039),
        onLockedDeleteClick: ()=>robotAppsService.send("RobotClips/onLockedDeleteClick"),
        onRobotClipsChangeNoConfig: ()=>robotAppsService.send("RobotClips/onRobotClipsChangeNoConfig"),
        onRobotClipChange: (robotClip)=>robotAppsService.send("RobotClips/onRobotClipChange", {
                robotClip: robotClip
            }),
        onRobotClipsChange: (newRobotClips, actionType)=>robotAppsService.send("RobotClips/onRobotClipsChange", {
                actionType: actionType,
                application: application,
                newRobotClips: newRobotClips
            }),
        onDeleteClick: ()=>robotAppsService.send("RobotClips/onDeleteClick"),
        onReferenceFrameCreate: ({ robotClip: robotClip  })=>robotAppsService.send("RobotClips/onReferenceFrameCreate", {
                robotClip: robotClip
            }),
        onExitReferenceFrameCreate: ()=>robotAppsService.send("RobotClips/onExitReferenceFrameCreate"),
        onTriadButtonClick: ()=>robotAppsService.send("RobotClips/TRIAD_SELECTED"),
        onPointToPointButtonClick: ()=>robotAppsService.send("RobotClips/POINT_TO_POINT_SELECTED"),
        onJoggerButtonClick: ()=>robotAppsService.send("RobotClips/JOGGER_SELECTED"),
        onJoggerCloseButtonClick: ()=>{
            jogger.onDisableFreedriveButtonClick();
            robotAppsService.send("RobotClips/JOGGER_CLOSE_BUTTON_CLICKED");
        },
        robotJoggerApi: {
            jointLimits: [
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -180,
                    max: 180
                },
                {
                    min: -180,
                    max: 180
                }
            ],
            position: jogger.getPosition(),
            rotation: jogger.getRotation(),
            jointAngles: jogger.getJointAngles(),
            freedriveStatus: jogger.getFreedriveStatus(),
            joggerSpeedPercentage: (0, $e9a5479fa42b7804$export$e1252723db1c541).getJoggerSpeedPercentage(),
            onJoggerPoseTranslationMouseDown: jogger.onJoggerPoseTranslationMouseDown,
            onJoggerPoseRotationMouseDown: jogger.onJoggerPoseRotationMouseDown,
            onJoggerJointArrowMouseDown: jogger.onJoggerJointArrowMouseDown,
            onJoggerArrowMouseUp: jogger.onJoggerArrowMouseUp,
            onSpeedSliderChange: jogger.onSpeedSliderChange,
            onToggleConstraintButtonClick: jogger.onToggleConstraintButtonClick,
            onEnableFreedriveButtonClick: jogger.onEnableFreedriveButtonClick,
            onDisableFreedriveButtonClick: jogger.onDisableFreedriveButtonClick
        },
        onReferenceFrameToolTipClick: ()=>tooltips.showTips("global_reference_frame"),
        onMoveJToolTipClick: ()=>tooltips.showTips("move_j_and_l"),
        onMoveLToolTipClick: ()=>tooltips.showTips("move_j_and_l")
    });
}








function $b69af58fe6e81d75$export$2e2bcd8739ae039({ pApplication: pApplication , robotAppsService: robotAppsService , manipRobotState: manipRobotState , tooltips: tooltips , getJointLimits: getJointLimits , getRobotClips: getRobotClips , getRobotClipIdsUsed: getRobotClipIdsUsed , getUniqueClipName: getUniqueClipName , getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame , validatePoseWaypoint: validatePoseWaypoint  }) {
    const { selectors: selectors  } = robotAppsService;
    const robotConfigs = pApplication.mLibrary.getConfigManager().listRobots();
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>robotAppsService.send("RobotClips/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>robotAppsService.send("RobotClips/onUnmount", {
            idxFunc: idxFunc
        }));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $7b36627f41554d51$export$2e2bcd8739ae039), {
        robotConfigs: robotConfigs,
        selectors: selectors,
        doesRobotConfigExist: robotConfigs.length > 0,
        robotName: robotConfigs.length && robotConfigs[0].mName,
        referenceFrameLabel: "GLOBAL REFERENCE FRAME",
        moveWithMode: (0, $49b61417b640529d$export$7556d3a9f806327e)[typeof robotAppsService.selectors.getRobotAppsServiceState().value.app === "string" ? robotAppsService.selectors.getRobotAppsServiceState().value.app : Object.keys(robotAppsService.selectors.getRobotAppsServiceState().value.app)[0]] || "",
        onWaypointAdded: ({ robotClip: robotClip  })=>robotAppsService.send("RobotClips/onWaypointAdded", {
                robotClip: robotClip
            }),
        onWaypointPathTypeChanged: ({ pathType: pathType , keyframeIndex: keyframeIndex , robotClip: robotClip  })=>{
            robotAppsService.send("RobotClips/onWaypointPathTypeChanged", {
                robotClip: robotClip,
                pathType: pathType,
                keyframeIndex: keyframeIndex
            });
        },
        onWaypointNameChanged: ({ name: name , keyframeIndex: keyframeIndex , robotClip: robotClip  })=>{
            robotAppsService.send("RobotClips/onWaypointNameChanged", {
                robotClip: robotClip,
                name: name,
                keyframeIndex: keyframeIndex
            });
        },
        onWaypointConfirmed: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onWaypointConfirmed", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onWaypointEditClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onWaypointEditClicked", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onWaypointTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotClips/onWaypointTimeChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                time: time
            }),
        onWaypointClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onWaypointClicked", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onRobotCommandAdded: ({ robotClip: robotClip  })=>robotAppsService.send("RobotClips/onRobotCommandAdded", {
                robotClip: robotClip
            }),
        onKeyframeRobotCommandChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , robotCommandType: robotCommandType  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                robotCommandType: robotCommandType
            }),
        onKeyframeRobotCommandWaitForTimeTimeChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , time: time  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandWaitForTimeTimeChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                time: time
            }),
        onKeyframeRobotCommandSetPayloadWeightChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , weight: weight  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandSetPayloadWeightChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                weight: weight
            }),
        onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveLVelocityScalingFactor: moveLVelocityScalingFactor  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandSetSpeedMoveLVelocityScalingFactorChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                moveLVelocityScalingFactor: moveLVelocityScalingFactor
            }),
        onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , moveJVelocityScalingFactor: moveJVelocityScalingFactor  })=>robotAppsService.send("RobotClips/onKeyframeRobotCommandSetSpeedMoveJVelocityScalingFactorChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                moveJVelocityScalingFactor: moveJVelocityScalingFactor
            }),
        onKeyframeDeleteClicked: ({ robotClip: robotClip , keyframeIndex: keyframeIndex  })=>robotAppsService.send("RobotClips/onKeyframeDeleteClicked", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex
            }),
        onKeyframeOrderChanged: ({ robotClip: robotClip , keyframes: keyframes  })=>robotAppsService.send("RobotClips/onKeyframeOrderChanged", {
                robotClip: robotClip,
                keyframes: keyframes
            }),
        onIgnoreReferenceFrameChanged: ({ robotClip: robotClip , keyframeIndex: keyframeIndex , ignoreReferenceFrame: ignoreReferenceFrame  })=>robotAppsService.send("RobotClips/onIgnoreReferenceFrameChanged", {
                robotClip: robotClip,
                keyframeIndex: keyframeIndex,
                ignoreReferenceFrame: ignoreReferenceFrame
            }),
        robotClips: getRobotClips(),
        robotClipIdsUsed: getRobotClipIdsUsed(),
        validatePoseWaypoint: validatePoseWaypoint,
        getDefaultTeachingReferenceFrame: getDefaultTeachingReferenceFrame,
        getUniqueClipName: getUniqueClipName,
        onClick: (robotClip)=>robotAppsService.send("RobotClips/onClipSelected", {
                robotClip: robotClip
            }),
        isAnyKeyframeInEditModeInClip: (0, $bedf83968cd4d388$export$2e2bcd8739ae039),
        isAnyKeyframeInEditMode: (robotClips)=>robotClips.some((robotClip)=>robotClip.keyframes.length && (0, $bedf83968cd4d388$export$2e2bcd8739ae039)(robotClip)),
        onLockedDeleteClick: ()=>robotAppsService.send("RobotClips/onLockedDeleteClick"),
        onRobotClipsChangeNoConfig: ()=>robotAppsService.send("RobotClips/onRobotClipsChangeNoConfig"),
        onRobotClipChange: (robotClip)=>robotAppsService.send("RobotClips/onRobotClipChange", {
                robotClip: robotClip
            }),
        onRobotClipsChange: (newRobotClips, actionType)=>robotAppsService.send("RobotClips/onRobotClipsChange", {
                newRobotClips: newRobotClips,
                actionType: actionType
            }),
        onDeleteClick: ()=>robotAppsService.send("RobotClips/onDeleteClick"),
        onReferenceFrameCreate: ({ robotClip: robotClip  })=>robotAppsService.send("RobotClips/onReferenceFrameCreate", {
                robotClip: robotClip
            }),
        onExitReferenceFrameCreate: ()=>robotAppsService.send("RobotClips/onExitReferenceFrameCreate"),
        onTriadButtonClick: ()=>robotAppsService.send("RobotClips/TRIAD_SELECTED"),
        onPointToPointButtonClick: ()=>robotAppsService.send("RobotClips/POINT_TO_POINT_SELECTED"),
        onJoggerButtonClick: ()=>robotAppsService.send("RobotClips/JOGGER_SELECTED"),
        onJoggerCloseButtonClick: ()=>robotAppsService.send("RobotClips/JOGGER_CLOSE_BUTTON_CLICKED"),
        robotJoggerApi: {
            jointLimits: getJointLimits(),
            position: manipRobotState.get___matrix__endEffector_referenceFrame__translation(),
            rotation: manipRobotState.get___matrix__endEffector_referenceFrame__rotation(),
            jointAngles: manipRobotState.getJointAnglesDegrees(),
            onPoseTranslationChange: (letter, value)=>robotAppsService.send("RobotClips/JOGGER_POSE_TRANSLATION_CHANGED", {
                    letter: letter,
                    value: value
                }),
            onPoseRotationChange: (letter, value)=>robotAppsService.send("RobotClips/JOGGER_POSE_ROTATION_CHANGED", {
                    letter: letter,
                    value: value
                }),
            onJointAnglesChange: (index, value)=>robotAppsService.send("RobotClips/JOGGER_JOINT_ANGLE_CHANGED", {
                    index: index,
                    value: value
                })
        },
        onReferenceFrameToolTipClick: ()=>tooltips.showTips("global_reference_frame"),
        onMoveJToolTipClick: ()=>tooltips.showTips("move_j_and_l"),
        onMoveLToolTipClick: ()=>tooltips.showTips("move_j_and_l")
    });
}













/**
 *
 * @param {{
 *   joggerSpeedPercentage: function,
 *   onSpeedSliderChange: function
 *   sliderMinValue: number,
 *   sliderMaxValue: number
 * }}
 */ function $f2a824840746fd4c$var$RobotJoggerSpeedSlider({ joggerSpeedPercentage: joggerSpeedPercentage , onSpeedSliderChange: onSpeedSliderChange , sliderMinValue: sliderMinValue , sliderMaxValue: sliderMaxValue , isDisabled: isDisabled  }) {
    (0, $gXNCa$react.useEffect)(()=>{
        handleSliderChange({
            target: document.getElementById("slider")
        });
    }, []);
    const scale = $gXNCa$d3scale.scalePow().exponent(2).domain([
        sliderMinValue,
        sliderMaxValue
    ]).range([
        sliderMinValue,
        sliderMaxValue
    ]);
    function handleSliderChange(e) {
        let target = e.target;
        const val = target.value;
        target.style.backgroundSize = (val - sliderMinValue) * 100 / (sliderMaxValue - sliderMinValue) + "% 100%";
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
        flexDirection: "column",
        padding: "0",
        style: {
            marginTop: "8rem"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                style: {
                    color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                    fontSize: "24px",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                    children: "Speed"
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                flexDirection: "row",
                style: {
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                        style: {
                            fontSize: "24px",
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                            position: "absolute",
                            marginRight: "5rem"
                        },
                        children: [
                            Math.floor(scale.invert(joggerSpeedPercentage)),
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $855932f7329443e3$export$2e2bcd8739ae039), {
                        id: "slider",
                        type: "range",
                        min: sliderMinValue,
                        max: sliderMaxValue,
                        step: 0.01,
                        value: scale.invert(joggerSpeedPercentage),
                        onMouseUp: (event)=>event.stopPropagation(),
                        onMouseDown: (event)=>event.stopPropagation(),
                        onMouseMove: (event)=>event.stopPropagation(),
                        onChange: (event)=>{
                            onSpeedSliderChange(scale((0, $e7ddd58468ef3df7$export$2e2bcd8739ae039)(event.target.value)));
                            handleSliderChange(event);
                        },
                        disabled: isDisabled,
                        style: {
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            opacity: isDisabled ? "0.3" : "1",
                            transform: "rotate(-90deg)",
                            position: "absolute"
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                        style: {
                            color: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).secondary_grey,
                            fontSize: "17px",
                            fontWeight: "700",
                            lineHeight: "2.85rem",
                            marginLeft: "4rem",
                            textAlign: "center"
                        },
                        children: [
                            "100% ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _ ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " _",
                            " ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                            " 0%"
                        ]
                    })
                ]
            })
        ]
    });
}
var $f2a824840746fd4c$export$2e2bcd8739ae039 = $f2a824840746fd4c$var$RobotJoggerSpeedSlider;






function $974c3a62b8a2e3b1$var$RobotJogger({ position: position , rotation: rotation , jointAngles: jointAngles , joggerSpeedPercentage: joggerSpeedPercentage , freedriveStatus: freedriveStatus , robotType: robotType , onJoggerPoseTranslationMouseDown: onJoggerPoseTranslationMouseDown , onJoggerPoseRotationMouseDown: onJoggerPoseRotationMouseDown , onJoggerJointArrowMouseDown: onJoggerJointArrowMouseDown , onJoggerArrowMouseUp: onJoggerArrowMouseUp , onSpeedSliderChange: onSpeedSliderChange , onEnableFreedriveButtonClick: onEnableFreedriveButtonClick , onDisableFreedriveButtonClick: onDisableFreedriveButtonClick , onToggleConstraintButtonClick: onToggleConstraintButtonClick  }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
        gridTemplateColumns: "800px 200px 200px",
        gridTemplateRows: "1fr",
        padding: "0px",
        style: {
            fontFamily: "Larsseit",
            justifyContent: "center",
            backgroundColor: "transparent"
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $e874e726514bc29c$export$2e2bcd8739ae039), {
                gridTemplateColumns: "50% 50%",
                gridTemplateRows: "50px 625px",
                padding: "0px",
                style: {
                    marginTop: "100px",
                    justifyContent: "center",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $c6c8dfaca663abb7$export$2e2bcd8739ae039), {
                    position: position,
                    rotation: rotation,
                    jointAngles: jointAngles,
                    joggerSpeedPercentage: joggerSpeedPercentage,
                    isFreedriveRunning: freedriveStatus.running,
                    robotType: robotType,
                    onJoggerJointArrowMouseDown: onJoggerJointArrowMouseDown,
                    onJoggerPoseTranslationMouseDown: onJoggerPoseTranslationMouseDown,
                    onJoggerArrowMouseUp: onJoggerArrowMouseUp,
                    onJoggerPoseRotationMouseDown: onJoggerPoseRotationMouseDown
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $f2a824840746fd4c$export$2e2bcd8739ae039), {
                joggerSpeedPercentage: joggerSpeedPercentage,
                onSpeedSliderChange: onSpeedSliderChange,
                sliderMinValue: 1,
                sliderMaxValue: 100,
                isDisabled: freedriveStatus.running
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $79df3d6dfc00b4b7$export$2e2bcd8739ae039), {
                flexDirection: "column",
                style: {
                    alignItems: "center",
                    marginTop: "7.5rem"
                },
                width: "100%",
                backgroundColor: "transparent",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$55e0fae517e6c4b0), {}),
                    !freedriveStatus.running && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$291e5412ac462041), {
                        height: "3rem",
                        width: "4rem",
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        TextColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).vention_blue,
                        onClick: onEnableFreedriveButtonClick,
                        style: {
                            position: "absolute",
                            top: "330px",
                            border: "none",
                            background: "none"
                        }
                    }),
                    freedriveStatus.running && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$a3039299a222d6ea), {
                        height: "3rem",
                        width: "4rem",
                        ToggleBackground: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).bright_green,
                        ToggleColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        TextColor: (0, $14a8afc1688fc92f$export$2e2bcd8739ae039).white,
                        onClick: onDisableFreedriveButtonClick,
                        style: {
                            position: "absolute",
                            top: "330px",
                            border: "none",
                            background: "none"
                        }
                    }),
                    freedriveStatus.running && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $eaff80254f7223d6$export$263016ca0ed42b1b), {
                        freedriveConstraintState: freedriveStatus.constraints,
                        onToggleConstraintButtonClick: onToggleConstraintButtonClick
                    })
                ]
            })
        ]
    });
}
var $974c3a62b8a2e3b1$export$2e2bcd8739ae039 = $974c3a62b8a2e3b1$var$RobotJogger;










const { getDispatch: $1c66ac2b68377f4a$var$getDispatch , getFreedriveStatus: $1c66ac2b68377f4a$var$getFreedriveStatus , getRobotConfig: $1c66ac2b68377f4a$var$getRobotConfig , getRobotCartesianPositionInMM: $1c66ac2b68377f4a$var$getRobotCartesianPositionInMM , getRobotCartesianRotationInDeg: $1c66ac2b68377f4a$var$getRobotCartesianRotationInDeg , getRobotJointStatesInDeg: $1c66ac2b68377f4a$var$getRobotJointStatesInDeg , getJoggerSpeedPercentage: $1c66ac2b68377f4a$var$getJoggerSpeedPercentage  } = (0, $e9a5479fa42b7804$export$e1252723db1c541);
const $1c66ac2b68377f4a$var$getRobotState = ()=>({
        getPosition: ()=>{
            const position = $1c66ac2b68377f4a$var$getRobotCartesianPositionInMM();
            return {
                mP: {
                    x: position?.x || 0,
                    y: position?.y || 0,
                    z: position?.z || 0
                }
            };
        },
        getRotation: ()=>{
            const rotation = $1c66ac2b68377f4a$var$getRobotCartesianRotationInDeg();
            return {
                mP: {
                    x: rotation?.x || 0,
                    y: rotation?.y || 0,
                    z: rotation?.z || 0
                }
            };
        },
        getJointAngles: ()=>$1c66ac2b68377f4a$var$getRobotJointStatesInDeg() || (0, $a94c350358e784aa$export$1b792dfa92d90e0b)(),
        getJoggerSpeedPercentage: $1c66ac2b68377f4a$var$getJoggerSpeedPercentage,
        getFreedriveStatus: ()=>$1c66ac2b68377f4a$var$getFreedriveStatus() || (0, $8bd3f182af6b3660$export$185802fd694ee1f5)()
    });
function $1c66ac2b68377f4a$var$RobotJoggerContainer({ shouldDisplayRobotJoggerRobotDisconnectedOverlay: shouldDisplayRobotJoggerRobotDisconnectedOverlay , shouldDisplayRobotJoggerRobotNotReadyOverlay: shouldDisplayRobotJoggerRobotNotReadyOverlay  }) {
    const dispatch = $1c66ac2b68377f4a$var$getDispatch();
    const robotConfig = $1c66ac2b68377f4a$var$getRobotConfig();
    const freedriveStatus = $1c66ac2b68377f4a$var$getRobotState().getFreedriveStatus();
    (0, $d3bbe4bc45b4a8e8$export$b99dd172d66b4df0)((idxFunc)=>dispatch("ManualControl/RobotJogger/onMount", {
            idxFunc: idxFunc
        }), (idxFunc)=>dispatch("ManualControl/RobotJogger/onUnmount", {
            idxFunc: idxFunc
        }));
    if (shouldDisplayRobotJoggerRobotNotReadyOverlay()) dispatch("RobotReadyStateNotReadyBody/joggerModal/ModalShown");
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)((0, $gXNCa$reactjsxruntime.Fragment), {
        children: [
            shouldDisplayRobotJoggerRobotDisconnectedOverlay() && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $a89ab9e959a7fd4f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $083dbba1d7d21bc0$export$2e2bcd8739ae039), {
                    onVerifyButtonClick: ()=>dispatch("RobotJoggerContainer/VerifyButton/onClick")
                })
            }),
            !freedriveStatus.running && shouldDisplayRobotJoggerRobotNotReadyOverlay() && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $a89ab9e959a7fd4f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $cdf6ac17ab4b4848$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $63fa3fc88f964c51$export$2e2bcd8739ae039), {
                        buttonText: "ENABLE ROBOT",
                        isLoading: (0, $e9a5479fa42b7804$export$e1252723db1c541).isRobotReadyStateNotReadyButtonLoading(),
                        message: "Enable robot to continue",
                        title: "Your robot is not in a ready state",
                        onClick: ()=>dispatch("RobotJoggerContainer/EnableButton/onClick")
                    })
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)((0, $974c3a62b8a2e3b1$export$2e2bcd8739ae039), {
                robotType: robotConfig?.parameters?.robotType,
                position: $1c66ac2b68377f4a$var$getRobotState().getPosition(),
                rotation: $1c66ac2b68377f4a$var$getRobotState().getRotation(),
                jointAngles: $1c66ac2b68377f4a$var$getRobotState().getJointAngles(),
                joggerSpeedPercentage: $1c66ac2b68377f4a$var$getRobotState().getJoggerSpeedPercentage(),
                freedriveStatus: freedriveStatus,
                robotJoggerTitle: "",
                onJoggerPoseTranslationMouseDown: (letter, value)=>dispatch("ManualControl/RobotJogger/onJoggerPoseTranslationMouseDown", {
                        letter: letter,
                        value: value
                    }),
                onJoggerPoseRotationMouseDown: (letter, value)=>dispatch("ManualControl/RobotJogger/onJoggerPoseRotationMouseDown", {
                        letter: letter,
                        value: value
                    }),
                onJoggerJointArrowMouseDown: (index, delta)=>dispatch("ManualControl/RobotJogger/onJoggerJointArrowMouseDown", {
                        index: index,
                        delta: delta
                    }),
                onJoggerArrowMouseUp: ()=>dispatch("ManualControl/RobotJogger/onJoggerArrowMouseUp"),
                onSpeedSliderChange: (joggerSpeedPercentage)=>dispatch("ManualControl/RobotJogger/onSpeedSliderChange", {
                        joggerSpeedPercentage: joggerSpeedPercentage
                    }),
                onEnableFreedriveButtonClick: ()=>dispatch("ManualControl/RobotJogger/onEnableFreedriveButtonClick"),
                onDisableFreedriveButtonClick: ()=>dispatch("ManualControl/RobotJogger/onDisableFreedriveButtonClick"),
                onToggleConstraintButtonClick: (constraintIndex)=>{
                    dispatch("ManualControl/RobotJogger/onToggleConstraintButtonClick", {
                        constraintIndex: constraintIndex
                    });
                }
            })
        ]
    });
}
var $1c66ac2b68377f4a$export$2e2bcd8739ae039 = $1c66ac2b68377f4a$var$RobotJoggerContainer;






function $e54a2e3a26cc8ed1$export$2e2bcd8739ae039(ArrayMatrix__endEffectorFrame_world, ArrayMatrix__teachingReferenceFrame_world, ArrayMatrix__executionReferenceFrame_world, ArrayMatrix__calibrationReferenceFrame_world) {
    const Matrix__calibrationReferenceFrame_world = new $gXNCa$three.Matrix4().fromArray(ArrayMatrix__calibrationReferenceFrame_world);
    const Matrix__endEffectorOffsetByExecutionReferenceFrame_world = new $gXNCa$three.Matrix4().fromArray((0, $ca0dfdf8b548132d$export$2e2bcd8739ae039)({
        ArrayMatrix__endEffectorFrame_world: ArrayMatrix__endEffectorFrame_world,
        ArrayMatrix__teachingReferenceFrame_world: ArrayMatrix__teachingReferenceFrame_world,
        ArrayMatrix__executionReferenceFrame_world: ArrayMatrix__executionReferenceFrame_world
    }));
    const Matrix__world_calibrationReferenceFrame = (0, $6623923a1bb51858$export$70ae2c07e401031b)(Matrix__calibrationReferenceFrame_world);
    return (0, $6623923a1bb51858$export$71cf47b8291c00ec)(Matrix__endEffectorOffsetByExecutionReferenceFrame_world, Matrix__world_calibrationReferenceFrame).toArray();
}


const $4fa36e821943b400$var$commonView = {
    ...(0, $c3e57ae7e5dd4d0a$export$2e2bcd8739ae039),
    RobotName: $a2bde123201d8861$export$92102e06f68899d9,
    RobotPartNumber: $a2bde123201d8861$export$53e3a918ec73881
};
const $4fa36e821943b400$var$utils = {
    ArrayOfArrayReferenceFrame__fromArrayOfPoint2DxExecutionReferenceFrame: $0d3588c60e71877c$export$2e2bcd8739ae039,
    executionEngineConfig_updateWithRobotAppsMachineContext: $8b66b82d3ade9884$export$a373a095246b6248,
    getUniqueClipNameFromApplication: $1d3cf5330bb207de$export$64c313e59f94d976,
    isRobotReady: $a4b0e5373d13ed39$export$2e2bcd8739ae039,
    machineLogicApplicationRobotParameters_updateWithRobotAppsMachineContext: $8b66b82d3ade9884$export$cb9dc74b8199ca4e,
    robotTypeFormatUR: $b2581f98af3b5a81$export$2e2bcd8739ae039,
    getCurrentJointAnglesAndPose: $3f65195cd5e8f23a$export$d7ce143e51c6582e
};
const $4fa36e821943b400$var$api = {
    ExecutionEngineAPI: $084cd0ab38537745$exports
};
const $4fa36e821943b400$export$a8d37c3100d63152 = {
    api: $4fa36e821943b400$var$api,
    controller: {
        features: $dbd3670ef76bb404$exports,
        initialize: (0, $e9a5479fa42b7804$export$57c55162807a37cb)
    },
    model: {
        createEmptyFreedriveStatus: $8bd3f182af6b3660$export$185802fd694ee1f5,
        types: $66ec0fd1738a6fd1$exports,
        typeInstanceCreators: $a94c350358e784aa$exports,
        typeInstanceOperations: $0c88886b9d748222$export$2e2bcd8739ae039
    },
    utils: $4fa36e821943b400$var$utils,
    view: {
        ...$4fa36e821943b400$var$commonView,
        ...(0, $6e14a26a864ddf12$export$2e2bcd8739ae039),
        RobotInstruction: $02291aaf8b5b0873$exports,
        RobotLoopInstruction: $00ddc4799a8e92a9$exports,
        RobotConfigWidget: (0, $4c342ce2d960949f$export$2e2bcd8739ae039),
        ReferenceFrames: (0, $4f6d6e695b2202d1$export$2e2bcd8739ae039),
        RobotArrays: (0, $6333a886e3e8e911$export$2e2bcd8739ae039),
        RobotClips: (0, $753aa4a6c6a82c34$export$2e2bcd8739ae039),
        ManualControlRobotJoggerContainer: (0, $1c66ac2b68377f4a$export$2e2bcd8739ae039)
    }
};
const $4fa36e821943b400$export$4a1a65d8c0fb68a1 = {
    api: $4fa36e821943b400$var$api,
    controller: {
        features: $42663375bb38ee89$exports,
        create: (0, $b632cfa24756cd8a$export$57c55162807a37cb)
    },
    model: {
        types: $66ec0fd1738a6fd1$exports,
        typeInstanceCreators: $a94c350358e784aa$exports,
        typeInstanceOperations: $0c88886b9d748222$export$2e2bcd8739ae039
    },
    utils: {
        ...$4fa36e821943b400$var$utils,
        ArrayMatrix__getChangeOfBasis_endEffectorOffsetByExecutionReferenceFrame_calibrationReferenceFrame: $e54a2e3a26cc8ed1$export$2e2bcd8739ae039
    },
    view: {
        ...$4fa36e821943b400$var$commonView,
        ...(0, $83195ab73a09d9e3$export$2e2bcd8739ae039),
        RobotInstruction: $8c0c7fef442bff47$exports,
        RobotLoopInstruction: $ed1bbdf4286a076f$exports,
        RobotSafetyStateModal: $cea0d0fa34c57db4$export$2e2bcd8739ae039,
        RobotConfigWidget: (0, $bf82d0717b3b7765$export$2e2bcd8739ae039),
        CalibrationParts: (0, $09297eee55ccfd1d$export$2e2bcd8739ae039),
        RobotArrays: (0, $1507d1ceb475f753$export$2e2bcd8739ae039),
        RobotClips: (0, $b69af58fe6e81d75$export$2e2bcd8739ae039)
    }
};


//# sourceMappingURL=index.js.map
